/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523b35a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523b35a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"c20decb8-a3ac-45ab-83a1-3d5859e9b661","title":"التعرّف على الطابعة","link":"finding-information-about-printer-topic.html","desc":"العثور على معلومات عن الطابعة","descFull":"العثور على معلومات عن الطابعة الموارد وأماكن وجودها ما الذي تبحث عنه؟ يمكنك العثور عليه هنا تعليمات الإعداد الأوّلي راجع وثائق الإعداد المرفقة مع الطابعة. برنامج الطابعة الطباعة أو برنامج تشغيل الفاكس البرنامج الثابت للطابعة الأداة المساعدة انتقل إلى  www.lexmark.com/downloads . دليل المستخدم  التفاعلي انتقل إلى العنوان  https://support.lexmark.com . مقاطع الفيديو التعليمية انتقل إلى  https://infoserve.lexmark.com/idv/ . تعليمات حول استخدام برنامج الطابعة. تعليمات خاصة بأنظمة تشغيل Microsoft Windows أو Macintosh—افتح أحد برامج أو تطبيقات الطابعة، ثم انقر فوق  تعليمات . انقر فوق   لعرض معلومات حساسة للسياق. يتم تثبيت \"التعليمات\" تلقائيًا مع برنامج الطابعة. بحسب نظام التشغيل، يتوفّر برنامج الطابعة إما في مجلد برنامج الطابعة أو على سطح المكتب. الوثائق دعم المحادثة المباشرة دعم البريد الإلكتروني دعم الصوت انتقل إلى العنوان  https://support.lexmark.com . حدد المنطقة أو البلد التي تتبعها، ثم حدد المنتج الذي بحوزتك لعرض موقع الدعم المناسب. يمكن العثور على معلومات الاتصال بالدعم الخاصة ببلدك أو منطقتك على موقع الويب أو على الضمان المطبوع المرفق بالطابعة. جهّزْ المعلومات التالية عند الاتصال بدعم العملاء: تاريخ الشراء ومكانه نوع الجهاز والرقم التسلسلي لمزيد من المعلومات، راجع  . معلومات السلامة المعلومات التنظيمية معلومات الضمان معلومات بيئية تختلف معلومات الضمان حسب البلد أو المنطقة: في الولايات المتحدة. —انظر \"بيان الضمان المحدود\" المرفق مع الطابعة أو المتوفر على العنوان  https://support.lexmark.com . في الدول والمناطق الأخرى —انظر الضمان المطبوع المرفق بهذه الطابعة. دليل معلومات المنتج —راجع الوثائق المرفقة مع الطابعة أو انتقل إلى  https://support.lexmark.com . معلومات حول جواز السفر الرقمي من Lexmark انتقل إلى  https://csr.lexmark.com/digital-passport.php . العثور على معلومات الطابعة"},{"UUID":"8bb37d25-94fb-4102-806b-280c5bf26149","title":"التعرّف على الطابعة","link":"finding-printer-serial-number-topic.html","desc":"العثور على الرقم التسلسلي للطابعة","descFull":"العثور على الرقم التسلسلي للطابعة افتح الدرج. حدد موقع الرقم التسلسلي على الجانب الأيمن من الطابعة. الرقم التسلسلي للطابعة الرقم التسلسلي"},{"UUID":"3c9e0c2a-67b8-4d8f-811d-48bf204d503f","title":"التعرّف على الطابعة","link":"printer-configurations-topic.html","desc":"مواصفات الطابعة احرص على تهيئة","descFull":"مواصفات الطابعة احرص على تهيئة الطابعة على سطح منبسط وقوي وثابت. الطراز الأساسي أجزاء طراز طابعة أساسي 1 وحدة تغذية المستندات التلقائية (ADF) 2 لوحة التحكم 3 منفذ USB 4 وحدة التغذية متعددة الأغراض 5 الدرج القياسي سعة 550 ورقة 6 حاوية قياسية الطراز المهيأ قد يتطلب تثبيت ملحق واحد أو أكثر على الطابعة أو الطابعة المتعددة الوظائف قاعدة عجلات أو أثاثًا أو ميزةً أخرى لتفادي عدم الثبات الذي قد يتسبب بإصابة. للمزيد من المعلومات حول عمليات التهيئة المدعومة، تفضل بزيارة  www.lexmark.com/multifunctionprinters . قد يتطلب تثبيت ملحق واحد أو أكثر على الطابعة أو الطابعة المتعددة الوظائف قاعدة عجلات أو أثاثًا أو ميزةً أخرى لتفادي عدم الثبات الذي قد يتسبب بإصابة. للمزيد من المعلومات حول عمليات التهيئة المدعومة، اتصل بالمكان الذي اشتريت منه الطابعة. لتقليل مخاطر عدم ثبات الجهاز، حمِّل كل درج بشكل منفرد. حافظ على إبقاء جميع الأدراج الأخرى مغلقة حتى الحاجة إليها. أجزاء طراز طابعة تمت تهيئته # خيار الأجهزة خيار أجهزة بديلة 1  لا يمكن تركيبها مع وحدة تشطيب الكتيبات أو ‏‫وحدة إنهاء التدبيس‬ وتثقيب الفتحات. 2  يجب تركيبه دائمًا مع درج اختياري سعة 550 ورقة وإما درج سعة 2 × 550 ورقة أو درج إدخال مزدوج سعة 2000 ورقة. 3  يجب تركيبه دائمًا مع درج اختياري سعة 550 ورقة. 4  يجب تركيبه دائمًا مع درج اختياري سعة 550 ورقة وواحد مما يلي: درجان سعة 550 ورقة أو درج إدخال مزدوج سعة 2000 ورقة أو خزانة. 1 وحدة إنهاء التدبيس‬ 1 وحدة التكديس 1 نقل الورق نقل الورق مع خيار الطي 2 الدرج سعة 1500ورقة 2 لا يوجد 3 درج الإدخال المزدوج سعة 2000 ورقة 3 الدرج سعة 2 ×‏550 ورقة 3 الخزانة 3 4 درج اختياري لاستيعاب 550 ورقة لا يوجد 5 وحدة إنهاء الكتيبات 4 وحدة إنهاء التدبيس وتثقيب الفتحات 4 قد لا تتوفر بعض الخيارات. لمزيد من المعلومات، اتصل بالمكان الذي اشتريت منه الطابعة. مواصفات الطابعة"},{"UUID":"18c036b4-2daf-4196-a4ed-2ed6193bbcbe","title":"التعرّف على الطابعة","link":"using-control-panel-topic.html","desc":"استخدام لوحة التحكم أجزاء من","descFull":"استخدام لوحة التحكم أجزاء من لوحة التحكم ووظائفها جزء لوحة التحكم الوظيفة 1 زر التشغيل/إيقاف التشغيل لتشغيل الطابعة أو إيقاف تشغيلها. لإيقاف تشغيل الطابعة، اضغط مع الاستمرار على زر التشغيل/إيقاف التشغيل لمدة خمس ثوانٍ. قم بتعيين الطابعة على وضع السكون. إخراج الطابعة من وضع Sleep (السكون) أو Hibernate (الإسبات). 2 شاشة عرض عرض رسائل الطابعة وحالة مستلزمات الطباعة. قم بإعداد الطابعة وتشغيلها. 3 مصباح المؤشر فحص حالة الطابعة. لوحة التحكم استخدام استخدام لوحة التحكم"},{"UUID":"19c6b4e2-e5aa-448c-aceb-db45fb53a1b6","title":"التعرّف على الطابعة","link":"using-home-screen-topic.html","desc":"رموز الشاشة الرئيسية قد تختلف","descFull":"رموز الشاشة الرئيسية قد تختلف الشاشة الرئيسية وفقًا لإعدادات تخصيص الشاشة الرئيسية وإعداد الشخص المسؤول و\"embedded solutions\" النشطة. رموز الشاشة الرئيسية ووظائفها # اسم الرمز الوظيفة 1 المستخدم  إظهار ما إذا كان المستخدم قد قام بتسجيل الدخول إلى الطابعة. 2 المعلومات المعروضة قم بعرض معلومات الطابعة المخصصة مثل عنوان IP الخاص بالطابعة أو التاريخ والوقت. 3 المستلزم إظهار حالة المستلزمات. 4 الإخطار عرض رسالة تحذير أو رسالة خطأ من الطابعة عندما تتطلب التدخل لمتابعة المعالجة. اطلع على مزيد من المعلومات حول رسالة التحذير أو رسالة الخطأ من الطابعة، وحول كيفية مسحها. 5 طباعة طباعة الصور الفوتوغرافية والمستندات. 6 النسخ نسخ الصور الفوتوغرافية والمستندات. 7 مسح ضوئي امسح المستندات ضوئيًا. 8 الفاكس أرسل رسائل الفاكس. استخدام الشاشة الرئيسية رموز الشاشة الرئيسية"},{"UUID":"b4e7c3ad-5aa3-4ec0-a699-6a2da4267607","title":"التعرّف على الطابعة","link":"colors-of-indicator-light-topic.html","desc":"ألوان ضوء المؤشر لون ضوء","descFull":"ألوان ضوء المؤشر لون ضوء المؤشر وحالة الطابعة المناظرة له لون ضوء المؤشر حالة الطابعة إيقاف الطابعة متوقفة عن التشغيل. أزرق ثابت الطابعة جاهزة. أزرق وامض تقوم الطابعة بالطباعة أو معالجة البيانات. وميض أحمر‬‏‫ تتطلب الطابعة تدخل المستخدم. لون كهرماني ثابت الطابعة في وضع \"السكون\". لون كهرماني وامض الطابعة في وضع السكون العميق أو الإسبات. ضوء المؤشر حالة الطابعة حالة الطابعة"},{"UUID":"48a40d26-07fd-4471-b509-0de06d9b3fff","title":"التعرّف على الطابعة","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"استخدام وحدة تغذية المستندات التلقائية","descFull":"استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية تحميل الورق في درج وحدة تغذية المستندات التلقائية (ADF) وعلى زجاج الماسحة الضوئية وحدة تغذية المستندات التلقائية (ADF) زجاج الماسحة الضوئية استخدم وحدة تغذية المستندات التلقائية (ADF) لطباعة المستندات ذات الصفحات المتعددة أو المستندات على الوجهين. قم بتحميل مستند أصلي ووجه الورق نحو الأعلى. للمستندات المتعددة الصفحات، تأكد من محاذاة الحافة الأمامية قبل التحميل. تأكد من ضبط موجّهات وحدة تغذية المستندات التلقائية (ADF) لتتطابق مع عرض الورق الذي تقوم بتحميله. استخدم زجاج الماسحة الضوئية لمستندات الصفحات الفردية أو صفحات الكتب أو العناصر الصغيرة (مثل البطاقات البريدية أو الصور الفوتوغرافية) أو الورق الشفاف أو ورق الصور الفوتوغرافية أو الوسائط الرفيعة (مثل قصاصات المجلات). ضع المستند بحيث يكون وجهه لأسفل في الركن الذي يحتوي على السهم. \"النسخ\" استخدام وحدة تغذية المستندات التلقائية (ADF) \"النسخ\" استخدام زجاج الماسحة الضوئية"},{"UUID":"76b01fd6-a4d1-4255-81a9-6ac63a08c805","title":"التعرّف على الطابعة","link":"locating-security-slot-topic.html","desc":"تحديد موقع فتحة الأمان الطابعة","descFull":"تحديد موقع فتحة الأمان الطابعة مجهزة بميزة قفل أمان. صِل قفل أمان متوافق مع أغلب أجهزة الكمبيوتر المحمولة في الموقع الموضح للتأكد من تثبيت الطابعة في مكانها. تحديد موقع تحديد موفع تحديد موقع فتحة الأمان"},{"UUID":"ddc5b226-9ded-4757-a95b-d9be9e97284d","title":"تحديد نوع الورق","link":"paper-guidelines-topic.html","desc":"إرشادات الورق استخدم الورق المناسب","descFull":"إرشادات الورق استخدم الورق المناسب لتفادي حالات الانحشار والمساعدة على ضمان خلو الطباعة من المشاكل. استخدم دائماً ورق جديد غير تالف. قبل تحميل الورق، تعرف على جانب الطباعة الموصى به. عادة ما يشار إلى هذه المعلومات على عبوة الورق. لا تستخدم ورق تم قصه أو شذبه باليد. لا تخلط بين أحجام الورق أو أنواعه أو أوزانه في الدرج نفسه حيث يؤدي هذا الخلط إلى انحشار الورق. لا تستخدم الورق المطلي ما لم يتم تصميمه خصيصاً لطباعة التصوير الفوتوغرافي الإلكتروني. لمزيد من المعلومات، راجع  دليل الورق والوسائط الخاصة . ورق تحديد إرشادات الورق"},{"UUID":"85196484-a8e5-4a4c-ac87-4b40bde41b9e","title":"تحديد نوع الورق","link":"paper-guidelines-topic.html","desc":"سمات الورق تؤثر سمات الورق","descFull":"سمات الورق تؤثر سمات الورق التالية على جودة الطباعة والموثوقية. تجب مراعاة هذه العوامل قبل الطباعة عليها. الوزن يمكن للأدراج التغذية بالورق بأوزان مختلفة. قد لا يكون الورق الذي يقل وزنه عن 60 جم/متر 2  (‏16 رطلاً) صلبًا بصورة كافية لتتم تغذيته بشكل صحيح، وقد يسبب الانحشارات. للحصول على مزيد من المعلومات، راجع الموضوع \"أوزان الورق المدعومة\". طي الطي هو ميل الورق إلى أن ينحني عند الحواف. التجعد الزائد يمكن أن يتسبب في حدوث مشكلات خاصة بتغذية الورق. قد يحدث التجعد بعد مرور الورق عبر الطابعة، حيث يكون معرضاً لدرجات حرارة عالية. يمكن أن يسهم تخزين الورق بحيث يكون غير ملفوف في ظروف الحرارة أو الرطوبة أو البرودة أو الجفاف في تجعد الورق قبل الطباعة مما يؤدي إلى مشاكل في تغذية الورق. نعومة تؤثر نعومة الورق على جودة الطباعة بشكل مباشر. إذا كان الورق خشناً للغاية، فقد لا يتمكن مسحوق الحبر من الدمج بطريقة ملائمة. إذا كان الورق شديد النعومة، فقد يؤدي إلى حدوث مشكلات في تغذية الورق وجودة الطباعة. نوصي باستخدام الورق ذي 50 نقطة شيفلد. محتوى Moisture يؤثر مقدار الرطوبة في الورق على كل من جودة الطباعة وقدرة الطابعة على تغذية الورق بشكل صحيح. اترك الورق في غلافه الأصلي إلى أن تستخدمه. فقد يؤثر تعرض الورق لتغييرات الرطوبة بالسلب على أدائه. قبل الطباعة، قم بتخزين الورق في غلافه الأصلي لمدة 24 إلى 48 ساعة. يجب أن تكون البيئة التي يتم تخزين الورق فيها مماثلة لبيئة الطابعة. قم بإطالة الوقت لعدة أيام إذا كانت بيئة التخزين أو النقل مختلفة تماماً عن بيئة الطابعة. قد يتطلب الورق السميك أيضاً فترة تكييف أطول. اتجاه التحبب يشير التحبب إلى محاذاة ألياف الورق في الورقة الواحدة. يكون التحبب  طوليًا  باتجاه طول الورق، أو  عرضيًا  باتجاه عرض الورق. للحصول على توصية بشأم اتجاه التحبب، راجع الموضوع \"أوزان الورق المدعومة\". محتوى الألياف تتم صناعة ورق التصوير الجاف الأعلى جودة من لب الخشب المعالج كيميائيًا بنسبة 100 بالمئة. يوفر هذا المحتوى للورق درجة عالية من الثبات، مما يقلل من مشاكل تغذية الورق ويحقق جودة طباعة أفضل. الورق الذي يحتوي على ألياف، مثل القطن، يمكن أن يؤثر بالسلب على عملية معالجة الورق. خصائص الورق"},{"UUID":"39dfb405-0bb3-4638-9176-0285eb32873d","title":"تحديد نوع الورق","link":"paper-guidelines-topic.html","desc":"الورق غير المقبول لا يوصى","descFull":"الورق غير المقبول لا يوصى باستخدام أنواع الورق التالية مع الطابعة: الأوراق التي تمت معالجتها كيميائيًا والتي يتم استخدامها لإنشاء نُسخ من دون ورق كربون. هي تعرف أيضًا باسم الورق الذي لا يحتوي على الكربون أو ورق نسخ لا يحتوي على الكربون (CCP) أو ورق لا يتطلب كربون (NCR). الأوراق المطبوعة مسبقًا والتي تحتوي على مواد كيميائية قد تلوث الطابعة. الأوراق المطبوعة مسبقًا والتي يمكن أن تتأثر بدرجة الحرارة داخل وحدة الصهر بالطابعة. الأوراق المطبوعة مسبقًا والتي تتطلب تسجيلاً (مكان الطباعة الدقيق على الورقة) أكبر من ±2,3 مم (±0,09 بوصة). على سبيل المثال، نماذج التعرف الضوئي على الأحرف (OCR). في بعض الأحيان، يمكن ضبط التسجيل بواسطة تطبيق برنامج للطباعة بنجاح على هذه النماذج. الورق المطلي (ورق السندات القابل للمسح) أو الورق الصناعي أو الورق الحراري. الورق ذو الحواف الخشنة أو الملمس غير الأملس للغاية أو الورق المجعد. الورق الذي لا يفي بالمعيار EN12281:2002 (الأوروبي). الورق الذي يقل وزنه عن 60جم/م 2  (16رطلاً). النماذج أو المستندات متعددة القطع. الورق غير المقبول"},{"UUID":"6ac94e49-d5e2-4a0b-beef-642f19e11d43","title":"تحديد نوع الورق","link":"paper-guidelines-topic.html","desc":"تخزين الورق استخدم توجيهات تخزين","descFull":"تخزين الورق استخدم توجيهات تخزين الورق تلك للمساعدة في تجنب حالات انحشار الورق وجودة الطباعة غير المتساوية: قم بتخزين الورق في غلافه الأصلي في البيئة نفسها مثل الطابعة لمدة تتراوح بين 24 و48 ساعة قبل الطباعة. قم بإطالة الوقت لعدة أيام إذا كانت بيئة التخزين أو النقل مختلفة تماماً عن بيئة الطابعة. قد يتطلب الورق السميك أيضاً فترة تكييف أطول. للحصول على أفضل النتائج، قم بتخزين الورق في درجة حرارة تبلغ 21 درجة مئوية (70 درجة فهرنهايت) ورطوبة نسبية تبلغ 40 بالمئة. توصي معظم الشركات المُصنِّعة للملصقات بالطباعة في نطاق درجة حرارة يتراوح ما بين 18 و24 درجة مئوية (بين 65 إلى 75 درجة فهرنهايت) مع رطوبة نسبية تتراوح ما بين 40 و60 بالمئة. قم بتخزين الورق في علب كرتونية، على منصة نقالة أو رف، بدلاً من وضعها على الأرضية. خزّن العبوات الفردية على سطح مستوٍ. لا تُخزّن أي شيء فوق عبوات الورق الفردية. أخرج الورق من العبوة الكرتونية أو الغلاف فقط عندما تكون جاهزًا لتحميله في الطابعة. حيث تساعد العبوة الكرتونية أو الغلاف في الحفاظ على الورق نظيفًا، وجافًا، ومستويًا. تخزين الورق"},{"UUID":"93fff92c-397f-4d66-9f8c-7fbdb5287c38","title":"تحديد نوع الورق","link":"paper-guidelines-topic.html","desc":"تحديد النماذج المطبوعة مسبقاً والورق","descFull":"تحديد النماذج المطبوعة مسبقاً والورق ذي الرأسية استخدم الورق طويل التحبب. استخدم فقط النماذج والورق ذي الرأسية المطبوع باستخدام الطباعة الليثوغرافية (الحجرية) بالإزاحة أو عملية الطباعة بالحفر. تجنب استخدام أنواع الورق ذات الأسطح الخشنة أو المصنوعة من مادة ثقيلة. استخدم أحبار لا تتأثر بالراتينج في مسحوق الحبر. تفي الأحبار المُعدة بالأكسدة أو القائمة على الزيوت، بوجه عام، بهذه المتطلبات؛ أما أحبار عصارة الأشجار فقد لا تفي بهذه المتطلبات. اطبع عينات على النماذج المطبوعة مسبقاً والورق ذي الرأسية التي ترغب في استخدامها قبل شراء كميات كبيرة منها. يحدد هذا الإجراء ما إذا كان الحبر الموجود في النموذج المطبوع مسبقًا أو الورق ذي الرأسية يؤثر على جودة الطباعة. متى راودك الشك، اتصل بمورِّد الورق. عند الطباعة على الورق ذي الرأسية، قم بتحميل الورق بالاتجاه المناسب في الطابعة. لمزيد من المعلومات، راجع  دليل الورق والوسائط الخاصة . عند الطباعة على الورق ذي الرأسية، قم بتحميل الورق بالاتجاه المناسب في الطابعة. الورق النماذج المطبوعة مسبقًا النماذج المطبوعة مسبقًا تحديد الورق ورق ذو رأسية ورق ذو رأسية تحديد"},{"UUID":"07748160-12e3-40ed-af5c-b83986ce1ec3","title":"أحجام الورق المدعومة","link":"paper-guidelines-topic.html","desc":"أحجام الورق التي يدعمها التهيئة","descFull":"أحجام الورق التي يدعمها التهيئة الأساسي أحجام الورق التي يدعمها التهيئة الأساسي حجم الورق الاتجاه الدرج القياسي سعة 550 ورقة وحدة التغذية متعددة الأغراض طباعة على الجانبين وحدة تغذية المستندات التلقائية 1  مدعوم فقط في بعض طرازات الطابعات. 2  يتم دعمه فقط عند تهيئته من قائمة الإعداد الشامل. 3  لدعم أحجام الورق التي تتراوح بين 95 x 139.7 ملم (3.74 x 5.5 بوصة) to 297 x 355.6 ملم (11.69 x 14 بوصة). 4  الحد الأقصى لطول حجم الورق العالمي في حالة ورق الشعارات هو 1320.8 mm/52 بوصة، قم بتحميل ورقة واحدة فقط من ورق الشعارات في كل مرة. 5  لدعم أحجام الورق التي تتراوح بين 95 x 139.7 ملم (3.74 x 5.5 بوصة) to 320 x 457.2 ملم (12.6 x 18 بوصة). 6  لدعم أحجام الورق التي تتراوح بين 105 x 139.7 ملم (4.13 x 5.5 بوصة) to 320 x 457.2 ملم (12.59 x 18 بوصة). 7  لدعم أحجام الورق التي تتراوح بين 76.2 x 128 ملم (3 x 5.04 بوصة) to 297 x 432 ملم (11.69 x 17.01 بوصة). بطاقة 4×6 تغذية من الحافة القصيرة X ✓ X X تغذية من الحافة الطويلة X X X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة X X X X 1/3 A4 تغذية من الحافة القصيرة ✓ ✓ X ✓ تغذية من الحافة الطويلة X X X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة ✓ X ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ X ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة X ✓ ✓ 1 ✓ 1 JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ X ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة X ✓ ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة ✓ X ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة ✓ X ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ X ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة X ✓ ✓ ✓ 12x18 304.8 x‏ 457.2 ملم 12.0 × 18.0 بوصة تغذية من الحافة القصيرة X ✓ ✓ X SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة X ✓ ✓ X أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة ✓ ✓ X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة ✓ ✓ X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة ✓ ✓ X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة ✓ ✓ X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة ✓ ✓ X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة ✓ ✓ X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة ✓ ✓ X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X ✓ 2 X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة ✓ ✓ X X Universal غير متاح ✓ 3 ✓ 4, 5 ✓ 6 ✓ 7 أحجام الورق المدعومة أحجام الورق المدعومة"},{"UUID":"bd2b5555-3aec-4370-b9f6-6007b42095cd","title":"أحجام الورق المدعومة","link":"paper-guidelines-topic.html","desc":"أحجام الورق المدعومة في الأدراج","descFull":"أحجام الورق المدعومة في الأدراج الاختيارية حجم الورق الاتجاه درج اختياري لاستيعاب 550 ورقة درج سعة 2 x‏ 550 ورقة درج الإدخال المزدوج سعة 2000 ورقة الدرج سعة 1500ورقة 1  يتم دعمه فقط عند تهيئته من قائمة الإعداد الشامل. 2  لدعم أحجام الورق التي تتراوح بين 139.7 x 215.9 مم (5.5 x 8.5 بوصة) to 304.8 x 457.2 مم (12 x 18 بوصة). بطاقة 4×6 تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة ✓ ✓ X X تغذية من الحافة الطويلة X X X X 1/3 A4 تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ X X A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ X X JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ X ✓ JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة ✓ ✓ X X Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة ✓ ✓ X X تغذية من الحافة الطويلة X X X X Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ X X Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ X X Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ X X Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ X X Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ X X 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة ✓ ✓ X X SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة ✓ ✓ X X أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة ✓ 1 ✓ 1 X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة ✓ 1 ✓ 1 X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة ✓ ✓ X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة ✓ ✓ X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة ✓ ✓ X X Universal غير متاح ✓ 2 ✓ 2 ✓ ✓ أحجام الورق المدعومة أحجام الورق المدعومة"},{"UUID":"1f9a6387-101c-44ed-bc33-bac80aa4f467","title":"أحجام الورق المدعومة","link":"paper-guidelines-topic.html","desc":"أحجام الورق التي تدعمها حاويات","descFull":"أحجام الورق التي تدعمها حاويات الإخراج يتم تركيب وحدة نقل الورق وأي من وحدة إنهاء التدبيس أو تثقيب الفتحات أو وحدة إنهاء الكتيبات في الطابعة. حجم الورق الاتجاه نقل الورق + ‏‫وحدة إنهاء التدبيس‬، وتثقيب الفتحات نقل الورق + وحدة إنهاء الكتيبات الحاوية القياسية (صندوق الإنهاء العلوي) الحاوية 1 (وحدة التدبيس/وحدة إنهاء تثقيب الفتحات وصندوق ‬‏‫الإزاحة) الحاوية 2 (صندوق نقل الورق) الحاوية القياسية (صندوق الإنهاء العلوي) الحاوية 1 (وحدة التدبيس/وحدة إنهاء تثقيب الفتحات وصندوق ‬‏‫الإزاحة) حاوية 2 (صندوق إنهاء الكتيبات) الحاوية 3 (صندوق نقل الورق) 1  لدعم أحجام الورق التي تتراوح بين 90 x 148 مم (3.55 x 5.83 بوصة) to 320 x 600 مم (12.59 x 23.62 بوصة). 2  لدعم أحجام الورق التي تتراوح بين 90 x 148 مم (3.55 x 5.83 بوصة) to 320 x 1260 مم (12.59 x 49.6 بوصة). 3  لدعم أحجام الورق التي تتراوح بين 182 x 257 مم (7.17 x 10.12 بوصة) to 304.8 x 457.2 مم (12 x 18 بوصة). بطاقة 4×6 تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة X X X X X X ✓ A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة X X X X X X X 1/3 A4 تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة X X X X X X ✓ A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة ✓ ✓ X ✓ ✓ X ✓ أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ Universal غير متاح ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 يتم تركيب وحدة نقل الورق المزودة بخيار الطي وإما وحدة إنهاء التدبيس وتثقيب الفتحات أو وحدة إنهاء الكتيبات في الطابعة. نقل الورق مع خيار الطي + ‏‫وحدة إنهاء التدبيس‬ وتثقيب الفتحات نقل الورق مع خيار الطي + وحدة إنهاء الكتيبات حجم الورق الاتجاه الحاوية القياسية (صندوق الإنهاء العلوي) الحاوية 1 (وحدة التدبيس/وحدة إنهاء تثقيب الفتحات وصندوق ‬‏‫الإزاحة) الحاوية 2 (صندوق نقل الورق) الحاوية القياسية (صندوق الإنهاء العلوي) الحاوية 1 (وحدة التدبيس/وحدة إنهاء تثقيب الفتحات وصندوق ‬‏‫الإزاحة) حاوية 2 (صندوق إنهاء الكتيبات) الحاوية 3 (صندوق نقل الورق) 1  لدعم أحجام الورق التي تتراوح بين 90 x 148 مم (3.55 x 5.83 بوصة) to 320 x 600 مم (12.59 x 23.62 بوصة). 2  لدعم أحجام الورق التي تتراوح بين 90 x 148 مم (3.55 x 5.83 بوصة) to 297 x 1260 مم (11.69 x 49.6 بوصة). 3  لدعم أحجام الورق التي تتراوح بين 182 x 257 مم (7.17 x 10.12 بوصة) to 304.8 x 457.2 مم (12 x 18 بوصة). بطاقة 4×6 تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة X X X X X X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة X X X X X X X 1/3 A4 تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة X X X X X X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ X ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة ✓ ✓ X ✓ ✓ ✓ X SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة ✓ ✓ X ✓ ✓ X X أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X ✓ X X X ✓ الا Universal غير متاح ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 أحجام الورق المدعومة أحجام الورق المدعومة"},{"UUID":"423946cd-90ac-4fef-b89c-e45317fa789e","title":"أحجام الورق المدعومة","link":"paper-guidelines-topic.html","desc":"أحجام الورق المدعومة لمهام التدبيس","descFull":"أحجام الورق المدعومة لمهام التدبيس والتثقيب أحجام الورق المدعومة من وحدة إنهاء التدبيس‬ حجم الورق الاتجاه تدبيس فردية مزدوج الركن الأيسر المزدوج بطاقة 4×6 تغذية من الحافة القصيرة X X X تغذية من الحافة الطويلة X X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X تغذية من الحافة الطويلة X X X 1/3 A4 تغذية من الحافة القصيرة X X X تغذية من الحافة الطويلة X X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة X X X تغذية من الحافة الطويلة X X X A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ ✓ JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة X X X تغذية من الحافة الطويلة X X X Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة ✓ X X تغذية من الحافة الطويلة ✓ ✓ ✓ Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ X تغذية من الحافة الطويلة ✓ ✓ X Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ X Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ X Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة X X X SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة X X X أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X X أحجام الورق المدعومة من وحدة إنهاء التدبيس‬ وتثقيب الصفحات حجم الورق الاتجاه تدبيس تثقيب الفتحات فردية مزدوج الركن الأيسر المزدوج فتحتان ثلاث فتحات أربع فتحات بطاقة 4×6 تغذية من الحافة القصيرة X X X X X X تغذية من الحافة الطويلة X X X X X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X X X X تغذية من الحافة الطويلة X X X X X X 1/3 A4 تغذية من الحافة القصيرة X X X X X X تغذية من الحافة الطويلة X X X X X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة X X X ✓ X X تغذية من الحافة الطويلة X X X ✓ X X A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ ✓ JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة ✓ ✓ X ✓ ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة X X X ✓ X X تغذية من الحافة الطويلة X X X ✓ X X Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ ✓ Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ ✓ Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة X X X X X X SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة X X X X X X أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X X X X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X X X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X X X X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X X X X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X X X X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X X X X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X X X X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X X X X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X X X X X أحجام الورق المدعومة من وحدة إنهاء الكتيب حجم الورق الاتجاه تدبيس تثقيب الفتحات فردية مزدوج الركن الأيسر المزدوج فتحتان ثلاث فتحات أربع فتحات بطاقة 4×6 تغذية من الحافة القصيرة X X X X X X تغذية من الحافة الطويلة X X X X X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X X X X تغذية من الحافة الطويلة X X X X X X 1/3 A4 تغذية من الحافة القصيرة X X X X X X تغذية من الحافة الطويلة X X X X X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة X X X ✓ X X تغذية من الحافة الطويلة X X X ✓ X X A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ X X X تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ X X JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة ✓ ✓ X ✓ ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة X X X ✓ X X تغذية من الحافة الطويلة X X X ✓ X X Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ ✓ Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X تغذية من الحافة الطويلة ✓ ✓ ✓ ✓ ✓ ✓ Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ X X Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة X X X X X X SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة X X X X X X أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X X X X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X X X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X X X X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X X X X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X X X X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X X X X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X X X X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X X X X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X X X X X أحجام الورق المدعومة أحجام الورق المدعومة"},{"UUID":"05becc99-22ae-4a02-b61f-f8abe4623f2c","title":"أحجام الورق المدعومة","link":"paper-guidelines-topic.html","desc":"أحجام الورق المدعومة لمهام الطي","descFull":"أحجام الورق المدعومة لمهام الطي أحجام الورق المدعومة بنقل الورق مزودة بخيار الطي حجم الورق الاتجاه نقل الورق مع خيار الطي فقط طي على شكل حرف C‬ طي على شكل حرف Z طي نصف ورقة على شكل حرف Z طية على شكل حرف V حاوية قياسية حاوية قياسية حاوية قياسية حاوية قياسية بطاقة 4×6 تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X 1/3 A4 تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة X X X X A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة X X ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة X X X X Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة X X X X Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة X X X X SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة X X X X أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X X X أحجام الورق المدعومة بواسطة وحدة نقل الورق ووحدة إنهاء الكتيبات حجم الورق الاتجاه نقل الورق + وحدة إنهاء الكتيبات طي متعدد على شكل حرف V طية على شكل حرف V الحاوية 2 الحاوية القياسية والحاوية 1، والحاوية 2 بطاقة 4×6 تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X 1/3 A4 تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة X X A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة X X JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة X X Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة ✓ ✓ SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة ✓ ✓ أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X أحجام الورق المدعومة بنقل الورق مع خيار الطي ووحدة إنهاء التدبيس وتثقيب الفتحات حجم الورق الاتجاه نقل الورق مع خيار الطي + ‏‫وحدة إنهاء التدبيس‬ وتثقيب الفتحات طي على شكل حرف C‬ طي على شكل حرف Z طي نصف ورقة على شكل حرف Z طية على شكل حرف V الحاوية 2 الحاوية 2 في الحاوية القياسية، الحاوية 2 في الحاوية القياسية، الحاوية 2 بطاقة 4×6 تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X 1/3 A4 تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة X X X X A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة X X ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة X X X X تغذية من الحافة الطويلة X X X X Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة X X X X Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة X X X X Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة X X X ✓ SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة X X X ✓ أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X X X أحجام الورق مدعومة بنقل الورق مع خيار الطي ووحدة إنهاء الكتيبات حجم الورق الاتجاه نقل الورق مع خيار الطي + وحدة إنهاء الكتيبات طي على شكل حرف C‬ طي على شكل حرف Z طي نصف ورقة على شكل حرف Z طي متعدد على شكل حرف V طي على شكل حرف V الحاوية 3 الحاوية 3 الحاوية القياسية والحاوية 1، والحاوية 3 الحاوية 2 الحاوية القياسية والحاوية 1 والحاوية 2 والحاوية 3 بطاقة 4×6 تغذية من الحافة القصيرة X X X X X تغذية من الحافة الطويلة X X X X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X X X تغذية من الحافة الطويلة X X X X X 1/3 A4 تغذية من الحافة القصيرة X X X X X تغذية من الحافة الطويلة X X X X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة X X X X X تغذية من الحافة الطويلة X X X X X A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة X X X X X A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة X X X ✓ ✓ تغذية من الحافة الطويلة X X X X X JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة X X ✓ ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة X X X X X تغذية من الحافة الطويلة X X X X X Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة X X X X X تغذية من الحافة الطويلة X X X X X Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ تغذية من الحافة الطويلة X X X X X Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة X X X ✓ ✓ Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة X X X X ✓ SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة X X X X ✓ أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X X X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X X X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X X X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X X X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X X X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X X X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X X X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X X X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X X X X أحجام الورق المدعومة أحجام الورق المدعومة"},{"UUID":"a2986e0c-d207-4950-8a88-3d2e708077f0","title":"أحجام الورق المدعومة","link":"paper-guidelines-topic.html","desc":"أحجام الورق مدعومة لمهام التكديس","descFull":"أحجام الورق مدعومة لمهام التكديس مع الفصل أحجام الورق المدعومة بواسطة وحدة التكديس مع الفصل أو ‏‫وحدة إنهاء التدبيس‬ حجم الورق الاتجاه ‏‫وحدة التكديس ‏‫وحدة إنهاء التدبيس‬ 1  لدعم أحجام الورق التي تتراوح بين 90 x 148 مم (3.55 x 5.83 بوصة) to 320 x 600 مم (12.59 x 23.62 بوصة). 2  لدعم أحجام الورق التي تتراوح بين 148 x 148 مم (5.83 x 5.83 بوصة) to 297 x 431.8 مم (11.69 x 17 بوصة). بطاقة 4×6 تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X 1/3 A4 تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة ✓ X تغذية من الحافة الطويلة ✓ X Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة X X SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة X X أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة ✓ X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة ✓ X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة ✓ X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة ✓ X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة ✓ X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة ✓ X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة ✓ X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة ✓ X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة ✓ X Universal غير متاح ✓ 1 ✓ 2 أحجام الورق التي تدعمها حاويات الإخراج حجم الورق Orientation (الاتجاه) نقل الورق + ‏‫وحدة إنهاء التدبيس‬، وتثقيب الفتحات نقل الورق + وحدة إنهاء الكتيبات الحاوية 1 الحاوية 1 1  لدعم أحجام الورق التي تتراوح بين 139.7 x 148 مم (5.5 x 5.83 بوصة) to 304.8 x 600 مم (12 x 23.62 بوصة). 2  لدعم أحجام الورق التي تتراوح بين 125 x 148 مم (4.93 x 5.83 بوصة) to 304.8 x 457.2 مم (12 x 18 بوصة). بطاقة 4×6 تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X 1/3 A4 تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة ✓ ✓ SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة X X أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X Universal غير متاح ✓ 1 ✓ 2 أحجام الورق التي تدعمها صناديق الإخراج (مع خيار نقل الورق مع خيار الطي) حجم الورق الاتجاه نقل الورق مع خيار الطي + ‏‫وحدة إنهاء التدبيس‬ وتثقيب الفتحات نقل الورق مع خيار الطي + وحدة إنهاء الكتيبات الحاوية 1 الحاوية 1 1  لدعم أحجام الورق التي تتراوح بين 139.7 x 148 مم (5.5 x 5.83 بوصة) to 304.8 x 600 مم (12 x 23.62 بوصة). 2  لدعم أحجام الورق التي تتراوح بين 125 x 148 مم (4.93 x 5.83 بوصة) to 304.8 x 457.2 مم (12 x 18 بوصة). بطاقة 4×6 تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X A6 105 x‏ 148  ملم (4,13 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X 1/3 A4 تغذية من الحافة القصيرة X X تغذية من الحافة الطويلة X X A5 148 x‏ 210  ملم (5,83 x‏ 8,27 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ A4 210 x‏ 297  ملم (8,27 x‏ 11,7 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ A3 297 x‏ 420  ملم (11,69 x‏ 16,54 بوصة تغذية من الحافة القصيرة ✓ ✓ JIS B5 182 x‏ 257  ملم (7,17 x‏ 10,1 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ JIS B4 257 x‏ 364  ملم (10,12 x‏ 14,33 بوصة تغذية من الحافة القصيرة ✓ ✓ Statement 139.7 x‏ 215.9 ملم (5,5 x‏ 8,5 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ Executive 184.2 x‏ 266.7 ملم (7,25 x‏ 10,5 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ Letter 215.9 x‏ 279.4  ملم (8,5 x‏ 11 بوصة تغذية من الحافة القصيرة ✓ ✓ تغذية من الحافة الطويلة ✓ ✓ Folio 215.9 x‏ 330.2  ملم (8,5 x‏ 13 بوصة تغذية من الحافة القصيرة ✓ ✓ Oficio (المكسيك) 215.9 x‏ 340.4 ملم (8,5 x‏ 13,4 بوصة تغذية من الحافة القصيرة ✓ ✓ Legal 215.9 x‏ 355.6 ملم (8,5 x‏ 14 بوصة تغذية من الحافة القصيرة ✓ ✓ Ledger 279.4 x‏ 431.8  ملم 11 x‏ 17 بوصة تغذية من الحافة القصيرة ✓ ✓ 12x18 304.8 x‏ 457.2 ملم (12 x‏ 18 بوصة تغذية من الحافة القصيرة ✓ ✓ SRA3 320.04 x‏ 449.58 ملم (12,6 x‏ 17,7 بوصة تغذية من الحافة القصيرة X X أظرف (Choukei #3) 120 x‏ 235 ملم (4,75 x‏ 9,25 بوصة تغذية من الحافة القصيرة X X Hagaki 100 x‏ 148 ملم (3,94 x‏ 5,83 بوصة تغذية من الحافة القصيرة X X B5 ظرف 176 x‏ 250 ملم (6,93 x‏ 9,84 بوصة تغذية من الحافة القصيرة X X ظرف (Commercial #9) 98.4 x‏ 225.4 ملم (3,875 x‏ 8,9 بوصة تغذية من الحافة القصيرة X X ظرف (Commercial #10) 104.8 x‏ 241.3 ملم (4,12 x‏ 9,5 بوصة تغذية من الحافة القصيرة X X ظرف (Monarch 7‑3/4) 98.4 x‏ 190.5 ملم (3,875 x‏ 7,5 بوصة تغذية من الحافة القصيرة X X أحجام الأظرف 110 x‏ 220 ملم (4,33 x‏ 8,66 بوصة تغذية من الحافة القصيرة X X ظرف (ISO C4) 229 x‏ 324 ملم (9 x‏ 12,8 بوصة تغذية من الحافة القصيرة X X ظرف (ISO C5) 162 x‏ 229 ملم (6,38 x‏ 9 بوصة تغذية من الحافة القصيرة X X Universal غير متاح ✓ 1 ✓ 2 أحجام الورق المدعومة أحجام الورق المدعومة"},{"UUID":"0174b183-5445-406f-9d95-22bf8ceeef92","title":"تحديد نوع الورق","link":"paper-guidelines-topic.html","desc":"أوزان الورق المدعومة أوزان الورق","descFull":"أوزان الورق المدعومة أوزان الورق المدعومة أوزان الورق التي تدعمها الطابعة درج قياسي أو اختياري سعة 550 ورقة، ودرجان سعة 550 ورقة، ودرج سعة 1500 ورقة، ودرج إدخال مزدوج سعة 2000 ورقة وحدة التغذية متعددة الأغراض طباعة على الجانبين وحدة تغذية المستندات التلقائية 60–300 جم/م 2 (ورق سندات بوزن من 16 إلى 80 رطلاً) 60–300 جم/م 2 (ورق سندات بوزن من 16 إلى 80 رطلاً) 60–220 جم/م 2 (ورق سندات بوزن من 16 إلى 59 رطلاً) 50–150 جم/م 2 (ورق سندات بوزن من 14 إلى 40 رطلاً) أوزان الورق المدعومة أوزان الورق المدعومة"},{"UUID":"74a30029-b64d-4b74-80f6-afdf6186a15a","title":"تحديد نوع الورق","link":"paper-guidelines-topic.html","desc":"أنواع الورق المدعومة أنواع الورق","descFull":"أنواع الورق المدعومة أنواع الورق المدعومة أنواع الورق التي يدعمها التهيئة الأساسي حجم الورق الدرج القياسي سعة 550 ورقة وحدة التغذية متعددة الأغراض طباعة على الجانبين وحدة تغذية المستندات التلقائية الورق العادي ✓ ✓ ✓ ✓ البطاقات ✓ ✓ ✓ X معاد تدويره ✓ ✓ ✓ ✓ ورق مصقول ✓ ✓ ✓ X ثقيل ولامع ✓ ✓ ✓ X ملصقات ✓ ✓ X X ملصقات من الفينيل ✓ ✓ X X ورق فاخر ✓ ✓ ✓ ✓ ظرف ✓ ✓ X X ظرف خشن ✓ ✓ X X ورق ذو رأسية ✓ ✓ ✓ ✓ مطبوعة مسبقًا ✓ ✓ ✓ ✓ ورق ملون ✓ ✓ ✓ ✓ ورق خفيف ✓ ✓ ✓ ✓ ورق ثقيل ✓ ✓ ✓ ✓ قطني خشن ✓ ✓ ✓ X نوع مخصص ✓ ✓ ✓ ✓ أنواع الورق التي تدعمها الأدراج الاختيارية حجم الورق درج اختياري لاستيعاب 550 ورقة درج سعة 2 x‏ 550 ورقة درج الإدخال المزدوج سعة 2000 ورقة الدرج سعة 1500ورقة الورق العادي ✓ ✓ ✓ ✓ البطاقات ✓ ✓ ✓ ✓ الورق الشفاف X X X X معاد تدويره ✓ ✓ ✓ ✓ ورق مصقول ✓ ✓ ✓ ✓ ثقيل ولامع ✓ ✓ ✓ ✓ ملصقات ✓ ✓ X X ملصقات من الفينيل ✓ ✓ X X ورق فاخر ✓ ✓ ✓ ✓ ظرف ✓ ✓ X X ظرف خشن ✓ ✓ X X ورق ذو رأسية ✓ ✓ ✓ ✓ مطبوعة مسبقًا ✓ ✓ ✓ ✓ ورق ملون ✓ ✓ ✓ ✓ ورق خفيف ✓ ✓ ✓ ✓ ورق ثقيل ✓ ✓ ✓ ✓ قطني خشن ✓ ✓ ✓ ✓ نوع مخصص ✓ ✓ ✓ ✓ أنواع الورق التي تدعمها حاوية الإخراج حجم الورق نقل الورق + ‏‫وحدة إنهاء التدبيس‬، وتثقيب الفتحات نقل الورق + وحدة إنهاء الكتيبات الحاوية القياسية (صندوق الإنهاء العلوي) الحاوية 1 (وحدة التدبيس ووحدة إنهاء تثقيب الفتحات وصندوق ‬‏‫الإزاحة) الحاوية 2 (صندوق نقل الورق) الحاوية القياسية (صندوق الإنهاء العلوي) الحاوية 1 (وحدة التدبيس ووحدة إنهاء تثقيب الفتحات وصندوق ‬‏‫الإزاحة) حاوية 2 (صندوق إنهاء الكتيبات) الحاوية 3 (صندوق نقل الورق) *  الحد الأقصى لطول حجم الورق العالمي في حالة ورق الشعارات هو 1320.8 mm/52 بوصة، قم بتحميل ورقة واحدة فقط من ورق الشعارات في كل مرة. الورق العادي ✓ ✓ ✓ ✓ ✓ ✓ * ✓ البطاقات ✓ ✓ ✓ ✓ ✓ X ✓ معاد تدويره ✓ ✓ ✓ ✓ ✓ ✓ * ✓ ورق مصقول ✓ ✓ ✓ ✓ ✓ ✓ * ✓ ثقيل ولامع ✓ ✓ ✓ ✓ ✓ X ✓ ملصقات ✓ ✓ ✓ ✓ ✓ X X ملصقات من الفينيل ✓ ✓ ✓ ✓ ✓ X X ورق فاخر ✓ ✓ ✓ ✓ ✓ ✓ * ✓ ظرف X X ✓ X X X ✓ ظرف خشن X X ✓ X X X ✓ ورق ذو رأسية ✓ ✓ ✓ ✓ ✓ ✓ * ✓ مطبوعة مسبقًا ✓ ✓ ✓ ✓ ✓ ✓ * ✓ ورق ملون ✓ ✓ ✓ ✓ ✓ ✓ * ✓ ورق خفيف ✓ ✓ ✓ ✓ ✓ ✓ * ✓ ورق ثقيل ✓ ✓ ✓ ✓ ✓ X X قطني خشن ✓ ✓ ✓ ✓ ✓ X X نوع مخصص ✓ ✓ ✓ ✓ ✓ ✓ * ✓ أنواع الورق التي تدعمها حاوية الإخراج (مع خيار نقل الورق مع خيار الطي) حجم الورق نقل الورق مع خيار الطي + ‏‫وحدة إنهاء التدبيس‬ وتثقيب الفتحات نقل الورق مع خيار الطي + وحدة إنهاء الكتيبات الحاوية القياسية (صندوق الإنهاء العلوي) الحاوية 1 (وحدة التدبيس/وحدة إنهاء تثقيب الفتحات وصندوق ‬‏‫الإزاحة) الحاوية 2 (صندوق نقل الورق) الحاوية القياسية (صندوق الإنهاء العلوي) الحاوية 1 (وحدة التدبيس/وحدة إنهاء تثقيب الفتحات وصندوق ‬‏‫الإزاحة) حاوية 2 (صندوق إنهاء الكتيبات) الحاوية 3 (صندوق نقل الورق) *  الحد الأقصى لطول حجم الورق العالمي في حالة ورق الشعارات هو 1320.8 mm/52 بوصة، قم بتحميل ورقة واحدة فقط من ورق الشعارات في كل مرة. الورق العادي ✓ ✓ ✓ ✓ ✓ ✓ ✓ البطاقات ✓ ✓ ✓ ✓ ✓ X ✓ معاد تدويره ✓ ✓ ✓ ✓ ✓ ✓ ✓ ورق مصقول ✓ ✓ ✓ ✓ ✓ ✓ ✓ ثقيل ولامع ✓ ✓ ✓ ✓ ✓ X ✓ ملصقات ✓ ✓ ✓ ✓ ✓ X ✓ ملصقات من الفينيل ✓ ✓ ✓ ✓ ✓ X ✓ ورق فاخر ✓ ✓ ✓ ✓ ✓ ✓ ✓ ظرف X X ✓ X X X ✓ ظرف خشن X X ✓ X X X ✓ ورق ذو رأسية ✓ ✓ ✓ ✓ ✓ X ✓ مطبوعة مسبقًا ✓ ✓ ✓ ✓ ✓ X ✓ ورق ملون ✓ ✓ ✓ ✓ ✓ ✓ ✓ ورق خفيف ✓ ✓ ✓ ✓ ✓ ✓ ✓ ورق ثقيل ✓ ✓ ✓ ✓ ✓ X X قطني خشن ✓ ✓ ✓ ✓ ✓ X X نوع مخصص ✓ ✓ ✓ ✓ ✓ ✓ * ✓ أنواع الورق المدعومة بواسطة نقل الورق مع خيار الطي، و‏‫وحدة التكديس ووحدة إنهاء التدبيس حجم الورق نقل الورق مع خيار الطي فقط ‏‫وحدة التكديس ‏‫وحدة إنهاء التدبيس‬ الورق العادي ✓ ✓ ✓ البطاقات ✓ ✓ ✓ معاد تدويره ✓ ✓ ✓ ورق مصقول ✓ ✓ ✓ ثقيل ولامع ✓ ✓ ✓ ملصقات ✓ ✓ ✓ ملصقات من الفينيل ✓ ✓ ✓ ورق فاخر ✓ ✓ ✓ ظرف ✓ ✓ ✓ ظرف خشن ✓ ✓ ✓ ورق ذو رأسية ✓ ✓ ✓ مطبوعة مسبقًا ✓ ✓ ✓ ورق ملون ✓ ✓ ✓ ورق خفيف ✓ ✓ ✓ ورق ثقيل ✓ ✓ ✓ قطني خشن ✓ ✓ ✓ نوع مخصص ✓ ✓ ✓ أنواع الورق المدعومة بوحدة التدبيس ووحدة إنهاء تثقيب الفتحات ووحدة إنهاء الكتيبات حجم الورق صندوق الإنهاء العلوي (الحاوية القياسية) ‏‫صندوق وحدة إنهاء التدبيس‬ (صندوق 1) إزاحة تثقيب الفتحات تدبيس طي إزاحة تثقيب الفتحات تدبيس طي الورق العادي X ✓ X ✓ ✓ ✓ ✓ ✓ البطاقات X X X X ✓ X X X معاد تدويره X ✓ X ✓ ✓ ✓ ✓ ✓ ورق مصقول X ✓ X ✓ ✓ ✓ ✓ ✓ ثقيل ولامع X X X X ✓ X X X ملصقات X X X X ✓ X X X ملصقات من الفينيل X X X X ✓ X X X ورق فاخر X ✓ X ✓ ✓ ✓ ✓ ✓ ورق ذو رأسية X ✓ X ✓ ✓ ✓ ✓ ✓ مطبوعة مسبقًا X ✓ X ✓ ✓ ✓ ✓ ✓ ورق ملون X ✓ X ✓ ✓ ✓ ✓ ✓ ورق خفيف X ✓ X ✓ ✓ ✓ ✓ ✓ ورق ثقيل X X X X ✓ X X X قطني خشن X ✓ X X ✓ ✓ X X نوع مخصص X ✓ X ✓ ✓ ✓ ✓ ✓ أنواع الورق المدعومة أنواع الورق المدعومة"},{"UUID":"e83691af-0ff1-4e55-a6d4-e2e86e09628e","title":"ميزات الإضافية للطابعة والدعم","link":"supported-applications-topic.html","desc":"التطبيقات المدعومة التطبيقات وطرازات الطابعات","descFull":"التطبيقات المدعومة التطبيقات وطرازات الطابعات المدعومة لها \"تطبيق\" طرز الطابعة مركز المسح الضوئي CX833، وCX961، وCX962، وCX963، وXC8355، وXC9635، وXC9645، وXC9655 تخصيص شاشة العرض CX833، وCX961، وCX962، وCX963، وXC8355، وXC9635، وXC9645، وXC9655 دعم العملاء XC8355، XC9635، XC9645، XC9655 Device Quotas XC8355، XC9635، XC9645، XC9655 تطبيقات الطابعة التطبيقات المثبتة مسبقًا"},{"UUID":"37959800-47c2-4d33-b704-6eed69cc4946","title":"ميزات الإضافية للطابعة والدعم","link":"supported-applications-topic.html","desc":"أنواع ‏‫محركات أقراص فلاش‬ والملفات","descFull":"أنواع ‏‫محركات أقراص فلاش‬ والملفات المدعومة محركات أقراص فلاش محركات أقراص فلاش التي تدعم USB 2.0 أو الإصدارات السابقة. محركات أقراص فلاش التي تدعم نظام ملفات التكنولوجيا الجديدة (NFTS) أو نظام ملفات جدول توزيع الملفات (FAT32). أنواع الملفات أنواع الملفات المدعومة مستندات صور PDF (الإصدار 1.7 أو إصدار سابق) تنسيقات ملفات Microsoft‏ (‎DOC و‎DOCX وXLS وXLSX وPPT و‎PPTX) JPEG أو JPG TIFF أو TIF GIF BMP PNG PCX DCX محركات أقراص فلاش أنواع الملفات المدعومة"},{"UUID":"5e3754eb-6edb-4db5-b0fc-2131ebe6eb0e","title":"ميزات الإضافية للطابعة والدعم","link":"supported-applications-topic.html","desc":"الخيارات الداخلية المتوفرة القرص الثابت","descFull":"الخيارات الداخلية المتوفرة القرص الثابت الميزات المرخصة IPDS الرمز الشريطي منفذ الحلول الداخلية (ISP) من  Lexmark بطاقة تسلسلية RS‑232C MarkNet  N8230 Fiber Ethernet 100BASE-FX(LC)، 1000BASE-SX(LC) منفذ الحلول الداخلية (ISP) خيارات داخلية بطاقة البرامج الثابتة القرص الثابت"},{"UUID":"eb696a60-1bed-48ce-9741-52d50e6f5827","title":"الإعداد والتثبيت والتهيئة","link":"selecting-location-printer-topic.html","desc":"تحديد موقع للطابعة اترك مساحةً","descFull":"تحديد موقع للطابعة اترك مساحةً كافية لفتح الأدراج والأغطية والأبواب ولتركيب خيارات الجهاز. ضع الطابعة بالقرب من مأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك التيار بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. لتجنب خطر الإصابة بصدمة كهربائية، لا تضع هذا المنتج أو تستخدمه بالقرب من الماء أو المواقع الرطبة. تأكد من أن تيار الهواء في الغرفة يتوافق مع أحدث مراجعة لمعيار ASHRAE 62 أو المعيار 156 للجنة الفنية CEN. توفر سطحاً منبسطاً قوياً وثابتاً. حافظ على الطابعة: نظيفة وجافة وخالية من الأتربة. بعيدًا عن مشابك الورق والدبابيس المنحرفة. بعيدًا عن تيار الهواء المباشر الصادر عن مكيفات الهواء أو المدفآت أو أجهزة التهوية. بعيدًا عن ضوء الشمس المباشر والرطوبة العالية جدًا. مراعاة درجات الحرارة الموصى بها وتجنب التقلبات: درجات الحرارة الموصى بها درجة الحرارة في البيئة المحيطة درجة حرارة التخزين دع المقدار التالي من المسافة الموصى بها حول الطابعة للتهوية المناسبة: المسافات الفارغة الموصى بها حول الطابعة 1 لأعلى 2 خلفي 3 الجانب الأيمن 4 المقدمة 5 الجانب الأيسر الطابعة تحديد موقع تحديد موقع للطابعة الطابعة الحد الأدنى للمسافات البينية تحريك الطابعة"},{"UUID":"00cd9779-3223-4cd2-9410-39f52ec5a312","title":"الإعداد والتثبيت والتهيئة","link":"printer-ports-topic.html","desc":"منافذ الطابعة لتجنب خطر الإصابة","descFull":"منافذ الطابعة لتجنب خطر الإصابة بصدمة كهربائية، لا تقم بإعداد هذا المنتج أو بإجراء أي توصيلات كهربائية أو كبلية، مثل كبل الطاقة أو ميزة الفاكس أو الهاتف، أثناء العواصف الرعدية. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. لتجنب خطر الحريق أو التعرض لصدمة كهربائية، لا تستخدم إلا سلك التيار المرفق بهذا المنتج أو سلكًا بديلاً معتمدًا من قبل الشركة المصنعة. لتقليل مخاطر اندلاع الحريق، استخدم فقط سلكًا بمعيار 26 AWG أو كابل اتصالات (RJ-11) أكبر عند توصيل هذا المنتج بشبكة الهاتف العامة. بالنسبة إلى المستخدمين في أستراليا، يجب أن يكون السلك معتمدًا من قبل هيئة الاتصالات والإعلام الأسترالية. لتفادي فقدان البيانات أو حدوث عطل ما في الطابعة، لا تلمس كابل USB أو أي مهايئ شبكة اتصال لاسلكية أو الطابعة في المناطق الموضحة أثناء عملية الطباعة. منافذ ومقبس الطابعة ووظائفها منفذ الطابعة الوظيفة 1 منفذ وحدة الإنهاء أو الخيار قم بتوصيل الطابعة بوحدة الإنهاء أو الخيار. 2 منفذ USB قم بتركيب لوحة مفاتيح أو أي خيار متوافق. 3 منفذ LINE يتوفر فقط عند تركيب بطاقة فاكس. صِل الطابعة بشكل صحيح بخط هاتف نشط عبر مقبس حائط قياسي (RJ‑11) أو مرشح DSL أو مهايئ VoIP أو أي مهايئ آخر يسمح لك بالوصول إلى خط الهاتف لإرسال الفاكسات واستلامها. 4 منفذ EXT يتوفر فقط عند تركيب بطاقة فاكس. قم بتوصيل المزيد من الأجهزة (الهاتف أو جهاز الرد الآلي) بالطابعة وخط الهاتف. استخدم هذا المنفذ إذا لم يكن لديك خط فاكس مخصص للطابعة وإذا كانت طريقة التوصيل هذه مدعومة في بلدك أو منطقتك. 5 منفذ USB الخاص بالطابعة قم بتوصيل الطابعة بالكمبيوتر. 6 منفذ Ethernet قم بتوصيل الطابعة بالشبكة. 7 قابس سلك التيار لتوصيل الطابعة بمأخذ تيار كهربائي موصل أرضيًا على نحو سليم. منافذ الطابعة منفذ USB منفذ Ethernet قابس سلك التيار"},{"UUID":"5e675d79-efbf-4df3-87e7-a5fd9e82d9de","title":"تهيئة التطبيقات والحلول","link":"setting-up-scan-center-topic.html","desc":"إعداد مركز المسح الضوئي من","descFull":"إعداد مركز المسح الضوئي من لوحة التحكم، حدد  مركز المسح الضوئي . حدد وجهة وأنشئها، ثم قم بتهيئة الاعدادات. يتم حفظ الوجهات التي تم إنشاؤها من ملقم الويب المضمن (Embedded Web Server) فقط. لمزيد من المعلومات، راجع المستندات التي أتت مع الحل. امسح المستند ضوئيًا. مركز المسح الضوئي إعداد"},{"UUID":"5ffd188e-d6df-42de-a319-a85dc4ff69be","title":"تهيئة التطبيقات والحلول","link":"setting-up-scan-center-topic.html","desc":"استخدام تخصيص شاشة العرض استخدام","descFull":"استخدام تخصيص شاشة العرض استخدام تخصيص شاشة العرض تأكد من تمكين إعدادات شاشة التوقف وعرض الشرائح وخلفية الشاشة من Embedded Web Server. انتقل إلى  التطبيقات تخصيص شاشة العرض تهيئة . إدارة صور شاشة التوقف وعرض الشرائح في قسم صور شاشة التوقف وعرض الشرائح، أضف صورة أو قم بتحريرها أو حذفها. يمكنك إضافة ما يصل إلى 10 صور. عند تمكين الإعداد، تظهر رموز الحالة على شاشة التوقف فقط عند وجود أخطاء أو تحذيرات أو إخطارات مستندة إلى السحابة. طبّق التغييرات. تغيير صورة ورق الحائط من لوحة التحكم، حدد  تغيير الخلفية . حدد صورة لاستخدامها. طبّق التغييرات. تشغيل عرض شرائح من محرك الأقراص فلاش أدخل محرك أقراص محمول في منفذ USB. من لوحة التحكم، حدد  عرض شرائح . يمكنك إزالة محرك الأقراص الفلاش بعد أن يبدأ عرض الشرائح، لكن لا يتم تخزين الصور في الطابعة. إذا توقف عرض الشرائح، فأدخل محرك أقراص فلاش مجددًا لعرض الصور. تخصيص شاشة العرض استخدام تخصيص الشاشة تغيير ورق الحائط تشغيل عرض شرائح إدارة شاشة التوقف"},{"UUID":"058f0271-1888-44ed-bd2b-76f021b413e1","title":"تهيئة التطبيقات والحلول","link":"setting-up-scan-center-topic.html","desc":"تهيئة الإشارات المرجعية إنشاء الإشارات","descFull":"تهيئة الإشارات المرجعية إنشاء الإشارات المرجعية افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الإشارات المرجعية إضافة إشارة مرجعية ، ثم اكتب اسم إشارة مرجعية. حدد نوع بروتوكول  العنوان ، وقم بأحد الإجراءات التالية: لبروتوكولَي HTTP وHTTPS، اكتب عنوان URL الذي تريد إنشاء إشارة مرجعية له. لبروتوكول HTTPS، تأكد من استخدام اسم الجهاز المضيف بدلاً من عنوان IP. على سبيل المثال، اكتب  myWebsite.com/sample.pdf  بدلاً من  123.﻿123.123.123/sample.pdf . تأكد من أن اسم الجهاز المضيف يطابق أيضًا قيمة الاسم الشائع (CN) في شهادة الملقم. لمزيد من المعلومات حول الحصول على قيمة CN في شهادة الملقم، راجع معلومات التعليمات الخاصة بمستعرض ويب لديك. لبروتوكول FTP، اكتب عنوان بروتوكول FTP. على سبيل المثال،  myServer/myDirectory . أدخل رقم منفذ بروتوكول FTP. المنفذ 21 هو المنفذ الافتراضي لإرسال الأوامر. لبروتوكول SMB، اكتب عنوان مجلد شبكة الاتصال. على سبيل المثال،  myServer/myShare/myFile.pdf . اكتب اسم مجال شبكة الاتصال. إذا لزم الأمر، حدد نوع  المصادقة  لبروتوكول FTP وSMB. لتقييد الوصول إلى الإشارة المرجعية، أدخل رقم PIN. يدعم التطبيق أنواع الملفات التالية: PDF وJPEG وTIFF. أنواع الملفات الأخرى مثل DOCX وXLSX مدعومة في بعض طرازات الطابعات. انقر فوق  حفظ . إنشاء مجلدات افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الإشارات المرجعية إضافة مجلد ، ثم اكتب اسم مجلد. لتقييد الوصول إلى المجلد، أدخل رقم PIN. انقر فوق  حفظ . الإشارات المرجعية إنشاء إنشاء إشارات مرجعية"},{"UUID":"29c0a473-4b9f-4e0b-ba90-4c67d974c0d2","title":"تهيئة التطبيقات والحلول","link":"setting-up-scan-center-topic.html","desc":"تهيئة دفتر العناوين إضافة جهات","descFull":"تهيئة دفتر العناوين إضافة جهات اتصال افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  دفتر العناوين ، ثم انقر فوق  إضافة جهة اتصال . إذا لزم الأمر، حدد طريقة لتسجيل الدخول لتمكين الوصول إلى التطبيق. انقر فوق  حفظ . إضافة المجموعات افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  دفتر العناوين ، ثم انقر فوق  إضافة جهة اتصال . يمكنك تعيين جهة اتصال واحدة أو أكثر إلى الفريق. انقر فوق  حفظ . إضافة جهات اتصال إضافة المجموعات دفتر العناوين"},{"UUID":"4fe6d90d-39c6-4e04-9586-617068eb74ef","title":"إعداد ميزات إمكانية الوصول واستخدامها","link":"activating-voice-guidance-topic.html","desc":"تنشيط التوجيه الصوتي من الشاشة","descFull":"تنشيط التوجيه الصوتي من الشاشة الرئيسية بحركة واحدة وبواسطة إصبع واحد، قم بالتمرير ببطء إلى اليسار ثم إلى الأعلى حتى تسمع رسالة صوتية. بواسطة إصبعين، المس  موافق . إذا لم تعمل الإيماءة، فاستخدم ضغطًا أكبر. من لوحة المفاتيح اضغط باستمرار على المفتاح  5  إلى أن تسمع رسالة صوتية. اضغط على  Tab  لنقل مؤشر التركيز إلى الزر موافق، ثم اضغط على  Enter . عند تنشيط التوجيه الصوتي، استخدم دائمًا إصبعين لتحديد أي عنصر على شاشة العرض. يتمتع الإرشاد الصوتي بدعم لغة محدود. التوجيه الصوتي التنشيط تنشيط التوجيه الصوتي"},{"UUID":"e241241b-ae32-4a1b-93db-7332ffad6d24","title":"إعداد ميزات إمكانية الوصول واستخدامها","link":"activating-voice-guidance-topic.html","desc":"إلغاء تنشيط التوجيه الصوتي بحركة","descFull":"إلغاء تنشيط التوجيه الصوتي بحركة واحدة وبواسطة إصبع واحد، قم بالتمرير ببطء إلى اليسار ثم إلى الأعلى حتى تسمع رسالة صوتية. باستخدام إصبعين، قم بأحد الإجراءين التاليين: حدد  التوجيه الصوتي ، ثم حدد  موافق . حدد  إلغاء . إذا لم تعمل الإيماءة، فاستخدم ضغطًا أكبر. يؤدي الضغط على زر الطاقة أو وضع الطابعة في وضع السكون أو السبات أيضًا إلى إلغاء تنشيط التوجيه الصوتي. التوجيه الصوتي إلغاء تنشيط إلغاء تنشيط التوجيه الصوتي"},{"UUID":"f1a720cc-3922-4933-9568-203b02da6475","title":"إعداد ميزات إمكانية الوصول واستخدامها","link":"activating-voice-guidance-topic.html","desc":"التنقل ضمن الشاشة باستخدام الإيماءات","descFull":"التنقل ضمن الشاشة باستخدام الإيماءات ينطبق معظم الإيماءات فقط عندما يتم تنشيط التوجيه الصوتي. استخدم لوحة مفاتيح فعلية لكتابة أحرف وضبط إعدادات معينة. الإيماءات ووظائفها الإيماءة الوظيفة التمرير إلى اليسار ثم إلى الأعلى باستخدام إصبع واحد تشغيل وضع إمكانية الوصول أو الخروج منه. تنطبق هذه الإيماءة أيضًا عندما تكون الطابعة في الوضع العادي. الضغط المزدوج باستخدام إصبع واحد تحديد خيار أو عنصر على الشاشة. الضغط المزدوج فوق رمز الصفحة الرئيسية باستخدام إصبعين إلغاء تنشيط وضع إمكانية الوصول. الضغط الثلاثي باستخدام إصبع واحد تكبير النصوص والصور أو تصغيرها. تفعيل وضع التكبير لاستخدام ميزة التقريب. التمرير إلى اليمين أو التمرير إلى الأسفل باستخدام إصبع واحد الانتقال إلى العنصر التالي على الشاشة. التمرير إلى اليسار أو التمرير إلى الأعلى باستخدام إصبع واحد الانتقال إلى العنصر السابق على الشاشة. التمرير إلى الأعلى ثم الأسفل باستخدام إصبع واحد الانتقال إلى العنصر الأوّل على الشاشة. التحريك الوصول إلى أجزاء من الصورة المكبّرة تتخطى حدود الشاشة. استخدام إصبعين لسحب صورة مكبّرة. تمكين وضع التكبير لاستخدام إيماءة التحريك. التمرير إلى الأعلى ثم اليمين باستخدام إصبع واحد رفع مستوى الصوت. تنطبق هذه الإيماءة أيضًا عندما تكون الطابعة في الوضع العادي. التمرير إلى الأسفل ثم اليمين باستخدام إصبع واحد خفض مستوى الصوت. تنطبق هذه الإيماءة أيضًا عندما تكون الطابعة في الوضع العادي. التمرير إلى الأعلى ثم اليسار باستخدام إصبع واحد الخروج من تطبيق والعودة إلى الشاشة الرئيسية. التمرير إلى الأسفل ثم اليسار باستخدام إصبع واحد العودة إلى الإعداد السابق. التنقل ضمن الشاشة استخدام الإيماءات إيماءات الشاشة باللمس إيماءات الشاشة"},{"UUID":"461cfedd-038f-426a-bb80-7d4a92630f62","title":"إعداد ميزات إمكانية الوصول واستخدامها","link":"activating-voice-guidance-topic.html","desc":"استخدام لوحة المفاتيح على الشاشة","descFull":"استخدام لوحة المفاتيح على الشاشة عندما تظهر لوحة المفاتيح على الشاشة، قم بإجراء واحد أو أكثر مما يلي: المس مفتاحًا للفظ الحرف وكتابته في الحقل. اسحب إصبعًا عبر أحرف مختلفة للفظ الأحرف المختلفة وكتابة الحرف في الحقل. المس مربع نص باستخدام إصبعين للفظ الأحرف في الحقل. المس زر  مسافة للخلف  لحذف الأحرف. لوحة المفاتيح على الشاشة استخدام"},{"UUID":"c5280354-bf32-4c98-a410-b8fe76934c5a","title":"إعداد ميزات إمكانية الوصول واستخدامها","link":"activating-voice-guidance-topic.html","desc":"تمكين وضع التكبير بحركة واحدة","descFull":"تمكين وضع التكبير بحركة واحدة وبواسطة إصبع واحد، قم بالتمرير ببطء إلى اليسار ثم إلى الأعلى حتى تسمع رسالة صوتية. لطرازات الطابعات غير المزودة بمكبرات صوت مضمنة، استخدم سماعات الرأس لسماع الرسالة. باستخدام إصبعين، قم بما يلي: المس  وضع التكبير . المس  موافق . إذا لم تعمل الإيماءة، فاستخدم ضغطًا أكبر. للحصول على مزيد من المعلومات حول التنقل ضمن شاشة مكبرة، راجع  . وضع التكبير تمكين تمكين وضع التكبير"},{"UUID":"8f70c3e3-d9ca-439d-8c1a-bc49c81328e2","title":"إعداد ميزات إمكانية الوصول واستخدامها","link":"activating-voice-guidance-topic.html","desc":"ضبط سرعة كلام التوجيه الصوتي","descFull":"ضبط سرعة كلام التوجيه الصوتي من لوحة التحكم، انتقل إلى  الإعدادات الجهاز إمكانية الوصول سرعة الكلام . حدد سرعة الكلام. التوجيه الصوتي ضبط سرعة الكلام ضبط سرعة الكلام التوجيه الصوتي ضبط سرعة الكلام التوجيه الصوتي"},{"UUID":"73d93d16-b0d3-4958-aab0-c234c87db2c8","title":"إعداد ميزات إمكانية الوصول واستخدامها","link":"activating-voice-guidance-topic.html","desc":"ضبط مستوى صوت سماعة الرأس","descFull":"ضبط مستوى صوت سماعة الرأس الافتراضي من لوحة التحكم، انتقل إلى  الإعدادات الجهاز ‏‫إمكانية الوصول‬ . لضبط مستوى صوت سماعة الرأس. تتم إعادة تعيين مستوى الصوت إلى القيمة الافتراضية بعد خروج المستخدم من وضع إمكانية الوصول أو عندما تخرج الطابعة من وضع السكون أو الإسبات. حجم سماعة الرأس، الضبط ضبط مستوى صوت سماعة الرأس"},{"UUID":"f911d083-f810-4ee6-9e0e-0710234cf6b5","title":"إعداد ميزات إمكانية الوصول واستخدامها","link":"activating-voice-guidance-topic.html","desc":"ضبط مستوى صوت مكبر الصوت","descFull":"ضبط مستوى صوت مكبر الصوت الداخلي الافتراضي من لوحة التحكم، اسحب لليمين إلى مركز التحكم. اضبط مستوى الصوت. إذا كان الوضع الهادئ مُمكّنًا، فتكون التنبيهات المسموعة متوقفة عن التشغيل. كما يخفض هذا الإعداد أداء الطابعة. تتم إعادة تعيين مستوى الصوت إلى القيمة الافتراضية بعد خروج المُستخدم من وضع إمكانية الوصول أو عندما تخرج الطابعة من وضع السكون أو الإسبات. مستوى صوت السماعة ضبط ضبط مستوى صوت السماعة"},{"UUID":"0fa5fadf-1dc8-4d06-a8d7-47599a7281f6","title":"إعداد ميزات إمكانية الوصول واستخدامها","link":"activating-voice-guidance-topic.html","desc":"تمكين كلمات المرور أو أرقام","descFull":"تمكين كلمات المرور أو أرقام التعريف الشخصية الملفوظة من لوحة التحكم، انتقل إلى  ‎الإعدادات الجهاز إمكانية الوصول نطق كلمات المرور/أرقام التعريف الشخصية . قم بتمكين الإعداد. كلمات المرور الملفوظة تمكين أرقام التعريف الشخصية تمكين"},{"UUID":"5986c206-eaf6-4fe1-ae99-8fa2dc00d7d6","title":"إعداد الطابعة للإرسال عبر الفاكس","link":"setting-up-printer-to-fax-group.html","desc":"إعداد وظيفة الفاكس باستخدام الفاكس","descFull":"إعداد وظيفة الفاكس باستخدام الفاكس التناظري إعداد وظيفة الفاكس باستخدام الفاكس التناظري يجب أن يتم تركيب بطاقة فاكس لكي تستخدم الطابعة الفاكس التناظري. قد تكون بعض طرق الاتصال قابلة للتطبيق في بعض الدول أو المناطق فقط. إذا تم تمكين وظيفة الفاكس ولم يتم إعدادها بالكامل، فقد يومض ضوء المؤشر باللون الأحمر. إذا لم تكن لديك بيئة بروتوكول TCP/IP، فيجب عليك استخدام لوحة التحكم لإعداد الفاكس. لتفادي فقدان البيانات أو حدوث عطل في الطابعة، احرص على عدم لمس الكابلات أو الطابعة في المنطقة الموضحة أثناء قيامها بإرسال فاكس أو استلامه. استخدام لوحة التحكم من لوحة التحكم انتقل  الإعدادات الفاكس إعداد الفاكس إعدادات الفاكس العامة . قم بتهيئة الإعدادات. استخدام Embedded Web Server افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. عرض عنوان IP للطابعة على لوحة التحكم للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الإعدادات الفاكس إعداد الفاكس إعدادات الفاكس العامة . قم بتهيئة الإعدادات. طبّق التغييرات. فاكس تناظري إعداد إعداد فاكس تناظري"},{"UUID":"c91fa34c-2a62-463c-b475-8a04696f5e7e","title":"إعداد الطابعة للإرسال عبر الفاكس","link":"setting-up-printer-to-fax-group.html","desc":"إعداد وظيفة الفاكس باستخدام etherFAX","descFull":"إعداد وظيفة الفاكس باستخدام etherFAX إعداد وظيفة الفاكس باستخدام etherFAX يجب تحديث برنامج الطابعة الثابت إلى أحدث إصدار. لمزيد من المعلومات، راجع قسم \"تحديث البرنامج الثابت\". يجب تثبيت حزمة ترخيص مناسبة في الطابعة. لمزيد من المعلومات، اتصل بـ etherFAX. تأكد من قيامك بتسجيل طابعتك في مدخل etherFAX. للحصول على المزيد من المعلومات، انتقل إلى  https://www.etherfax.net/lexmark . الرقم التسلسلي للطابعة مطلوب عند التسجيل. لمزيد من المعلومات، راجع  . افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. عرض عنوان IP للطابعة على لوحة التحكم للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الإعدادات الفاكس إعداد الفاكس إعدادات الفاكس العامة . يظهر خيار  إعداد الفاكس  فقط عند تعيين  وضع الفاكس  على  الفاكس . في حقل اسم الفاكس، اكتب اسمًا فريدًا. في حقل رقم الفاكس، أدخل رقم الفاكس الذي قام etherFAX بتوفيره. من قائمة  نقل الفاكس ، حدد  etherFAX . تظهر هذه القائمة فقط عند توفر أكثر من ناقل فاكس واحد. إذا تم تركيب etherFAX في الطابعة فقط، فستتم تهيئة الطابعة تلقائيًا. طبّق التغييرات. etherFAX إعداد وظيفة الفاكس إعداد وظيفة الفاكس استخدام etherFAX"},{"UUID":"21082144-479f-407e-97ba-778d3d61c377","title":"إعداد الطابعة للإرسال عبر الفاكس","link":"setting-up-printer-to-fax-group.html","desc":"إعداد وظيفة الفاكس باستخدام ملقم","descFull":"إعداد وظيفة الفاكس باستخدام ملقم الفاكس تتيح لك هذه الميزة إرسال رسائل الفاكس إلى موفر خدمة فاكس يدعم استلام البريد الإلكتروني. تدعم هذه الميزة رسائل الفاكس الصادرة فقط. لدعم استلام الفاكس، تأكد من أن الفاكس الذي تملكه يستند إلى جهاز، مثل الفاكس التناظري أو etherFAX أو Fax over IP‏ (FoIP) وتمت تهيئته في الطابعة. افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. عرض عنوان IP للطابعة على لوحة التحكم للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الإعدادات الفاكس . من قائمة  وضع الفاكس ، حدد  خادم الفاكس ، ثم انقر فوق  حفظ . انقر فوق  إعداد ملقم الفاكس . في الحقل  تنسيق إلى ، اكتب  [#]@myfax.com ، حيث يرمز  [#]  إلى رقم الفاكس و myfax.com  إلى مجال موفر الفاكس. إذا لزم الأمر، فقم بتهيئة حقل عنوان الرد أو الموضوع أو الرسالة. للسماح للطابعة باستلام رسائل الفاكس، قم بتمكين إعداد استلام الفاكس المستند إلى جهاز. احرص على أن يكون لديك فاكس مستند إلى جهاز وتمت تهيئته. انقر فوق  حفظ . انقر فوق  إعدادات البريد الإلكتروني لملقم الفاكس ، ثم قم بتمكين  استخدام ملقم البريد الإلكتروني SMTP . إذا لم تكن الإعدادات مهيأة، فراجع  . طبّق التغييرات. ملقم الفاكس، استخدام إعداد وظيفة الفاكس إعداد وظيفة الفاكس باستخدام ملقم الفاكس"},{"UUID":"5cc443c7-2496-4efc-b71d-3a41706fd6d0","title":"إعداد الطابعة للإرسال عبر الفاكس","link":"setting-up-printer-to-fax-group.html","desc":"إعداد الفاكس باستخدام خط هاتف","descFull":"إعداد الفاكس باستخدام خط هاتف قياسي إعداد الفاكس باستخدام خط هاتف قياسي تنطبق هذه الإرشادات فقط على الطابعات المثبت عليها بطاقة فاكس. لتجنب خطر الإصابة بصدمة كهربائية، لا تقم بإعداد هذا المنتج أو بإجراء أي توصيلات كهربائية أو كبلية، مثل كبل الطاقة أو ميزة الفاكس أو الهاتف، أثناء العواصف الرعدية. لتجنب خطر الإصابة بصدمة كهربائية، لا تستخدم ميزة الفاكس أثناء العواصف الرعدية. لتقليل مخاطر اندلاع الحريق، استخدم فقط سلكًا بمعيار 26 AWG أو كابل اتصالات (RJ-11) أكبر عند توصيل هذا المنتج بشبكة الهاتف العامة. بالنسبة إلى المستخدمين في أستراليا، يجب أن يكون السلك معتمدًا من قبل هيئة الاتصالات والإعلام الأسترالية. الإعداد 1: الطابعة متصلة بخط فاكس مخصص قم بتوصيل أحد طرفَي كابل الهاتف بمنفذ الخط الخاص بالطابعة. قم بتوصيل الطرف الآخر من الكبل بمقبس هاتف تناظري نشط بالحائط. يمكن إعداد الطابعة لاستلام الفاكسات تلقائيًا (تعيين  الرد التلقائي  إلى  تشغيل ) أو يدويًا (تعيين  الرد التلقائي  إلى  إيقاف ). إذا أردت استلام الفاكسات تلقائيًا، فقم بتعيين الطابعة للرد بعد عدد محدد من الرنات. الإعداد 2: تشارك الطابعة الخط مع جهاز رد آلي إذا اشتركت في خدمة الرنات المميزة، فتأكد من تعيين نمط الرنة الصحيح للطابعة. وإلا، فلن تستلم الطابعة الفاكسات حتى لو قمت بتعيينها على استلام الفاكسات تلقائيًا. متصلة بنفس مقبس الحائط الخاص بالهاتف قم بتوصيل أحد طرفَي كابل الهاتف بمنفذ الخط الخاص بالطابعة. قم بتوصيل الطرف الآخر من الكابل بمقبس هاتف تناظري نشط بالحائط. قم بتوصيل جهاز الرد الآلي بمنفذ الهاتف المتوفر في الطابعة. متصلة بمقابس حائط مختلفة قم بتوصيل أحد طرفَي كابل الهاتف بمنفذ الخط الخاص بالطابعة. قم بتوصيل الطرف الآخر من الكابل بمقبس هاتف تناظري نشط بالحائط. إذا كنت تملك رقم هاتف واحدًا فقط على الخط المتوفر لديك، فقم بتعيين الطابعة لاستلام الفاكسات تلقائيًا. قم بتعيين الطابعة للرد على المكالمات الهاتفية بعد رنتَين لجهار الرد الآلي. على سبيل المثال، إذا كان جهاز الرد الآلي يرد على المكالمات بعد أربع رنات، فقم بتعيين إعداد الطابعة  عدد الرنات قبل الرد  إلى  6 . إعداد فاكس استخدام اتصال خط الهاتف القياسي إعداد الفاكس استخدام اتصال خط الهاتف القياسي جهاز الرد الآلي إعداد"},{"UUID":"0fd80d3f-a244-4c74-a1f0-6aacf114d143","title":"إعداد الطابعة للإرسال عبر الفاكس","link":"setting-up-printer-to-fax-group.html","desc":"إعداد الفاكس في البلدان أو","descFull":"إعداد الفاكس في البلدان أو المناطق حيث مقابس ومآخذ الحائط الخاصة بالهاتف مختلفة إعداد الفاكس في البلدان أو المناطق حيث مقابس ومآخذ الحائط الخاصة بالهاتف مختلفة تنطبق هذه الإرشادات فقط على الطابعات المثبت عليها بطاقة فاكس. لتجنب خطر الإصابة بصدمة كهربائية، لا تقم بإعداد هذا المنتج أو بإجراء أي توصيلات كهربائية أو كبلية، مثل كبل الطاقة أو ميزة الفاكس أو الهاتف، أثناء العواصف الرعدية. لتجنب خطر الإصابة بصدمة كهربائية، لا تستخدم ميزة الفاكس أثناء العواصف الرعدية. لتقليل مخاطر اندلاع الحريق، استخدم فقط سلكًا بمعيار 26 AWG أو كابل اتصالات (RJ-11) أكبر عند توصيل هذا المنتج بشبكة الهاتف العامة. بالنسبة إلى المستخدمين في أستراليا، يجب أن يكون السلك معتمدًا من قبل هيئة الاتصالات والإعلام الأسترالية. إن مقبس الحائط القياسي الذي تعتمده معظم البلدان أو المناطق هو RJ‑11. إذا كان مقبس أو معدات الحائط المتوفرة لا تتوافق مع هذا النوع من الاتصال، فاستخدم مهايئ هاتف. قد لا يُرفق مهايئ مخصّص لبلدك أو منطقتك مع الطابعة، وقد تُضطر إلى شرائه منفصلاً. قد يتوفر قابس مهايئ مثبّت في منفذ الهاتف في الطابعة. لا تخرج قابس المهايئ من منفذ الهاتف المتوفر في الطابعة إذا كنت متصلاً بنظام هاتف متسلسل أو متتالٍ. رقم قطعة قابس المهايئ اسم القطعة رقم الجزء قابس مهايئ Lexmark 40X8519 توصيل الطابعة بمقبس حائط بخلاف RJ‑11 قم بتوصيل أحد طرفَي كابل الهاتف بمنفذ الخط الخاص بالطابعة. قم بتوصيل الطرف الآخر من الكابل بمهايئ RJ‑11، ثم قم بتوصيل المهايئ بمقبس الحائط. إذا أردت توصيل جهاز آخر بموصل غير RJ‑11 بمقبس الحائط نفسه، فقم بتوصيله مباشرة بمهايئ الهاتف. إعداد الفاكس إعداد فاكس"},{"UUID":"e670f9ff-69ca-4d99-8b9e-b556561d1cca","title":"إعداد الطابعة للإرسال عبر الفاكس","link":"setting-up-printer-to-fax-group.html","desc":"توصيل بخدمة الرنة المميزة تسمح","descFull":"توصيل بخدمة الرنة المميزة تسمح لك خدمة الرنة المميزة بامتلاك عدة أرقام هاتف على خط واحد. يتم تعيين نمط رنة مختلف لكل رقم هاتف. من لوحة التحكم، انتقل إلى  الإعدادات الفاكس إعداد الفاكس إعدادات استقبال الفاكس عناصر التحكم الخاصة بالمسؤول الرد عند . حدد نمط رنة. خدمة الرنة المميزة توصيل الطابعة بخدمة الرنة المميزة تعيين نمط رنة للطابعة"},{"UUID":"2b697556-9281-48f6-b909-2b6686a2d357","title":"إعداد الطابعة للإرسال عبر الفاكس","link":"setting-up-printer-to-fax-group.html","desc":"إعداد تاريخ الفاكس ووقته إعداد","descFull":"إعداد تاريخ الفاكس ووقته إعداد تاريخ الفاكس ووقته من لوحة التحكم، انتقل إلى  الإعدادات الجهاز التفضيلات التاريخ والوقت تهيئة . قم بتهيئة الإعدادات. الإرسال عبر الفاكس ضبط التاريخ والوقت التاريخ والوقت إعدادات الفاكس"},{"UUID":"010433cd-9c11-4d3f-8400-fa1c4b1f64ef","title":"إعداد الطابعة للإرسال عبر الفاكس","link":"setting-up-printer-to-fax-group.html","desc":"تهيئة التوقيت الصيفي من لوحة","descFull":"تهيئة التوقيت الصيفي من لوحة التحكم، انتقل إلى  الإعدادات الجهاز التفضيلات التاريخ والوقت تهيئة . في القائمة  المنطقة الزمنية ، حدد  (UTC+مستخدم) مخصص . في قائمة  تهيئة ، حدد  مقابلة التوقيت الدولي المنسق . قم بتهيئة الإعدادات. تهيئة التوقيت الصيفي التوقيت الصيفي تهيئة"},{"UUID":"29482c1c-456c-4951-beac-716700b171e6","title":"إعداد الطابعة للإرسال عبر الفاكس","link":"setting-up-printer-to-fax-group.html","desc":"تهيئة إعدادات مكبر صوت الفاكس","descFull":"تهيئة إعدادات مكبر صوت الفاكس من لوحة التحكم انتقل  الإعدادات الفاكس إعداد الفاكس ‏‫إعدادات السماعة‬ . قم بما يلي: قم بتعيين  وضع مكبر الصوت  إلى  قيد التشغيل دائمًا . قم بتعيين  مستوى صوت مكبر الصوت  إلى  مرتفع . قم بتنشيط  مستوى صوت الرنين . تهيئة الإعدادات مكبر صوت الفاكس مكبر صوت الفاكس تهيئة الإعدادات"},{"UUID":"0fd292ab-1dcf-447d-a61b-cea9f48ee5bf","title":"تحميل الورق والوسائط الخاصة","link":"loading-trays-group.html","desc":"تعيين حجم الوسائط الخاصة ونوعها","descFull":"تعيين حجم الوسائط الخاصة ونوعها تعيين حجم الوسائط الخاصة ونوعها بالنسبة إلى الوسائط الخاصة مثل الملصقات أو البطاقات أو الأظرف، اتبع ما يلي: من لوحة التحكم، انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . حدد مصدر الورق، ثم قم بضبط حجم الوسائط الخاصة ونوعها. تعيين حجم الورق تحديد نوع الورق"},{"UUID":"3d71472e-f777-4ea6-8a91-4b7ecbac5f4b","title":"تحميل الورق والوسائط الخاصة","link":"loading-trays-group.html","desc":"تهيئة إعدادات الورق العام تهيئة","descFull":"تهيئة إعدادات الورق العام تهيئة إعدادات الورق العام تتيح لك قائمة  إعداد Universal  ضبط عرض وارتفاع حجم الورق الذي لم يتم تعيينه مسبقًا في الطابعة. من لوحة التحكم، انتقل إلى  الإعدادات الورق تهيئة الوسائط إعداد Universal . حدد  جميع أدراج الإدخال ، ثم قم بتهيئة الإعدادات الخاصة بحجم الورق الذي تريد تخصيصه. تعيين حجم الورق تخصيص حجم الورق"},{"UUID":"848f5712-6e8f-4001-818e-996faecc0a35","title":"تحميل الورق والوسائط الخاصة","link":"loading-trays-group.html","desc":"تحميل درج جرار سعة 550","descFull":"تحميل درج جرار سعة 550 ورقة لتقليل مخاطر عدم ثبات الجهاز، حمِّل كل درج بشكل منفرد. حافظ على إبقاء جميع الأدراج الأخرى مغلقة حتى الحاجة إليها. افتح الدرج. لتجنب انحشار الورق، لا تقم بفتح الأدراج أثناء عمل الطابعة. اضبط الموجهات لتتطابق مع حجم الورق الذي تقوم بتحميله. استخدم المؤشرات الموجودة على الجزء السفلي من الدرج لتحديد موضع الموجهات. يتم دعم الورق المثقوب مسبقًا في الدرج الجرار سعة 550 ورقة القياسي فقط. يتم دعم الورق بحجم A3 فقط في الدرج الاختياري سعة 550 ورقة. قم بثني حواف الورق وتهويتها وتسويتها قبل التحميل. حمِّل حزمة الورق بحيث يكون الوجه القابل للطباعة للأعلى. لا تحرّك الورق داخل الدرج. تأكد من تثبيت موجّهات الجوانب بإحكام على الورق. تأكد من أن ارتفاع رزمة الورق لم يتعدَ مؤشر الحد الأقصى لتعبئة الورق. قد يتسبب التحميل الزائد في انحشار الورق. قم بإدخال الدرج. إذا لزم الأمر، فعيِّن حجم الورق ونوعه ليطابقا الورق الذي تم تحميله في الدرج. عند تركيب وحدة إنهاء، يتم تدوير الصفحات بزاوية 180 درجة عند طباعتها. عند تحميل ورق ذي رأسية، نفِّذ أحد الإجراءات التالية: بدون توصيل وحدة الإنهاء مع توصيل وحدة الإنهاء الطباعة على وجه واحد، على الحافة الطويلة الطباعة على وجه واحد، على الحافة الطويلة الطباعة على وجه واحد، على حافة قصيرة الطباعة على وجه واحد، على حافة قصيرة الطباعة على الجانبين، على الحافة الطويلة الطباعة على الجانبين، على الحافة الطويلة الطباعة على الجانبين، على الحافة القصيرة الطباعة على الجانبين، على الحافة القصيرة عند تحميل الورق المثقوب مسبقًا، نفِّذ أحد الإجراءات التالية: بدون وحدة إنهاء اختيارية مع وحدة إنهاء اختيارية الطباعة على وجه واحد، على الحافة الطويلة الطباعة على وجه واحد، على الحافة الطويلة الطباعة على وجه واحد، على حافة قصيرة الطباعة على وجه واحد، على حافة قصيرة الطباعة على الجانبين، على الحافة الطويلة الطباعة على الجانبين، على الحافة الطويلة الطباعة على الجانبين، على الحافة القصيرة الطباعة على الجانبين، على الحافة القصيرة الدرج سعة 550 ورقة تحميل تحميل الدرج سعة 550 ورقة تحميل الأدراج"},{"UUID":"24b30e5b-7aac-415f-b98a-32b72e5fc6d3","title":"تحميل الورق والوسائط الخاصة","link":"loading-trays-group.html","desc":"تحميل درج الإدخال المزدوج سعة","descFull":"تحميل درج الإدخال المزدوج سعة 2000 ورقة لتقليل مخاطر عدم ثبات الجهاز، حمِّل كل درج بشكل منفرد. حافظ على إبقاء جميع الأدراج الأخرى مغلقة حتى الحاجة إليها. افتح الدرج. لتجنب انحشار الورق، لا تسحب الأدراج إلى الخارج عندما تكون الطابعة مشغولة. قم بثني حواف الورق وتهويتها وتسويتها قبل التحميل. قم بتحميل رزمة الورق إلى مقحمة الدرج الأيمن مع توجيه الجانب القابل للطباعة لأعلى. لا تحرّك الورق داخل الدرج. تأكد من أن ارتفاع رزمة الورق لم يتعدَ مؤشر الحد الأقصى لتعبئة الورق. قد يتسبب التحميل الزائد في انحشار الورق. أدخل مقحمة الدرج اليمنى في الطابعة. قم بتحميل رزمة الورق إلى مقحمة الدرج الأيسر مع توجيه الجانب القابل للطباعة لأعلى. قم بإدخال الدرج. إذا لزم الأمر، عيِّن حجم الورق ونوعه ليطابقا حجم الورق الذي تم تحميله في الدرج. عند تركيب وحدة إنهاء، يتم تدوير الصفحات بزاوية 180 درجة عند طباعتها. عند تحميل الورق ذي الرأسية للطباعة على وجه واحد، قم بتحميله بحيث يكون وجهه لأعلى مع توجيه الرأس نحو مقدمة الدرج. عند تحميل الورق ذي الرأسية للطباعة على الجانبين، قم بتحميله بحيث يكون وجهه لأسفل مع توجيه الرأس نحو مقدمة الدرج. درج الإدخال المزدوج سعة 2000 ورقة تحميل تحميل درج الإدخال المزدوج سعة 2000 ورقة تحميل الأدراج"},{"UUID":"fcf48424-e1a4-4e6d-84ec-505b5fdd3bfe","title":"تحميل الورق والوسائط الخاصة","link":"loading-trays-group.html","desc":"تحميل الدرج سعة 1500ورقة لتقليل","descFull":"تحميل الدرج سعة 1500ورقة لتقليل مخاطر عدم ثبات الجهاز، حمِّل كل درج بشكل منفرد. حافظ على إبقاء جميع الأدراج الأخرى مغلقة حتى الحاجة إليها. افتح الباب K. لتجنب انحشار الورق، لا تقم بفتح الأدراج أثناء عمل الطابعة. قم بثني حواف الورق وتهويتها وتسويتها قبل التحميل. حمِّل رزمة الورق بحيث يكون الوجه القابل للطباعة لأسفل. لا تحرّك الورق داخل الدرج. تأكد من أن ارتفاع رزمة الورق لم يتعدَ مؤشر الحد الأقصى لتعبئة الورق. قد يتسبب التحميل الزائد في انحشار الورق. أغلق الباب K. إذا لزم الأمر، عيِّن حجم الورق ونوعه ليطابقا حجم الورق الذي تم تحميله في الدرج. عند تحميل الورق ذي الرأسية للطباعة على وجه واحد، قم بتحميله بحيث يكون وجهه لأسفل مع توجيه الرأس نحو الجزء الخلفي من الطابعة. عند تحميل الورق ذي الرأسية للطباعة على الجانبين، قم بتحميله بحيث يكون وجهه لأسفل مع توجيه الرأس نحو الجزء العلوي من الطابعة. عند تحميل حجم ورق مختلف، تأكد من ضبط الموجهات. قم بما يلي: باستخدام مفك براغي مسطح الرأس، قم بإزالة المسامير اللولبية من موجهات الورق. انزع موجهات الورق. قم بمحاذاة موجّهات الورق لتتطابق مع حجم الورق الذي تقوم بتحميله. قم بتثبيت البراغي على موجهات الورق. الدرج سعة 1500ورقة تحميل تحميل الدرج"},{"UUID":"700b192f-164e-4e32-b1e6-777d0b3a65f0","title":"تحميل الورق والوسائط الخاصة","link":"loading-trays-group.html","desc":"تحميل وحدة التغذية المتعددة الأغراض","descFull":"تحميل وحدة التغذية المتعددة الأغراض قم بفتح وحدة التغذية متعددة الأغراض. اضبط موجّهات الجوانب لتتطابق مع حجم الورق الذي تقوم بتحميله. قم بثني حواف الورق وتهويتها وتسويتها قبل التحميل. قم بتحميل الورق. تأكد من تثبيت موجّهات الجوانب بإحكام على الورق. عند تحميل ورق ذي رأسية، نفِّذ أحد الإجراءات التالية: بدون توصيل وحدة الإنهاء مع توصيل وحدة الإنهاء الطباعة على وجه واحد، على الحافة الطويلة الطباعة على وجه واحد، على الحافة الطويلة الطباعة على الجانبين، على الحافة الطويلة الطباعة على الجانبين، على الحافة الطويلة عند تحميل الورق المثقوب مسبقًا، نفِّذ أي من الإجراءات التالية: بدون توصيل وحدة الإنهاء مع توصيل وحدة الإنهاء الطباعة على وجه واحد، على الحافة الطويلة الطباعة على وجه واحد، على الحافة الطويلة الطباعة على الجانبين، على الحافة الطويلة الطباعة على الجانبين، على الحافة الطويلة للأظرف‬ قم بتحميل الظرف بحيث يكون اللسان متجهًا لأعلى باتجاه الجزء الخلفي من الطابعة. قم بتحميل الظرف الأوروبي مع توجيه اللسان لأعلى للدخول إلى وحدة التغذية متعددة الأغراض أولاً. عند تركيب وحدة إنهاء، تقوم الطابعة بتدوير الصفحات إلى 180 درجة. تحميل الورق في وحدة التغذية متعددة الأغراض تحميل الورق ذي الرأسية تحميل الورق المثقب مسبقًا"},{"UUID":"3c0fec3f-f9db-4f09-920c-8a977b89ab2d","title":"تحميل الورق والوسائط الخاصة","link":"loading-trays-group.html","desc":"ربط الأدراج افتح متصفح ويب،","descFull":"ربط الأدراج افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الإعدادات الورق تهيئة الدرج . قم بتعيين حجم الورق ونوع الورق نفسهما للأدراج التي تقوم بربطها. تأكد من تحميل الأدراج المرتبطة بنفس اتجاه الورق. احفظ الإعدادات. انقر فوق  الإعدادات الجهاز الصيانة قائمة التهيئة تهيئة الدرج . قم بتعيين  ربط الأدراج  إلى  تلقائي . احفظ الإعدادات. من أجل إلغاء ربط الأدراج، تأكد من عدم وجود أدراج تتمتع بإعدادات حجم الورق ونوعه نفسها. تختلف درجة حرارة وحدة الصهر وفقًا لنوع الورق المحدد. لتجنب مشاكل الطباعة، طابق إعداد نوع الورق في الطابعة مع الورق الذي يتم تحميله في الدرج. إلغاء ربط الأدراج ربط الأدراج ربط الأدراج إلغاء ربط الأدراج"},{"UUID":"7bcfbeda-7481-4f1c-945f-e3943de402a6","title":"تثبيت البرامج وبرامج التشغيل والبرنامج الثابت وتحديثها","link":"installing-printer-software-topic.html","desc":"تثبيت برنامج الطابعة يكون برنامج","descFull":"تثبيت برنامج الطابعة يكون برنامج تشغيل الطباعة مضمنًا في حزمة مثبّت البرنامج. بالنسبة إلى أجهزة كمبيوتر Macintosh مع الإصدار 10.7 أو إصدار أحدث منه لنظام التشغيل macOS، لا تحتاج إلى تثبيت برنامج التشغيل للطباعة على طابعة تعتمد خدمة AirPrint. إذا كنت تريد ميزات طباعة مخصصة، فقم بتنزيل برنامج تشغيل الطباعة. احصل على نسخة من حزمة برنامج تثبيت البرامج. من القرص المضغوط الخاص بالبرنامج المرفق مع طابعتك. انتقل إلى  www.lexmark.com/downloads . انتقل إلى  www.dell.com/support/printers . من موقع الويب الخاص بنا أو من المكان الذي اشتريت منه الطابعة. عليك تشغيل برنامج التثبيت، ثم اتباع الإرشادات التي تظهر على شاشة الكمبيوتر. تثبيت برنامج الطابعة برنامج الطابعة تثبيت تثبيت برنامج تشغيل الطباعة برنامج تشغيل الطباعة تثبيت"},{"UUID":"f7a84f70-9f46-472b-8f7a-7529edc60696","title":"تثبيت البرامج وبرامج التشغيل والبرنامج الثابت وتحديثها","link":"installing-printer-software-topic.html","desc":"تثبيت برنامج تشغيل الفاكس انتقل","descFull":"تثبيت برنامج تشغيل الفاكس انتقل إلى  www.lexmark.com/downloads ، وابحث عن طراز طابعتك، ومن ثم قم بتنزيل حزمة المثبت المناسبة. انتقل إلى موقع الويب الخاص بنا أو المكان الذي اشتريت منه الطابعة، ومن ثم احصل على حزمة المثبت. انتقل إلى  www.dell.com/support ، ومن ثم قم بتنزيل حزمة المثبت المناسبة. من الكمبيوتر، انقر فوق  خصائص الطابعة ، ومن ثم انتقل إلى علامة التبويب  تهيئة . عليك تشغيل برنامج التثبيت، ثم اتباع الإرشادات التي تظهر على شاشة الكمبيوتر. حدد  الفاكس ، ومن ثم انقر فوق  تطبيق . برنامج تشغيل الفاكس تثبيت تثبيت برنامج تشغيل الفاكس"},{"UUID":"7d66113b-aeee-47b5-a67d-2d5491d8a937","title":"تثبيت البرامج وبرامج التشغيل والبرنامج الثابت وتحديثها","link":"installing-printer-software-topic.html","desc":"إضافة طابعات إلى الكمبيوتر قبل","descFull":"إضافة طابعات إلى الكمبيوتر قبل أن تبدأ، قم بأحد الإجراءات التالية: قم بتوصيل الطابعة والكمبيوتر بشبكة الاتصال نفسها. للحصول على مزيد من المعلومات حول توصيل الطابعة بشبكة اتصال، انظر  . قم بتوصيل الكمبيوتر بالطابعة. لمزيد من المعلومات، راجع  . قم بتوصيل الطابعة بالكمبيوتر باستخدام كابل USB. لمزيد من المعلومات، راجع  . كابل USB يُباع منفصلاً. لمستخدمي نظام التشغيل Windows قم بتثبيت برنامج تشغيل الطباعة على الكمبيوتر. لمزيد من المعلومات، راجع  . افتح  الطابعات والماسحات الضوئية ، ومن ثم انقر فوق  إضافة طابعة أو ماسحة ضوئية . وفقًا لاتصال الطابعة، قم بأحد الإجراءات التالية: حدد طابعة من القائمة، ومن ثم انقر فوق  إضافة جهاز . انقر فوق  إظهار طابعات Wi-Fi Direct ، وحدد طابعة، ومن ثم انقر فوق  إضافة جهاز . انقر فوق  الطابعة التي أريدها غير مدرجة ، ومن ثم من النافذة  إضافة طابعة ، قم بما يلي: حدد  إضافة طابعة باستخدام عنوان IP أو اسم المضيف ، ثم انقر فوق  التالي . في الحقل نوع الجهاز، حدد  جهاز TCP/IP . في حقل اسم المضيف أو عنوان IP، اكتب عنوان IP الخاص بالطابعة، ثم انقر فوق  التالي . اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. حدد برنامج تشغيل طباعة، ومن ثم انقر فوق  التالي . حدد  استخدام برنامج التشغيل المثبت حاليًا (مستحسن) ، ومن ثم انقر فوق  التالي . اكتب اسم طابعة، ومن ثم انقر فوق  التالي . انقر فوق  إنهاء . لمستخدمي Macintosh افتح  الطابعات والماسحات الضوئية . انقر فوق  إضافة طابعة أو ماسح ضوئي أو فاكس ، ثم حدد طابعة. من قائمة  إضافة طابعة  حدد برنامج تشغيل الطباعة. لاستخدام برنامج تشغيل الطباعة الخاص بـ Macintosh، حدد إما  AirPrint  أو  Secure AirPrint . إذا كنت تريد ميزات طباعة مخصصة، فحدد برنامج تشغيل الطباعة من Lexmark. لتثبيت برنامج التشغيل، انظر  . إذا كنت تريد ميزات طباعة مخصصة، فحدد برنامج تشغيل الطباعة الخاص بالشركة المصنعة. لتثبيت برنامج التشغيل، انظر  . إضافة الطابعة. إضافة طابعات إلى الكمبيوتر"},{"UUID":"7ea048f4-5b0a-451b-bdec-e54cd151d20f","title":"تثبيت البرامج وبرامج التشغيل والبرنامج الثابت وتحديثها","link":"installing-printer-software-topic.html","desc":"تصدير ملف تهيئة افتح متصفح","descFull":"تصدير ملف تهيئة افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. من Embedded Web Server (ملقم ويب المضمن)، انقر فوق  تصدير التهيئة . حدد تهيئة للتصدير. اعتمادًا على التهيئة الذي حددته، يتم تصدير الملفات بتنسيق ZIP أو CSV. تصدير ملف تهيئة ملف التهيئة تصدير"},{"UUID":"515569fa-7d69-4f91-913b-69d45050a69c","title":"تثبيت البرامج وبرامج التشغيل والبرنامج الثابت وتحديثها","link":"installing-printer-software-topic.html","desc":"استيراد ملف تهيئة افتح متصفح","descFull":"استيراد ملف تهيئة افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. من Embedded Web Server، انقر فوق  استيراد التهيئة . استعرض للوصول إلى الموقع الذي تم حفظ الملف فيه. يتم حفظ الملفات إما بتنسيق ZIP أو CSV. انقر فوق  استيراد . استيراد ملف تهيئة ملف التهيئة استيراد"},{"UUID":"4c9d230e-32a1-4b48-9e76-97d015ba9af7","title":"تثبيت البرامج وبرامج التشغيل والبرنامج الثابت وتحديثها","link":"installing-printer-software-topic.html","desc":"إضافة الخيارات المتاحة في برنامج","descFull":"إضافة الخيارات المتاحة في برنامج تشغيل الطباعة لمستخدمي نظام التشغيل Windows افتح مجلد الطابعات. حدد الطابعة التي تريد تحديثها، ثم قم بأي مما يلي: بالنسبة لنظام التشغيل Windows 7 أو الإصدارات الأحدث، حدد  خصائص الطابعة . بالنسبة للإصدارات الأقدم، حدد  خصائص . انتقل إلى علامة التبويب  تهيئة  tab، and then select  تحديث الآن ‑ اسأل الطابعة . طبّق التغييرات. لمستخدمي Macintosh افتح  الطابعات والماسحات الضوئية . انقر فوق  إضافة طابعة أو ماسح ضوئي أو فاكس ، ثم حدد طابعة. اختر برنامج تشغيل الطباعة. طبّق التغييرات. إضافة خيارات الأجهزة في برنامج تشغيل الطباعة برنامج تشغيل الطباعة إضافة خيارات الأجهزة"},{"UUID":"0b7a14c4-a4a7-4d8e-90e8-5a8f0badfbb2","title":"تحديث البرنامج الثابت","link":"installing-printer-software-topic.html","desc":"تحديث البرنامج الثابت للطابعة باستخدام","descFull":"تحديث البرنامج الثابت للطابعة باستخدام لوحة التحكم استخدام مركز الإخطار يمكن تطبيق هذه الطريقة فقط في بعض طرازات الطابعة. من لوحة التحكم، انتقل إلى مركز الإشعارات، ثم حدد  تحديث البرنامج الثابت متاح . تحديد  تثبيت الآن . تتم إعادة تشغيل الطابعة تلقائيًا بعد التحديث. استخدام القائمة \"إعدادات\" من لوحة التحكم، انتقل إلى  الإعدادات الجهاز تحديث البرنامج الثابت . وفقًا لطراز الطابعة لديك، حدد  التحقق من التحديثات  أو  التحقق من وجود تحديثات الآن . في حالة توفر تحديث جديد، حدد  تثبيت الآن . تتم إعادة تشغيل الطابعة تلقائيًا بعد التحديث. تحديث البرنامج الثابت استخدام لوحة التحكم البرنامج الثابت، تحديث استخدام لوحة التحكم"},{"UUID":"78101fa2-6e5f-49e7-8de8-25c04b26ff89","title":"تحديث البرنامج الثابت","link":"installing-printer-software-topic.html","desc":"تحديث البرنامج الثابت باستخدام Embedded","descFull":"تحديث البرنامج الثابت باستخدام Embedded Web Server قبل أن تبدأ، تأكد من أن: لقد قمت بتنزيل أحدث البرامج الثابتة للطابعة من  https://support.lexmark.com  وحفظه على محرك الأقراص المحمول أو الكمبيوتر. لنشر البرنامج الثابت للطابعة، قم باستخراج ملف البرنامج الثابت FLS من الحزمة ZIP. لقد قمت بتنزيل أحدث برنامج للطابعة وحفظته على محرك الأقراص المحمول أو الكمبيوتر. لمزيد من المعلومات، اتصل بالمكان الذي اشتريت منه الطابعة. لقد قمت بتنزيل أحدث برنامج للطابعة وحفظته على محرك الأقراص المحمول أو الكمبيوتر. لمزيد من المعلومات، اتصل بالوكيل. أنت لا تستخدم رمزًا خاصًا على طابعتك لتجنب فقدان هذه الوظيفة. تأكد من تشغيل كافة الطابعات التي تتلقى تحديثات البرنامج الثابت أثناء عملية تحديث البرنامج الثابت بأكمله. قد يؤدي إيقاف تشغيل الطابعة أثناء تحديث البرنامج الثابت إلى حدوث تلف شديد بها. إذا كانت الطابعة متصلة بالشبكة عند التحقق من وجود تحديثات، فلن يلزم تنزيل البرنامج الثابت. افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  حالة الجهاز . قم بالتمرير لأسفل وانقر فوق  تحديث البرنامج الثابت . وفقًا لطراز الطابعة لديك، انقر فوق  التحقق من التحديثات  أو  التحقق من وجود تحديثات الآن . في حالة توفر تحديث جديد، انقر فوق  أوافق، ابدأ التحديث . تتم إعادة تشغيل الطابعة تلقائيًا بعد التحديث. تحديث البرنامج الثابت استخدام Embedded Web Server البرنامج الثابت، تحديث استخدام Embedded Web Server"},{"UUID":"dd083fc9-e247-4714-a561-26616160f19e","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تركيب الدرج الاختياري سعة 550","descFull":"تركيب الدرج الاختياري سعة 550 ورقة لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. قم بإخراج الدرج الاختياري سعة 550 ورقة. لتجنب إتلاف الدرج، تأكد من إمساكه من الجانبين الأمامي والخلفي عند رفعه. قم بتركيب غطاء الدرج الأيمن. اسحب مقحمة الدرج سعة 550 ورقة للخارج. قم بإزالة غطاء الدرج العلوي. أزل البراغي. قم بتركيب غطاء الدرج السفلي. قم بتثبيت البراغي. قم بتركيب غطاء الدرج العلوي. أدخل مقحمة الدرج سعة 550 ورقة. انزع الغطاء الموجود أسفل الجانب الأيمن من الطابعة. قم بمحاذاة الطابعة مع الدرج الذي يتسع لـ 550 ورقة، ثم قم بخفضه في مكانه. إذا كان وزن الطابعة يفوق 20 كجم (44 رطلاً)، فقد يلزم وجود شخصَين أو أكثر لرفعها بأمان. اسحب مقحمة الدرج القياسية. قم بتثبيت الدرج سعة 550 ورقة بالطابعة. قم بإدخال مقحمة الدرج القياسية. قم بتثبيت الجزء الخلفي من الدرج سعة 550 ورقة بالطابعة. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. أضف الدرج إلى برنامج تشغيل الطباعة ليصبح متوفرًا لمهام الطباعة. لمزيد من المعلومات، راجع  . تركيب الدرج سعة 550 ورقة الدرج سعة 550 ورقة التثبيت خيارات الأجهزة الدرج سعة 550 ورقة"},{"UUID":"61af21b3-f379-4408-abc3-95fda63f0a21","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تركيب درج سعة 2 ×","descFull":"تركيب درج سعة 2 × 550 ورقة لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. يجب تثبيت هذا الخيار مع درج اختياري سعة 550 ورقة. ضع الخيار في أسفل التهيئة. إذا كان الدرج مثبتًا بالفعل بسعة 550 ورقة، فقم بإلغاء تثبيت الدرج، ثم قم بإزالة الغطاء الجانبي للدرج، ثم قم بإزالة غطاء الدرج السفلي، ثم ضع الدرج أعلى هذا الخيار. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. قم بإخراج الدرج سعة 2 × 550 ورقة من علبته، ثم قم بإزالة جميع مواد التغليف. قم بقفل العجلة لمنع الدرج سعة 2 × 550 ورقة من التحرك. قم بمحاذاة الدرج الذي سعة 550 ورقة مع الدرج الذي سعة 2 × 550 ورقة، ثم قم بخفضه في مكانه. لتجنب إتلاف الدرج، تأكد من الإمساك بالجوانب الأمامية والخلفية عند رفع الدرج. اسحب مقحمة الدرج سعة 550 ورقة للخارج. قم بتثبيت الدرج سعة 550 ورقة في الدرج سعة 2 × 550 ورقة. أدخل مقحمة الدرج سعة 550 ورقة. قم بتثبيت الجزء الخلفي من الدرج سعة 550 ورقة في الدرج سعة 2 × 550 ورقة. انزع الغطاء الموجود أسفل الجانب الأيمن من الطابعة. قم بمحاذاة الطابعة مع الأدراج الاختيارية، ثم قم بخفضها في مكانها. إذا كان وزن الطابعة يفوق 20 كجم (44 رطلاً)، فقد يلزم وجود شخصَين أو أكثر لرفعها بأمان. اسحب مقحمة الدرج القياسية. قم بتثبيت الدرج سعة 550 ورقة بالطابعة. قم بإدخال مقحمة الدرج القياسية. قم بتثبيت الجزء الخلفي من الدرج سعة 550 ورقة بالطابعة. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. أضف الدرج إلى برنامج تشغيل الطباعة ليصبح متوفرًا لمهام الطباعة. لمزيد من المعلومات، راجع  . درج سعة 2 x‏ 550 ورقة التثبيت خيارات الأجهزة درج سعة 2 x‏ 550 ورقة تركيب الدرج سعة 2 ×‏ 550 ورقة"},{"UUID":"5ecab549-db71-44d0-a4bb-b8c3db990dbf","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تثبيت درج الإدخال المزدوج سعة","descFull":"تثبيت درج الإدخال المزدوج سعة 2000 ورقة تثبيت درج الإدخال المزدوج سعة 2000 ورقة لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. يجب تثبيت هذا الخيار مع درج اختياري سعة 550 ورقة. تم ضع هذا الخيار في أسفل التهيئة. إذا كان الدرج مثبتًا بالفعل بسعة 550 ورقة، فقم بإلغاء تثبيت الدرج، ثم قم بإزالة الغطاء الجانبي للدرج، ثم قم بإزالة غطاء الدرج السفلي، ثم ضع الدرج أعلى هذا الخيار. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. قم بإخراج الدرج المزدوج من عبوته، ثم قم بإزالة جميع مواد التغليف. أقفل العجلة لمنع الدرج المزدوج من التحرك. D قم بمحاذاة الدرج المزدوج سعة 550 ورقة مع الدرج المزدوج، ثم قم بخفضه في مكانه. لتجنب إتلاف الدرج، تأكد من الإمساك بالجوانب الأمامية والخلفية عند رفع الدرج. اسحب مقحمة الدرج سعة 550 ورقة للخارج. قم بتثبيت الدرج سعة 550 ورقة في الدرج المزدوج. أدخل مقحمة الدرج. قم بتثبيت الجزء الخلفي من الدرج سعة 550 ورقة في الدرج المزدوج. انزع الغطاء الموجود أسفل الجانب الأيمن من الطابعة. قم بمحاذاة الطابعة مع الأدراج الاختيارية، ثم قم بخفضها في مكانها. إذا كان وزن الطابعة يفوق 20 كجم (44 رطلاً)، فقد يلزم وجود شخصَين أو أكثر لرفعها بأمان. اسحب الدرج القياسي إلى الخارج. قم بتثبيت الدرج سعة 550 ورقة بالطابعة. قم بإدخال الدرج. قم بتثبيت الجزء الخلفي من الدرج سعة 550 ورقة بالطابعة. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. أضف الدرج إلى برنامج تشغيل الطباعة ليصبح متوفرًا لمهام الطباعة. لمزيد من المعلومات، راجع  . درج الإدخال المزدوج سعة 2000 ورقة التثبيت خيارات الأجهزة درج الإدخال المزدوج سعة 2000 ورقة تثبيت درج الإدخال المزدوج سعة 2000 ورقة"},{"UUID":"589ca4db-42ea-407e-9f59-c52c6f39fff6","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تركيب الخزانة لمنع خطر التعرض","descFull":"تركيب الخزانة لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. يجب تثبيت هذا الخيار مع درج سعة 550 ورقة. ضع هذا الخيار في أسفل التهيئة. إذا كان الدرج سعة 550 مثبتًا بالفعل، فقم بإزالة الدرج، ثم قم بإزالة غطاء الدرج السفلي وضعه فوق هذا الخيار. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بفك العلبة، ثم قم بتجميع الخزانة. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. أقفل العجلة لمنع الخزانة من التحرك. قم بتركيب الغطاء الجانبي للدرج سعة 550 ورقة. قم بمحاذاة الدرج مع خزانة الطابعة، ثم اخفضه إلى مكانه. لتجنب إتلاف الدرج، تأكد من إمساكه من الجانبين الأمامي والخلفي عند رفعه. اسحب مقحمة الدرج. ثبّت الدرج في الخزانة. أدخل مقحمة الدرج. قم بتثبيت الجزء الخلفي من الدرج بالخزانة. انزع الغطاء الموجود أسفل الجانب الأيمن من الطابعة. قم بمحاذاة الطابعة مع الخزانة والدرج، ثم أنزلها في مكانها. إذا كان وزن الطابعة يفوق 20 كجم (44 رطلاً)، فقد يلزم وجود شخصَين أو أكثر لرفعها بأمان. اسحب مقحمة الدرج القياسية. قم بتثبيت الدرج سعة 550 ورقة بالطابعة. قم بإدخال مقحمة الدرج القياسية. قم بتثبيت الجزء الخلفي من الدرج سعة 550 ورقة بالطابعة. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. خزانة تثبيت خيارات الأجهزة خزانة تثبيت الخزانة"},{"UUID":"70b3aff6-3b8c-4526-b9b4-773604b7dc0f","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تركيب درج سعة 1500 ورقة","descFull":"تركيب درج سعة 1500 ورقة لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. قبل تثبيت هذا الخيار، تأكد من تركيب درج اختياري سعة 550 ورقة وأي من درج 2 × 500 ورقة أو درج جرار سعة 2000 ورقة بالفعل. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. قم بإزالة غطاء الاتصال. لا تتخلص من الغطاء. قم بإزالة غطاء المنفذ. لا تتخلص من الغطاء. قم بإزالة أغطية البراغي من الطابعة. لا تتخلص من أغطية البراغي. قم بإخراج الدرج سعة 1500 ورقة من عبوته، ثم قم بإزالة جميع مواد التغليف. قم بتثبيت البراغي لحامل التثبيت. قم بتركيب حامل التثبيت على الطابعة. استخدم دعامة التثبيت والبراغي المرفقة مع الدرج سعة 1500 ورقة. قم بتثبيت البراغي المتبقية. قم بتثبيت درج سعة 1500 ورقة قم بتوصيل كابل الدرج بالطابعة. قم بتركيب غطاء كابل الدرج. قم بتحريك الدرج الذي يتسع لـ 1500 ورقة باتجاه الطابعة. قم بتوصيل أحد طرفَي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. أضف الدرج إلى برنامج تشغيل الطباعة ليصبح متوفرًا لمهام الطباعة. لمزيد من المعلومات، راجع  . تركيب الدرج الجرار سعة 1500 ورقة الدرج سعة 1500ورقة التثبيت خيارات الأجهزة الدرج سعة 1500ورقة"},{"UUID":"5805f205-a810-41c4-890f-4abe4133c92b","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تركيب وحدة إنهاء التدبيس تركيب","descFull":"تركيب وحدة إنهاء التدبيس تركيب وحدة إنهاء التدبيس لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. أخرج وحدة إنهاء التدبيس من العبوة، ثم أزل كل مواد التغليف. قم بتثبيت دليل التغذية. انزع الحاوية القياسية. لا تتخلص من الصندوق. قبل تثبيت الخيار، ضع علامة صندوق الخروج في الوضع المغلق. عند إزالة الخيار، ضع علامة صندوق الخروج في الوضع المفتوح. قم بإزالة الأسطوانة الاحتياطية. لا تتخلص من الأسطوانة. أدخل أسطوانة التغذية المرفقة مع وحدة إنهاء التدبيس حتى تسمع صوت  طقطقة  عند تركيبها في مكانها. تأكد من وجود الزنبرك المعدني أمام أسطوانة التغذية. قم بتركيب اسطوانة وحدة التدبيس حتى  تسمع صوت  استقرارها في مكانها. افتح الباب الأمامي، ثم قم بإزالة الغطاء الموجود على الجانب الأيسر من الطابعة. لا تتخلص من البرغي والغطاء. قم بإزالة الغطاء الخلفي الأيسر. لا تتخلص من البرغي والغطاء. قم بإزالة غطاء الصندوق الداخلي. لا تتخلص من الغطاء. قم بمحاذاة، ثم أدخل غطاء الصندوق الداخلي الذي يأتي مع وحدة إنهاء الدبابيس. قم بتثبيت البراغي على غطاء الصندوق الداخلي. قم بتوصيل شريط تمرير وحدة إنهاء التدبيس‬. أدخل وحدة إنهاء التدبيس. قم بتثبيت حامل التثبيت لتثبيت وحدة الإنهاء بالطابعة. استخدم البرغي الذي كان مزودًا مع وحدة الإنهاء. قم بتركيب الغطاء الخلفي الأيسر، ثم قم بتحريك وحدة إنهاء الدبابيس إلى اليسار. قم بتركيب غطاء الكسوة العلوي الأيسر المرفق مع وحدة الإنهاء. أدخل خرطوشة الدبابيس في وحدة الإنهاء حتى تصدر  صوت  استقرارها في مكانها. أغلق الباب الأمامي، ثم قم بتحريك وحدة الإنهاء باتجاه الطابعة. قم بتوصيل كابل الخيار بالطابعة. قم بتوصيل أحد طرفَي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. أضف وحدة الإنهاء في برنامج تشغيل الطباعة لتصبح متوفرة لمهام الطباعة. لمزيد من المعلومات، راجع  . تثبيت وحدة إنهاء التدبيس ‏‫وحدة إنهاء التدبيس‬ تثبيت خيارات الأجهزة ‏‫وحدة إنهاء التدبيس‬"},{"UUID":"e5ea872d-9596-4c10-94ac-4bba459eabc8","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تثبيت ‏‫وحدة التكديس مع الفصل","descFull":"تثبيت ‏‫وحدة التكديس مع الفصل تثبيت ‏‫وحدة التكديس مع الفصل لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. أخرج ‏‫وحدة التكديس مع الفصل من العبوة، ثم أزل كل مواد التغليف. قم بتوصيل الغطاء الخلفي الداخلي بوحدة التكديس مع الفصل. انزع الحاوية القياسية. لا تتخلص من الصندوق. قم بإزالة غطاء موصل نقل الورق. لا تتخلص من الغطاء. قبل تثبيت الخيار، ضع علامة صندوق الخروج في الوضع المغلق. قم بمحاذاة مع الفصل ثم قم بتثبيتها على الطابعة.  تأكد من تثبيت القطع بشكل آمن ومحاذاتها مع الطابعة. قم بتوصيل الأشرطة الواقية الخاصة بوحدة التكديس مع الفصل بالطابعة. ضع علامة صندوق الخروج في الوضع المفتوح. قم بتركيب غطاء علم الصندوق حتى  تسمع صوت  استقرارها في مكانها. قم بتوصيل أحد طرفَي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. أضف وحدة التكديس في برنامج تشغيل الطباعة لتصبح متوفرة لمهام الطباعة. لمزيد من المعلومات، راجع  . وحدة التكديس مع الفصل التركيب تثبيت وحدة التكديس مع الفصل خيارات الأجهزة التثبيت"},{"UUID":"167fd89e-88bd-4159-8020-3445a8b6f26b","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تثبيت وحدة نقل الورق مع","descFull":"تثبيت وحدة نقل الورق مع خيار الطي لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. يمكن أيضًا تثبيت هذا الخيار مع وحدة إنهاء التدبيس أو تثقيب الفتحات أو وحدة إنهاء الكتيبات. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. قم بفك حاوية نقل الورق باستخدام خيار الطي، ثم قم بإزالة جميع مواد التغليف. انزع الحاوية القياسية. لا تتخلص من الصندوق. قبل تثبيت الخيار، ضع علامة صندوق الخروج في الوضع المغلق. عند إزالة الخيار، ضع علامة صندوق الخروج في الوضع المفتوح. قم بإزالة الأسطوانة الاحتياطية. لا تتخلص من الأسطوانة. أدخل أسطوانة التغذية المرفقة مع الخيار حتى تسمع صوت  طقطقة  عند استقراره في مكانه. تأكد من وجود الزنبرك المعدني أمام أسطوانة التغذية. قم بتركيب اسطوانة وحدة التدبيس حتى  تسمع صوت  استقرارها في مكانها. افتح الباب الأمامي، ثم قم بإزالة الغطاء الموجود على الجانب الأيسر من الطابعة. لا تتخلص من البرغي والغطاء. أغلق الباب الأمامي. قم بإزالة غطاء موصل نقل الورق. لا تتخلص من الغطاء. قم بإزالة الغطاء الخلفي الأيسر. لا تتخلص من البرغي والغطاء. قم بإزالة غطاء الصندوق الداخلي. لا تتخلص من البرغي والغطاء. قم بالمحاذاة، ثم أدخل غطاء الحاوية الداخلي الذي يأتي مع الخيار. قم بتثبيت البراغي على غطاء الصندوق الداخلي. نعلق قطع الشريط الرغوي على الخيار. افتح الباب F، ثم أحكم ربط البراغي. أغلق الباب F. قم بتركيب حامل التثبيت المعدني بالخيار. أدخل الخيار. تأكد من وجود حامل التثبيت المعدني أمام الطابعة. افتح الباب F، ثم استخدم مفك البراغي المرفق مع الخيار، وقم بتثبيت البرغي. أغلق الباب F. قم بتثبيت البراغي في الخيار. قم بتركيب الغطاء الخلفي الأيسر. افتح الباب الأمامي، ثم قم بتركيب الغطاء الموجود على الجانب الأيسر من الطابعة. أغلق الباب الأمامي. ارفع غطاء السلة، ثم قم بمحاذاة حاوية الخيارات وإرفاقها. قم بتثبيت البراغي في صندوق الخيار. تركيب غطاء القطع. قم بتوصيل كابل الخيار بالطابعة. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. خيارات الأجهزة نقل الورق مع خيار الطي نقل الورق مع خيار الطي تثبيت"},{"UUID":"83bc2e18-fe40-4c8b-b1f8-cb05ebc276b6","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تثبيت وحدة إنهاء التدبيس وتثقيب","descFull":"تثبيت وحدة إنهاء التدبيس وتثقيب الفتحات وخيار نقل الورق لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. قم بفك نقل الورق. انزع الحاوية القياسية. لا تتخلص من الصندوق. قبل تثبيت الخيار، ضع علامة صندوق الخروج في الوضع المغلق. عند إزالة الخيار، ضع علامة صندوق الخروج في الوضع المفتوح. قم بإزالة الأسطوانة الاحتياطية. لا تتخلص من الأسطوانة. أدخل أسطوانة التغذية المرفقة مع نقل الورق حتى تسمع صوت  طقطقة  عند استقرارها في مكانها. تأكد من وجود الزنبرك المعدني أمام أسطوانة التغذية. قم بتركيب الغطاء حتى  تسمع صوت  استقراره في مكانه. افتح الباب الأمامي، ثم قم بإزالة الغطاء الموجود على الجانب الأيسر من الطابعة. لا تتخلص من البرغي والغطاء. أغلق الباب الأمامي. قم بإزالة غطاء موصل نقل الورق. لا تتخلص من الغطاء. أزل الغطاء. لا تتخلص من الغطاء. قم بتركيب حامل التثبيت المعدني. أدخل نقل الورق. افتح المقبض G، ثم قم بتثبيت البرغي في مقدمة وحدة نقل الورق. مقبض إغلاق G. قم بتركيب البرغي في الجزء الخلفي من وحدة نقل الورق. افتح الباب الأمامي، ثم قم بتركيب الغطاء المرفق مع وحدة نقل الورق بالجانب الأيسر من الطابعة. أغلق الباب الأمامي. أخرج وحدة إنهاء تثقيب الفتحات ووحدة التدبيس من علبتها. قم بتثبيت المثبت. قم بإزالة قطع الشريط حول وحدة الإنهاء. قم بتركيب حامل التثبيت على وحدة الإنهاء. قم بتوصيل الشريط الرغوي بوحدة الإنهاء. قم بتركيب موجّه التغذية بوحدة الإنهاء. قم بتوصيل الصندوق بوحدة الإنهاء. افتح باب وحدة الإنهاء، ثم أدخل صندوق تثقيب الفتحات. ضع موسع الحاوية في صندوق الإنهاء. يتم استخدام موسع الحاوية للورق بحجم A3 أو أطول وفي ظروف الرطوبة العالية للمساعدة في تكديس الورق. يتم تقليل سعة الحاوية عند استخدام موسع الحاوية. أغلق باب وحدة الإنهاء. قم بتركيب حامل التثبيت على الطابعة. تأكد من محاذاة البراغي مع العلامات الموجودة على حامل التثبيت. قم بتوصيل حامل التثبيت المعدني المرفق مع وحدة نقل الورق بالطابعة. افتح باب وحدة الإنهاء، وقم بإزالة البرغي، ثم اسحب قفل وحدة الإنهاء. قم بتوصيل وحدة الإنهاء بالطابعة. قم بتثبيت وحدة الإنهاء بالطابعة، ثم قم بتثبيت البرغي. قم بتوصيل كابل وحدة الإنهاء بالطابعة. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. خيارات الأجهزة نقل الورق خيارات الأجهزة وحدة إنهاء التدبيس، تثقيب الفتحات نقل الورق التثبيت وحدة إنهاء التدبيس، تثقيب الفتحات التثبيت"},{"UUID":"fb4056c8-db6b-4028-8aea-1eb3acae3bfb","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تثبيت وحدة إنهاء التدبيس وتثقيب","descFull":"تثبيت وحدة إنهاء التدبيس وتثقيب الفتحات ونقل الورق مع خيار الطي لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. قم بفك حاوية نقل الورق باستخدام خيار الطي، ثم قم بإزالة جميع مواد التغليف. انزع الحاوية القياسية. لا تتخلص من الصندوق. قبل تثبيت الخيار، ضع علامة صندوق الخروج في الوضع المغلق. عند إزالة الخيار، ضع علامة صندوق الخروج في الوضع المفتوح. قم بإزالة الأسطوانة الاحتياطية. لا تتخلص من الأسطوانة. أدخل أسطوانة التغذية المرفقة مع الخيار حتى تسمع صوت  طقطقة  عند استقراره في مكانه. تأكد من وجود الزنبرك المعدني أمام أسطوانة التغذية. قم بتركيب الغطاء حتى  تسمع صوت  استقراره في مكانه. افتح الباب الأمامي، ثم قم بإزالة الغطاء الموجود على الجانب الأيسر من الطابعة. لا تتخلص من البرغي والغطاء. أغلق الباب الأمامي. قم بإزالة غطاء موصل نقل الورق. لا تتخلص من الغطاء. قم بإزالة الغطاء الخلفي الأيسر. لا تتخلص من البرغي والغطاء. قم بإزالة غطاء الصندوق الداخلي. لا تتخلص من البرغي والغطاء. قم بمحاذاة الغطاء الداخلي للصندوق الذي يأتي مع ناقلة الورق مع خيار الطي، ثم أدخله. قم بتثبيت البراغي على غطاء الصندوق الداخلي. نعلق قطع الشريط الرغوي على الخيار. افتح الباب F، ثم أحكم ربط البراغي. أغلق الباب F. قم بتركيب حامل التثبيت بالخيار. أدخل الخيار. تأكد من وجود حامل التثبيت المعدني أمام الطابعة. افتح الباب F، ثم استخدم مفك البراغي المرفق مع الخيار، وقم بتثبيت البرغي. أغلق الباب F. قم بتثبيت البراغي في الخيار. قم بتركيب الغطاء الخلفي الأيسر. أخرج وحدة إنهاء تثقيب الفتحات ووحدة التدبيس من علبتها. قم بتثبيت المثبت. قم بإزالة قطع الشريط حول وحدة الإنهاء. قم بتركيب حامل التثبيت على وحدة الإنهاء. قم بتوصيل الشريط الرغوي بوحدة الإنهاء. قم بإزالة جرعة الرغوة الصغيرة الموجودة على الجانب الأيمن من وحدة الإنهاء. قم بتركيب موجّه التغذية بوحدة الإنهاء. قم بتوصيل الصندوق بوحدة الإنهاء. افتح باب وحدة الإنهاء، ثم أدخل صندوق تثقيب الفتحات. ضع موسع الحاوية في صندوق الإنهاء. يتم استخدام موسع الحاوية للورق بحجم A3 أو أطول وفي ظروف الرطوبة العالية للمساعدة في تكديس الورق. يتم تقليل سعة الحاوية عند استخدام موسع الحاوية. أغلق باب وحدة الإنهاء. ارفع غطاء السلة، ثم قم بمحاذاة الغطاء وإرفاقه بالخيار. قم بتثبيت البراغي. افتح الباب الأمامي، ثم قم بتثبيت غطاء الكسوة المرفق مع الخيار. قم بتركيب حامل التثبيت على الطابعة. تأكد من محاذاة البراغي مع العلامات الموجودة على حامل التثبيت. افتح باب وحدة الإنهاء، وقم بإزالة البرغي، ثم اسحب قفل وحدة الإنهاء. قم بتوصيل كابل الخيار بالطابعة. قم بتوصيل كابل الإنهاء بالخيار. قم بتوصيل وحدة الإنهاء بالطابعة. قم بتثبيت وحدة الإنهاء بالطابعة، ثم قم بتثبيت البرغي. أغلق باب وحدة الإنهاء. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. خيارات الأجهزة نقل الورق مع خيار الطي خيارات الأجهزة وحدة إنهاء التدبيس، تثقيب الفتحات نقل الورق مع خيار الطي تثبيت وحدة إنهاء التدبيس، تثقيب الفتحات تثبيت"},{"UUID":"78f26813-75f4-4af0-8342-9779cade90aa","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تثبيت خيار وحدة إنهاء الكتيبات","descFull":"تثبيت خيار وحدة إنهاء الكتيبات ونقل الورق لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. قم بفك نقل الورق. انزع الحاوية القياسية. لا تتخلص من الصندوق. قبل تثبيت الخيار، ضع علامة صندوق الخروج في الوضع المغلق. عند إزالة الخيار، ضع علامة صندوق الخروج في الوضع المفتوح. قم بإزالة الأسطوانة الاحتياطية. لا تتخلص من الأسطوانة. أدخل أسطوانة التغذية المرفقة مع نقل الورق حتى تسمع صوت  طقطقة  عند استقرارها في مكانها. تأكد من وجود الزنبرك المعدني أمام أسطوانة التغذية. قم بتركيب اسطوانة وحدة التدبيس حتى  تسمع صوت  استقرارها في مكانها. افتح الباب الأمامي، ثم قم بإزالة الغطاء الموجود على الجانب الأيسر من الطابعة. لا تتخلص من البرغي والغطاء. أغلق الباب الأمامي. قم بإزالة غطاء موصل نقل الورق. لا تتخلص من الغطاء. أزل الغطاء. لا تتخلص من الغطاء. قم بتركيب حامل التثبيت المعدني. أدخل نقل الورق. افتح المقبض G، ثم قم بتثبيت البرغي في مقدمة وحدة نقل الورق. مقبض إغلاق G. قم بتركيب البرغي في الجزء الخلفي من وحدة نقل الورق. افتح الباب الأمامي، ثم قم بتركيب الغطاء المرفق مع وحدة نقل الورق بالجانب الأيسر من الطابعة. أغلق الباب الأمامي. قم بفك تغليف وحدة إنهاء الكتيبات، ثم أزل كل مواد التغليف. قم بتركيب حامل التثبيت على وحدة الإنهاء. قم بتوصيل الشريط الرغوي بوحدة الإنهاء. قم بتركيب موجّه التغذية بوحدة الإنهاء. قم بتوصيل الصندوق العلوي بوحدة الإنهاء. ارفع غطاء الحاوية، ثم قم بتركيب الحاوية السفلية بوحدة الإنهاء. افتح باب وحدة الإنهاء. قم بإزالة مادة التغليف من صندوق الثقب، ثم أدخلها في وحدة الإنهاء. ضع موسع الحاوية على حاوية الإنهاء. يتم استخدام موسع الحاوية للورق بحجم A3 أو أطول وفي ظروف الرطوبة العالية للمساعدة في تكديس الورق. يتم تقليل سعة الحاوية عند استخدام موسع الحاوية. قم بتركيب السلة في الجزء الخلفي من وحدة الإنهاء. أغلق باب وحدة الإنهاء. قم بتركيب حامل التثبيت على الطابعة. تأكد من محاذاة البراغي مع العلامات الموجودة على حامل التثبيت. قم بتركيب حامل التثبيت المرفق مع ناقلة الورق بالطابعة. افتح باب وحدة الإنهاء، وقم بإزالة البرغي، ثم اسحب قفل وحدة الإنهاء. قم بتوصيل وحدة الإنهاء بالطابعة. قم بتثبيت وحدة الإنهاء بالطابعة، ثم قم بتثبيت البرغي. أغلق باب وحدة الإنهاء. قم بتوصيل كابل وحدة الإنهاء بالطابعة. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. تثبيت نقل الورق تثبيت نقل الورق تثبيت وحدة إنهاء الكتيبات تثبيت وحدة إنهاء الكتيبات"},{"UUID":"abb43bcd-a5b3-4322-b3ef-bd28dd37865b","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تركيب وحدة إنهاء الكتيبات ونقل","descFull":"تركيب وحدة إنهاء الكتيبات ونقل الورق مع خيار الطي لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. قم بفك نقل الورق باستخدام خيار الطي. انزع الحاوية القياسية. لا تتخلص من الصندوق. قبل تثبيت الخيار، ضع علامة صندوق الخروج في الوضع المغلق. عند إزالة الخيار، ضع علامة صندوق الخروج في الوضع المفتوح. قم بإزالة الأسطوانة الاحتياطية. لا تتخلص من الأسطوانة. أدخل أسطوانة التغذية المرفقة مع الخيار حتى تسمع صوت  طقطقة  عند استقراره في مكانه. تأكد من وجود الزنبرك المعدني أمام أسطوانة التغذية. قم بتركيب اسطوانة وحدة التدبيس حتى  تسمع صوت  استقرارها في مكانها. افتح الباب الأمامي، ثم قم بإزالة الغطاء الموجود على الجانب الأيسر من الطابعة. لا تتخلص من البرغي والغطاء. أغلق الباب الأمامي. قم بإزالة غطاء موصل نقل الورق. لا تتخلص من الغطاء. قم بإزالة الغطاء الخلفي الأيسر. لا تتخلص من البرغي والغطاء. قم بإزالة غطاء الصندوق الداخلي. لا تتخلص من البرغي والغطاء. قم بالمحاذاة، ثم أدخل غطاء الحاوية الداخلي الذي يأتي مع الخيار. قم بتثبيت البراغي على غطاء الصندوق الداخلي. نعلق قطع الشريط الرغوي على الخيار. افتح الباب F، ثم أحكم ربط البراغي. أغلق الباب F. قم بتركيب حامل التثبيت بالخيار. أدخل الخيار. تأكد من وجود حامل التثبيت المعدني أمام الطابعة. افتح الباب F، ثم استخدم مفك البراغي المرفق مع الخيار، وقم بتثبيت البرغي. أغلق الباب F. قم بتثبيت البراغي في الخيار. قم بتركيب الغطاء الخلفي الأيسر. قم بفك تغليف وحدة إنهاء الكتيبات، ثم أزل كل مواد التغليف. قم بتركيب حامل التثبيت على وحدة الإنهاء. قم بتوصيل الشريط الرغوي بوحدة الإنهاء. قم بتركيب موجّه التغذية بوحدة الإنهاء. قم بتوصيل الصندوق العلوي بوحدة الإنهاء. ارفع غطاء الحاوية، ثم قم بتركيب الحاوية السفلية بوحدة الإنهاء. افتح باب وحدة الإنهاء. قم بإزالة مادة التغليف من صندوق الثقب، ثم أدخلها في وحدة الإنهاء. ضع موسع الحاوية على حاوية الإنهاء. يتم استخدام موسع الحاوية للورق بحجم A3 أو أطول وفي ظروف الرطوبة العالية للمساعدة في تكديس الورق. يتم تقليل سعة الحاوية عند استخدام موسع الحاوية. قم بتركيب السلة في الجزء الخلفي من وحدة الإنهاء. أغلق باب وحدة الإنهاء. ارفع غطاء السلة، ثم قم بمحاذاة الغطاء وإرفاقه بالخيار. قم بتثبيت البراغي. افتح الباب الأمامي، ثم قم بتثبيت غطاء الكسوة المرفق مع الخيار. قم بتركيب حامل التثبيت على الطابعة. تأكد من محاذاة البراغي مع العلامات الموجودة على حامل التثبيت. افتح باب وحدة الإنهاء، وقم بإزالة البرغي، ثم اسحب قفل وحدة الإنهاء. قم بتوصيل كابل الخيار بالطابعة. قم بتوصيل كابل الإنهاء بالخيار. قم بتوصيل وحدة الإنهاء بالطابعة. قم بتثبيت وحدة الإنهاء بالطابعة، ثم قم بتثبيت البرغي. أغلق باب وحدة الإنهاء. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. خيارات الأجهزة نقل الورق مع خيار الطي خيارات الأجهزة وحدة إنهاء الكتيبات نقل الورق مع خيار الطي تثبيت وحدة إنهاء الكتيبات تثبيت"},{"UUID":"75caa7f9-fdc5-4a6f-8e7f-6c2ecdd935ce","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تركيب رف لوحة المفاتيح قم","descFull":"تركيب رف لوحة المفاتيح قم بإيقاف تشغيل الطابعة. افتح الباب B. قم بإزالة الغطاء الأمامي، ثم أغلق الباب B. قم بفك رف لوحة المفاتيح. أدخل كابل لوحة المفاتيح في الرف. قم بلف الكابل على شكل حلقة داخل الرف. أزل الغطاء اللاصق. قم بمحاذاة لوحة المفاتيح ثم قم بتوصيلها بالقاعدة. قم بمحاذاة الرف، وقم بتوصيل كابل لوحة المفاتيح بالطابعة، وأدخل الرف، ثم قم بتوصيله بالطابعة. قم بتشغيل الطابعة. خيارات الأجهزة رف لوحة المفاتيح رف لوحة المفاتيح التثبيت تثبيت رف لوحة المفاتيح"},{"UUID":"f3ce88ab-8199-4561-a352-face4399236e","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تثبيت بطاقة فاكس لمنع خطر","descFull":"تثبيت بطاقة فاكس لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. افتح غطاء الوصول إلى لوحة وحدة التحكم. يمكن للمكونات الإلكترونية الخاصة بلوحة وحدة التحكم أن تتعرض للتلف بسهولة بسبب الكهرباء الاستاتيكية. المس سطحًا معدنيًا على الطابعة قبل أن تلمس أي مكوّنات إلكترونية على لوحة وحدة التحكم أو أي موصلات. قم بإزالة غطاء منفذ الفاكس. لا تتخلص من البرغي والغطاء. قم بفك تغليف بطاقة الفاكس. قم بتوصيل كابل الفاكس بلوحة وحدة التحكم. قم بمحاذاة بطاقة الفاكس ثم قم بتثبيتها على الطابعة. أغلق غطاء الوصول إلى لوحة وحدة التحكم حتى تسمع صوت  طقطقة  استقراره في مكانه، ثم قم بتثبيت البرغي. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك التيار بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. بطاقة فاكس التثبيت تثبيت الخيارات الداخلية بطاقة فاكس"},{"UUID":"fc5a99d7-5e65-4d01-8859-b4c0240ce4a7","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تثبيت قارئ البطاقة لمنع خطر","descFull":"تثبيت قارئ البطاقة لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. قم بإيقاف تشغيل الطابعة. افتح الباب B. افتح غطاء منفذ USB الأمامي. قم بإزالة غطاء منفذ USB السفلي. إذا لم تكن طابعتك تحتوي على هذا الجزء، فانتقل إلى الخطوة التالية. قم بإزالة الغطاء الواقي من قارئ البطاقة. أدخل قارئ البطاقة. قم بتركيب غطاء المنفذ السفلي حتى صوت  طقطقة  استقرارها في مكانها. قم بتركيب موجّه الملصقات. قم بتوصيل غطاء منفذ USB الأمامي حتى صوت  طقطقة  استقرارها في مكانها. أغلق الباب B حتى يصدر صوت  طقطقة  عند استقراره في مكانه. قم بتشغيل الطابعة. قارئ البطاقات تثبيت خيارات داخلية قارئ البطاقات"},{"UUID":"6b60fd83-8204-4e0e-b6fb-0e17c438b57d","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تركيب منفذ حلول داخلية تركيب","descFull":"تركيب منفذ حلول داخلية تركيب منفذ حلول داخلية لمنع خطر التعرض للصعقة الكهربائية، إذا كنت ستصل إلى لوحة وحدة التحكم أو تقوم بتثبيت قِطع أجهزة أو وحدات ذاكرة إضافية في وقت لاحق من إعداد الطابعة، فأوقف تشغيل الطابعة وقم بفصل سلك التيار من المقبس الكهربائي قبل المتابعة. إذا كانت هناك أي أجهزة أخرى متصلة بالطابعة، فأطفئها أيضًا وافصل أي كابلات متصلة بالطابعة. تتطلّب هذه المهمة مفكّاً مسطّح الرأس. قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة.  افتح غطاء الوصول إلى لوحة وحدة التحكم. يمكن للمكونات الإلكترونية الخاصة بلوحة وحدة التحكم أن تتعرض للتلف بسهولة بسبب الكهرباء الاستاتيكية. المس سطحًا معدنيًا على الطابعة قبل أن تلمس أي مكوّنات إلكترونية على لوحة وحدة التحكم أو أي موصلات. أزل غطاء منفذ الحلول الداخلية (ISP). لا تتخلص من البرغي والغطاء. أخرج مجموعة منفذ الحلول الداخلية (ISP) من عبوتها. محتويات مجموعة أدوات منفذ الحلول الداخلية (ISP) 1 ISP 2 كابل منفذ الحلول الداخلية الموسّع 3 حامل تثبيت 4 البراغي قم بتوصيل حامل التثبيت بلوحة وحدة التحكم حتى تسمع صوت  طقطقة  استقراره في مكانه. قم بتوصيل موفر خدمة الإنترنت (ISP) بحامل التثبيت، ثم قم بتوصيل الكبل الممتد لمزود خدمة الإنترنت (ISP) بالموصل الخاص به الموجود على لوحة وحدة التحكم. قم بتثبيت منفذ الحلول الداخلية (ISP) بالطابعة. أغلق غطاء الوصول إلى لوحة وحدة التحكم. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك التيار بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. منفذ الحلول الداخلية التثبيت جاري تثبيت الخيارات منفذ الحلول الداخلية"},{"UUID":"55cbac6d-4458-4e79-b26e-d9eaf769be5b","title":"تركيب الوحدات الاختيارية للجهاز","link":"installing-optional-550-sheet-tray-topic.html","desc":"تغيير إعدادات منفذ الطابعة بعد","descFull":"تغيير إعدادات منفذ الطابعة بعد تثبيت منفذ حلول داخلية إذا كان عنوان IP الخاص بالطابعة ثابتًا، فلا تغيّر التهيئة. إذا تمت تهيئة أجهزة الكمبيوتر لاستخدام اسم الشبكة بدلاً من عنوان IP، فلا تغيّر التهيئة. إذا كنت تضيف منفذ حلول داخلية (ISP) لاسلكيًا إلى طابعة تمت تهيئتها مسبقًا لاتصال Ethernet، فافصل الطابعة عن شبكة Ethernet. لمستخدمي نظام التشغيل Windows افتح مجلد الطابعات. من القائمة المختصرة للطابعة المزودة بمنفذ الحلول الداخلية (ISP) الجديد، افتح خصائص الطابعة. قم بتهيئة المنفذ من القائمة. حدّث عنوان IP. طبّق التغييرات. لمستخدمي نظام التشغيل Macintosh من تفصيلات النظام في قائمة Apple، انتقل إلى لائحة الطابعات، ثم حدد  + IP . اكتب عنوان IP في حقل العنوان. طبّق التغييرات. إعدادات منفذ الطابعة تغيير تغيير إعدادات منفذ الطابعة بعد تركيب منفذ الحلول الداخلية"},{"UUID":"03cc962c-cd49-4112-be10-c4c82c723b3a","title":"التوصيل عبر شبكة اتصال","link":"connecting-printer-to-wireless-network-topic.html","desc":"توصيل الطابعة بشبكة اتصال Wi-Fi","descFull":"توصيل الطابعة بشبكة اتصال Wi-Fi قبل أن تبدأ، تأكد من أن: مهايئ نشط  معيَّن على  تلقائي . من لوحة التحكم، انتقل إلى  الإعدادات شبكة الاتصال/المنافذ نظرة عامة حول شبكة الاتصال مهايئ نشط . إن كابل Ethernet غير متصل بالطابعة. استخدام لوحة التحكم من لوحة التحكم، انتقل إلى  الإعدادات الشبكة/المنافذ اللاسلكي الإعداد على لوحة الطابعة اختر الشبكة . حدد شبكة اتصال Wi-Fi، ثم أدخِل كلمة المرور الخاصة بشبكة الاتصال. بالنسبة للطابعات المزودة بإمكانية Wi‑Fi مدمجة، تظهر مطالبة لإعداد شبكة Wi‑Fi أثناء الإعداد الأولي. توصيل الطابعة بشبكة Wi‑Fi توصيل الطابعة بشبكة اتصال لاسلكية شبكة اتصال لاسلكية"},{"UUID":"85b7bc3a-099c-4441-ac77-455dbb5401cc","title":"التوصيل عبر شبكة اتصال","link":"connecting-printer-to-wireless-network-topic.html","desc":"توصيل الطابعة بشبكة اتصال لاسلكية","descFull":"توصيل الطابعة بشبكة اتصال لاسلكية باستخدام إعداد Wi-Fi المحمي (WPS) قبل أن تبدأ، تأكد من أن: نقطة الوصول (الموجّه اللاسلكي) معتمدة لإعداد WPS أو متوافقة مع إعداد WPS. لمزيد من المعلومات، انظر المستندات المرفقة لنقطة الوصول الخاصة بك. تركيب مهايئ شبكة اتصال لاسلكية في الطابعة. للحصول على مزيد من المعلومات، راجع التعليمات المرفقة بالمهايئ. مهايئ نشط  معيَّن على  تلقائي . من لوحة التحكم، انتقل إلى  الإعدادات شبكة الاتصال/المنافذ نظرة عامة حول شبكة الاتصال مهايئ نشط . استخدام طريقة \"ضغطة زر\" من لوحة التحكم، انتقل إلى  الإعدادات شبكة الاتصال/المنافذ لاسلكي إعداد Wi-Fi المحمي بدء طريقة النسخ بضغطة زر . اتبع الإرشادات التي تظهر على شاشة العرض. استخدام طريقة رقم التعريف الشخصي (PIN) من لوحة التحكم، انتقل إلى  الإعدادات شبكة الاتصال/المنافذ لاسلكي إعداد Wi-Fi المحمي البدء بطريقة PIN . انسخ رقم WPS PIN المكون من ثمانية أرقام. افتح متصفح ويب، ثم اكتب عنوان IP الخاص بنقطة الوصول في حقل العنوان. لمعرفة عنوان IP، راجع المستندات التي أتت مع نقطة الوصول. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. قم بالوصول إلى إعدادات WPS. لمزيد من المعلومات، انظر المستندات المرفقة لنقطة الوصول الخاصة بك. أدخل رقم PIN المكون من ثمانية أرقام، ثم احفظ التغييرات. إعداد Wi‑Fi Protected Setup شبكة اتصال لاسلكية شبكة اتصال لاسلكية إعداد Wi‑Fi Protected Setup الاتصال بالشبكة اللاسلكية استخدام طريقة رقم PIN الاتصال بالشبكة اللاسلكية استخدام طريقة \"ضغطة زر\""},{"UUID":"4e382727-77c4-4bb4-8ca3-d918d51b2bb9","title":"التوصيل عبر شبكة اتصال","link":"connecting-printer-to-wireless-network-topic.html","desc":"تهيئة Wi‑Fi Direct Wi-Fi Direct","descFull":"تهيئة Wi‑Fi Direct Wi-Fi Direct  تمكن أجهزة Wi-Fi من الاتصال ببعضها البعض مباشرة دون استخدام نقطة وصول (الموجّه اللاسلكي). من لوحة التحكم انتقل إلى  إعدادات الشبكة/المنافذ Wi-Fi Direct . قم بتهيئة الإعدادات. تمكين Wi-Fi Direct —لتمكين الطابعة من بث شبكة اتصال Wi-Fi Direct الخاصة بها. اسم Wi‑Fi Direct —لتعيين اسم لشبكة اتصال Wi‑Fi Direct. كلمة مرور Wi-Fi Direct —لتعيين كلمة المرور للتفاوض على الأمان اللاسلكي عند استخدام اتصال نظير إلى نظير. إظهار كلمة المرور على صفحة الإعداد —إظهار كلمة المرور على صفحة إعداد شبكة الاتصال. رقم القناة المفضلة  —لتعيين القناة المفضلة لشبكة Wi‑Fi Direct. عنوان IP لمالك المجموعة  - يعين عنوان IP لمالك المجموعة. قبول طلبات زر الضغط تلقائيًا —للسماح للطابعة بقبول طلبات الاتصال تلقائيًا. قبول طلبات زر الضغط تلقائيًا غير آمن. بشكل افتراضي، لا تكون كلمة مرور شبكة اتصال Wi-Fi Direct مرئية على شاشة عرض الطابعة. لإظهار كلمة المرور، قم بتمكين رمز النظرة الخاطفة لكلمة المرور. من لوحة التحكم، انتقل إلى  الإعدادات الأمان إعدادات متنوعة تمكين كلمة المرور/إظهار رمز PIN . لمعرفة كلمة المرور الخاصة بشبكة Wi-Fi Direct دون إظهارها على شاشة الطابعة، قم بطباعة  صفحة إعداد الشبكة . من لوحة التحكم، انتقل إلى  الإعدادات التقارير الشبكة صفحة إعداد الشبكة . Wi‑Fi Direct تهيئة تهيئة Wi‑Fi Direct"},{"UUID":"e2d0d7ca-5596-4bac-9d42-52ff41ec5c42","title":"التوصيل عبر شبكة اتصال","link":"connecting-printer-to-wireless-network-topic.html","desc":"توصيل جهاز محمول بالطابعة قبل","descFull":"توصيل جهاز محمول بالطابعة قبل توصيل جهازك المحمول، تأكد من تهيئة Wi‑Fi Direct. لمزيد من المعلومات، راجع  . استخدام Wi‑Fi Direct تنطبق هذه الإرشادات فقط على الأجهزة المحمولة التي تعمل على نظام التشغيل الأساسي  Android . من الجهاز المحمول اذهب إلى قائمة  الإعدادات . قم بتمكين  Wi‑Fi ، ثم اضغط على Wi‑Fi Direct . حدد اسم Wi-Fi Direct للطابعة. قم بتأكيد الاتصال على لوحة التحكم بالطابعة. استخدام Wi‑Fi من الجهاز المحمول اذهب إلى قائمة  الإعدادات . اضغط على  Wi‑Fi ، ومن ثم حدد اسم Wi-Fi Direct للطابعة. تتم إضافة السلسلة DIRECT-xy (حيث يكون x وy حرفين عشوائيين) قبل اسم Wi-Fi Direct. أدخل كلمة مرور Wi-Fi Direct. توصيل الجهاز المحمول إلى الطابعة توصيل بالطابعة استخدام Wi‑Fi Direct"},{"UUID":"6df8717e-6814-4800-8cff-be078ba464d5","title":"التوصيل عبر شبكة اتصال","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi‑Fi Direct توصيل كمبيوتر بالطابعة","descFull":"Wi‑Fi Direct توصيل كمبيوتر بالطابعة قبل توصيل الكمبيوتر، تأكد من تهيئة Wi‑Fi Direct. لمزيد من المعلومات، راجع  . لمستخدمي نظام التشغيل Windows افتح  الطابعات والماسحات الضوئية ، ومن ثم انقر فوق  إضافة طابعة أو ماسحة ضوئية . انقر فوق  إظهار طابعات Wi-Fi Direct ، ومن ثم حدد اسم Wi-Fi Direct للطابعة. من شاشة عرض الطابعة، دوّن رقم PIN المكوّن من ثمانية أرقام الخاص للطابعة. أدخل رقم PIN على الكمبيوتر. إذا لم يكن برنامج تشغيل الطباعة مثبتًا بالفعل، فسيقوم Windows بتنزيل برنامج التشغيل المناسب. لمستخدمي Macintosh انقر فوق الرمز لاسلكي، ومن ثم حدد اسم Wi‑Fi Direct للطابعة. تتم إضافة السلسلة DIRECT-xy (حيث يكون x وy حرفين عشوائيين) قبل اسم Wi-Fi Direct. اكتب كلمة مرور Wi-Fi Direct. قم بتحويل الكمبيوتر إلى شبكة اتصاله السابقة بعد قطع الاتصال بشبكة اتصال Wi-Fi Direct. توصيل الكمبيوتر بالطابعة"},{"UUID":"553df33b-1f60-4dad-bc8c-9a40213cd536","title":"التوصيل عبر شبكة اتصال","link":"connecting-printer-to-wireless-network-topic.html","desc":"إلغاء تنشيط شبكة اتصال Wi-Fi","descFull":"إلغاء تنشيط شبكة اتصال Wi-Fi من لوحة التحكم، انتقل إلى  الإعدادات الاتصال/المنافذ نظرة عامة حول شبكة الاتصال مهايئ نشطة شبكة اتصال قياسية . حدد  نعم  لإعادة تشغيل الطابعة. شبكة Wi‑Fi، معطلة إلغاء تنشيط شبكة اتصال Wi-Fi"},{"UUID":"8779f495-5dd7-4341-9165-44755cf5b3c8","title":"التوصيل عبر شبكة اتصال","link":"connecting-printer-to-wireless-network-topic.html","desc":"التحقق من اتصال الطابعة التحقق","descFull":"التحقق من اتصال الطابعة التحقق من اتصال الطابعة من لوحة التحكم، انتقل إلى  الإعدادات التقارير الشبكة صفحة إعداد الشبكة . تأكد من القسم الأول من الصفحة، وتأكد من أن الحالة متصلة. إذا كانت الحالة هي غير متصلة، فقد تكون لوحة تفريغ LAN غير نشطة أو قد يكون هناك خلل في كابل الشبكة. اتصل بالمسؤول لديك للحصول على مساعدة. فحص توصيل شبكة الاتصال اتصال الطابعة بالشبكة فحص"},{"UUID":"dd03e671-5788-46ef-ac2e-974e7c60e760","title":"التوصيل عبر شبكة اتصال","link":"connecting-printer-to-wireless-network-topic.html","desc":"إعداد الطباعة التسلسلية (Windows فقط)","descFull":"إعداد الطباعة التسلسلية (Windows فقط) قم بتعيين المعلمات في الطابعة. من لوحة التحكم، انتقل إلى القائمة حيث توجد إعدادات المنافذ. قم بتحديد موقع قائمة إعدادات المنفذ التسلسلي، ثم قم بضبط الإعدادات، إذا لزم الأمر. طبّق التغييرات. من الكمبيوتر، افتح مجلّد الطابعات ثم حدد الطابعة الخاصة بك. افتح خصائص الطابعة، ثم حدد منفذ الاتصال من القائمة. عيّن معلمات منفذ الاتصال في Device Manager (مدير الأجهزة). تخفف الطباعة التسلسلية من سرعة الطباعة. تأكد من أن الكبل التسلسلي متّصل بالمنفذ التسلسلي على طابعتك. إعداد الطباعة التسلسلية الطباعة التسلسلية إعداد"},{"UUID":"46f6a066-e4e5-423a-8ac3-0181f6587ff9","title":"تأمين الطابعة","link":"erasing-printer-memory-topic.html","desc":"محو ذاكرة الطابعة لمسح الذاكرة","descFull":"محو ذاكرة الطابعة لمسح الذاكرة غير الدائمة أو البيانات المخزنة مؤقتًا في الطابعة، أوقف تشغيل الطابعة. لمسح الذاكرة الدائمة وإعدادات الجهاز وشبكة الاتصال وإعدادات الأمان والحلول المضمنة embedded solutions، قم بالإجراءات التالية: من لوحة التحكم، انتقل إلى  الإعدادات‏‎ الجهاز الصيانة خارج الخدمة . حدد  حفظ كل المعلومات على الذاكرة الدائمة ، ثم حدد  مسح . حدد  معالج بدء الإعداد الأولي  أو  ترك الطابعة غير متصلة ، ثم حدد خيار  التالي . ابدأ العملية. تؤدي أيضًا هذه العملية إلى إتلاف مفتاح التشفير الذي يتم استخدامه لحماية بيانات المستخدم. يجعل إتلاف مفتاح التشفير البيانات غير قابلة للاسترداد. الذاكرة غير الدائمة مسح الذاكرة الدائمة مسح ذاكرة الطابعة مسح مسح ذاكرة الطابعة مسح الذاكرة غير الدائمة مسح الذاكرة الدائمة"},{"UUID":"7a7d1fa5-1b66-4bbe-b4a3-2b60669b7912","title":"تأمين الطابعة","link":"erasing-printer-storage-drive-topic.html","desc":"مسح محرك أقراص تخزين الطابعة","descFull":"مسح محرك أقراص تخزين الطابعة مسح محرك أقراص تخزين الطابعة من لوحة التحكم، انتقل إلى  الإعدادات‏‎ الجهاز الصيانة خارج الخدمة . حسب محرك أقراص التخزين المثبت على الطابعة، قم بأي من الإجراءات التالية: بالنسبة إلى القرص الثابت، حدد خانة الاختيار  تصحيح كل المعلومات على القرص الثابت ، وحدد  مسح ، ثم حدد طريقة لمسح البيانات. قد تستغرق عملية تصحيح المعلومات على القرص الثابت فترة تتراوح ما بين دقائق عديدة وأكثر من ساعة، فتصبح الطابعة غير متوفرة لإجراء مهام أخرى. بالنسبة لمحرك التخزين الذكي، حدد  مسح جميع بيانات المستخدم بشكل مشفر على محرك أقراص التخزين الذكي (ISD)‬ ، ثم حدد  مسح . محرك أقراص التخزين مسح القرص الثابت مسح محرك أقراص التخزين الذكي مسح مسح محرك أقراص التخزين مسح القرص الثابت مسح محرك أقراص التخزين الذكي"},{"UUID":"f40b3d48-39fa-4dfd-80a4-b986552afc69","title":"تأمين الطابعة","link":"restoring-factory-default-settings-topic.html","desc":"استعادة إعدادات المصنع الافتراضية من","descFull":"استعادة إعدادات المصنع الافتراضية من لوحة التحكم، انتقل إلى  الإعدادات الجهاز استعادة إعدادات المصنع الافتراضية . حدد  استعادة الإعدادات . حدد الإعدادات التي تريد استعادتها، ثم حدد  استعادة . إعدادات المصنع الافتراضية استعادة إعدادات الطابعة استعادة الإعدادات الافتراضية للمصنع"},{"UUID":"53109676-96a2-484c-8570-5cc9a1db2325","title":"تأمين الطابعة","link":"statement-of-volatility-topic.html","desc":"بيان الذاكرة بيان الذاكرة أنواع","descFull":"بيان الذاكرة بيان الذاكرة أنواع الذاكرة وأوصافها نوع الذاكرة الوصف الذاكرة غير الدائمة تستخدم الطابعة ذاكرة الوصول العشوائي (RAM) القياسية لتخزين بيانات المستخدم المؤقتة أثناء مهام الطباعة والنسخ البسيطة. الذاكرة الدائمة قد تستخدم الطابعة شكلَين من أشكال الذاكرة الدائمة: EEPROM وNAND (ذاكرة فلاش). يعمل النوعان على تخزين نظام التشغيل وإعدادات الطباعة ومعلومات شبكة الاتصال. كما أنهما يخزنان إعدادات الماسحة الضوئية والإشارات المرجعية والحلول المضمنة Embedded Solutions. محرك الأقراص الثابتة للتخزين قد تحتوي بعض الطابعات على محرك الأقراص الثابتة مثبّت فيها. إن القرص الثابت في الطابعة مصمم ليؤدي وظائف محددة خاصة بالطابعة. ويسمح القرص الثابت للطابعة بالاحتفاظ ببيانات المستخدم المخزّنة مؤقتًا من مهام الطباعة المعقدة وبيانات النماذج وبيانات الخطوط. محرك أقراص التخزين الذكي (ISD) قد تحتوي بعض الطابعات على محرك أقراص تخزين ذكي (ISD) مثبّت فيها. ويستخدم محرك أقراص التخزين الذكي (ISD) ذاكرة فلاش دائمة لتخزين بيانات المستخدم من مهام الطباعة المعقدة وبيانات النماذج وبيانات الخطوط. امسح محتوى أي ذاكرة مثبتة بالطابعة في الظروف التالية: إذا تم التوقف عن استخدام الطابعة. إذا تم استبدال القرص الثابت أو محرك أقراص التخزين الذكي (ISD) في الطابعة. إذا تم نقل الطابعة إلى قسم أو موقع مختلف. إذا تمت صيانة الطابعة من قبل شخص من خارج شركتك. إذا تم نقل الطابعة من موقعك لغرض الصيانة. إذا تم بيع الطابعة إلى شركة أخرى. للتخلص من محرك أقراص تخزين، اتبع السياسات والإجراءات المتبعة في شركتك. بيان الذاكرة الذاكرة غير الدائمة الذاكرة الدائمة محرك أقراص التخزين الثابتة محرك أقراص التخزين الذكي محو ذاكرة الطابعة تأمين بيانات الطابعة"},{"UUID":"53f9d08f-55de-442f-a160-bd18b959a0f5","title":"طباعة","link":"printing-from-computer-topic.html","desc":"الطباعة من كمبيوتر لمستخدمي نظام","descFull":"الطباعة من كمبيوتر لمستخدمي نظام التشغيل Windows بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة، ومن ثم انقر فوق  الخصائص  أو  التفضيلات  أو  الخيارات  أو  إعداد . عند الضرورة، اضبط الإعدادات. انقر فوق  موافق  ثم انقر فوق  طباعة . لمستخدمي Macintosh أثناء فتح أحد المستندات، اختر  ملف طباعة . حدد طابعة، ثم حدد إعدادًا من  الإعدادات المسبقة . عند الضرورة، اضبط الإعدادات. انقر فوق  ‎طباعة . طباعة من جهاز الكمبيوتر مستندات، طباعة من جهاز الكمبيوتر"},{"UUID":"7d26bfc7-21d7-4781-a595-8de6bbaca05e","title":"الطباعة من جهاز محمول","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"الطباعة من جهاز محمول باستخدام","descFull":"الطباعة من جهاز محمول باستخدام خدمة Lexmark Print يعد  Lexmark  Print أحد حلول الطباعة عبر الأجهزة المحمولة للأجهزة المحمولة التي تعمل بنظام  Android  الإصدار 6.0 أو الأحدث. وهو يتيح إرسال المستندات والصور إلى الطابعات المتصلة بشبكة الاتصال وملقمات إدارة الطباعة. تأكد من تنزيل تطبيق Lexmark Print من متجر  Google Play  تخزينها وتمكينها في الجهاز المحمول. يجب التأكد من أن الطابعة والجهاز المحمول متصلَين بشبكة الاتصال نفسها. من جهازك المحمول، حدد مستندًا من مدير الملفات. أرسل المستند أو شاركه إلى Lexmark Print. قد لا تدعم بعض تطبيقات الأطراف الثالثة ميزة الإرسال أو المشاركة. لمزيد من المعلومات، راجع الوثائق المرفقة مع التطبيق. حدد طابعة. عند الضرورة، اضبط الإعدادات. اطبع المستند. Lexmark Print استخدام طباعة المستندات من جهاز محمول جهاز محمول الطباعة من"},{"UUID":"1f579e8f-c21c-4fb8-a037-fbd6f93c6fe5","title":"الطباعة من جهاز محمول","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"الطباعة من جهاز محمول باستخدام","descFull":"الطباعة من جهاز محمول باستخدام خدمة الطباعة Mopria™ تعد خدمة طباعة Mopria أحد حلول الطباعة عبر الأجهزة المحمولة للأجهزة المحمولة التي تعمل بنظام  Android  إصدار 5.0 أو أحدث. فهي تتيح لك الطباعة مباشرة إلى أي طابعة معتمدة من Mopria™. تأكد من تنزيل خدمة الطباعة Mopria من متجر  Google Play  وتمكينها على جهازك المحمول. من جهازك المحمول، قم بتشغيل تطبيق متوافق أو حدد مستندًا من مدير الملفات. اضغط على  طباعة . حدد طابعة، ثم اضبط الإعدادات إذا لزم الأمر. اضغط على  . خدمة الطباعة Mopria طباعة من جهاز محمول جهاز محمول الطباعة من طباعة استخدام خدمة الطباعة Mopria"},{"UUID":"934f4002-70ee-4d34-a8a9-0aa68264f71c","title":"الطباعة من جهاز محمول","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"الطباعة من جهاز محمول باستخدام","descFull":"الطباعة من جهاز محمول باستخدام AirPrint تسمح ميزة برنامج AirPrint هي حل للطباعة عبر الأجهزة المحمولة لك بالطباعة مباشرة من أجهزة Apple إلى طابعة تعتمد خدمة AirPrint. تأكد من أن جهاز Apple والطابعة متصلَين بشبكة الاتصال نفسها. إذا كان للشبكة موزعات لاسلكية متعددة، فتأكد من أن كلا الجهازَين متصلان بشبكة الاتصال الفرعية نفسها. هذا التطبيق مدعوم فقط في بعض أجهزة Apple. من جهازك المحمول، حدد مستندًا من مدير الملفات أو قم بتشغيل تطبيق متوافق. اضغط على  طباعة . حدد طابعة، ثم اضبط الإعدادات إذا لزم الأمر. اطبع المستند. استخدام AirPrint طباعة من جهاز محمول جهاز محمول الطباعة من"},{"UUID":"fa2b5537-0dda-467f-8aee-9df5f9dcec58","title":"الطباعة من جهاز محمول","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"الطباعة من جهاز محمول باستخدام","descFull":"الطباعة من جهاز محمول باستخدام Wi‑Fi Direct®‎ Wi‑Fi Direct  هي عبارة عن خدمة طباعة تتيح لك الطباعة باستخدام أي طابعة مزوّدة بخدمة Wi‑Fi Direct. تأكد من أن الجهاز المحمول متصل بشبكة اتصال الطابعة اللاسلكية. للحصول على المزيد من المعلومات، انظر  . من جهازك المحمول، شغّل تطبيقًا متوافقًا أو حدد مستندًا من مدير الملفات. وفقًا لطراز جهازك المحمول، نفّذ أحد الإجراءات التالية: اضغط على  الطباعة . اضغط على  الطباعة . اضغط على  الطباعة . حدد طابعة، ثم اضبط الإعدادات إذا لزم الأمر. اطبع المستند. Wi‑Fi Direct الطباعة من جهاز محمول الطباعة من جهاز محمول جهاز محمول طباعة من الطباعة استخدام Wi‑Fi Direct"},{"UUID":"06b099e3-7af1-4c22-ad5c-5217a756c9b6","title":"طباعة","link":"printing-from-flash-drive-topic.html","desc":"الطباعة من محرك أقراص فلاش","descFull":"الطباعة من محرك أقراص فلاش أدخل محرك الأقراص الفلاش. للحصول على مزيد من المعلومات حول محركات الأقراص الفلاش المدعومة، راجع  . إذا أدخلت محرك الأقراص الفلاش عند ظهور رسالة خطأ، فستتجاهل الطابعة محرك الأقراص الفلاش. إذا أدخلت محرك الأقراص الفلاش أثناء معالجة الطابعة لمهام طباعة أخرى، فستظهر الرسالة  مشغولة  على الشاشة. من لوحة التحكم، حدد  الطباعة . حدد  ‏‫برنامج تشغيل USB‬ ، ثم حدد المستند الذي تريد طباعته. إذا لزم الأمر، قم بتهيئة الإعدادات. اطبع المستند. لتفادي فقدان البيانات أو حدوث عطل في الطابعة، لا تلمس محرك الأقراص الفلاش أو الطابعة في المنطقة الموضحة أثناء عملية الطباعة أو القراءة أو الكتابة من وحدة الذاكرة. طباعة من محرك أقراص فلاش محرك الأقراص الفلاش، الطباعة من"},{"UUID":"da48ec1e-ce07-46d0-b4e3-dd7326330856","title":"طباعة","link":"configuring-confidential-jobs-topic.html","desc":"تهيئة المهام السرية من لوحة","descFull":"تهيئة المهام السرية من لوحة التحكم، انتقل إلى  الإعدادات‏‎ الأمان إعداد الطباعة السرية . قم بتهيئة الإعدادات. عناصر قائمة  إعداد الطباعة السرية  وأوصافها إعداد الوصف الحد الأقصى لرقم PIN غير الصالح تعيين حد لعدد مرات إدخال رقم PIN غير صالح. عند بلوغ الحد الأقصى، يتم حذف مهام الطباعة الخاصة باسم المستخدم هذا. انتهاء فترة المهمة السرية تعيين فترة انتهاء صلاحية فردية لكل مهمة محجوزة قبل حذفها تلقائيًا من ذاكرة الطابعة أو القرص الثابت أو محرك أقراص التخزين الذكي. تكون المهمة المحجوزة  سرية  أو  متكررة  أو  محفوظة  أو  تحقق . تكرار انتهاء فترة المهمة تعيين وقت انتهاء صلاحية مهام الطباعة التي تريد تكرارها. التحقق من انتهاء فترة المهمة تعيين وقت انتهاء صلاحية طباعة نسخة من مهمة للتحقق من جودتها قبل طباعة النسخ المتبقية. حفظ انتهاء فترة المهمة تعيين فترة انتهاء الصلاحية للمهام التي تريد تخزينها في الطابعة لطباعتها لاحقًا. يتطلب تعليق كل المهام تعيين الطابعة لتعليق كل مهام الطباعة. الاحتفاظ بالمستندات المتكررة تعيين الطابعة للاحتفاظ بكل المستندات باسم الملف نفسه. مهام طباعة سرية تهيئة المهام المحجوزة تهيئة تخزين مهام الطباعة مهام توقف الطباعة"},{"UUID":"9a425cb0-ab0a-47f4-af20-340b133914bc","title":"طباعة","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"طباعة المهام السرية والمهام المحجوزة","descFull":"طباعة المهام السرية والمهام المحجوزة الأخرى لمستخدمي نظام التشغيل Windows بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة، ومن ثم انقر فوق  الخصائص  أو  التفضيلات  أو  الخيارات  أو  إعداد . انقر فوق  الطباعة والتوقف . انقر فوق  استخدام الطباعة والتوقف ، ثم عيِّن اسم مستخدم. حدد من بين أي من أنواع مهام الطباعة التالية: طباعة سرية  — تطلب الطابعة رقم تعريف شخصي قبل السماح لك بطباعة المهمة. إذا قمت بتحديد نوع الوظيفة هذا، فأدخل رقم التعريف الشخصي (PIN) المكون من أربعة أرقام. التحقق من الطباعة —عند إرسال هذه المهمة، تطبع الطابعة نسخة واحدة وتعلق النسخ الباقية المطلوبة في ذاكرة الطابعة. طباعة احتياطية  — تقوم الطابعة بتخزين المهمة في الذاكرة حتى تتمكن من طباعة المهمة لاحقًا. تكرار الطباعة —عند إرسال هذه المهمة تطبع الطابعة جميع النسخ المطلوبة للمهمة وتخزن المهمة في الذاكرة، حتى يتسنى لك طباعة نسخ إضافية لاحقاً. انقر فوق  \"موافق\" . انقر فوق  ‎طباعة . من لوحة التحكم بالطابعة، حرِّر مهمة الطباعة. حدد  طباعة . حدد  المهام المحجوزة  ، ثم حدد اسم المستخدم الخاص بك. بالنسبة لمهام الطباعة السرية، حدد  سري ، وأدخل رقم التعريف الشخصي (PIN)، ثم حدد  نعم . حدد مهمة الطباعة، ثم حدد  طباعة . لمستخدمي Macintosh أثناء فتح أحد المستندات، اختر  ملف طباعة . حدد طابعة. من القائمة المنسدلة  أمان وظائف الطباعة   قم بتمكين  الطباعة باستخدام رقم PIN‎  ، ثم أدخل رمز PIN المكون من أربعة أرقام. انقر فوق  ‎طباعة . من لوحة التحكم بالطابعة، حرِّر مهمة الطباعة. حدد  المهام المحجوزة ، ثم حدد اسم الكمبيوتر. حدد  سري ، ثم أدخل رقم PIN. حدد مهمة الطباعة، ثم حدد  طباعة . طباعة المهام المحجوزة طباعة مهام طباعة سرية مهام طباعة سرية طباعة المهام المحجوزة طباعة"},{"UUID":"32afb11c-d1de-4f5b-91fd-684c524f9091","title":"طباعة","link":"printing-font-sample-list-topic.html","desc":"طباعة قائمة نماذج الخطوط من","descFull":"طباعة قائمة نماذج الخطوط من لوحة التحكم انتقل إلى  الإعدادات  التقارير ‏‫الطباعة ‏‫خطوط الطباعة . حدد نوع الخط. طباعة قائمة نماذج الخطوط قائمة نماذج الخطوط طباعة"},{"UUID":"05f79b62-204c-4c44-994f-938135794edf","title":"طباعة","link":"printing-directory-list-topic.html","desc":"طباعة قائمة الأدلة من لوحة","descFull":"طباعة قائمة الأدلة من لوحة تحكم الطابعة، انتقل إلى  الإعدادات  التقارير الطباعة . حدد  دليل الطباعة . طباعة قائمة الأدلة قائمة الأدلة طباعة"},{"UUID":"a7e4a7e0-8b71-4eea-a52c-2085a9604814","title":"طباعة","link":"placing-separator-sheets-in-print-jobs-topic.html","desc":"وضع أوراق فاصلة في مهام","descFull":"وضع أوراق فاصلة في مهام الطباعة بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة، ومن ثم انقر فوق  الخصائص  أو  التفضيلات  أو  الخيارات  أو  إعداد . انقر فوق  الورق/الإنهاء . في قائمة  أوراق فاصلة‬  حدد إعدادًا. انقر فوق  موافق  ثم انقر فوق  طباعة . ‏‫الأوراق الفاصلة وضع وضع أوراق فاصلة"},{"UUID":"36ff7be8-2f6d-46cc-8d0d-0f570f3c1eef","title":"طباعة","link":"canceling-print-job-topic.html","desc":"إلغاء مهمة طباعة من لوحة","descFull":"إلغاء مهمة طباعة من لوحة التحكم، حدد  قائمة انتظار المهام . حدد  طباعة ، ثم حدد مهمة لإلغائها. إذا كان هناك مستند قيد الطباعة بالفعل، فحدد  إلغاء المهمة  في الزاوية اليمنى السفلية من الشاشة لإيقاف الطباعة. مهمة طباعة إلغاء إلغاء مهمة الطباعة"},{"UUID":"1ad6fbbc-055d-4d96-9d41-90ed0d4a91c9","title":"طباعة","link":"adjusting-toner-darkness-topic.html","desc":"ضبط قتامة مسحوق الحبر من","descFull":"ضبط قتامة مسحوق الحبر من لوحة تحكم الطابعة، انتقل إلى  الإعدادات الطباعة الجودة . اضبط إعداد  قتامة مسحوق الحبر . قتامة مسحوق الحبر ضبط ضبط ‏‫قتامة مسحوق الحبر‬"},{"UUID":"da538408-8a58-414c-a568-4cdeb017eddb","title":"النسخ","link":"making-copies-topic.html","desc":"إنشاء النُسخ حمِّل مستند أصلي","descFull":"إنشاء النُسخ حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. لتجنب الحصول على صورة مقتصّة، تأكد من تطابق حجم ورقة المستند الأصلي مع حجم ورقة الإخراج. من لوحة التحكم، حدد  نسخ ، ثم حدد عدد النُسخ. عند الضرورة، اضبط إعدادات النسخ. انسخ المستند. إنشاء النُسخ النسخ مستندات النسخ باستخدام وحدة تغذية المستندات التلقائية النسخ استخدام زجاج الماسحة الضوئية"},{"UUID":"319c0007-e3b0-42e6-940b-fc16aa8a03db","title":"النسخ","link":"copying-photos-topic.html","desc":"نسخ الصور الفوتوغرافية نسخ الصور","descFull":"نسخ الصور الفوتوغرافية نسخ الصور الفوتوغرافية ضع صورة فوتوغرافية على زجاج الماسحة الضوئية. من لوحة التحكم، انتقل إلى  النسخ المزيد من الإعدادات المحتوى نوع المحتوى الصور . حدد  مصدر المحتوى ، ثم حدد الإعداد الذي يتطابق بشكل أفضل مع الصورة الفوتوغرافية الأصلية. انسخ الصورة الفوتوغرافية. النسخ صور فوتوغرافية الصور الفوتوغرافية، النسخ"},{"UUID":"f69be025-e614-43d0-8c26-5f0d20c0eebd","title":"النسخ","link":"copying-on-letterhead-topic.html","desc":"النسخ على الورق ذي الرأسية","descFull":"النسخ على الورق ذي الرأسية النسخ على الورق ذي الرأسية حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة تحكم الطابعة، انتقل إلى  النسخ النسخ من . تحديد حجم المستند الأصلي. حدد  نسخ إلى ، ومن ثم حدد مصدر الورق الذي يتضمن الورق ذي الرأسية. إذا قمت بتحميل الورق ذي الرأسية في وحدة التغذية متعددة الأغراض، فحدد  وحدة التغذية متعددة الأغراض  وحدد حجم الورق ثم حدد  الورق ذي الرأسية . انسخ المستند. النسخ على ورق ذي رأسية ورق ذو رأسية النسخ على"},{"UUID":"cb9352c0-67e3-4448-947a-52fbfe14b4b3","title":"النسخ","link":"copying-on-both-sides-of-paper-topic.html","desc":"النسخ على وجهَي الورقة النسخ","descFull":"النسخ على وجهَي الورقة النسخ على وجهَي الورقة حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة تحكم الطابعة، انتقل إلى  النسخ المزيد من الإعدادات الوجهان . حدد إعدادًا. انسخ المستند. النسخ على كلا وجهي الورقة النسخ على الوجهين النسخ على الوجهين"},{"UUID":"78e14474-7801-46e8-861e-75e420753f51","title":"النسخ","link":"reducing-or-enlarging-copies-topic.html","desc":"تصغير أو تكبير النُسخ تصغير","descFull":"تصغير أو تكبير النُسخ تصغير أو تكبير النُسخ حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة تحكم الطابعة، انتقل إلى  النسخ المزيد من الإعدادات المقياس . حدد إعدادًا. يؤدي تغيير حجم المستند الأصلي أو حجم الإخراج بعد تعيين  المقياس  إلى إعادة قيمة المقياس إلى  تلقائي . انسخ المستند. تصغير حجم نسخة تكبير حجم نسخة حجم النسخ ضبط"},{"UUID":"d20a00cb-6336-4e9b-8056-d4409b12b92a","title":"النسخ","link":"collating-copies-topic.html","desc":"ترتيب النُسخ ترتيب النُسخ حمِّل","descFull":"ترتيب النُسخ ترتيب النُسخ حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة تحكم، انتقل إلى  النسخ المزيد من الإعدادات الترتيب‬ على [1،2،1،2،1،2] . انسخ المستند. ترتيب النُسخ فرز نُسخ متعددة"},{"UUID":"2d87441d-f62f-4b30-8c05-870e14dd32cc","title":"النسخ","link":"placing-separator-sheets-between-copies-topic.html","desc":"وضع أوراق فاصلة بين النُسخ","descFull":"وضع أوراق فاصلة بين النُسخ وضع أوراق فاصلة بين النُسخ حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة التحكم، انتقل إلى  النسخ المزيد من الإعدادات الأوراق الفاصلة . قم بتمكين القائمة، ثم حدد إعدادًا. انسخ المستند. ‏‫الأوراق الفاصلة إضافة وضع أوراق فاصلة"},{"UUID":"7f823949-cb2e-46a2-9974-a1515ad7486f","title":"النسخ","link":"copying-multiple-pages-onto-single-sheet-topic.html","desc":"طباعة عدة صفحات على ورقة","descFull":"طباعة عدة صفحات على ورقة واحدة طباعة عدة صفحات على ورقة واحدة حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة التحكم، انتقل إلى  النسخ المزيد من الإعدادات ‏‫عدد الصفحات لكل وجه‬ . قم بتمكين القائمة، ثم حدد إعدادًا. انسخ المستند. نسخ صفحات متعددة على ورقة واحدة توفير الورق"},{"UUID":"40e3ed24-971a-4348-9d4f-817afa481160","title":"النسخ","link":"copying-cards-topic.html","desc":"نسخ البطاقات نسخ البطاقات قم","descFull":"نسخ البطاقات نسخ البطاقات قم بتحميل بطاقة على زجاج الماسحة الضوئية. من لوحة التحكم، انتقل إلى  النسخ النسخ من بطاقة التعريف . انسخ البطاقة. النسخ بطاقات البطاقات، النسخ"},{"UUID":"0024aaf6-05f4-4be3-87fb-bfa9f06eff3b","title":"النسخ","link":"creating-copy-shortcut-topic.html","desc":"إنشاء اختصار نسخة إنشاء اختصار","descFull":"إنشاء اختصار نسخة إنشاء اختصار نسخة من لوحة التحكم، حدد  النسخ . قم بتهيئة الإعدادات ومن ثم حدد  . إنشاء اختصار. إنشاء اختصار نسخة إضافة اختصار نسخة"},{"UUID":"e0d0a48e-cfad-49ed-82f4-e9ff72a5792d","title":"البريد الإلكتروني","link":"configuring-smtp-settings-topic.html","desc":"تهيئة إعدادات SMTP تهيئة إعدادات","descFull":"تهيئة إعدادات SMTP تهيئة إعدادات SMTP قم بتهيئة إعدادات بروتوكول نقل البريد البسيط (SMTP) لإرسال مستند ممسوح ضوئيًا عبر البريد الإلكتروني. تختلف الإعدادات باختلاف مقدم خدمة البريد الإلكتروني. قبل البدء، تأكد من اتصال الطابعة بشبكة اتصال ومن أن شبكة الاتصال متصلة بالإنترنت. استخدام لوحة التحكم من لوحة التحكم، انتقل إلى  الإعدادات البريد الإلكتروني إعداد البريد الإلكتروني . قم بتهيئة الإعدادات.  استخدام Embedded Web Server افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الإعدادات‏‎ البريد الإلكتروني . في قائمة  إعداد البريد الإلكتروني ، قم بتهيئة الإعدادات.  انقر فوق  حفظ . موفرو خدمة البريد الإلكتروني AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live أو Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail إذا واجهت أخطاء في استخدام الإعدادات المتوفرة، فاتصل بموفر الخدمة الخاص بك. إذا لم يكن موفر الخدمة الخاص بك مدرجًا في القائمة، فاتصل بموفر الخدمة الخاص بك. AOL Mail إعداد AOL Mail إعداد القيمة مدخل SMTP الرئيسي smtp.aol.com منفذ مدخل SMTP الرئيسي 587 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور التطبيق  لإنشاء كلمة مرور للتطبيق، انتقل إلى صفحة  أمان حساب AOL ، وقم بتسجيل الدخول إلى حسابك، ومن ثم انقر فوق  إنشاء وإدارة كلمات مرور التطبيقات . Comcast Mail إعدادات Comcast Mail إعداد القيمة مدخل SMTP الرئيسي smtp.comcast.net منفذ مدخل SMTP الرئيسي 587 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور الحساب تأكد من تمكين إعداد أمان وصول الأطراف الثالثة على حسابك. للحصول على مزيد من المعلومات، انتقل إلى   صفحة مساعدة Comcast Xfinity Connect . Gmail تأكد من تمكين التحقق من الصحة بخطوتين على حسابك. لتمكين التحقق من الصحة بخطوتين، انتقل إلى صفحة  أمان حساب Google ، سجِّل الدخول إلى حسابك، ثم من قسم  كيفية تسجيل الدخول إلى Google  انقر فوق  التحقق من الصحة بخطوتين . إعدادات SMTP لـ Gmail إعداد القيمة مدخل SMTP الرئيسي smtp.gmail.com منفذ مدخل SMTP الرئيسي 587 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور التطبيق لإنشاء كلمة مرور للتطبيق، انتقل إلى صفحة  أمان حساب Google  سجِّل الدخول إلى حسابك، ومن ثم من قسم  كيفية تسجيل الدخول إلى Google  انقر فوق  ‬‏‫التحقق من الصحة بخطوتين كلمات مرور التطبيقات . تظهر عبارة \" كلمات مرور التطبيقات \" فقط في حال تم تمكين التحقق بخطوتين. iCloud Mail تأكد من تمكين التحقق من الصحة بخطوتين على حسابك. إعدادات iCloud Mail إعداد القيمة مدخل SMTP الرئيسي smtp.mail.me.com منفذ مدخل SMTP الرئيسي 587 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور التطبيق لإنشاء كلمة مرور التطبيق، انتقل إلى صفحة  إدارة حساب iCloud ، وسجِّل الدخول إلى حسابك، ثم من قسم  تسجيل الدخول والأمان ، انقر فوق  كلمات المرور الخاصة بالتطبيقات إنشاء كلمة مرور خاصة بالتطبيق . Mail.com إعدادات Mail.com إعداد القيمة مدخل SMTP الرئيسي smtp.mail.com منفذ مدخل SMTP الرئيسي 587 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور الحساب NetEase Mail (mail.126.com) تأكد من تمكين خدمة SMTP على حسابك. لتمكين الخدمة، من صفحة NetEase Mail الرئيسية، انقر فوق  الإعدادات POP3/SMTP/IMAP ، ثم قم بتمكين  خدمة IMAP/SMTP  أو  خدمة POP3/SMTP . إعدادات NetEase Mail‏ (mail.126.com) إعداد القيمة مدخل SMTP الرئيسي smtp.126.com منفذ مدخل SMTP الرئيسي 465 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور التخويل يتم توفير كلمة مرور التخويل عند تمكين  خدمة IMAP/SMTP  أو  خدمة POP3/SMTP . NetEase Mail (mail.163.com) تأكد من تمكين خدمة SMTP على حسابك. لتمكين الخدمة، من صفحة NetEase Mail الرئيسية، انقر فوق  الإعدادات POP3/SMTP/IMAP ، ثم قم بتمكين  خدمة IMAP/SMTP  أو  خدمة POP3/SMTP . إعدادات NetEase Mail ‏(mail.163.com) إعداد القيمة مدخل SMTP الرئيسي smtp.163.com منفذ مدخل SMTP الرئيسي 465 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور التخويل يتم توفير كلمة مرور التخويل عند تمكين  خدمة IMAP/SMTP  أو  خدمة POP3/SMTP . NetEase Mail (mail.yeah.net) تأكد من تمكين خدمة SMTP على حسابك. لتمكين الخدمة، من صفحة NetEase Mail الرئيسية، انقر فوق  الإعدادات POP3/SMTP/IMAP ، ثم قم بتمكين  خدمة IMAP/SMTP  أو  خدمة POP3/SMTP . إعدادات NetEase Mail ‏(mail.yeah.net) إعداد القيمة مدخل SMTP الرئيسي smtp.yeah.net منفذ مدخل SMTP الرئيسي 465 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور التخويل يتم توفير كلمة مرور التخويل عند تمكين  خدمة IMAP/SMTP  أو  خدمة POP3/SMTP . Outlook Live أو Microsoft 365 تنطبق هذه الإعدادات على حسابات مجالات البريد الإلكتروني outlook.com وhotmail.com وعلى حسابات Microsoft 365. الإعدادات لـ Outlook Live أو Microsoft 365 إعداد القيمة مدخل SMTP الرئيسي smtp.office365.com منفذ مدخل SMTP الرئيسي 587 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور الحساب أو كلمة مرور التطبيق بالنسبة إلى الحسابات التي تم تعطيل التحقق من الصحة بخطوتين فيها، استخدم كلمة مرور حسابك. بالنسبة إلى حسابات outlook.com أو hotmail.com التي تم تمكين التحقق من الصحة بخطوتين فيها، استخدم كلمة مرور للتطبيق. لإنشاء كلمة مرور للتطبيق، انتقل إلى صفحة  إدارة حساب Outlook Live ، وسجِّل الدخول إلى حسابك، ومن ثم انقر فوق  إنشاء كلمة مرور جديدة للتطبيق . للحصول على خيارات إعداد أكثر للشركات التي تستخدم Microsoft 365، انتقل إلى  صفحة تعليمات Microsoft 365 . QQ Mail تأكد من تمكين خدمة SMTP على حسابك. لتمكين الخدمة من صفحة QQ Mail الرئيسية، انقر فوق  الإعدادات الحساب . من قسم  خدمة POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV ، قم بتمكين إما  خدمة POP3/SMTP  أو  خدمة IMAP/SMTP . إعدادات QQ Mail إعداد القيمة مدخل SMTP الرئيسي smtp.qq.com منفذ مدخل SMTP الرئيسي 587 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز رمز التخويل لإنشاء رمز للتخويل، من الصفحة الرئيسية لبريد QQ، انقر فوق  الإعدادات الحساب ، ومن ثم من القسم  خدمة POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV ، انقر فوق  إنشاء رمز تخويل . Sina Mail تأكد من تمكين خدمة POP3/SMTP على حسابك. لتمكين الخدمة، من صفحة Sina Mail الرئيسية، انقر فوق  الإعدادات إعدادات أكثر POP/IMAP/SMTP المستخدم النهائي ، ثم قم بتمكين  خدمة POP3/SMTP . إعدادات Sina Mail إعداد القيمة مدخل SMTP الرئيسي smtp.sina.com منفذ مدخل SMTP الرئيسي 587 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز رمز التخويل لإنشاء رمز تخويل، من صفحة البريد الإلكتروني الرئيسية، انقر فوق  الإعدادات إعدادات إضافية POP/IMAP/SMTP المستخدم النهائي ، ثم قم بتمكين  حالة رمز التخويل . Sohu Mail تأكد من تمكين خدمة SMTP على حسابك. لتمكين الخدمة، من صفحة Sohu Mail الرئيسية، انقر فوق  الخيارات الإعدادات POP3/SMTP/IMAP ، ثم قم بتمكين إما  خدمة IMAP/SMTP  أو  خدمة POP3/SMTP . إعدادات Sohu Mail إعداد القيمة مدخل SMTP الرئيسي smtp.sohu.com منفذ مدخل SMTP الرئيسي 465 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة المرور المستقلة يتم تقديم كلمة المرور المستقلة عند تمكين  خدمة IMAP/SMTP  أو  خدمة POP3/SMTP . Yahoo! Mail إعدادات Yahoo! Mail إعداد القيمة مدخل SMTP الرئيسي smtp.mail.yahoo.com منفذ مدخل SMTP الرئيسي 587 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور التطبيق  لإنشاء كلمة مرور للتطبيق، انتقل إلى صفحة  أمان حساب Yahoo ، وسجِّل الدخول إلى حسابك، ومن ثم من قسم  كلمة مرور التطبيق ، انقر فوق  إنشاء كلمة مرور . Zoho Mail إعدادات Zoho Mail إعداد القيمة مدخل SMTP الرئيسي smtp.zoho.com منفذ مدخل SMTP الرئيسي 587 استخدام SSL/TLS مطلوب المطالبة بشهادة موثوقة تعطيل عنوان الرد عنوان بريدك الإلكتروني مصادقة ملقم SMTP تسجيل الدخول/عادي البريد الإلكتروني المُبادر من الجهاز استخدام بيانات اعتماد SMTP للجهاز مُعرِّف مستخدم الجهاز عنوان بريدك الإلكتروني كلمة مرور الجهاز كلمة مرور الحساب أو كلمة مرور التطبيق بالنسبة إلى الحسابات التي تم تعطيل التحقق من الصحة بخطوتين فيها، استخدم كلمة مرور حسابك. بالنسبة إلى الحسابات التي تم تمكين التحقق من الصحة بخطوتين فيها، استخدم كلمة مرور للتطبيق. لإنشاء كلمة مرور للتطبيق، انتقل إلى صفحة  أمان حساب Zoho Mail ، وسجِّل الدخول إلى حسابك، ومن ثم من قسم  كلمات مرور تطبيقات محددة ، انقر فوق  إنشاء كلمة مرور جديدة . موفرو خدمة البريد الإلكتروني تكوين إعدادات ملقم البريد الإلكتروني إعدادات SMTP تكوين وظيفة البريد الإلكتروني إعداد إعدادات ملقم البريد الإلكتروني تهيئة"},{"UUID":"070ccc20-931d-402c-8f80-48be1c2d4868","title":"البريد الإلكتروني","link":"sending-email-topic.html","desc":"إرسال بريد إلكتروني قبل أن","descFull":"إرسال بريد إلكتروني قبل أن تبدأ، تأكد من تهيئة إعدادات SMTP. لمزيد من المعلومات، راجع  . حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة تحكم الطابعة، انتقل إلى  المسح الضوئي البريد الإلكتروني . أدخل المعلومات المطلوبة، ثم اختر  التالي . إذا لزم الأمر، قم بتهيئة الإعدادات. حدد  المسح الضوئي ، ثم أرسل البريد الإلكتروني. البريد الإلكتروني إرسال إرسال بريد إلكتروني"},{"UUID":"e0503fd6-86b8-4b85-ae35-a27c2bbb22c0","title":"البريد الإلكتروني","link":"creating-email-shortcut-topic.html","desc":"إنشاء اختصار بريد إلكتروني استخدام","descFull":"إنشاء اختصار بريد إلكتروني استخدام لوحة التحكم من لوحة تحكم الطابعة، انتقل إلى  المسح الضوئي البريد الإلكتروني . أدخل المعلومات المطلوبة، ثم حدد  . إنشاء اختصار. استخدام Embedded Web Server افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الاختصارات إضافة اختصار . قم بتهيئة الإعدادات. انقر فوق  حفظ . إنشاء اختصار البريد الإلكتروني إضافة اختصار البريد الإلكتروني اختصار البريد الإلكتروني إنشاء"},{"UUID":"e9f8fda2-198c-44d7-baa2-f13da06edfcd","title":"الفاكس","link":"sending-fax-topic.html","desc":"إرسال فاكس إرسال فاكس استخدام","descFull":"إرسال فاكس إرسال فاكس استخدام لوحة التحكم حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة التحكم، حدد  الفاكس . حدد  إضافة مستلم  أو  دفتر العناوين . عند الضرورة، اضبط الإعدادات. أرسل الفاكس. استخدام الكمبيوتر قبل أن تبدأ، تأكد من تثبيت برنامج تشغيل الفاكس. لمزيد من المعلومات، راجع  . لمستخدمي نظام التشغيل Windows بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة، ومن ثم انقر فوق  الخصائص  أو  التفضيلات  أو  الخيارات  أو  إعداد . انقر فوق  الفاكس تمكين الفاكس عرض الإعدادات دائمًا قبل الإرسال عبر الفاكس ، ثم أدخل رقم المستلم. إذا لزم الأمر، قم بتهيئة الإعدادات. أرسل الفاكس. لمستخدمي Macintosh أثناء فتح أحد المستندات، اختر  ملف طباعة . حدد الطابعة التي تُضاف كلمة  ‑ فاكس  بعد اسمها. في الحقل \"إلى\"، أدخل رقم المستلم. إذا لزم الأمر، قم بتهيئة الإعدادات. أرسل الفاكس. إرسال فاكس فاكس، إرسال"},{"UUID":"482ed37c-3b8c-4fdd-ae42-95f301781dc7","title":"الفاكس","link":"scheduling-fax-topic.html","desc":"جدولة فاكس جدولة فاكس حمِّل","descFull":"جدولة فاكس جدولة فاكس حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة التحكم، حدد  الفاكس . حدد  إضافة مستلم  أو  دفتر العناوين ، ثم أدخل المعلومات المطلوبة. حدد  وقت الإرسال ، تهيئة التاريخ والوقت، ثم حدد  تم . إذا لزم الأمر، قم بتهيئة إعدادات فاكس أخرى. أرسل الفاكس. فاكس مجدول الفاكس، الجدولة"},{"UUID":"86c2c01a-f2a9-4f77-a945-c8521bd7d8b1","title":"الفاكس","link":"creating-fax-destination-shortcut-topic.html","desc":"إنشاء اختصار وجهة الفاكس إنشاء","descFull":"إنشاء اختصار وجهة الفاكس إنشاء اختصار وجهة الفاكس من لوحة التحكم، حدد  الفاكس . حدد  إضافة مستلم  أو  دفتر العناوين ، ثم أدخل المعلومات المطلوبة. عند الضرورة، اضبط الإعدادات. حدد  . إنشاء اختصار. إنشاء اختصار وجهة الفاكس وجهة الفاكس إنشاء اختصار إضافة اختصار وجهة الفاكس اختصار، إنشاء وجهة الفاكس"},{"UUID":"17203c20-1984-4cbe-bf05-c6ad90ad3b2b","title":"الفاكس","link":"changing-fax-resolution-topic.html","desc":"تغيير دقة الفاكس تغيير دقة","descFull":"تغيير دقة الفاكس تغيير دقة الفاكس حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة التحكم، حدد  الفاكس . حدد  إضافة مستلم  أو  دفتر العناوين ، ثم أدخل المعلومات المطلوبة. حدد  الدقة ، ثم حدد إعدادًا. أرسل الفاكس. دقة الفاكس تغيير تغيير دقة الفاكس"},{"UUID":"c86c737d-3cd9-4ac9-983d-7a8851d0dc68","title":"الفاكس","link":"adjusting-fax-darkness-topic.html","desc":"ضبط قتامة الفاكس ضبط قتامة","descFull":"ضبط قتامة الفاكس ضبط قتامة الفاكس حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة التحكم، حدد  الفاكس . حدد  إضافة مستلم  أو  دفتر العناوين ، ثم أدخل المعلومات المطلوبة. حدد  المزيد من الإعدادات القتامة ، ثم اضبط الإعداد. أرسل الفاكس. ضبط درجة قتامة الفاكس درجة قتامة الفاكس ضبط"},{"UUID":"c90f2496-49f1-4cbe-9af6-c0d8bfa86241","title":"الفاكس","link":"printing-fax-log-topic.html","desc":"طباعة سجل الفاكس طباعة سجل","descFull":"طباعة سجل الفاكس طباعة سجل الفاكس من لوحة التحكم، انتقل إلى  الإعدادات التقارير الفاكس . حدد سجل الفاكس سجل الفاكس طباعة طباعة سجل الفاكس"},{"UUID":"3385b50c-f1c4-4672-92c0-2b3443ea96c0","title":"الفاكس","link":"blocking-junk-faxes-topic.html","desc":"منع استلام الفاكسات غير المرغوب","descFull":"منع استلام الفاكسات غير المرغوب فيها من لوحة التحكم، انتقل إلى  الإعدادات الفاكس إعداد الفاكس إعدادات استقبال الفاكس عناصر التحكم الخاصة بالمسؤول . قم بتمكين قائمة  حظر استلام رسائل الفاكس المجهولة‬ . الفاكسات غير المرغوب فيها الحظر منع الفاكسات غير الهامة"},{"UUID":"0c99d02c-6ba4-494e-92c2-01b0bbdc2b6c","title":"الفاكس","link":"holding-faxes-topic.html","desc":"إيقاف رسائل الفاكس إيقاف رسائل","descFull":"إيقاف رسائل الفاكس إيقاف رسائل الفاكس من لوحة التحكم، انتقل إلى  الإعدادات الفاكس إعداد الفاكس إعدادات استلام الفاكس إيقاف رسائل الفاكس . حدد إعدادًا. إيقاف الفاكسات رسائل الفاكس المستلمة إيقاف فاكس إيقاف"},{"UUID":"2693d1ae-6d76-4b97-b2a9-0db33ebe4eb3","title":"الفاكس","link":"forwarding-fax-topic.html","desc":"إعادة توجيه الفاكس إعادة توجيه","descFull":"إعادة توجيه الفاكس إعادة توجيه الفاكس من لوحة التحكم، انتقل إلى  الإعدادات الفاكس إعداد الفاكس إعدادات استقبال الفاكس عناصر التحكم الخاصة بالمسؤول . حدد  إعادة توجيه رسائل الفاكس ، ثم حدد  طباعة وإعادة توجيه  أو  إعادة توجيه . في قائمة  إعادة توجيه إلى  ، حدد وجهة ثم قم بتهيئة الإعدادات. إعادة توجيه الفاكس فاكس إعادة توجيه"},{"UUID":"488243cd-7483-4e4c-b2bc-ec32b23009ab","title":"مسح ضوئي","link":"scanning-to-computer-topic.html","desc":"جارٍ المسح الضوئي إلى الكمبيوتر","descFull":"جارٍ المسح الضوئي إلى الكمبيوتر قبل أن تبدأ، تأكد من أن الكمبيوتر والطابعة متصلَين بشبكة الاتصال نفسها. لمستخدمي نظام التشغيل Windows استخدام الأداة ScanBack من Lexmark من الكمبيوتر، قم بتشغيل  الأداة ScanBack من Lexmark ، ثم انقر فوق  إنشاء ملف تعريف . لتنزيل الأداة المساعدة، انتقل إلى  www.lexmark.com/downloads . إذا كنت تفضل استخدام ملف تعريف مسح ضوئي موجود، فانقر فوق  ملف التعريف الموجود . انقر فوق  إعداد  ثم أضف عنوان IP الخاص بالطابعة. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. انقر فوق  موافق , ثم انقر فوق  موافق . حدد تنسيق وحجم المستند المراد مسحه ضوئيًا. حدد تنسيق ملف ودقة مسح ضوئي، ثم انقر فوق  التالي . اكتب اسمًا فريدًا لملف تعريف المسح الضوئي. استعرض وصولاً إلى الموقع الذي تريد حفظ المستند الممسوح ضوئيًا فيه، ثم قم بإنشاء اسم ملف. لإعادة استخدام ملف تعريف المسح الضوئي، قم بتمكين  إنشاء اختصار ، ثم أنشئ اسم اختصار فريدًا. انقر فوق  إنهاء . قم بتحميل مستند أصلي في وحدة التغذية التلقائية بالمستندات أو على زجاج الماسحة الضوئية. من لوحة التحكم الخاصة بالطابعة، انتقل إلى  ملفات تعريف المسح الضوئي جارٍ المسح الضوئي إلى الكمبيوتر ، ثم حدد ملف تعريف المسح. على جهاز الكمبيوتر الخاص بك، انقر فوق  اكتمل الفحص . لمستخدمي نظام التشغيل Windows استخدام الفاكس والمسح الضوئي في Windows تأكد من أن الطابعة موصلة بالكمبيوتر. لمزيد من المعلومات، راجع  . قم بتحميل مستند أصلي في وحدة التغذية التلقائية بالمستندات أو على زجاج الماسحة الضوئية. من الكمبيوتر، افتح  الفاكس والمسح الضوئي في Windows . انقر فوق  مسح ضوئي جديد ، ثم حدد مصدرًا للماسحة الضوئية. إذا لزم الأمر، غيّر إعدادات المسح الضوئي. امسح المستند ضوئيًا. انقر فوق  حفظ باسم ، واكتب اسم ملف، ثم انقر فوق  حفظ . لمستخدمي Macintosh تأكد من أن الطابعة موصلة بالكمبيوتر. لمزيد من المعلومات، راجع  . قم بتحميل مستند أصلي في وحدة التغذية التلقائية بالمستندات أو على زجاج الماسحة الضوئية. من الكمبيوتر، قم بأي مما يلي: افتح  Image Capture . افتح  الطابعات والماسحات الضوئية ، ثم حدد طابعة. انقر فوق  مسح ضوئي فتح الماسحة الضوئية . من نافذة الماسحة الضوئية، نفذ إجراءً واحدًا أو أكثر مما يلي: حدد الموقع حيث تريد حفظ المستند الممسوح ضوئيًا. تحديد حجم المستند الأصلي. لإجراء المسح الضوئي من وحدة التغذية التلقائية بالمستندات، حدد  وحدة التغذية بالمستندات  من  قائمة المسح الضوئي  أو قم بتمكين  استخدام وحدة التغذية بالمستندات . إذا لزم الأمر، قم بتهيئة إعدادات المسح الضوئي. انقر فوق  مسح ضوئي . جارٍ المسح الضوئي إلى الكمبيوتر كمبيوتر، مسح ضوئي إلى الأداة ScanBack من Lexmark"},{"UUID":"2e7da08e-af66-45ec-b61a-5a8322ad198f","title":"مسح ضوئي","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"جارٍ المسح الضوئي إلى ملقم","descFull":"جارٍ المسح الضوئي إلى ملقم FTP جارٍ المسح الضوئي إلى ملقم FTP قبل أن تبدأ، تأكد من أن الطابعة متصلة بملقم FTP. حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة التحكم انتقل إلى  المسح الضوئي FTP . أدخل المعلومات المطلوبة، ثم اختر  التالي . إذا لزم الأمر، قم بتهيئة إعدادات FTP. امسح المستند ضوئيًا. ملقم بروتوكول FTP جارٍ المسح الضوئي إلى المسح الضوئي إلى ملقم بروتوكول FTP"},{"UUID":"bbcd89c9-2818-41ea-bc5b-7c1a15398a50","title":"مسح ضوئي","link":"creating-FTP-shortcut-topic.html","desc":"إنشاء اختصار FTP إنشاء اختصار","descFull":"إنشاء اختصار FTP إنشاء اختصار FTP من لوحة التحكم، حدد  المسح الضوئي FTP . أدخل عنوان ملقم FTP ومن ثم المس  . إنشاء اختصار. إنشاء اختصار عنوان FTP إضافة اختصار عنوان FTP"},{"UUID":"b7c5c841-fe29-40b2-9c6a-dbf8ab3cc916","title":"مسح ضوئي","link":"scanning-to-network-folder-topic.html","desc":"جارٍ المسح الضوئي إلى مجلد","descFull":"جارٍ المسح الضوئي إلى مجلد شبكة قبل البدء، تأكد من تهيئة مجلد الشبكة الذي تريد مسح المستند ضوئيًا إليه بالفعل. حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. من لوحة التحكم، انتقل إلى  مركز المسح الضوئي مجلد الشبكة . حدد مجلد الشبكة المناسب. لإضافة مجلد شبكة، راجع  . امسح المستند ضوئيًا. المسح الضوئي إلى مجلد شبكة اتصال مجلد شبكة اتصال جارٍ المسح الضوئي إلى"},{"UUID":"b6509074-6f5a-4a33-8889-19dd4f9e7e69","title":"مسح ضوئي","link":"configuring-network-folder-destination-topic.html","desc":"تهيئة وجهة مجلد الشبكة تهيئة","descFull":"تهيئة وجهة مجلد الشبكة تهيئة وجهة مجلد الشبكة من لوحة التحكم، انتقل إلى  مركز المسح الضوئي مجلد الشبكة إنشاء مجلد الشبكة . قم بتهيئة الإعدادات اللازمة. قم بتسجيل الدخول إلى الشبكة، ثم اختر  التالي . قم بتهيئة إعدادات مجلد الشبكة، ثم حدد  تم . لمسح مستند ضوئيًا إلى مجلد شبكة، راجع  . وجهة مجلد الشبكة تهيئة إنشاء مجلد الشبكة"},{"UUID":"973291b7-cdba-4a80-ba03-882f6dfe25b5","title":"مسح ضوئي","link":"creating-network-folder-shortcut-topic.html","desc":"إضافة اختصار لمجلد شبكة الاتصال","descFull":"إضافة اختصار لمجلد شبكة الاتصال افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الاختصارات إضافة اختصار . من قائمة  نوع الاختصار ، حدد  مجلد شبكة الاتصال ، ثم قم بتهيئة الإعدادات. طبّق التغييرات. اختصار مجلد شبكة الاتصال إنشاء اختصار"},{"UUID":"27d21426-3ea5-4dea-8438-56acd39de552","title":"مسح ضوئي","link":"scanning-to-flash-drive-topic.html","desc":"جارٍ المسح الضوئي إلى محرك","descFull":"جارٍ المسح الضوئي إلى محرك الأقراص الفلاش جارٍ المسح الضوئي إلى محرك الأقراص الفلاش حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. أدخل محرك الأقراص الفلاش. من لوحة التحكم، حدد  المسح الضوئي ، ثم حدد  محرك أقراص USB . حدد موقعًا لحفظ الملف، وقم بإنشاء اسم ملف، ثم حدد  التالي . قم بتهيئة إعدادات المسح. امسح المستند ضوئيًا. لتفادي فقدان البيانات أو حدوث عطل في الطابعة، لا تلمس محرك الأقراص الفلاش أو الطابعة في المنطقة الموضحة أثناء عملية الطباعة أو القراءة أو الكتابة من وحدة الذاكرة. المسح الضوئي إلى محرك أقراص فلاش محرك أقراص فلاش جارٍ المسح الضوئي إلى"},{"UUID":"d718818d-d860-4a56-93b3-825918c91cdb","title":"قوائم الطابعة","link":"menu-map-topic.html","desc":"خريطة القوائم 1  تظهر","descFull":"خريطة القوائم 1  تظهر هذه القائمة فقط عند تركيب وحدة إنهاء. 2  يظهر فقط عند تثبيت محرك أقراص التخزين. جهاز التفضيلات وضع Eco لوحة المشغل البعيد الإخطارات إدارة الطاقة مشاركة البيانات مع Lexmark إمكانية الوصول استعادة الإعدادات الافتراضية للمصنع الصيانة تحديث البرنامج الثابت حول هذه الطابعة جهاز التفضيلات وضع Eco لوحة المشغل البعيد الإخطارات إدارة الطاقة إمكانية الوصول استعادة الإعدادات الافتراضية للمصنع الصيانة تحديث البرنامج الثابت حول هذه الطابعة طباعة التخطيط الإنهاء 1 إعداد الجودة حساب المهام PDF PostScript PCL صورة الورق تهيئة الدرج تهيئة الوسائط تهيئة الحاوية 1 النسخ الإعدادات الافتراضية للنسخ الفاكس إعدادات الفاكس الافتراضية البريد الإلكتروني إعداد البريد الإلكتروني إعدادات البريد الإلكتروني الافتراضية إعداد ارتباط ويب FTP إعدادات بروتوكول FTP الافتراضية برنامج تشغيل USB مسح ضوئي من محرك الأقراص الفلاش طباعة من محرك الأقراص الفلاش شبكة الاتصال/المنافذ نظرة عامة حول شبكة الاتصال لاسلكي Wi‑Fi Direct إدارة خدمات الهاتف المحمول Ethernet TCP/IP إدارة الشبكة البسيط (SNMP) IPSec 802.1x تهيئة LPD إعدادات بروتوكول HTTP/FTP ThinPrint USB تقييد الوصول إلى شبكة الاتصال الخارجية الأمان طرق تسجيل الدخول جدولة أجهزة USB سجل مراقبة الأمان قيود تسجيل الدخول إعداد الطباعة السرية التشفير مسح ملفات البيانات الموقتة إعدادات حلول LDAP متنوع خدمات السحابة التسجيل في خدمات السحابة تقارير صفحة إعدادات القوائم جهاز طباعة الاختصارات الفاكس شبكة الاتصال استكشاف الأخطاء وإصلاحها صفحات اختبار جودة الطباعة تنظيف الماسحة الضوئية دمج النماذج 2 دمج النماذج خريطة القائمة قوائم الطباعة"},{"UUID":"97829c4e-d41d-4c76-a202-c64ee2281d53","title":"جهاز","link":"preferences-topic.html","desc":"التفضيلات عناصر قائمة التفضيلات وأوصافها","descFull":"التفضيلات عناصر قائمة التفضيلات وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. لغة شاشة العرض غير متاح [قائمة اللغات] لتعيين لغة النص الذي يظهر على شاشة العرض. الدولة/المنطقة غير متاح [قائمة البلدان أو المناطق] تحديد البلد أو المنطقة التي تمت تهيئة الطابعة للعمل فيها. تشغيل الإعداد الأولي غير متاح إيقاف * تشغيل لتشغيل معالج الإعداد. لوحة مفاتيح نوع لوحة المفاتيح [قائمة اللغات] لتحديد لغة كنوع للوحة المفاتيح. قد لا تظهر كل قيم  نوع لوحة المفاتيح  أو قد تحتاج إلى أجهزة خاصة لتظهر. التاريخ والوقت تهيئة التاريخ والوقت الحاليان ضبط التاريخ والوقت يدويًا تنسيق التاريخ  ( شهر-يوم-سنة *) تنسيق الوقت  ( 12 ساعة صباحًا/مساءً *) المنطقة الزمنية فرق التوقيت الصيفي (DST) (بتوقيت جرينتش GMT) بدء التوقيت الصيفي (DST) نهاية التوقيت الصيفي (DST) بدء التوقيت الصيفي (DST) تهيئة بروتوكول تاريخ الطابعة ووقتها ووقت شبكة الاتصال. شهر‑يوم‑سنة  هو الإعداد الافتراضي للمصنع في الولايات المتحدة.  يوم - شهر - سنة  هو الإعداد الافتراضي للمصنع الدولي. تظهر عناصر  مقابلة التوقيت الدولي المنسق (توقيت جرينتش)  و بدء التوقيت الصيفي  و نهاية التوقيت الصيفي  و مقابلة التوقيت الصيفي  عندما يتم تعيين  المنطقة الزمنية  إلى  (مستخدم التوقيت الدولي المنسق+) مخصص  فقط. يظهر عنصرًا  المعرّف الرئيسي  و كلمة المرور  فقط في حالة تعيين  تمكين المصادقة  على  مفتاح MD5 . بروتوكول زمن الشبكة تمكين NTP  ( تشغيل *) ملقم NTP تمكين المصادقة  ( لا يوجد *) المعرّف الرئيسي كلمة المرور أحجام الورق غير متاح نظام الولايات المتحدة * متري تحديد وحدة قياس أحجام الورق. يتم تحديد الإعداد الأولي لحجم الورق بناءً على الدولة أو المنطقة التي تم تحديدها في معالج الإعداد الأولي. إضاءة الشاشة غير متاح 20–100%  (100*) لضبط سطوع شاشة العرض. الوصول إلى محرك الأقراص الفلاش غير متاح تعطيل ممكَّن * تمكين الوصول إلى وظيفة محرك الأقراص الفلاش الخاص بالطابعة. السماح بإزالة الخلفية غير متاح إيقاف تشغيل * تحديد ما إذا كانت إزالة الخلفية مسموحة. السماح بالمسح الضوئي للمهام المخصصة غير متاح إيقاف تشغيل * تحديد ما إذا كان إعداد  المسح الضوئي لمهمة مخصصة  يظهر للنسخ والمسح الضوئي والفاكس. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. المسح الضوئي لصفحة واحدة مسطحة غير متاح إيقاف * تشغيل قم بتعيين الطابعة لمسح أي نوع من المهام ضوئيًا يتضمن زجاج الماسحة الضوئية كصفحة واحدة. تعود الطابعة إلى الشاشة الرئيسية بعد إجراء مسح ضوئي مفتوح مرة واحدة بدلاً من عرض المطالبات. أصوات الجهاز كتم كل الأصوات إيقاف * تشغيل لتهيئة إعدادات الصوت الخاصة بالطابعة. تعليقات الأزرار إيقاف تشغيل * مستوى الصوت 0–10  (5*) صوت تحميل وحدة تغذية المستندات التلقائية إيقاف تشغيل * التحكم في الإنذار إيقاف منفرد * متتابع إنذار الخرطوشة إيقاف منفرد * متتابع وضع السماعة إيقاف دائمًا * تشغيل دومًا تشغيل حتى التوصيل مستوى صوت الجرس إيقاف * تشغيل مهلة توقف الشاشة غير متاح 5–300 ثانية  (60*) قم بتعيين فترة الخمول بالثواني قبل عرض شاشة العرض الشاشة الرئيسية، أو قبل أن تقوم الطابعة بتسجيل خروج أحد حسابات المستخدمين تلقائيًا. القائمة التفضيلات"},{"UUID":"2f97bbc4-a04c-4a23-85ca-e4644171ca9e","title":"جهاز","link":"preferences-topic.html","desc":"وضع Eco عناصر قائمة وضع","descFull":"وضع Eco عناصر قائمة وضع Eco وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. طباعة الوجهان على وجه واحد على وجهين * تحديد ما إذا كنت تريد الطباعة على وجه واحد من الورق أم على الوجهين. عدد الصفحات لكل وجه إيقاف * صفحتان لكل وجه 3 صفحات لكل وجه 4 صفحات لكل وجه 6 صفحات لكل وجه 9 صفحات لكل وجه 12 صفحة لكل وجه 16 صفحة لكل وجه حدد عدد الصفحات المطلوب طباعتها على وجه واحد من الورق. قتامة مسحوق الحبر 1–5  (4*) تحديد درجة نصوع الصور النصية أو قتامتها. موفر الألوان إيقاف * تشغيل قم بتعيين الطابعة لتقليل كمية مسحوق الحبر التي تستخدمها عند طباعة الرسومات والصور. النسخ الأوجه وجه واحد على وجه واحد * وجه واحد على وجهين وجهين على وجه واحد وجهين على وجهين تحديد سلوك المسح الضوئي استنادًا إلى المستند الأصلي. عدد الصفحات لكل وجه إيقاف * صفحتان بالاتجاه الطولي 4 صفحات بالاتجاه الطولي صفحتان بالاتجاه الأفقي 4 صفحات بالاتجاه الأفقي حدد عدد الصفحات المطلوب نسخها على وجه واحد من الورق. القتامة 1–9  (5*) تحديد قتامة الصور النصية الممسوحة ضوئيًا. القائمة وضع Eco"},{"UUID":"0e7ec307-0350-4c64-8b51-afc1aae82ced","title":"جهاز","link":"preferences-topic.html","desc":"لوحة المشغل البعيد عناصر قائمة","descFull":"لوحة المشغل البعيد عناصر قائمة لوحة التشغيل عن بعد وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. اتصال VNC الخارجي عدم السماح * السماح توصيل جهاز عميل حوسبة الشبكة الافتراضية (VNC) الخارجي بلوحة التحكم عن بُعد. نوع المصادقة لا شيء * المصادقة القياسية تعيين نوع المصادقة عند الوصول إلى خادم جهاز عميل حوسبة الشبكة الافتراضية (VNC). \"كلمة مرور VNC\" يتم تحديد الإعداد من قبل المستخدم. تحديد كلمة المرور للاتصال بخادم جهاز عميل حوسبة الشبكة الافتراضية (VNC). يظهر عنصر القائمة هذا فقط عند تعيين  نوع المصادقة  إلى  مصادقة قياسية . القائمة لوحة المشغل البعيد"},{"UUID":"cd49d72d-1de9-4632-9b2b-3b4ea1d847ea","title":"جهاز","link":"preferences-topic.html","desc":"الإخطارات عناصر قائمة الإخطارات وأوصافها","descFull":"الإخطارات عناصر قائمة الإخطارات وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. صوت تحميل وحدة تغذية المستندات التلقائية غير متاح إيقاف تشغيل * حدد ما إذا كانت الطابعة ستصدر إشارة صوتية مخصصة عند تحميل مستند أصلي في وحدة تغذية المستندات التلقائية (ADF). التحكم في الإنذار غير متاح إيقاف منفرد * متتابع قم بتحديد عدد المرات التي ينطلق فيها صوت الإنذار عندما تتطلب الطابعة تدخل المستخدم. مستلزمات الطباعة‬ عرض تقديرات مستلزمات الطباعة عرض التقديرات * عدم عرض التقديرات لعرض حالة المستلزمات المقدرة. إنذار الخرطوشة إيقاف منفرد * متتابع قم بتحديد عدد المرات التي ينطلق فيها صوت الإنذار عند انخفاض الحبر في خرطوشة مسحوق الحبر. إنذار التدبيس إيقاف * فردية متتابع اضبط عدد المرات التي يصدر فيها صوت التنبيه عندما تكون خرطوشة الدبابيس فارغة. لا يظهر عنصر القائمة هذا إلا عند تركيب وحدة إنهاء التدبيس. إنذار تثقيب الفتحات إيقاف * فردية متتابع اضبط عدد المرات التي يصدر فيها المنبه صوتًا عندما تكون حاوية تثقيب الفتحات ممتلئة أو مفقودة. يظهر عنصر القائمة هذا فقط في حال تركيب وحدة إنهاء التدبيس وتثقيب الفتحات. إعداد تنبيهات البريد الإلكتروني مدخل SMTP الرئيسي يتم تحديد الإعداد من قبل المستخدم. كتابة عنوان IP أو اسم الجهاز المضيف الخاص بملقم SMTP الأولي. منفذ مدخل SMTP الرئيسي 1–65535  (25*) أدخل رقم المنفذ الخاص بملقم SMTP الأولي. مدخل SMTP الثانوي يتم تحديد الإعداد من قبل المستخدم. كتابة عنوان IP أو اسم الجهاز المضيف الخاص بملقم SMTP الثانوي. منفذ مدخل SMTP الثانوي 1–65535  (25*) أدخل رقم منفذ الملقم لملقم SMTP الثانوي. مهلة SMTP 5–30 ثانية  (30*) قم بتحديد الوقت الذي ينتظره ملقم SMTP قبل أن يتوقف عن محاولة إرسال بريد إلكتروني. عنوان الرد يتم تحديد الإعداد من قبل المستخدم. تحديد عنوان رد في البريد الإلكتروني. استخدام عنوان الرد الافتراضي الخاص بـ SMTP دائمًا تشغيل إيقاف * لاستخدام عنوان الرد الافتراضي في ملقم SMTP دائمًا. استخدام SSL/TLS معطّل * تفاوض مطلوب إرسال بريد إلكتروني باستخدام ارتباط مشفّر. المطالبة بشهادة موثوقة تشغيل * إيقاف المطالبة بشهادة موثوقة عند الوصول إلى ملقم SMTP. عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. إعداد تنبيهات البريد الإلكتروني مصادقة ملقم SMTP لا يُطلَب أي مصادقة * تسجيل الدخول/عادي NTLM CRAM-MD5 Digest-MD5 Kerberos 5 قم بتعيين نوع المصادقة لملقم SMTP. بريد إلكتروني يبدأه الجهاز لا شيء * استخدام بيانات اعتماد SMTP للجهاز قم بتحديد ما إذا كانت بيانات الاعتماد مطلوبة لرسائل البريد الإلكتروني التي يرسلها الجهاز. بريد إلكتروني يبدأه المستخدم لا شيء * استخدام بيانات اعتماد SMTP للجهاز استخدام مُعرِّف مستخدم الجلسة وكلمة المرور استخدام عنوان البريد الإلكتروني وكلمة المرور للجلسة مطالبة المستخدم قم بتحديد ما إذا كانت بيانات الاعتماد مطلوبة لرسائل البريد الإلكتروني التي يرسلها المستخدم. استخدام بيانات اعتماد جهاز الدليل النشط تشغيل إيقاف * قم بتمكين بيانات اعتماد المستخدم وتعيينات المجموعة للاتصال بملقم SMTP. مُعرِّف مستخدم الجهاز يتم تحديد الإعداد من قبل المستخدم. حدد معرف المستخدم لتسجيل الدخول إلى ملقم SMTP. كلمة مرور الجهاز يتم تحديد الإعداد من قبل المستخدم. قم بتحديد كلمة المرور لتسجيل الدخول إلى ملقم SMTP. Kerberos 5 REALM يتم تحديد الإعداد من قبل المستخدم. قم بتحديد realm لبروتوكول مصادقة Kerberos 5. مجال NTLM يتم تحديد الإعداد من قبل المستخدم. قم بتحديد اسم المجال لبروتوكول أمان NTLM. تعطيل خطأ \"لم يتم إعداد خادم SMTP\" تشغيل إيقاف * قم بتعطيل رسالة خطأ حول إعداد ملقم SMTP. إعداد قوائم البريد الإلكتروني والتنبيهات يتم تحديد الإعداد من قبل المستخدم. قم بتحديد عناوين البريد الإلكتروني وقم بتمكين تنبيه البريد الإلكتروني. يظهر عنصر القائمة هذا فقط في خادم الويب المضمّن Embedded Web Server. منع حدوث الخطأ أداة استشعار التغذية المتعددة لوحدة التغذية التلقائية بالمستندات (ADF) إيقاف تشغيل * قم بتعيين الطابعة لتكتشف متى يقوم وحدة التغذية التلقائية للمستندات (ADF) بالتقاط أكثر من ورقة واحدة في وقت واحد. متابعة تلقائية إيقاف تشغيل * لجعل الطابعة تتابع معالجة مهمة أو طباعتها تلقائيًا بعد مسح شروط حضور معيّنة. عند التعيين على  تشغيل ، الإعداد الافتراضي هو 5 ثواني. إعادة التشغيل التلقائي إعادة التشغيل في وضع السكون إعادة التشغيل دائمًا * ‏‫Reboot never (عدم إعادة التشغيل مطلقًا)‬ لتعيين الطابعة لإعادة التشغيل في حال حدوث خطأ. ‏‫Max Auto Reboots (الحد الأقصى لمرات إعادة التشغيل التلقائي)‬ 1–20  (2*) لتعيين عدد مرات إعادة التشغيل التلقائي التي يمكن للطابعة تنفيذها. نافذة إعادة التشغيل التلقائي 1–525600  (720*) قم بتحديد عدد الثواني التي تستغرقها الطابعة قبل القيام بإعادة التشغيل التلقائي. عداد إعادة التشغيل التلقائي الإعداد عبارة عن معلومات للقراءة فقط. إظهار عدد عمليات إعادة التشغيل التلقائية التي قامت بها الطابعة. عرض خطأ ورق قصير تشغيل المسح التلقائي * تعيين الطابعة على عرض رسالة عند حدوث خطأ متعلق بالورق القصير. يشير الورق القصير إلى حجم الورق الذي يتم تحميله. حماية الصفحة إيقاف * تشغيل تعيين الطابعة على معالجة الصفحة بالكامل في الذاكرة قبل طباعتها. إصلاح محتوى انحشار الورق إصلاح انحشار الورق إيقاف تشغيل تلقائي * تعيين الطابعة على إعادة طباعة الصفحات المنحشرة. إصلاح انحشار الورق في الماسحة الضوئية مستوى المهمة مستوى الصفحة * تحديد كيفية إعادة بدء مهمة المسح الضوئي بعد إصلاح انحشار الورق. القائمة الإخطارات"},{"UUID":"f91afb57-4597-4e87-9bb5-ecb389e6a1fb","title":"جهاز","link":"preferences-topic.html","desc":"إدارة الطاقة عناصر قائمة إدارة","descFull":"إدارة الطاقة عناصر قائمة إدارة الطاقة وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. ملف تعريف وضع السكون الطباعة في وضع السكون البقاء في الوضع النشط بعد الطباعة الدخول في وضع السكون بعد الطباعة * قم بتعيين الطابعة إلى البقاء في الوضع النشط أو الدخول إلى  وضع السكون  بعد الطباعة. اللمس للتنشيط من وضع السكون العميق إيقاف تشغيل * قم بتنشيط الطابعة من  وضع السكون العميق . ‏‫Timeouts (أزمنة التوقف)‬ وضع السكون دقيقة إلى 114 دقيقة  (15*) لتعيين فترة الخمول قبل أن تبدأ الطابعة بالعمل في  وضع السكون . مهلة وضع الإسبات تعطيل ساعة واحدة ساعتان 3 ساعات 6 ساعات يوم 2 أيام 3 أيام * أسبوع أسبوعان شهر واحد لتعيين الفترة الزمنية قبل إيقاف تشغيل الطابعة. Hibernate Timeout on Connection (زمن توقف وضع الإسبات في حالة الاتصال) وضع الإسبات عدم استخدام وضع الإسبات * عيّن  مهلة وضع الإسبات  لإيقاف تشغيل الطابعة أثناء وجود اتصال Ethernet نشط. جدولة أوضاع الطاقة عمليات الجدولة إضافة جدول جديد يمكنك جدولة وقت دخول الطابعة في  وضع السكون  أو  الإسبات . القائمة إدارة الطاقة"},{"UUID":"266f6212-e974-4f62-880c-2602b5990071","title":"جهاز","link":"preferences-topic.html","desc":"مشاركة البيانات مع Lexmark مشاركة","descFull":"مشاركة البيانات مع Lexmark مشاركة البيانات مع عناصر قائمة Lexmark ووصفها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. مشاركة البيانات مع Lexmark نعم لا * لإرسال معلومات استخدام الطابعة وأدائها إلى Lexmark. وقت إرسال البيانات وقت البدء وقت التوقف حدد الإطار الزمني لجمع البيانات ونقلها. توقيت إرسال بيانات المشاركة  يظهر فقط عند تحديد  نعم  في  مشاركة البيانات مع Lexmark . القائمة مشاركة البيانات مع Lexmark"},{"UUID":"31054218-0e86-486d-8861-d2c5cee973e7","title":"جهاز","link":"preferences-topic.html","desc":"إمكانية وصول ذوي الاحتياجات الخاصة","descFull":"إمكانية وصول ذوي الاحتياجات الخاصة عناصر قائمة إمكانية الوصول وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. المدة الفاصلة لضغطات المفاتيح المتكررة 0.00–5.00  (0.00*) لتعيين المدة الفاصلة بالثواني التي تتجاهل فيها الطابعة ضغطات المفاتيح المتكررة على لوحة مفاتيح مرفقة. التأخير الأولي لتكرار المفتاح 0.25–5.00  (1.00*) لتعيين مدة التأخير الأولية بالثواني قبل أن يبدأ مفتاح تكرار بالتكرار. معدل التكرار للمفتاح 0.5–30.0  (30.0*) لتعيين عدد الضغطات في الثانية لمفتاح تكرار. تقليص زمن توقف الشاشة إيقاف * تشغيل السماح للمستخدم بالبقاء في الموقع نفسه وإعادة تعيين مؤقت  مهلة توقف الشاشة  عند انتهائها بدلاً من العودة إلى الشاشة الرئيسية. مستوى صوت سماعات الرأس 1–10  (5*) لضبط مستوى صوت سماعة الرأس. تمكين التوجيه الصوتي عند إرفاق سماعة رأس إيقاف * تشغيل قم بتمكين التوجيه الصوتي عند إدخال سماعات الرأس في مقبس سماعة الرأس. لفظ كلمات المرور/أرقام PIN إيقاف * تشغيل لتعيين الطابعة لقراءة كلمات المرور أو أرقام التعريف الشخصية بصوت عالٍ. سرعة الكلام بطيء للغاية بطيء عادي * سريع أسرع سريع للغاية متسارع متسارع للغاية أقصى سرعة لتعيين سرعة كلام التوجيه الصوتي. القائمة إمكانية وصول"},{"UUID":"5a768e91-7ddd-4097-8af8-d1acca6e9bb7","title":"جهاز","link":"preferences-topic.html","desc":"استعادة الإعدادات الافتراضية للمصنع عنصر","descFull":"استعادة الإعدادات الافتراضية للمصنع عنصر القائمة استعادة إعدادات المصنع ووصفه عنصر القائمة الإعدادات الوصف استعادة الإعدادات استعادة كل الإعدادات استعادة إعدادات الطابعة استعادة إعدادات الشبكة استعادة إعدادات الفاكس استعادة إعدادات التطبيقات استعادة إعدادات المصنع الافتراضية للطابعة. القائمة استعادة الإعدادات الافتراضية للمصنع"},{"UUID":"a47e6482-3968-453f-9f7b-51bb2c895e3a","title":"الصيانة","link":"preferences-topic.html","desc":"قائمة التهيئة عناصر قائمة التهيئة","descFull":"قائمة التهيئة عناصر قائمة التهيئة وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تهيئة USB USB PnP 1 * 2 لتغيير وضع برنامج تشغيل USB الخاص بالطابعة لتحسين توافقها مع كمبيوتر شخصي. مسح USB ضوئيًا إلى موقع محلي تشغيل * إيقاف لتعيين ما إذا كنت تريد اعتبار برنامج تشغيل جهاز USB كجهاز USB بسيط (واجهة واحدة) أو كجهاز USB مركّب (واجهات متعددة). سرعة USB كاملة تلقائية * لتعيين منفذ USB للعمل بالسرعة الكاملة وتعطيل إمكانات السرعة العالية الخاصة به. تهيئة الدرج استشعار الحجم استشعار  [x]  الدرج  ( On *) تعيين الدرج لاستشعار حجم الورق المحمّل فيه تلقائيًا. ربط علبة الورق تلقائي * إيقاف لتعيين الطابعة إلى ربط الأدراج التي لها إعدادات نوع الورق وحجم الورق نفسها. عرض رسالة مقحمة الدرج إيقاف للأحجام غير المعروفة فقط * دائماً لعرض رسالة تتيح للمستخدم تغيير إعدادات حجم الورق ونوعه بعد إدخال الدرج. مطالبات الورق تلقائية * وحدة التغذية المتعددة الأغراض ورق يدوي لتعيين مصدر الورق الذي يقوم المستخدم بملئه عند ظهور المطالبة بتحميل الورق. لكي تظهر  وحدة التغذية المتعددة الأغراض  في قائمة  الورق  قم بتعيين  تهيئة وحدة التغذية المتعددة الأغراض  إلى  كاسيت . مطالبات الأظرف تلقائية * وحدة التغذية المتعددة الأغراض التغذية اليدوية للأظرف لتعيين مصدر الورق الذي يقوم المستخدم بملئه عند ظهور المطالبة بتحميل المغلفات. لكي تظهر  وحدة التغذية المتعددة الأغراض  في قائمة  الورق  قم بتعيين  تهيئة وحدة التغذية المتعددة الأغراض  إلى  كاسيت . الاستجابة للمطالبات مطالبة المستخدم * متابعة استخدام الإعدادات الحالية لتعيين الطابعة إلى معالجة مطالبات تغيير الورق أو الأظرف. الأحجام العالمية المتعددة إيقاف * تشغيل لتعيين الدرج لدعم أحجام الورق العامة المتعددة. تقارير غير متاح صفحة إعدادات القوائم سجل الأحداث ملخص سجل الأحداث لطباعة تقارير حول إعدادات قوائم الطابعة وحالاتها وسجلات الأحداث الخاصة بها. استخدام المستلزمات والعدادات مسح محفوظات استخدام المستلزمات البدء إعادة تعيين سجل استخدام المستلزمات إلى مستوى شحن المصنع. إعادة تعيين ITM البدء لإعادة تعيين العداد بعد تركيب عنصر مستلزمات جديد أو مجموعة صيانة جديدة. إعادة تعيين عداد الخرطوشة السوداء البدء إعادة تعيين عداد خرطوشة اللون السماوي البدء إعادة تعيين عداد خرطوشة اللون الأرجواني البدء إعادة تعيين عداد خرطوشة اللون الأصفر البدء إعادة تعيين عداد وحدة التصوير السوداء البدء إعادة تعيين عداد مجموعة التصوير بالألوان البدء إعادة تعيين عداد مجموعة الأسطوانة MPF البدء إعادة ضبط عداد مجموعة الأسطوانة سعة 1500 ورقة البدء إعادة تعيين عداد مجموعة الأسطوانة البدء نطاقات التغطية المرتبطة بالمستويات مقاييس التغطية المرتبطة بالمستويات  ( إظهار *) لعرض قسم فواتير التغطية المتدرجة في تقرير إحصائيات الجهاز. نطاقات التغطية المرتبطة بالمستويات عمليات ضبط الوسائط الكبيرة إيقاف * تشغيل السماح بإجراء التعديلات عند الطباعة على ورق كبير أو سميك. مرات المحاكاة في الطابعة محاكاة PPDS إيقاف * تشغيل لتعيين الطابعة للتعرف على دفق بيانات PPDS واستخدامه. محاكاة PS إيقاف تشغيل * لتعيين الطابعة للتعرف على دفق بيانات PS واستخدامه. تمكين Formsmerge إيقاف * تشغيل تنشيط دمج النماذج. يجب تثبيت ترخيص Formsmerge. يجب تثبيت ذاكرة فلاش للمستخدم. تمكين Prescribe إيقاف * تشغيل قم بتنشيط لغة الطابعة PRESCRIBE. يجب تثبيت ترخيص PRESCRIBE. أمان المحاكي مهلة الصفحة  (60*) تعيين مهلة الصفحة أثناء المحاكاة. إعادة تعيين المحاكي بعد المهمة  ( إيقاف *) إعادة تعيين المحاكي بعد مهمة طباعة. تعطيل الوصول إلى رسالة الطابعة  ( تشغيل *) لتحديد ما إذا كان المحاكي يمكنه الوصول إلى الإعداد الأولي للطابعة أم لا. تهيئة الفاكس دعم طاقة الفاكس المنخفضة تعطيل وضع السكون السماح بوضع السكون تلقائي * لتحديد ما إذا كانت الطابعة تدعم جزء الفاكس الخاص ببنية الطاقة المنخفضة. موقع تخزين الفاكس القرص * NAND لتعيين موقع التخزين لكل رسائل الفاكس. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. تهيئة الطباعة وضع الأسود فقط إيقاف * تشغيل طباعة مهام غير النسخ بتدرج الرمادي. تراكب الألوان إيقاف 1 2 * 3 4 5 لتحسين الإخراج المطبوع بهدف التعويض عن خطأ تسجيل في الطابعة. توضيح الخط 0–150  (24*) قم بتعيين قيمة حجم نقاط النص، بحيث تُستخدم شاشات التردد العالي إذا كانت القيمة الحالية أقل منها عند طباعة بيانات الخط. على سبيل المثال، إذا كانت القيمة هي 24، فإن كل الخطوط التي بحجم 24 أو أقل تستخدم شاشات التردد العالي. استخدم الخطوط الأصلية في محرك أقراص التخزين الذكي (ISD) تشغيل * إيقاف اسمح للمستخدم باختيار ما إذا كان سيتم استخدام الخطوط المجانية الموجودة في محرك التخزين الذكي (ISD). يظهر عنصر القائمة هذا فقط عند تركيب محرك أقراص تخزين ذكي (ISD). عمليات الجهاز الوضع الهادئ إيقاف * تشغيل لضبط كمية الضوضاء التي تحدثها الطابعة. يؤدي تمكين هذا الإعداد إلى خفض أداء الطابعة بصورة عامة. تمكين وضع الاندفاع تشغيل * إيقاف لتعيين الطابعة لتسريع صفحة واحدة وربما الصفحة الأولى من مهمة متعددة الصفحات لإنجاز المهمة بسرعة أكبر. يظهر عنصر القائمة هذا فقط في بعض طرازات الطابعات. الوضع الآمن إيقاف * تشغيل لتعيين الطابعة لتعمل في وضع خاص حيث توفر أكبر قدر ممكن من الوظائف بالرغم من المشكلات المعروفة. على سبيل المثال، عند التعيين على  تشغيل  وكان محرك الطباعة على الجانبين لا يعمل، يتم إجراء الطباعة على وجه واحد حتى إذا تم تعيين المهمة على الطباعة على الجانبين. يتيح تمكين هذا الإعداد الطباعة من وحدة التغذية متعددة الأغراض فقط. الحد الأدنى لذاكرة النسخ 20 ميغابايت 30 ميغابايت 50 ميغابايت 80 ميغابايت * 100 ميغابايت لتعيين تخصيص الذاكرة الأدنى لتخزين مهام النسخ. مسح الحالة المخصصة البدء حذف السلاسل المحددة من المستخدم للرسائل  الافتراضية  أو الرسائل  البديلة  المخصصة. مسح كل الرسائل المثبّتة عن بُعد البدء حذف الرسائل التي تم تثبيتها عن بُعد. عرض شاشات الخطأ تلقائيًا إيقاف تشغيل * لعرض رسائل الخطأ الموجودة على شاشة العرض بعد بقاء الطابعة غير نشطة على الشاشة الرئيسية لفترة من الوقت. الالتزام بالاتجاه أثناء نسخ المسار السريع إيقاف * تشغيل تعيين الطابعة لاستخدام إعداد الاتجاه ضمن قائمة  النسخ  عند إرسال مهام النسخ السريع. خدمة الذاكرة الدائمة حالة التشفير لإظهار حالة التشفير لمحرك التخزين. تشفير خدمة الذاكرة الدائمة تمكين تشفير الصورة المعكوسة يدويًا. إعداد مستشعر تصحيح مسحوق الحبر تفضيل تكرار المعايرة تعطيل تعديلات اللون الأقل تعديلات اللون القليلة عادي * دقة اللون الجيدة دقة اللون الأفضل لتعيين الطابعة لإدخال كمية مسحوق الحبر المناسبة للحفاظ على تناسق الألوان. معايرة كاملة البدء تشغيل معايرة اللون الكاملة. طباعة صفحة معلومات TPS البدء لطباعة صفحة تشخيص تحتوي على معلومات حول معايرة أداة استشعار تصحيح مسحوق الحبر. تهيئة التطبيق تطبيقات LES إيقاف تشغيل * لتمكين تطبيقات Lexmark Embedded Solutions ‏(LES). تهيئة الماسح الضوئي تسجيل دليل الماسح الضوئي اختبار الطباعة السريع تسجيل وحدة تغذية المستندات التلقائية الأمامية تسجيل وحدة تغذية المستندات التلقائية الخلفية التسجيل المسطح طباعة صفحة هدف الاختبار السريع، أو لتسجيل وحدة التغذية المسطحة ووحدة تغذية المستندات التلقائية (ADF) يدويًا بعد استبدال وحدة تغذية المستندات التلقائية (ADF) أو زجاج الماسحة الضوئية أو لوحة وحدة التحكم. عند طباعة صفحة هدف للاختبار السريع، تأكد من أن تباعد الهامش على الصفحة المستهدفة موحد على طول الطريق حول الهدف. إذا لم يكن منتظمًا، فيجب إعادة تعيين هوامش الطابعة. إعادة تعيين عداد الصيانة إعادة ضبط عداد صيانة ADF  ( البدء ) لإعادة تعيين العداد بعد استبدال مجموعة صيانة وحدة التغذية التلقائية بالمستندات (ADF). مسح الحافة مسح الحافة المسطحة  (3*) مسح حافة وحدة تغذية المستندات التلقائية  (3*) لتعيين حجم منطقة عدم الطباعة بالميليمتر حول وحدة تغذية المستندات التلقائية أو مهمة مسح ضوئي على ماسحة ضوئية مسطّحة. ADF Deskew (تصحيح الحدود في وحدة تغذية المستندات التلقائية) تصحيح الحدود الإلكترونية في وحدة تغذية المستندات التلقائية  ( تشغيل *) تخفيف تشوه الصفحات في المستندات الممسوحة ضوئيًا من وحدة تغذية المستندات التلقائية. تعطيل الماسح الضوئي لا * نعم ADF فقط لتعطيل الماسحة الضوئية عندما لا تعمل بشكل صحيح. ترتيب البايت بتنسيق Tiff ترتيب التخزين في وحدة المعالجة المركزية Little Endian Big Endian لتعيين ترتيب البايت لإخراجات المسح الضوئي بتنسيق TIFF. الصفوف الفعلية بتنسيق Tiff لكل شريط تشغيل * إيقاف تعيين قيمة علامة RowsPerStrip لمخرجات المسح الضوئي بتنسيق TIFF. حد تنظيف زجاج الماسحة الضوئية 1000–30000  (10000*) عيّن عدد عمليات المسح الضوئي التي يتم إجراؤها قبل حصول المستخدم على طلب تنظيف زجاج الماسحة الضوئية. القائمة قائمة التهيئة"},{"UUID":"dfd3173b-4715-42fe-9829-60cdfaa5f720","title":"الصيانة","link":"preferences-topic.html","desc":"المسح خارج نطاق الخدمة عناصر","descFull":"المسح خارج نطاق الخدمة عناصر قائمة المسح خارج نطاق الخدمة وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف المسح خارج نطاق الخدمة آخر تنظيف للذاكرة الإعداد عبارة عن معلومات للقراءة فقط. إظهار متى تم مسح ذاكرة الطابعة آخر مرة. التصحيح الأخير للقرص الثابت الإعداد عبارة عن معلومات للقراءة فقط. إظهار متى تم مسح القرص الثابت آخر مرة. يظهر عنصر القائمة هذا فقط عندما يتم تركيب قرص ثابت. آخر مسح لمحرك أقراص التخزين الذكي (ISD) الإعداد عبارة عن معلومات للقراءة فقط. إظهار متى تم مسح محرك التخزين الذكي (ISD) آخر مرة. يظهر عنصر القائمة هذا فقط عند تركيب محرك أقراص تخزين ذكي (ISD). تنظيف كل المعلومات الموجودة على الذاكرة الثابتة مسح كل إعدادات الطابعة وشبكة الاتصال مسح كل التطبيقات وإعدادات التطبيقات مسح كل الاختصارات وإعدادات الاختصارات مسح كل المعلومات الموجودة على الذاكرة الدائمة. تصحيح كل المعلومات على القرص الثابت مسح التنزيلات (مسح كل وحدات الماكرو والخطوط وإخراجات PFO، إلخ.) مسح المهام المخزّنة مؤقتًا مسح المهام المحجوزة مسح كافة المعلومات الموجودة على القرص الثابت. يظهر عنصر القائمة هذا فقط عندما يتم تركيب قرص ثابت. مسح محرك أقراص التخزين الذكي مسح مسح جميع المعلومات الموجودة على ISD. يظهر عنصر القائمة هذا فقط عند تركيب محرك أقراص تخزين ذكي (ISD). القائمة المسح خارج نطاق الخدمة"},{"UUID":"1f1262ea-c3c3-4f85-a4ae-182add0d71bd","title":"جهاز","link":"preferences-topic.html","desc":"تحديث البرنامج الثابت  عناصر","descFull":"تحديث البرنامج الثابت  عناصر قائمة تحديث البرنامج الثابت وأوصافها عنصر القائمة الإعدادات الوصف الإصدار الحالي الإعداد عبارة عن معلومات للقراءة فقط. عرض إصدار البرنامج الثابت المثبّت على الطابعة. تحقق من وجود تحديثات الآن التثبيت الآن تثبيت في وقت لاحق تحقق من وجود تحديثات للبرنامج الثابت. التحقق التلقائي من التحديثات تشغيل إيقاف * تعيين الطابعة للتحقق من وجود تحديثات للبرنامج الثابت تلقائيًا. القائمة تحديث البرنامج الثابت"},{"UUID":"69b211ce-f2b5-4e70-9abc-830536a2c265","title":"جهاز","link":"preferences-topic.html","desc":"حول هذه الطابعة عناصر قائمة","descFull":"حول هذه الطابعة عناصر قائمة حول هذه الطابعة وأوصافها عنصر القائمة الوصف علامة الأصول لتحديد هوية الطابعة. موقع الطابعة لتحديد موقع الطابعة. الاتصال لتحديد معلومات جهة الاتصال للطابعة. إصدار برنامج النظام لعرض إصدار البرنامج الثابت المثبّت على الطابعة. المشغل لعرض رقم محرّك الطابعة. الرقم التسلسلي عرض الرقم التسلسلي للطابعة. تصدير ملف التهيئة إلى USB تصدير ملف التهيئة إلى محرك أقراص فلاش. تصدير السجلات المضغوطة إلى USB تصدير ملفات السجلات المضغوطة إلى محرك الأقراص الفلاش. إرسال السجلات لإرسال معلومات سجل الطابعة إلى Lexmark. القائمة حول هذه الطابعة"},{"UUID":"43160df7-f8c5-48f7-ad45-2b262ee5101b","title":"طباعة","link":"layout-topic.html","desc":"التخطيط عناصر قائمة التخطيط وأوصافها","descFull":"التخطيط عناصر قائمة التخطيط وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. الأوجه على وجه واحد على وجهين * تحديد ما إذا كنت تريد الطباعة على وجه واحد من الورق أم على الوجهين. نمط القلب حافة طويلة * حافة قصيرة تحديد وجه الورقة الذي تريد أن يتم ربطه عند تنفيذ الطباعة على الجانبين. الصفحات الفارغة طباعة عدم الطباعة * لطباعة الصفحات الفارغة المضمنة في مهمة طباعة. ترتيب إيقاف (1,1,1,2,2,2) تشغيل (1,2,1,2,1,2) * لإبقاء صفحات مهمة طباعة مكدّسة بترتيب تسلسلي لا سيما عند طباعة نُسخ متعددة من المهمة. الأوراق الفاصلة لا شيء * بين النُسخ بين المهام بين الصفحات لإدخال أوراق فاصلة فارغة عند الطباعة. مصدر الأوراق الفاصلة الدرج  [x] (1*) وحدة التغذية المتعددة الأغراض تحديد مصدر الورق للورقة الفاصلة. عدد الصفحات لكل وجه إيقاف * صفحتان لكل وجه 3 صفحات لكل وجه 4 صفحات لكل وجه 6 صفحات لكل وجه 9 صفحات لكل وجه 12 صفحة لكل وجه 16 صفحة لكل وجه طباعة صور الصفحات المتعددة على وجه واحد من الورق. ترتيب الصفحات لكل وجه أفقي * عكس الأفقي رأسية عكس الرأسي تحديد موضع الصور في المستند المتعدد الصفحات عند استخدام قائمة  الصفحات لكل وجه . اتجاه الصفحات لكل وجه تلقائي * عرضي طولي تحديد اتجاه الصور في المستند المتعدد الصفحات عند استخدام قائمة  الصفحات لكل وجه . حد الصفحات لكل وجه لا شيء * متواصل طباعة حد حول كل صورة صفحة عند استخدام قائمة  الصفحات لكل وجه . النُسخ 1–9999  (1*) تحديد عدد النُسخ لكل مهمة طباعة. منطقة الطباعة عادي * ملاءمة الصفحة الصفحة الكاملة تعيين المساحة التي يمكن طباعتها على الورقة. القائمة التخطيط"},{"UUID":"bea76aa7-4ecc-466f-9d2c-a685656983b1","title":"طباعة","link":"layout-topic.html","desc":"الإنهاء عناصر قائمة الإنهاء وأوصافها","descFull":"الإنهاء عناصر قائمة الإنهاء وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. مهمة التدبيس إيقاف * ‎دبوس واحد، الزاوية العلوية اليسرى ‎دبوسان، على اليسار دبوس واحد، الزاوية العلوية اليمنى دبوسان، لأعلى دبوس واحد، الزاوية السفلية اليسرى دبوسان، لأسفل دبوس واحد، الزاوية السفلية اليمنى دبوسان، على اليمين تحديد موضع الدبوس لكل مهام الطباعة. لا يظهر عنصر القائمة هذا إلا عند تركيب وحدة إنهاء التدبيس. اختبار التدبيس البدء تحديد ما إذا كانت وحدة إنهاء التدبيس تعمل على نحو سليم. لا يظهر عنصر القائمة هذا إلا عند تركيب وحدة إنهاء التدبيس. تثقيب الفتحات إيقاف * تشغيل تثقيب فتحات بطول حافة المخرجات المطبوعة. يظهر عنصر القائمة هذا فقط في حال تركيب وحدة إنهاء التدبيس وتثقيب الفتحات. وضع تثقيب الفتحات فتحتان 3 فتحات 4 فتحات تعيين وضع تثقيب الفتحات للمخرجات المطبوعة. 3 فتحات  هو الإعداد الافتراضي للمصنع في الولايات المتحدة. إن  4 فتحات  هو إعداد المصنع الافتراضي العالمي. يظهر عنصر القائمة هذا فقط عند تركيب وحدة إنهاء التدبيس أو تثقيب الفتحات أو وحدة إنهاء الكتيبات. صفحات الإزاحة لا شيء * بين النُسخ بين المهام إزاحة المخرجات في كل مهمة طباعة أو كل نسخة من مهمة الطباعة. يعمل الإعداد  بين النُسخ  على إزاحة كل نسخة من مهمة الطباعة في حال تعيين  ترتيب  على  تشغيل [1،2،1،2،1،2]‎ . إذا تم تعيين الإعداد  ترتيب  على  إيقاف [1,1,1,2,2,2] ، فعندئذٍ تتم إزاحة كل مجموعة من الصفحات المطبوعة، على سبيل المثال كل الصفحات المشار إليها بالرقم 1 وكل الصفحات المشار إليها بالرقم 2. يؤدي الإعداد  بين المهام  إلى تعيين وضع الإزاحة نفسه لكامل مهمة الطباعة بغض النظر عن عدد النُسخ المطبوعة. القائمة الإنهاء"},{"UUID":"d0fe0220-08ae-4ac3-bf80-2632abe06984","title":"طباعة","link":"layout-topic.html","desc":"إعداد عناصر قائمة الإعداد وأوصافها","descFull":"إعداد عناصر قائمة الإعداد وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. لغة الطابعة محاكاة PCL محاكاة PS * لتعيين لغة الطابعة. لا يؤدي إعداد لغة الطابعة كلغة افتراضية إلى منع برنامج ما من إرسال مهام الطباعة التي تستخدم لغة طابعة أخرى. انتظار مهمة إيقاف * تشغيل للاحتفاظ بمهام الطباعة التي تتطلب مستلزمات لتمكين طباعة المهام التي لا تتطلب المستلزمات المفقودة. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. مهلة إيقاف المهمة 0–255  (30*) لتعيين الفترة الزمنية بالثواني التي تنتظرها الطابعة ليتدخل المستخدم قبل حجز المهام التي تتطلب موارد غير متوفرة. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. تنزيل الهدف ذاكرة الوصول العشوائي (RAM) * الفلاش القرص لتحديد موقع حفظ كل الموارد الدائمة التي يتم تنزيلها إلى الطابعة. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. استخدام الطابعة السرعة القصوى الحد الأقصى للإنتاجية * تلعب آلية السحب دورًا محوريًا في تحديد حالة وحدات مطور الألوان أثناء عملية الطباعة، حيث تُمكّنها من الانخراط في عملية نقل مسحوق الحبر الملون أو الانفصال عنها وفقًا لمتطلبات الطباعة. عند التعيين على  الحد الأقصى للإنتاجية ، يظل الجهاز متصل بوحدات مطور الألوان حتى عندما تكون الطابعة في وضع الخمول. عند التعيين على  السرعة القصوى ، يظل الجهاز متصل بوحدات مطور الألوان بغض النظر عن احتواء المهمة على محتوى أحادي اللون أو ملون. استخدام الطابعة المنخفض السرعة الحد الأقصى للإنتاجية * السرعة القصوى جب على الطابعة التبديل تلقائيًا بين \"الحد الأقصى للإنتاجية\" (وضع باللون الأسود) للطباعة أحادية اللون و\"السرعة القصوى\" (وضع الألوان) للطباعة الملونة، حتى في السرعات المنخفضة. يؤدي هذا الإعداد إلى تغيير سلوك الطابعة فقط عندما يعمل محرك الطباعة بسرعة معالجة تبلغ 25 صفحة في الدقيقة. ولن يكون له أي تأثير عند تشغيل محرك الطباعة بسرعات معالجة أعلى. حفظ المورد إيقاف * تشغيل لتحديد ماذا تفعل الطابعة بالموارد التي يتم تنزيلها عندما تتلقى مهمة تتطلب حجم ذاكرة أكبر من ذلك المتوفر. عند التعيين إلى  إيقاف ، تحتفظ الطابعة فقط بالموارد التي تم تنزيلها إلى أن تصبح الذاكرة مطلوبة. يتم حذف الموارد المرتبطة بلغة الطابعة غير النشطة. عند التعيين إلى  تشغيل ، تحتفظ الطابعة بكل الموارد الدائمة التي تم تنزيلها لكل اللغات. إذا لزم الأمر، تعرض الطابعة رسائل تشير إلى أن الذاكرة ممتلئة بدلاً من حذف الموارد الدائمة. ترتيب طباعة الكل ترتيب أبجدي * الأحدث أولاً الأقدم أولاً لتحديد الترتيب عند اختيار طباعة كل المهام المحجوزة والسرية. الحذف التلقائي لمهام الطباعة المحجوزة إيقاف * تشغيل اضبط الطابعة على إلغاء المهام الموجودة في قائمة الانتظار تلقائيًا عند مقاطعتها بأخطاء مثل انقطاع الورق ونقص المستلزمات. القائمة إعداد"},{"UUID":"538b49af-c858-4d5e-ac87-5d5116214544","title":"طباعة","link":"layout-topic.html","desc":"الجودة عناصر قائمة الجودة وأوصافها","descFull":"الجودة عناصر قائمة الجودة وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. وضع الطباعة غير متاح أبيض وأسود الألوان * تعيين كيفية إنشاء الطابعة لمحتوى بالألوان. دقة الطباعة غير متاح جودة اللون 4800 * 1200 نقطة لكل بوصة تعيين الدقة للمخرجات المطبوعة. توفر دقة  جودة اللون 4800  مخرجات عالية الجودة بسرعة قصوى. قتامة مسحوق الحبر غير متاح من 1 إلى 5  (4*) تحديد درجة نصوع الصور النصية أو قتامتها. ألوان نصفية غير متاح عادي * تفاصيل لتحسين المخرجات المطبوعة بحيث تكون خطوطها أكثر تجانسًا وحوافها أدق. موفر الألوان غير متاح إيقاف * تشغيل تقليل كمية مسحوق الحبر المستخدم لطباعة الرسومات والصور. عند التعيين إلى  تشغيل ، يتجاوز هذا الإعداد قيمة إعداد  قتامة الحبر . إضاءة RGB غير متاح من ‑6 إلى 6  (0*) لضبط سطوع كل عنصر RGB وعنصر رمادي على الصفحة. لا يؤثر هذا الإعداد في الملفات التي يتم فيها استخدام سمات ألوان CMYK. تباين RGB غير متاح من 0 إلى 5  (0*) لضبط تباين كل عنصر RGB وعنصر رمادي على الصفحة. لا يؤثر هذا الإعداد في الملفات التي يتم فيها استخدام سمات ألوان CMYK. تشبع RGB غير متاح من 0 إلى 5  (0*) للاحتفاظ بالقيم الأبيض والأسود مع ضبط قيم الألوان لكل عنصر على الصفحة. لا يؤثر هذا الإعداد في الملفات التي يتم فيها استخدام سمات ألوان CMYK. التصوير المتقدم توازن الألوان سماوي  (0*) أرجواني  (0*) أصفر  (0*) أسود  (0*) ضبط كمية مسحوق الحبر المستخدمة لكل لون. إعادة تعيين الإعدادات الافتراضية لإعادة تعيين كل إعدادات الألوان إلى قيمها الافتراضية. تصحيح الألوان إيقاف تلقائي * يدوي تعديل إعدادات الألوان المستخدمة لطباعة المستندات. يقوم الإعداد  إيقاف —بتعيين الطابعة إلى الحصول على تصحيح الألوان من البرنامج. يقوم الإعداد  تلقائي —بتعيين الطابعة إلى تطبيق ملفات تعريف الألوان المختلفة على كل عنصر في الصفحة المطبوعة. يسمح الإعداد  يدوي —بتخصيص تحويلات ألوان RGB أو CMYK التي يتم تطبيقها على كل عنصر في الصفحة المطبوعة. نماذج الألوان نماذج ألوان الطباعة اطبع صفحات نموذجية لكل من جداول تحويل الألوان RGB وCMYK المستخدمة في الطابعة. ضبط الألوان ضبط الألوان معايرة الطابعة لضبط تغييرات الألوان في المخرجات المطبوعة. استبدال الألوان الموضعي تعيين قيم CMYK مخصصة قم بتعيين قيم CMYK محددة لـ 20 لونًا موضعيًا محددًا. القائمة الجودة"},{"UUID":"eff0c60b-32a3-4442-a90d-3d3cfa7645ca","title":"طباعة","link":"layout-topic.html","desc":"حساب المهام عناصر قائمة حساب","descFull":"حساب المهام عناصر قائمة حساب المهام وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. حساب المهام إيقاف * تشغيل تعيين الطابعة لإنشاء سجل بمهام الطباعة التي تستلمها. تكرار سجل الحساب يوميًا أسبوعيًا شهريًا * تحديد عدد مرات إنشاء الطابعة لملف السجل. إجراء السجل عند نهاية التكرار لا شيء * إرسال السجل الحالي عبر البريد الإلكتروني البريد الإلكتروني وحذف السجل الحالي نشر السجل الحالي نشر وحذف السجل الحالي تحديد استجابة الطابعة عند انتهاء صلاحية حد التكرار. تُحدد القيمة المحددة في  تكرار سجل الحساب  عند تنفيذ هذا الإجراء. مستوى السجل ممتلئ تقريبًا تشغيل * (‏5 ميجابايت) إيقاف لتحديد الحد الأقصى لحجم ملف السجل قبل أن تنفذ الطابعة  سجل إجراء وشك الامتلاء . يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. سجل إجراء وشك الامتلاء لا شيء * إرسال السجل الحالي عبر البريد الإلكتروني البريد الإلكتروني وحذف السجل الحالي إرسال بريد إلكتروني وحذف السجل الأقدم نشر السجل الحالي نشر وحذف السجل الحالي نشر وحذف أقدم سجل حذف السجل الحالي حذف أقدم سجل حذف الكل باستثناء الحالي حذف كل السجلات حدد كيفية استجابة الطابعة عندما يكون محرك التخزين ممتلئًا تقريبًا. إن القيمة المحددة في إعداد  سجل وشك الامتلاء  تحدد وقت تنفيذ هذا الإجراء. سجل إجراء الامتلاء لا شيء * البريد الإلكتروني وحذف السجل الحالي إرسال بريد إلكتروني وحذف السجل الأقدم نشر وحذف السجل الحالي نشر وحذف أقدم سجل حذف السجل الحالي حذف أقدم سجل حذف الكل باستثناء الحالي حذف كل السجلات حدد كيفية استجابة الطابعة عندما يصل استخدام محرك التخزين إلى الحد الأقصى (100 ميجابايت). عنوان URL لنشر السجل يتم تحديد الإعداد من قبل المستخدم. تحديد المكان الذي تنشر فيه الطابعة سجلات حساب المهمة. عنوان البريد الإلكتروني لإرسال السجلات يتم تحديد الإعداد من قبل المستخدم. تحديد عنوان البريد الإلكتروني الذي ترسل إليه الطابعة سجلات حساب المهمة. بادئة ملف السجل يتم تحديد الإعداد من قبل المستخدم. تحديد البادئة المطلوبة لملفات السجل. يتم استخدام اسم المضيف الحالي المحدد في قائمة TCP/IP كبادئة ملف السجل الافتراضي. القائمة حساب المهام"},{"UUID":"7b91e1cd-8769-464c-b8f8-a68bd64d2062","title":"طباعة","link":"layout-topic.html","desc":"PDF عناصر قائمة PDF وأوصافها","descFull":"PDF عناصر قائمة PDF وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تغيير الحجم للملاءمة إيقاف * تشغيل تغيير حجم محتوى الصفحة لكي يلائم حجم الورق المحدد. التعليقات الإيضاحية طباعة عدم الطباعة * تحديد ما إذا كان لا بد من طباعة التعليقات الإيضاحية في PDF. خطأ في طباعة PDF إيقاف تشغيل * خطأ في تمكين طباعة PDF. القائمة PDF"},{"UUID":"338d9e9a-6345-48c0-a1fa-dc4579e80cfb","title":"طباعة","link":"layout-topic.html","desc":"PostScript PostScript عناصر قائمة PostScript","descFull":"PostScript PostScript عناصر قائمة PostScript وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. خطأ في طباعة PS إيقاف * تشغيل اطبع صفحة تصف خطأ مضاهاة PostScript®. عندما يحدث خطأ، تتوقف معالجة المهمة وتطبع الطابعة رسالة خطأ، ويتم التخلص من باقي مهمة الطباعة. الحد الأدنى لعرض السطر 1–30  (2*) لتعيين عرض الكتابة الأدنى. تستخدم المهام المطبوعة بدقة 1200 نقطة لكل بوصة القيمة مباشرةً. وضع بدء قفل PS إيقاف تشغيل * تعطيل ملف SysStart. يؤدي تمكين ملف SysStart إلى تعريض الطابعة أو شبكة الاتصال إلى خطر أمني. تجانس الصورة إيقاف * تشغيل تحسين التباين والوضوح في الصور منخفضة الدقة. لا يؤثر هذا الإعداد في الصور التي تصل دقتها إلى 300 نقطة لكل بوصة أو أعلى. أولوية الخط دائم * مؤقت/قرص إنشاء ترتيب البحث عن الخطوط. يقوم الخيار  دائم —بضبط الطابعة للبحث في ذاكرتها عن الخط المطلوب قبل البحث في محرك التخزين. يقوم الإعداد  الفلاش/القرص  — بضبط الطابعة للبحث في محرك التخزين عن الخط المطلوب قبل البحث في ذاكرة الطابعة. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. مهلة الانتظار إيقاف تشغيل * لتمكين الطابعة من الانتظار للحصول على المزيد من البيانات قبل إلغاء مهمة طباعة. عند التعيين على  تشغيل ، يكون إعداد المصنع الافتراضي هو 40 ثانية. القائمة PostScript"},{"UUID":"5ed98720-b8cd-47e3-97ca-34c087315f67","title":"طباعة","link":"layout-topic.html","desc":"PCL عناصر قائمة PCL وأوصافها","descFull":"PCL عناصر قائمة PCL وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. مصدر الخط دائم * القرص تنزيل ذاكرة محمولة بطاقة الخط الكل تحديد المصدر الذي يشمل تحديد الخط الافتراضي. القرص —يظهر فقط في حالة تثبيت قرص ثابت غير معيب وغير محمي للقراءة/الكتابة ويحتوي على خطوط. لا يظهر  تنزيل —إلا في حال وجود الخطوط التي تم تنزيلها في ذاكرة الطابعة. الفلاش —يظهر فقط في حالة تركيب ذاكرة فلاش غير معيبة وغير محمية للقراءة/الكتابة وتحتوي على خطوط. بطاقة الخط  — تظهر فقط في حالة تثبيت بطاقة خط صالحة أو تهيئة محرك تخزين ذكي. اسم الخط [قائمة الخطوط المتاحة] ( Courier *) لتحديد خط من مصدر الخطوط المحدد. مجموعة الرموز [قائمة مجموعات الرموز المتاحة] ( 10U PC‑8 *) تحديد مجموعة الرموز لاسم كل خط. مجموعة الرموز هي عبارة عن مجموعة من الحروف الأبجدية والرقمية وعلامات الترقيم والرموز الخاصة. تدعم مجموعات الرموز اللغات المختلفة أو برامج محددة مثل رموز الرياضيات الخاصة بالنص العلمي. مقياس الخطوط 0.08–100.00  (10.00*) تحديد مقياس الخطوط للخطوط الثابتة أو أحادية المسافة. يشير عنصر القائمة هذا إلى عدد أحرف المسافة الثابتة في بوصة أفقية من الكتابة. الاتجاه الاتجاه الطولي * عرضي عكس الاتجاه الطولي العكس الأفقي تحديد اتجاه النص والرسومات على الصفحة. الأسطر في كل صفحة 1–255 تحديد عدد الأسطر في النص لكل صفحة تمت طباعتها عبر دفق بيانات PCL®‎. يقوم عنصر القائمة هذا بتنشيط آلية التباعد الرأسي الذي يؤدي إلى طباعة عدد الأسطر المطلوبة المحدد بين هوامش الصفحة الافتراضية. \"60\" هو إعداد المصنع الافتراضي بالولايات المتحدة. \"64\" هو إعداد المصنع الافتراضي الدولي. الحد الأدنى لعرض السطر في PCL5 1–30  (2*) قم بتعيين الحد الأدنى الأولي لقيمة عرض الحد لأي مهمة مطبوعة بدقة 1200 نقطة في البوصة من خلال المحاكي المناسب. الحد الأدنى لعرض السطر في PCLXL 1–30  (2*) عرض A4 198 ملم * 203 ملم لتعيين عرض الصفحة المنطقية على ورق بحجم A4. الصفحة المنطقية هي الفراغ على الصفحة الفعلية حيث تتم طباعة البيانات. إرجاع حرف تلقائي بعد تغذية السطر تشغيل إيقاف * تعيين الطابعة على الرجوع إلى أول السطر بعد أمر تحكم تغذية السطر. الرجوع إلى أول السطر هو آلية تعطي أوامر للطابعة بتحرك موضع المؤشر إلى الموضع الأول على السطر نفسه. ‎تغذية سطر تلقائية بعد إرجاع الحرف بعد ‏‫إرجاع حرف تلقائي‬ تشغيل إيقاف * تعيين الطابعة على إضافة سطر بعد أمر تحكم الرجوع إلى أول السطر. إعادة ترقيم الدرج تخصيص وحدة تغذية متعددة الأغراض تعيين الدرج  [x] تخصيص الورق اليدوي تعيين الأظرف اليدوية تهيئة الطابعة للعمل مع برنامج تشغيل طباعة مختلف أو تطبيق مخصص يستخدم مجموعة مختلفة من نماذج المصدر لطلب مصدر ورق محدد. اختر من بين الخيارات التالية: إيقاف *—تستخدم الطابعة نماذج مصدر الورق الافتراضية للمصنع. بلا —يتجاهل مصدر الورق الأمر \"تحديد تغذية الورق\". 0–199 —حدد قيمة رقمية لتعيين قيمة مخصصة لمصدر ورق. عرض إعدادات المصنع الافتراضية عرض القيمة الافتراضية للمصنع المعيّنة لكل مصدر ورق. استعادة الإعدادات الافتراضية استعادة قيم إعادة ترقيم الدرج إلى إعدادات المصنع الافتراضية. زمن توقف الطباعة إيقاف تشغيل * (90) لتعيين الطابعة لإنهاء مهمة طباعة بعد البقاء في وضع الخمول للفترة المحددة من الوقت. القائمة دفق بيانات"},{"UUID":"3c8e2980-99c2-42e2-971f-175fe1d969f6","title":"طباعة","link":"layout-topic.html","desc":"صورة عناصر قائمة الصورة وأوصافها","descFull":"صورة عناصر قائمة الصورة وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. \"ملاءمة تلقائية\" تشغيل إيقاف * تحديد أفضل إعداد متاح لحجم الورق واتجاه الصورة. عند تعيين عنصر القائمة هذا إلى  تشغيل ، سيتجاوز إعدادات التحجيم والاتجاه للصورة. تبديل إيقاف * تشغيل لعكس الصور أحادية اللون ثنائية الدرجة. لا ينطبق عنصر القائمة هذا على تنسيقات صور GIF أو JPEG. التحجيم الملاءمة المثلى * إرساء إلى أعلى يسارًا إرساء في الوسط تناسب الارتفاع/العرض تناسب الارتفاع تناسب العرض ضبط الصورة لملاءمة المساحة التي يمكن طباعتها. عند تعيين  الملاءمة التلقائية  إلى  تشغيل ، يتم تعيين  التحجيم  تلقائيًا إلى  الملاءمة المثلى . الاتجاه الاتجاه الطولي * عرضي عكس الاتجاه الطولي العكس الأفقي تحديد اتجاه النص والرسومات على الصفحة. القائمة صورة"},{"UUID":"d6a2d7b1-b782-4f48-b927-46eb6c386419","title":"الورق","link":"tray-configuration-topic.html","desc":"تهيئة الدرج عناصر قائمة تهيئة","descFull":"تهيئة الدرج عناصر قائمة تهيئة الدرج وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. المصدر الافتراضي غير متاح الدرج  [x] (1*) وحدة التغذية المتعددة الأغراض ورق يدوي التغذية اليدوية للأظرف قم بتعيين مصدر ورق افتراضي لكافة مهام الطباعة. حجم الورق/نوعه الدرج  [x] وحدة التغذية المتعددة الأغراض ورق يدوي التغذية اليدوية للأظرف الحجم النوع تحديد حجم الورق أو نوع الورق الذي يتم تحميله في كل مصدر ورق. استبدال الحجم غير متاح إيقاف Statement/A5 Letter/A4 11 x 17/A3 كل الخيارات المدرجة * تعيين الطابعة على استبدال حجم ورق محدد إذا لم يتم تحميل الحجم المطلوب في أي مصدر ورق. يطالب الإعداد  إيقاف ‎—المستخدم بتحميل الطابعة بحجم الورق المطلوب. يسمح الإعداد  كل الخيارات المدرجة —كل عمليات الاستبدال المتاحة. تهيئة وحدة التغذية متعددة الأغراض غير متاح كاسيت * يدوي الأول تحديد أداء وحدة التغذية متعددة الأغراض. كاسيت —يؤدي هذا الإعداد إلى تهيئة وحدة التغذية متعددة الأغراض كمصدر تلقائي للورق. يدوي ‎—يؤدي هذا إعداد إلى تعيين وحدة التغذية متعددة الأغراض لمهام الطباعة بالتغذية اليدوية فقط. أولاً  يؤدي هذا الإعداد إلى تهيئة وحدة التغذية متعددة الأغراض كمصدر أساسي للورق. القائمة تهيئة الدرج"},{"UUID":"f7fa80fb-c374-4762-8ba3-42985057a0bd","title":"الورق","link":"tray-configuration-topic.html","desc":"تهيئة الوسائط عناصر قائمة تهيئة","descFull":"تهيئة الوسائط عناصر قائمة تهيئة الوسائط وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. وحدات القياس غير متاح بوصات مليمترات تحديد وحدة قياس الورق العالمي. بوصات  هو إعداد المصنع الافتراضي الخاص بالولايات المتحدة.  الميليمتر  هو إعداد المصنع الافتراضي الدولي. الإعداد العام كافة أدراج الإدخال العرض الرأسي تعيين العرض الرأسي للورق العالمي. الارتفاع الرأسي تعيين الارتفاع الرأسي للورق العالمي. اتجاه التغذية  ( الحافة القصيرة *) تعيين الطابعة لاختيار الورق من اتجاه الحافة القصيرة إلى الحافة الطويلة. تظهر  الحافة الطويلة  فقط إذا كانت الحافة الأطول أقصر من الحد الأقصى للعرض المدعوم. أحجام المسح الضوئي المخصصة اسم حجم المسح الضوئي يتم تحديد الإعداد من قبل المستخدم. قم بتعيين اسم للفحص المخصص. العرض 1.–8.5 بوصات  (8.5*) 25–215.9 ملم  (215.9*) حدد عرض المستند الأصلي. الارتفاع 1–25 بوصة  (11*) 25–635 ملم  (279.4*) حدد ارتفاع المستند الأصلي. الاتجاه الاتجاه الطولي * عرضي حدد اتجاه المحتوى في المستند الأصلي. عمليتا مسح ضوئي لكل جانب إيقاف * تشغيل قم بتعيين العدد الافتراضي لعمليات المسح على كل جانب من جوانب الطابعة. إعداد نوع الوسائط [قائمة أنواع الورق] الملمس الوزن اتجاه التحميل إرسال إلى الحاوية تحديد مادة الورق ووزنه واتجاهه. القائمة تهيئة الوسائط"},{"UUID":"2d4eff96-f771-48ea-8316-c88ad6ffc9f8","title":"الورق","link":"tray-configuration-topic.html","desc":"تهيئة الحاوية عناصر قائمة تهيئة","descFull":"تهيئة الحاوية عناصر قائمة تهيئة الحاوية وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. حاوية الإخراج الحاوية القياسية * الحاوية  [x] حدد حاوية الإخراج لمهام الطابعة. تهيئة الحاويات علبة البريد * ارتباط ارتباط اختياري تعيين النوع تهيئة وضع التشغيل لحاويات الإخراج. علبة البريد —تسمح بتحديد الحاوية القياسية وأي حاوية اختيارية بشكل فردي. الارتباط —يسمح بربط كل حاويات الإخراج معًا كما لو كانت حاوية واحدة كبيرة. الارتباط الاختياري ‎—يعامل كل الحاويات الاختيارية على أنها حاوية إخراج واحدة كبيرة. تعيين النوع —يقوم بإعداد بتعيين حاوية أو مجموعة حاويات مرتبطة لكل نوع من أنواع الورق. أسماء السلة المخصصة حاوية قياسية الحاوية  [x] قم بتعيين اسم لكل حاوية. القائمة تهيئة الحاوية"},{"UUID":"8c98e01f-d3a7-44da-a4fa-8e34d2caec68","title":"النسخ","link":"copy-defaults-topic.html","desc":"الإعدادات الافتراضية للنسخ  عناصر","descFull":"الإعدادات الافتراضية للنسخ  عناصر قائمة الإعدادات الافتراضية للنسخ وأوصافها عنصر القائمة عناصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. نوع المحتوى غير متاح نص نص/صورة فوتوغرافية * صورة فوتوغرافية رسومات تحسين نتيجة المخرجات استنادًا إلى محتوى المستند الأصلي. مصدر المحتوى غير متاح ليزر أسود وأبيض ليزر ألوان * ضخ الحبر‬ صورة فوتوغرافية/فيلم مجلة جريدة صحيفة غير ذلك تحسين نتيجة المخرجات استنادًا إلى مصدر المستند الأصلي. جوانب غير متاح وجه واحد على وجه واحد * وجه واحد على وجهين وجهين على وجه واحد وجهين على وجهين تحديد سلوك المسح الضوئي استنادًا إلى المستند الأصلي. الأوراق الفاصلة غير متاح لا شيء * بين النُسخ بين المهام بين الصفحات تحديد هل سيتم إدخال أوراق فاصلة فارغة عند الطباعة أم لا. مصدر الأوراق الفاصلة غير متاح الدرج  [x] (1*) وحدة التغذية المتعددة الأغراض تحديد مصدر الورق للورقة الفاصلة. اللون غير متاح إيقاف تشغيل * تلقائية تعيين الطابعة للحصول على إخراج الوان من مهمة مسح ضوئي. عدد الصفحات لكل وجه غير متاح إيقاف * صفحتان بالاتجاه الطولي 4 صفحات بالاتجاه الطولي صفحتان بالاتجاه الأفقي 4 صفحات بالاتجاه الأفقي تحديد عدد صور الصفحات المطلوب طباعتها على وجه واحد من الورق. طباعة حدود للصفحات غير متاح إيقاف * تشغيل وضع حد حول كل صورة عند طباعة العديد من الصفحات على ورقة واحدة. ترتيب غير متاح إيقاف [1,1,1,2,2,2] تشغيل [1,2,1,2,1,2] * طباعة العديد من النُسخ بترتيب تسلسلي. صفحات الإزاحة غير متاح لا شيء * بين النُسخ بين المهام إزاحة المخرجات في كل مهمة طباعة أو كل نسخة من مهمة الطباعة. بين النُسخ ‎—يعمل هذا الإعداد على إزاحة كل نسخة من مهمة الطباعة في حال تعيين  ترتيب  على  تشغيل [1،2،1،2،1،2]‎ . إذا تم تعيين الإعداد  ترتيب  على  إيقاف [1,1,1,2,2,2] ، فعندئذٍ تتم إزاحة كل مجموعة من الصفحات المطبوعة، على سبيل المثال كل الصفحات المرقمة بالرقم 1 وكل الصفحات المرقمة بالرقم 2. بين المهام —يؤدي هذا الإعداد إلى تعيين وضع الإزاحة نفسه لكامل مهمة الطباعة بغض النظر عن عدد النُسخ المطبوعة. لا يظهر عنصر القائمة هذا إلا عند تركيب وحدة تجميع الإزاحة أو وحدة إنهاء التدبيس وتثقيب الفتحات. تدبيس غير متاح إيقاف * ‎دبوس واحد، الزاوية العلوية اليسرى ‎دبوسان، على اليسار دبوس واحد، الزاوية العلوية اليمنى دبوسان، لأعلى دبوس واحد، الزاوية السفلية اليسرى دبوسان، لأسفل دبوس واحد، الزاوية السفلية اليمنى دبوسان، على اليمين 4 دبابيس تحديد موضع الدبوس لكل مهام الطباعة. لا يظهر عنصر القائمة هذا إلا عند تركيب وحدة إنهاء التدبيس. خرامة غير متاح إيقاف * فتحتان 3 فتحات 4 فتحات تثقيب الفتحات على الإخراج المطبوع. يظهر عنصر القائمة هذا فقط عند تركيب وحدة إنهاء التدبيس أو تثقيب الفتحات أو وحدة إنهاء الكتيبات. حجم \"النسخ من\" [قائمة بأحجام الورق] تعيين حجم الورق للمستند الأصلي. Letter  إعداد المصنع الافتراضي في الولايات المتحدة.  A4  هو إعداد المصنع الافتراضي الدولي. مصدر \"النسخ إلى\" غير متاح الدرج  [x] (1*) وحدة التغذية المتعددة الأغراض مطابقة الحجم تلقائيًا تحديد مصدر الورق لمهمة النسخ. درجة الحرارة غير متاح من ‑4 إلى 4  (0*) لتحديد إنشاء إخراج أكثر برودة أو أكثر سخونة. القتامة غير متاح من 1 إلى 9  (5*) ضبط قتامة الصورة الممسوحة ضوئيًا. عدد النُسخ غير متاح 1–9999  (1*) تحديد عدد النُسخ. رأس/تذييل الصفحة غير متاح الرأس الأيسر الرأس الأوسط الرأس الأيمن التذييل الأيسر التذييل الأوسط التذييل الأيمن تحديد معلومات الرأس أو التذييل على الصورة الممسوحة ضوئيًا. التراكب غير متاح سري النسخ مسودة عاجل مخصص إيقاف * تحديد نص التراكب للطباعة على كل نسخة. تراكب مخصص غير متاح يتم تحديد الإعداد من قبل المستخدم. اكتب النص لاختيار  مخصص  في قائمة  التراكب . التصوير المتقدم توازن الألوان سماوي إلى أحمر  (0*) أرجواني إلى أخضر  (0*) أصفر إلى أزرق  (0*) ضبط كثافة الألوان الأزرق السماوي والأرجواني والأصفر. سحب اللون سحب اللون  ( لا يوجد *) الحد الافتراضي للون الأحمر  (128*) الحد الافتراضي للون الأخضر  (128*) الحد الافتراضي للون الأزرق  (128*) تحديد اللون الذي سيتم سحبه أثناء المسح الضوئي، وضبط إعداد السحب لذلك اللون. اكتشاف اللون التلقائي حساسية الألوان  (5*) حساسية المنطقة  (5*) تهيئة إعداد اكتشاف الألوان تلقائيًا. التباين الأفضل للمحتوى * 0–5 تحديد التباين للصورة الممسوحة ضوئيًا. إزالة الخلفية اكتشاف الخلفية  ( مستنِد إلى المحتوى *) المستوى  (0*) إزالة لون الخلفية أو التشويش من صورة من المستند الأصلي. المستند إلى المحتوى —يزيل هذا الخيار لون الخلفية من المستند الأصلي. ثابت ‎—يزيل هذا الخيار التشويش من الصورة الفوتوغرافية. توسيط تلقائي إيقاف * تشغيل محاذاة المحتوى في منتصف الصفحة. صورة معكوسة إيقاف * تشغيل إنشاء صورة معكوسة من المستند الأصلي. صورة سلبية إيقاف * تشغيل إنشاء صورة سلبية من المستند الأصلي. تفاصيل الظل من ‑4 إلى 4  (0*) ضبط تفاصيل الظل في المستند الأصلي. مسح ضوئي من حافة إلى حافة إيقاف * تشغيل إجراء مسح ضوئي للمستند الأصلي من الحافة إلى الحافة. الوضوح 1–5  (3*) ضبط وضوح الصورة الممسوحة ضوئيًا. عناصر تحكم المسؤول السماح بنُسخ ملوّنة إيقاف تشغيل * طباعة نُسخ ملونة. السماح بالنُسخ ذات الأولوية إيقاف تشغيل * مقاطعة مهمة طباعة لإنشاء نُسخ. المسح الضوئي لمهمة مخصصة إيقاف * تشغيل تعيين الطابعة لمسح مجموعة المستندات الأصلية الأولى ضوئيًا باستخدام الإعدادات المحددة، ومن ثم إجراء مسح ضوئي للمجموعة التالية بنفس الإعدادات أو إعدادات مختلفة. للسماح بالحفظ كاختصار إيقاف تشغيل * حفظ إعدادات النسخ كاختصار. عينة نسخ إيقاف * تشغيل طباعة نسخة نموذجية للتحقق من الجودة قبل طباعة النُسخ المتبقية. القائمة الإعدادات الافتراضية للنسخ"},{"UUID":"2a0df596-d85e-4a63-8c9f-2ccb8a362deb","title":"إعدادات الفاكس الافتراضية","link":"fax-defaults-subgroup.html","desc":"وضع الفاكس عنصر قائمة ","descFull":"وضع الفاكس عنصر قائمة  وضع الفاكس  ووصفه عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. وضع الفاكس الفاكس * ملقم الفاكس تعطيل تحديد وضع الفاكس. القائمة وضع الفاكس"},{"UUID":"b6e0b4b0-e130-41e8-9dc1-034a1719c080","title":"إعدادات الفاكس الافتراضية","link":"fax-defaults-subgroup.html","desc":"إعداد الفاكس عناصر قائمة إعدادات","descFull":"إعداد الفاكس عناصر قائمة إعدادات الفاكس العامة وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. إعدادات الفاكس العامة اسم الفاكس يتم تحديد الإعداد من قبل المستخدم. لتحديد مُعرِّف الفاكس. رقم الفاكس يتم تحديد الإعداد من قبل المستخدم. لتحديد رقم الفاكس. مُعرّف الفاكس اسم الفاكس رقم الفاكس * لتعيين معرّف الفاكس الذي سيتم استخدامه في أثناء تفاوض الفاكس. تمكين إرسال الفاكس يدويًا إيقاف * تشغيل لتشغيل وظيفة الفاكس اليدوي في الطابعة. يتطلب عنصر القائمة هذا مشترك خط هاتف وسماعة هاتف. استخدام خط هاتف عادي للرد على مهمة فاكس واردة وطلب رقم الفاكس. للانتقال مباشرة إلى وظيفة الفاكس اليدوية، المس  #  و 0  على لوحة المفاتيح. استخدام الذاكرة استلام الكل معظم الذاكرة للاستلام مساوٍ * الأكثر إرسالاً إرسال الكل تعيين مقدار ذاكرة الطابعة الداخلية المخصصة لإرسال الفاكس. يمنع عنصر القائمة هذا حالات التخزين المؤقت للذاكرة والفاكسات الفاشلة. إلغاء الفاكسات السماح * عدم السماح لإلغاء رسائل الفاكس الصادرة أو الواردة. تغطية رقم الفاكس إيقاف * From Left (من اليسار) From Right (من اليمين) تحديد التنسيق المخصص لتغطية رقم الفاكس الصادر. إعدادات الفاكس العامة الأرقام التي تتم تغطيتها 0–58  (0*) لتحديد عدد الأرقام التي تتم تغطيتها في رقم الفاكس الصادر. لتمكين اكتشاف الخط المتصل إيقاف تشغيل * تحديد ما إذا كان خط الهاتف متصلاً بالطابعة. يتم اكتشاف الأحداث فورًا. Enable Line In Wrong Jack Detection (تمكين الخط أثناء الكشف عن المقبس الخاطئ) إيقاف تشغيل * تحديد ما إذا كان خط الهاتف متصلاً بمنفذ الطابعة الصحيح. يتم اكتشاف الأحداث فورًا. Enable Extension in Use Support (تمكين دعم الهاتف الداخلي المستخدم) إيقاف تشغيل * تحديد ما إذا كان خط الهاتف مستخدمًا من قبل جهاز آخر، مثل هاتف آخر على الخط نفسه. يتم اكتشاف الأحداث فورًا. تحسين توافق الفاكس يتم تحديد الإعداد من قبل المستخدم. تهيئة وظيفة الفاكس في الطابعة للحصول على توافق مثالي مع أجهزة الفاكس الأخرى. نقل الفاكس T.38 تناظري G.711 etherFAX تعيين طريقة نقل الفاكس. يظهر عنصر القائمة هذا فقط إذا كانت حزمة ترخيص etherFAX أو Fax Over IP‏ (FoIP) مثبتة في الطابعة. إعدادات فاكس HTTPS تظهر هذه القائمة فقط عند تعيين  نقل الفاكس  إلى  etherFAX . عنوان URL الخاص بخدمة HTTPS يتم تحديد الإعداد من قبل المستخدم. تحديد عنوان URL الخاص بخدمة etherFAX. وكيل HTTPS يتم تحديد الإعداد من قبل المستخدم. تحديد عنوان URL الخاص بالوكيل. مستخدم وكيل HTTPS يتم تحديد الإعداد من قبل المستخدم. تحديد اسم المستخدم وكلمة المرور لخادم الوكيل. كلمة مرور وكيل HTTPS تشفير إرسال الفاكس تعطيل ممكَّن * مطلوب تمكين التشفير لرسائل الفاكس الصادرة. تشفير استلام الفاكس تعطيل ممكَّن * مطلوب تمكين التشفير لرسائل الفاكس الواردة. حالة فاكس HTTPS الإعداد عبارة عن معلومات للقراءة فقط. عرض حالة اتصال etherFAX. إعدادات إرسال الفاكس درجة الوضوح قياسي * عالية ممتاز فائق الوضوح تعيين درجة وضوح الصورة الممسوحة ضوئيًا. تزيد الدقة العالية من مدة إرسال الفاكس وتتطلب مساحة ذاكرة أكبر. حجم المستند الأصلي [قائمة أحجام الورق] ( أحجام مختلطة *) تحديد حجم المستند الأصلي. الاتجاه الاتجاه الطولي * عرضي لتحديد اتجاه المستند الأصلي. جوانب إيقاف * حافة قصيرة حافة طويلة تحديد اتجاه المستند الأصلي عند إجراء المسح الضوئي على كلا جانبَي المستند. نوع المحتوى نص * نص/صورة فوتوغرافية صورة فوتوغرافية رسومات تحسين نتيجة المخرجات استنادًا إلى محتوى المستند الأصلي. مصدر المحتوى ليزر أسود وأبيض ليزر ألوان * ضخ الحبر صورة فوتوغرافية/فيلم مجلة جريدة صحيفة غير ذلك تحسين نتيجة المخرجات استنادًا إلى مصدر المستند الأصلي. القتامة 1–9  (5*) ضبط قتامة الصورة الممسوحة ضوئيًا. خلف PABX تشغيل إيقاف * تعيين الطابعة لطلب رقم الفاكس دون انتظار التعرّف على نغمة الطلب. التبادل الفرعي التلقائي الخاص (PABX) عبارة عن شبكة اتصال هاتفية تسمح بوجود رقم وصول فردي لتوفير خطوط متعددة للمتصلين من الخارج. وضع الاتصال النغمة * النبض تحديد وضع الاتصال للفاكسات الواردة أو الصادرة. التصوير المتقدم توازن الألوان سماوي - أحمر  (0*) أرجواني - أخضر  (0*) أصفر - أزرق  (0*) ضبط كثافة اللون أثناء المسح الضوئي. سحب اللون الأفضل للمحتوى * 0 1 2 3 4 5 تعيين تباين المخرجات. صورة معكوسة إيقاف * تشغيل إنشاء صورة معكوسة من المستند الأصلي. تفاصيل الظل من ‑4 إلى 4  (0*) ضبط القدر المرئي من تفاصيل الظل على الصورة الممسوحة ضوئيًا. مسح ضوئي من حافة إلى حافة إيقاف تشغيل * السماح بإجراء المسح الضوئي للمستند الأصلي من الحافة إلى الحافة. الوضوح 1–5  (3*) ضبط وضوح الصورة الممسوحة ضوئيًا. درجة الحرارة من ‑4 إلى 4  (0*) لتحديد إنشاء إخراج أكثر برودة أو أكثر سخونة. عناصر تحكم المسؤول إعادة اتصال تلقائي 0–9  (5*) لتحديد عدد محاولات الطابعة القيام بالطلب قبل إلغاء إرسال الفاكس إلى وجهة محددة. تردد إعادة الطلب من دقيقة إلى 200  دقيقة (3*) زيادة المدة الزمنية بين محاولات إعادة الاتصال لزيادة فرصة إرسال الفاكس بنجاح. \"تمكين ECM\" تشغيل * إيقاف تنشيط وضع تصحيح الخطأ (ECM) لمهام الفاكس. يكتشف وضع تصحيح الخطأ (ECM) الأخطاء في عملية نقل الفاكس التي تنتج من الضوضاء المصاحبة لخط الهاتف وقوة الإشارة الضعيفة ويصححها. لتمكين إجراء عمليات المسح الضوئي للفاكس تشغيل * إيقاف لإنشاء رسائل فاكس باستخدام الماسحة الضوئية في الطابعة. من برنامج التشغيل إلى الفاكس تشغيل * إيقاف السماح لبرنامج تشغيل الطباعة بإرسال الفاكس. للسماح بالحفظ كاختصار تشغيل * إيقاف حفظ أرقام الفاكسات كاختصارات على الطابعة. السرعة القصوى 33600 * 14400 9600 4800 2400 تعيين الحد الأقصى لسرعة إرسال الفاكس. المسح الضوئي لمهمة مخصصة إيقاف * تشغيل لتشغيل المسح الضوئي للمهام المخصصة بشكل افتراضي. معاينة المسح الضوئي إيقاف * تشغيل لعرض معاينة المسح الضوئي على شاشة العرض. ضبط انحراف وحدة تغذية المستندات التلقائية إيقاف تشغيل * لتصحيح الانحراف البسيط في الصورة الممسوحة ضوئيًا. لتمكين عمليات المسح الضوئي للفاكسات الملونة إيقاف بشكل افتراضي * تشغيل بشكل افتراضي عدم الاستخدام مطلقًا الاستخدام دائمًا تمكين عمليات المسح الضوئي الملونة لإرسال الفاكس. التحويل التلقائي للفاكسات الملونة إلى فاكسات أحادية اللون تشغيل * إيقاف تحويل جميع الفاكسات الملونة الصادرة إلى الأبيض والأسود. تأكيد رقم الفاكس إيقاف * تشغيل طلب تأكيد رقم الفاكس من المستخدم. بادئة الطلب يتم تحديد الإعداد من قبل المستخدم. تعيين بادئة الطلب. قواعد بادئة الطلب الهاتفي يتم تحديد الإعداد من قبل المستخدم. إنشاء قاعدة بادئة طلب هاتفي. إعدادات استلام الفاكس انتظار مهمة الفاكس لا شيء * مسحوق الحبر مسحوق الحبر والمستلزمات لإزالة مهام الفاكس التي تتطلب موارد محددة غير متوفرة من قائمة انتظار الطباعة. الرنات التي يجب الرد عليها 1–25  (3*) لتعيين عدد الرنات اللازمة قبل قيام الطابعة بالرد على الفاكسات الواردة. تقليل تلقائي تشغيل * إيقاف تغيير حجم الفاكس الوارد ليلائم حجم الصفحة. مصدر الورق الدرج  [x] تلقائي * لتعيين مصدر الورق لطباعة الفاكس الوارد. جوانب تشغيل إيقاف * الطباعة على وجهَي الورق. الأوراق الفاصلة لا شيء * قبل المهمة بعد المهمة تحديد هل سيتم إدخال أوراق فاصلة فارغة عند الطباعة أم لا. مصدر الأوراق الفاصلة الدرج  [x] (1*) تحديد مصدر الورق للورقة الفاصلة. حاوية الإخراج حاوية قياسية تحديد حاوية إخراج رسائل الفاكس المستلمة. تذييل الفاكس تشغيل إيقاف * طباعة معلومات الإرسال في الجزء السفلي من كل صفحة من صفحات الفاكس المستلَم. طابع الوقت في تذييل الفاكس استلام * طباعة لطباعة طابع التاريخ في الجزء السفلي من كل صفحة من فاكس مستلَم. إيقاف الفاكسات وضع الفاكس الموقوف  (إيقاف‏‎*) إيقاف طباعة الفاكسات المستَلَمة حتى يتم تحريرها. جدول إيقاف الفاكس لتعيين جدول لحجز الفاكسات. يظهر عنصر القائمة هذا فقط عند تعيين  وضع الفاكس المحجوز  إلى  مجدول . عناصر تحكم المسؤول تمكين استلام الفاكس تشغيل * إيقاف تعيين الطابعة لاستلام الفاكسات. لتمكين استلام الفاكس بالألوان تشغيل * إيقاف تعيين الطابعة لاستلام الفاكس بالألوان. تمكين معرّف المتصل تشغيل إيقاف * لعرض معلومات معرّف المتصل للمكالمة الواردة على شاشة عرض الطابعة. إعاقة استلام الفاكسات المجهولة تشغيل إيقاف * لحظر الفاكسات الواردة غير المزودة بمعرّف فاكس. قائمة الفاكسات الممنوعة إضافة فاكس محظور تحديد أرقام الهواتف التي تريد حظرها. الرد عند كل الرنات * الرنين المفرد فقط الرنين المزدوج فقط الرنين الثلاثي فقط رنات فردية أو مزدوجة فقط رنات فردية أو ثلاثية فقط الرنين المزدوج أو الثلاثي فقط تعيين نمط رنين مميز للفاكس الوارد. رد تلقائي تشغيل * إيقاف تعيين الطابعة لاستلام الفاكس تلقائيًا. رمز الرد اليدوي على المكالمات 0–9  (9*) إدخال رمز في لوحة أرقام الهاتف يدويًا لبدء استلام الفاكس. لا يظهر عنصر القائمة هذا إلا عندما تتشارك الطابعة مع خط الهاتف في الهاتف. لا يظهر عنصر القائمة هذا إلا عند تعيين الطابعة لاستلام الفاكس يدويًا. إعادة توجيه رسائل الفاكس الطباعة * طباعة وإعادة توجيه إعادة توجيه لتحديد ما إذا كنت تريد إعادة توجيه فاكس مستلَم. إعادة توجيه إلى وجهة 1 وجهة 2 تحديد أين تتم إعادة توجيه فاكس مستلم. يظهر عنصر القائمة هذا فقط عند تعيين  إعادة توجيه الفاكسات  إلى  طباعة وإعادة توجيه  أو  إعادة توجيه . السرعة القصوى 33600 * 14400 9600 4800 2400 تعيين الحد الأقصى لسرعة إرسال الفاكس. صفحة غلاف الفاكس صفحة غلاف الفاكس إيقاف بشكل افتراضي * تشغيل بشكل افتراضي عدم الاستخدام مطلقًا الاستخدام دائمًا تهيئة الإعدادات لصفحة غلاف الفاكس. تضمين حقل إلى إيقاف * تشغيل تضمين حقل من إيقاف * تشغيل من يتم تحديد الإعداد من قبل المستخدم. تضمين حقل الرسالة إيقاف * تشغيل الرسالة: يتم تحديد الإعداد من قبل المستخدم. تضمين شعار إيقاف * تشغيل تضمين تذييل [x] إيقاف * تشغيل تذييل [x] يتم تحديد الإعداد من قبل المستخدم. إعدادات سجل الفاكس تردد سجل الإرسال دائمًا * عدم الاستخدام عند الخطأ فقط تحديد عدد مرات إنشاء الطابعة سجل إرسال. إجراء سجل الإرسال الطباعة  ( تشغيل *) البريد الإلكتروني  ( إيقاف *) طباعة سجل لعمليات إرسال الفاكس الناجحة أو التي تُظهر أخطاء في الإرسال أو إرسالها عبر البريد الإلكتروني. سجل أخطاء الاستلام عدم الطباعة مطلقًا * تشغيل عند حدوث خطأ طباعة سجل لعمليات استلام الفاكس التي أظهرت فشلاً. سجلات طباعة تلقائية تشغيل * إيقاف طباعة كل أنشطة الفاكس. مصدر ورق السجل الدرج  [x] (1*) تحديد مصدر الورق لطباعة السجلات. عرض السجلات اسم الفاكس البعيد * الرقم المطلوب تعريف المُرسِل عن طريق اسم الفاكس البعيد أو رقم الفاكس. تمكين سجل المهمة تشغيل * إيقاف عرض ملخص بكل مهام الفاكس. تمكين سجل المكالمات تشغيل * إيقاف لعرض ملخص بمحفوظات مكالمات الفاكس. سلة إخراج السجلات الحاوية القياسية * الحاوية  [x] تحديد حاوية الإخراج للسجلات المطبوعة. إعدادات السماعة وضع السماعة إيقاف دائمًا * تشغيل دومًا تشغيل حتى التوصيل تعيين وضع مكبر الصوت الداخلي للفاكس. صوت السماعة منخفض * عالٍ ضبط مستوى صوت مكبر الصوت الداخلي للفاكس. مستوى صوت الجرس إيقاف * تشغيل تمكين مستوى صوت الرنين. VoIP Settings (إعدادات VoIP) بروتوكول VoIP SIP * H.323 لتعيين بروتوكول نقل الصوت عبر بروتوكول الإنترنت (VoIP). ملقم STUN يتم تحديد الإعداد من قبل المستخدم. لتحديد ملقم STUN المستخدم لعبور جدار حماية. فرض وضع الفاكس إيقاف تشغيل * لتبديل مدخل VoIP من تناظري إلى T.38 في بداية مكالمة الفاكس. فرض تأخير وضع الفاكس 0–15  (7*) لتعيين فترة التأخير بالثواني عند إرسال دعوة أخرى من  فرض وضع الفاكس . إعدادات SIP الوكيل يتم تحديد الإعداد من قبل المستخدم. لتحديد عنوان IP للنظام الذي يحوّل رقم الهاتف إلى عنوان IP الذي يتم إرسال الفاكس إليه. دائرة السجلات يتم تحديد الإعداد من قبل المستخدم. لتحديد اسم أو عنوان IP للنظام الذي يعالج تسجيل الأجهزة العميلة لبروتوكول بدء الجلسة (SIP). المستخدم يتم تحديد الإعداد من قبل المستخدم. لتحديد اسم مستخدم SIP. كلمة المرور يتم تحديد الإعداد من قبل المستخدم. لتحديد كلمة المرور المستخدمة للتسجيل في مسجّل SIP. معرّف التصديق يتم تحديد الإعداد من قبل المستخدم. اسم المستخدم الذي يتم استخدامه عند التسجيل. إذا لم يتم تعيين إعداد  معرّف المصادقة  فسيستخدم الإعداد اسم المستخدم لملء حقل المستخدم بدلاً من ذلك. النقل للتسجيل UDP * برنامج التعاون الفني لتعيين نوع نقل SIP للتسجيل. النقل للمكالمات الواردة UDP * برنامج التعاون الفني UDP وTCP لتعيين نوع نقل SIP للمكالمات الواردة. نقل المكالمات الصادرة UDP * برنامج التعاون الفني لتعيين نوع نقل SIP للمكالمات الصادرة. وكيل الاتصالات الصادرة يتم تحديد الإعداد من قبل المستخدم. لتحديد وكيل للاتصالات الصادرة من أجل إعادة توجيه كل اتصالات SIP. الاتصال يتم تحديد الإعداد من قبل المستخدم. لتحديد اسم جهة اتصال لـ SIP. النطاق يتم تحديد الإعداد من قبل المستخدم. لتحديد اسم نطاق لـ SIP. إذا لم يتم تعيين إعداد النطاق، فسيستخدم الإعداد اسم  جهة الاتصال  بدلاً من ذلك. حالة تسجيل SIP الإعداد عبارة عن معلومات للقراءة فقط. لعرض حالة تسجيل SIP. إعدادات H.323 المدخل يتم تحديد الإعداد من قبل المستخدم. لتحديد عنوان IP الخاص بمدخل H.323. حارس البوابة يتم تحديد الإعداد من قبل المستخدم. لتحديد حارس بوابة H.323. المستخدم يتم تحديد الإعداد من قبل المستخدم. لتحديد اسم المستخدم الذي يتم استخدامه مع مدخل H.323. كلمة المرور يتم تحديد الإعداد من قبل المستخدم. لتحديد كلمة المرور الخاصة بمدخل H.323. تمكين البدء السريع إيقاف * تشغيل لتمكين البدء السريع. تعطيل نفقية H.245 إيقاف * تشغيل لتعطيل نفقية H.323. تعطيل اكتشاف حارس البوابة إيقاف تشغيل * لتعطيل اكتشاف حارس بوابة H.323. إعدادات T.38 تكرار المؤشر 0–5  (3*) لتعيين عدد المرات التي يتم فيها تكرار مؤشر فاكس في اتصال T.38. التكرار المنخفض السرعة 0–5  (3*) لتعيين عدد المرات التي يتم فيها تكرار البيانات المنخفضة السرعة في اتصال T.38. التكرار العالي السرعة 0–5  (1*) لتعيين عدد المرات التي يتم فيها تكرار البيانات العالية السرعة في اتصال T.38. القائمة إعداد الفاكس"},{"UUID":"4dbd55aa-1b32-4599-876b-4044aa41cdd7","title":"إعدادات الفاكس الافتراضية","link":"fax-defaults-subgroup.html","desc":"إعداد ملقم الفاكس إعدادات الفاكس","descFull":"إعداد ملقم الفاكس إعدادات الفاكس العامة عناصر قائمة إعدادات الفاكس العامة وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. إلى تنسيق غير متاح تحديد مستلم الفاكس. إذا كنت تريد استخدام رقم الفاكس، فاكتب علامة الرقم (#) قبل الرقم. عنوان الرد غير متاح تحديد عنوان رد لإرسال الفاكس. الموضوع غير متاح تحديد موضوع ورسالة الفاكس. الرسالة غير متاح تمكين الاستلام التناظري إيقاف * تشغيل إعداد الطابعة لاستلام الفاكسات التناظرية. إعدادات البريد الإلكتروني لملقم الفاكس عناصر قائمة  إعدادات البريد الإلكتروني لملقم الفاكس  وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. استخدام ملقم SMTP للبريد الإلكتروني تشغيل إيقاف * استخدام إعدادات بروتوكول نقل البريد البسيط (SMTP) للبريد الإلكتروني في استلام الفاكسات وإرسالها. عند التعيين إلى  تشغيل ، لا يظهر أي من الإعدادات الأخرى لقائمة  إعدادات البريد الإلكتروني لخادم الفاكس . مدخل SMTP الرئيسي غير متاح كتابة عنوان IP أو اسم الجهاز المضيف الخاص بملقم SMTP الأولي. منفذ مدخل SMTP الرئيسي 1–65535 (25*) أدخل رقم المنفذ الخاص بملقم SMTP الأولي. مدخل SMTP الثانوي غير متاح اكتب عنوان IP الخاص بالملقم أو اسم الجهاز المضيف لملقم SMTP الثانوي أو الاحتياطي. منفذ مدخل SMTP الثانوي 1–65535 (25*) لإدخال رقم منفذ الملقم الخاص بملقم SMTP الثانوي أو الاحتياطي. مهلة SMTP 5–30 (30*) تعيين الوقت قبل أن ينتهي وقت الطابعة إذا لم يستجب خادم SMTP. عنوان الرد غير متاح تحديد عنوان رد لإرسال الفاكس. استخدام SSL/TLS معطّل * تفاوض مطلوب تحديد هل يمكن إرسال فاكس باستخدام ارتباط مٌشفر. المطالبة بشهادة موثوقة إيقاف تشغيل * تحديد شهادة موثوقة عند الوصول إلى ملقم SMTP. مصادقة ملقم SMTP لا يُطلَب أي مصادقة * تسجيل الدخول/عادي NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 قم بتعيين نوع المصادقة لملقم SMTP. البريد الإلكتروني المُبادر من الجهاز لا شيء * استخدام بيانات اعتماد SMTP للجهاز تحديد ما إذا كانت بيانات الاعتماد مطلوبة للبريد الإلكتروني الذي بدأه الجهاز. بريد إلكتروني يبدأه المستخدم لا شيء * استخدام بيانات اعتماد SMTP للجهاز استخدام مُعرِّف مستخدم الجلسة وكلمة مرورها استخدام عنوان البريد الإلكتروني للجلسة وكلمة مرورها مطالبة المستخدم تحديد ما إذا كانت بيانات الاعتماد مطلوبة للبريد الإلكتروني الذي بدأه المستخدم. استخدام بيانات اعتماد جهاز الدليل النشط إيقاف * تشغيل تمكين بيانات اعتماد المستخدم ووجهات المجموعة للاتصال بملقم SMTP. مُعرِّف مستخدم الجهاز غير متاح تحديد معرّف المستخدم وكلمة المرور للاتصال بخادم SMTP. كلمة مرور الجهاز غير متاح Kerberos 5 REALM غير متاح قم بتحديد realm لبروتوكول مصادقة Kerberos 5. مجال NTLM غير متاح قم بتحديد اسم المجال لبروتوكول أمان NTLM. تعطيل خطأ \"لم يتم إعداد ملقم SMTP\" إيقاف * تشغيل لإخفاء رسالة الخطأ \"لم يتم إعداد ملقم SMTP\". إعدادات المسح الضوئي لخادم الفاكس عناصر قائمة  إعدادات المسح الضوئي لملقم الفاكس  وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تنسيق الصورة TIFF (.tif) PDF ‏(‎.pdf) * XPS ‏(‎.xps) TXT (.txt) RTF ‏(‎.rtf) DOCX ‏(‎.docx) XLSX ‏(‎.xlsx) CSV (.csv) تحديد تنسيق الملف للصورة الممسوحة ضوئيًا. نوع المحتوى نص * نص/صورة فوتوغرافية صورة فوتوغرافية رسومات تحسين نتيجة المخرجات استنادًا إلى محتوى المستند الأصلي. مصدر المحتوى ليزر أسود وأبيض ليزر ألوان * ضخ الحبر صورة فوتوغرافية/فيلم مجلة جريدة صحيفة غير ذلك تحسين نتيجة المخرجات استنادًا إلى مصدر المستند الأصلي. دقة الفاكس قياسي * عالية ممتاز فائق الوضوح تعيين دقة الفاكس. جوانب إيقاف * حافة قصيرة حافة طويلة تحديد اتجاه المستند الأصلي عند إجراء المسح الضوئي على كلا جانبَي المستند.   القتامة 1–9 (5*) تعيين قتامة مسحوق الحبر للإخراج. الاتجاه الاتجاه الطولي * عرضي تحديد اتجاه النص والرسومات على الصفحة. حجم المستند الأصلي [قائمة بأحجام الورق] تعيين حجم الورق للمستند الأصلي. يكون  أحجام مختلطة  هو إعداد المصنع الافتراضي بالولايات المتحدة.  A4  هو إعداد المصنع الافتراضي الدولي. قد يختلف هذا الإعداد وفقًا لطراز الطابعة التي تستخدمها. استخدام ملفات TIFF متعددة الصفحات إيقاف تشغيل * اختيار بين ملفات ذات صفحة واحدة وملفات متعددة الصفحات بتنسيق TIFF. القائمة إعداد ملقم الفاكس"},{"UUID":"27b1d615-4ffa-4587-b251-36b9cd791c52","title":"البريد الإلكتروني","link":"email-setup-topic.html","desc":"إعداد البريد الإلكتروني  عناصر","descFull":"إعداد البريد الإلكتروني  عناصر قائمة إعداد البريد الإلكتروني وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. مدخل SMTP الرئيسي يتم تحديد الإعداد من قبل المستخدم. كتابة عنوان IP أو اسم الجهاز المضيف الخاص بملقم SMTP الأولي لإرسال رسالة بريد إلكتروني. منفذ مدخل SMTP الرئيسي 1–65535 (25*) أدخل رقم المنفذ الخاص بملقم SMTP الأولي. مدخل SMTP الثانوي يتم تحديد الإعداد من قبل المستخدم. اكتب عنوان IP الخاص بالملقم أو اسم الجهاز المضيف لملقم SMTP الثانوي أو الاحتياطي. منفذ مدخل SMTP الثانوي 1–65535  (25*) لإدخال رقم منفذ الملقم الخاص بملقم SMTP الثانوي أو الاحتياطي. مهلة SMTP 5–30 ثانية  (30*) تعيين الوقت قبل أن ينتهي وقت الطابعة إذا لم يستجب خادم SMTP. عنوان الرد يتم تحديد الإعداد من قبل المستخدم. تحديد عنوان رد في البريد الإلكتروني. استخدام عنوان الرد الافتراضي الخاص بـ SMTP دائمًا تشغيل إيقاف * لاستخدام عنوان الرد الافتراضي في ملقم SMTP دائمًا. استخدام SSL/TLS معطّل * تفاوض مطلوب تحديد ما إذا كنت تريد إرسال بريد إلكتروني باستخدام ارتباط مُشفر. المطالبة بشهادة موثوقة إيقاف تشغيل * المطالبة بشهادة موثوقة عند الوصول إلى ملقم SMTP. مصادقة ملقم SMTP لا يُطلَب أي مصادقة * تسجيل الدخول/عادي NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 قم بتعيين نوع المصادقة لملقم SMTP. بريد إلكتروني يبدأه الجهاز لا شيء * لا شيء * استخدام بيانات اعتماد SMTP للجهاز تحديد ما إذا كانت بيانات الاعتماد مطلوبة للبريد الإلكتروني الذي بدأه الجهاز. بريد إلكتروني يبدأه المستخدم لا شيء * استخدام بيانات اعتماد SMTP للجهاز استخدام مُعرِّف مستخدم الجلسة وكلمة مرورها استخدام عنوان البريد الإلكتروني وكلمة المرور للجلسة مطالبة المستخدم تحديد ما إذا كانت بيانات الاعتماد مطلوبة للبريد الإلكتروني الذي بدأه المستخدم. استخدام بيانات اعتماد جهاز الدليل النشط إيقاف * تشغيل تحديد ما إذا كانت بيانات الاعتماد مطلوبة للبريد الإلكتروني الذي بدأه المستخدم. مُعرِّف مستخدم الجهاز يتم تحديد الإعداد من قبل المستخدم. تحديد معرّف المستخدم وكلمة المرور للاتصال بخادم SMTP. كلمة مرور الجهاز يتم تحديد الإعداد من قبل المستخدم. Kerberos 5 REALM يتم تحديد الإعداد من قبل المستخدم. قم بتحديد realm لبروتوكول مصادقة Kerberos 5. مجال NTLM يتم تحديد الإعداد من قبل المستخدم. قم بتحديد اسم المجال لبروتوكول أمان NTLM. تعطيل خطأ \"لم يتم إعداد خادم SMTP\" إيقاف * تشغيل لإخفاء رسالة الخطأ \"لم يتم إعداد ملقم SMTP\". القائمة إعداد البريد الإلكتروني"},{"UUID":"37b23029-86fa-4b85-9f6d-376ed0f6462e","title":"البريد الإلكتروني","link":"email-setup-topic.html","desc":"إعدادات البريد الإلكتروني الافتراضية ","descFull":"إعدادات البريد الإلكتروني الافتراضية  عناصر قائمة إعدادات البريد الإلكتروني الافتراضية وأوصافها عنصر القائمة عناصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. الموضوع: غير متاح يتم تحديد الإعداد من قبل المستخدم. تحديد موضوع ورسالة البريد الإلكتروني. الرسالة: غير متاح يتم تحديد الإعداد من قبل المستخدم. اسم الملف غير متاح يتم تحديد الإعداد من قبل المستخدم. تحديد اسم الملف للمستند الممسوح ضوئيًا. تهيئة غير متاح JPEG (.jpg) PDF ‏(‎.pdf) * TIFF (.tif) XPS ‏(‎.xps) TXT (.txt) RTF ‏(‎.rtf) DOCX ‏(‎.docx) CSV (.csv) تحديد تنسيق الملف للمستند الممسوح ضوئيًا. قد تختلف عناصر القائمة بحسب طراز طابعتك. الإعدادات العامة للتعرف الضوئي على الأحرف اللغات المعروفة [قائمة اللغات] لتهيئة إعدادات التعرف الضوئي على الأحرف (OCR). يظهر عنصر القائمة هذا في حال قمت بشراء حلّ التعرف الضوئي على الأحرف وتثبيته. تدوير تلقائي إيقاف * تشغيل تسوية الألوان إيقاف * تشغيل تحسين التباين التلقائي إيقاف * تشغيل إعدادات PDF إصدار PDF 1.3 1.4 1.5 * 1.6 1.7 تهيئة إعدادات PDF للصورة الممسوحة ضوئيًا. يتم دعم  ‎الإصدار الأرشيفي  و ‎الإصدار الأرشيفي (PDF/A)  فقط إذا تم تعيين  إصدار PDF  إلى 1.4 أو 1.7. Highly Compressed  يظهر هذا الخيار فقط عندما يتم تركيب محرك أقراص تخزين ذكي (ISD). آمن  يتم دعمه فقط عندما يتم تعيين  إصدار PDF  على 1.4 أو أعلى. أرشيفي (PDF/A) إيقاف * تشغيل إصدار أرشيفي A‑1a * A‑1b A‑2u مضغوط لدرجة عالية إيقاف * تشغيل آمن إيقاف * تشغيل قابل للبحث إيقاف * تشغيل تقسيم المهمة حسب الصفحات 0 * نوع المحتوى غير متاح نص نص/صورة فوتوغرافية * صورة فوتوغرافية رسومات لتحديد محتوى المستند الأصلي. مصدر المحتوى غير متاح ليزر أبيض وأسود * ليزر ألوان ضخ الحبر‬ صورة فوتوغرافية/فيلم مجلة جريدة صحيفة غير ذلك لتحديد مصدر المستند الأصلي. اللون غير متاح أبيض وأسود رمادي الألوان * تلقائية حدد كيفية التقاط المستند الأصلي. درجة الوضوح غير متاح 75 نقطة لكل بوصة 150 نقطة لكل بوصة * 200 نقطة لكل بوصة 300 نقطة لكل بوصة 400 نقطة لكل بوصة 600 نقطة لكل بوصة تعيين درجة وضوح الصورة الممسوحة ضوئيًا. القتامة غير متاح 1–9  (5*) ضبط قتامة الصورة الممسوحة ضوئيًا. الاتجاه غير متاح الاتجاه الطولي * عرضي لتحديد اتجاه المستند الأصلي. حجم المستند الأصلي غير متاح أحجام مختلطة تعيين حجم الورق للمستند الأصلي. جوانب غير متاح إيقاف * حافة قصيرة حافة طويلة تحديد اتجاه المستند الأصلي عند إجراء المسح الضوئي على كلا جانبَي المستند. التصوير المتقدم عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. توازن الألوان سماوي أرجواني أصفر ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) ضبط كثافة الألوان الأزرق السماوي والأرجواني والأصفر. سحب اللون سحب اللون لا شيء * أحمر أخضر أزرق تحديد اللون الذي سيتم سحبه أثناء المسح الضوئي، وضبط إعداد السحب لذلك اللون. الحد الافتراضي للأحمر 0–255  (128*) الحد الافتراضي للأخضر 0–255  (128*) الحد الافتراضي للأزرق 0–255  (128*) اكتشاف اللون التلقائي حساسية اللون 1–9  (5*) تهيئة إعداد اكتشاف الألوان تلقائيًا. حساسية المنطقة 1–9  (5*) عمق بت للبريد الإلكتروني 1 بت * 8 بت الحد الأدنى لدقة المسح الضوئي 75 نقطة لكل بوصة 150 نقطة لكل بوصة 200 نقطة لكل بوصة 300 نقطة لكل بوصة * جودة JPEG غير متاح الأفضل للمحتوى * 5–95 تعيين جودة JPEG للصورة الممسوحة ضوئيًا. التباين غير متاح الأفضل للمحتوى * 0–5 تحديد التباين للصورة الممسوحة ضوئيًا. إزالة الخلفية اكتشاف الخلفية مستند إلى المحتوى * ثابت المستوى‏‎  من ‑4 إلى 4  (0*) إزالة لون الخلفية أو التشويش من صورة من المستند الأصلي. صورة معكوسة غير متاح إيقاف * تشغيل إنشاء صورة معكوسة من المستند الأصلي. صورة سلبية غير متاح إيقاف * تشغيل إنشاء صورة سلبية من المستند الأصلي. تفاصيل الظل غير متاح من ‑4 إلى 4  (0*) ضبط تفاصيل الظلال في الصورة الممسوحة ضوئيًا. مسح ضوئي من حافة إلى حافة غير متاح إيقاف * تشغيل إجراء مسح ضوئي للمستند الأصلي من الحافة إلى الحافة. الوضوح غير متاح 1–5  (3*) ضبط وضوح الصورة الممسوحة ضوئيًا. درجة الحرارة غير متاح من ‑4 إلى 4  (0*) إنشاء مخرج أكثر زرقة أو احمرارًا للمستند الأصلي. الصفحات الفارغة إزالة الصفحة الفارغة عدم الإزالة * إزالة قم بإزالة الصفحات الفارغة من المستند الأصلي. استشعار الصفحة الفارغة 1–9  (5*) تعيين استشعار عمليات المسح الضوئي بالنسبة إلى الصفحات الفارغة في المستند الأصلي. عناصر تحكم المسؤول عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. أقصى حجم للبريد الإلكتروني 0–65535  (0*) تعيين حجم الملف المسموح به لكل بريد إلكتروني. رسالة أخطاء الحجم يتم تحديد الإعداد من قبل المستخدم. تحديد رسالة خطأ ترسلها الطابعة عندما يتجاوز بريد إلكتروني حجم الملف المسموح به. يمكنك كتابة ما يصل إلى 1024 حرفًا. تحديد الوجهات يتم تحديد الإعداد من قبل المستخدم. قصر إرسال البريد الإلكتروني على قائمة أسماء المجالات المحددة. استخدام فاصلة للفصل بين المجالات. إرسال نسخة لي عدم الظهور مطلقًا * تشغيل بشكل افتراضي إيقاف بشكل افتراضي تشغيل دومًا إرسال نسخة من البريد الإلكتروني إلى نفسك. السماح برسائل البريد الإلكتروني الذاتية فقط إيقاف * تشغيل تعيين الطابعة لإرسال رسائل البريد الإلكتروني إليك فقط. استخدام \"نسخة:/مخفية:\" إيقاف * تشغيل تمكين نسخة مماثلة ونسخة مماثلة مخفية في البريد الإلكتروني. استخدام ملفات TIFF متعددة الصفحات إيقاف * تشغيل تمكين المسح الضوئي لعدة صور TIFF في ملف TIFF واحد. ضغط TIFF JPEG LZW * تعيين نوع الضغط لملفات TIFF. الإعداد الافتراضي للنص 5–95  (75*) تعيين جودة النص في المحتوى الذي يتم مسحه ضوئيًا. الإعداد الافتراضي للوضع نص/صورة الفوتوغرافية 5–95  (75*) تعيين جودة النص والصورة الفوتوغرافية في المحتوى الذي يتم مسحه ضوئيًا. الإعداد الافتراضي للصورة الفوتوغرافية 5–95  (50*) تعيين جودة الصورة الفوتوغرافية للمحتوى الذي يتم مسحه ضوئيًا. ضبط انحراف وحدة تغذية المستندات التلقائية إيقاف * تشغيل تعيين الطابعة لضبط الصور المنحرفة من المستندات الممسوحة ضوئيًا من وحدة تغذية المستندات التلقائية (ADF). سجل الإرسال طباعة السجل * عدم طباعة السجل طباعة الأخطاء فقط طباعة سجل إرسال لعمليات مسح البريد الإلكتروني الضوئية. مصدر ورق السجل الدرج  [x] (1*) وحدة التغذية المتعددة الأغراض تحديد مصدر الورق لطباعة السجلات. المسح الضوئي لمهمة مخصصة إيقاف * تشغيل تعيين الطابعة لمسح مجموعة المستندات الأصلية الأولى ضوئيًا باستخدام الإعدادات المحددة، ومن ثم إجراء مسح ضوئي للمجموعة التالية بنفس الإعدادات أو إعدادات مختلفة. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. معاينة المسح الضوئي إيقاف تشغيل * عرض معاينة المسح الضوئي للمستند الأصلي. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. للسماح بالحفظ كاختصار إيقاف تشغيل * حفظ عنوان بريد إلكتروني كاختصار. إرسال الصور عبر البريد الإلكتروني على شكل مرفق * ارتباط الويب تحديد كيفية إرسال الصور المضمنة في البريد الإلكتروني. إعادة تعيين معلومات البريد الإلكتروني بعد الإرسال إيقاف تشغيل * إعادة تعيين حقول إلى والموضوع والرسالة واسم الملف إلى قيمها الافتراضية بعد إرسال بريد إلكتروني. القائمة إعدادات البريد الإلكتروني الافتراضية"},{"UUID":"0a7b9927-7b2a-41d0-b87d-1753a7e227f6","title":"البريد الإلكتروني","link":"email-setup-topic.html","desc":"إعداد ارتباط ويب عناصر قائمة","descFull":"إعداد ارتباط ويب عناصر قائمة إعداد ارتباط ويب وأوصافها عنصر القائمة الإعدادات الوصف ملقم يتم تحديد الإعداد من قبل المستخدم. تحديد بيانات اعتماد الملقم الذي يستضيف الصور المُضمنة في البريد الإلكتروني. تسجيل الدخول يتم تحديد الإعداد من قبل المستخدم. كلمة المرور يتم تحديد الإعداد من قبل المستخدم. المسار يتم تحديد الإعداد من قبل المستخدم. اسم الملف يتم تحديد الإعداد من قبل المستخدم. ارتباط الويب يتم تحديد الإعداد من قبل المستخدم. القائمة إعداد ارتباط ويب"},{"UUID":"705465b8-f4b7-44a8-9116-755f327612a2","title":"FTP","link":"ftp-defaults-topic.html","desc":"إعدادات بروتوكول FTP الافتراضية ","descFull":"إعدادات بروتوكول FTP الافتراضية  عناصر قائمة إعدادات FTP الافتراضية وأوصافها عنصر القائمة عناصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تهيئة غير متاح JPEG (.jpg) PDF ‏(‎.pdf) * TIFF (.tif) XPS ‏(‎.xps) TXT (.txt) RTF ‏(‎.rtf) DOCX ‏(‎.docx) CSV (.csv) تحديد تنسيق الملف للصورة الممسوحة ضوئيًا. الإعدادات العامة للتعرف الضوئي على الأحرف اللغات المعروفة [قائمة اللغات] لتهيئة إعدادات التعرف الضوئي على الأحرف (OCR). تظهر هذه القائمة فقط في حال شرائك حلّ التعرف الضوئي على الأحرف (OCR) وتثبيته. تدوير تلقائي إيقاف * تشغيل تسوية الألوان إيقاف * تشغيل تحسين التباين التلقائي إيقاف * تشغيل إعدادات PDF إصدار PDF 1.3 1.4 1.5 * 1.6 1.7 تهيئة إعدادات ملفات PDF للصورة الممسوحة ضوئيًا. يتم دعم  ‎الإصدار الأرشيفي  و ‎الإصدار الأرشيفي (PDF/A)  فقط إذا تم تعيين  إصدار PDF  إلى 1.4 أو 1.7. Highly Compressed  يظهر هذا الخيار فقط عندما يتم تركيب محرك أقراص تخزين ذكي (ISD). آمن  يتم دعمه فقط عندما يتم تعيين  إصدار PDF  على 1.4 أو أعلى. أرشيفي (PDF/A) إيقاف * تشغيل إصدار أرشيفي A‑1a * A‑1b A‑2u مضغوط لدرجة عالية إيقاف * تشغيل آمن إيقاف * تشغيل قابل للبحث إيقاف * تشغيل تقسيم المهمة حسب الصفحات 0 * نوع المحتوى غير متاح نص نص/صورة فوتوغرافية * رسومات صورة فوتوغرافية تحسين نتيجة الإخراج بالاستناد إلى نوع محتوى المستند الأصلي. مصدر المحتوى غير متاح ليزر أسود وأبيض ليزر ألوان * ضخ الحبر‬ صورة فوتوغرافية/فيلم مجلة جريدة صحيفة غير ذلك تحسين نتيجة المخرجات استنادًا إلى نوع محتوى المستند الأصلي. اللون غير متاح أبيض وأسود رمادي الألوان * تلقائي تعيين الطابعة لالتقاط محتوى الملف بالألوان أو بلون واحد. درجة الوضوح غير متاح 75 نقطة لكل بوصة 150 نقطة لكل بوصة * 200 نقطة لكل بوصة 300 نقطة لكل بوصة 400 نقطة لكل بوصة 600 نقطة لكل بوصة تعيين درجة وضوح الصورة الممسوحة ضوئيًا. القتامة غير متاح 1–9  (5*) ضبط قتامة الصورة الممسوحة ضوئيًا. الاتجاه غير متاح الاتجاه الطولي * عرضي لتحديد اتجاه المستند الأصلي. حجم المستند الأصلي غير متاح أحجام مختلطة * تعيين حجم الورق للمستند الأصلي. جوانب غير متاح إيقاف * حافة طويلة حافة قصيرة تحديد الاتجاه عند إجراء المسح الضوئي على كلا وجهي المستند. اسم الملف غير متاح يتم تحديد الإعداد من قبل المستخدم. تحديد اسم الملف للصورة الممسوحة ضوئيًا. التصوير المتقدم عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. توازن الألوان سماوي أرجواني أصفر ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) ضبط كثافة الألوان الأزرق السماوي والأرجواني والأصفر. سحب اللون سحب اللون لا شيء * أحمر أخضر أزرق تحديد اللون الذي سيتم سحبه أثناء المسح الضوئي، وضبط إعداد السحب لذلك اللون. الحد الافتراضي للأحمر 0–255  (128*) الحد الافتراضي للأخضر 0–255  (128*) الحد الافتراضي للأزرق 0–255  (128*) اكتشاف اللون التلقائي حساسية اللون 1–9  (5*) تهيئة إعداد اكتشاف الألوان تلقائيًا. حساسية المنطقة 1–9  (5*) عمق بت للبريد الإلكتروني 1 بت * 8 بت الحد الأدنى لدقة المسح الضوئي 75 نقطة لكل بوصة 150 نقطة لكل بوصة 200 نقطة لكل بوصة 300 نقطة لكل بوصة * جودة JPEG غير متاح الأفضل للمحتوى * 5–95 تعيين جودة JPEG للصورة الممسوحة ضوئيًا. التباين غير متاح الأفضل للمحتوى * 0–5 تحديد التباين للصورة الممسوحة ضوئيًا. إزالة الخلفية اكتشاف الخلفية مستند إلى المحتوى * ثابت المستوى‏‎  من ‑4 إلى 4  (0*) إزالة لون الخلفية أو التشويش من صورة من المستند الأصلي. صورة معكوسة غير متاح إيقاف * تشغيل إنشاء صورة معكوسة من المستند الأصلي. صورة سلبية غير متاح إيقاف * تشغيل إنشاء صورة سلبية من المستند الأصلي. تفاصيل الظل غير متاح من ‑4 إلى 4  (0*) ضبط تفاصيل الظلال في الصورة الممسوحة ضوئيًا. مسح ضوئي من حافة إلى حافة غير متاح إيقاف * تشغيل إجراء مسح ضوئي للمستند الأصلي من الحافة إلى الحافة. الوضوح غير متاح 1–5  (3*) ضبط وضوح الصورة الممسوحة ضوئيًا. درجة الحرارة غير متاح من ‑4 إلى 4  (0*) إنشاء مخرج أكثر زرقة أو احمرارًا للمستند الأصلي. الصفحات الفارغة إزالة الصفحة الفارغة عدم الإزالة * إزالة قم بإزالة الصفحات الفارغة من المستند الأصلي. استشعار الصفحة الفارغة 1–9  (5*) تعيين استشعار عمليات المسح الضوئي بالنسبة إلى الصفحات الفارغة في المستند الأصلي. عناصر تحكم المسؤول عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. الإعداد الافتراضي للنص 5–95  (75*) تعيين جودة النص بصورة ممسوحة ضوئيًا. الإعداد الافتراضي للوضع نص/صورة الفوتوغرافية 5–95  (75*) تعيين جودة النص والصورة الفوتوغرافية لصورة ممسوحة ضوئيًا. الإعداد الافتراضي للصورة الفوتوغرافية 5–95  (50*) تعيين جودة الصورة الفوتوغرافية لصورة ممسوحة ضوئيًا. استخدام ملفات TIFF متعددة الصفحات تشغيل * إيقاف تمكين المسح الضوئي لعدة صور TIFF في ملف TIFF واحد. ضغط TIFF LZW * JPEG تعيين نوع الضغط لملفات TIFF. سجل الإرسال طباعة السجل * عدم طباعة السجل طباعة الأخطاء فقط طبع سجل إرسال لعمليات المسح الضوئي عبر بروتوكول FTP. مصدر ورق السجل الدرج  [x] (1*) وحدة التغذية المتعددة الأغراض تحديد مصدر الورق لطباعة سجلات بروتوكول FTP. المسح الضوئي لمهمة مخصصة إيقاف * تشغيل تعيين الطابعة لمسح مجموعة المستندات الأصلية الأولى ضوئيًا باستخدام الإعدادات المحددة، ومن ثم إجراء مسح ضوئي للمجموعة التالية بنفس الإعدادات أو إعدادات مختلفة. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. معاينة المسح الضوئي إيقاف تشغيل * عرض معاينة المستند الأصلي. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. للسماح بالحفظ كاختصار إيقاف تشغيل * حفظ عنوان بروتوكول FTP كاختصار. القائمة إعدادات بروتوكول FTP الافتراضية"},{"UUID":"21897339-d086-4eb4-879a-d68200cdbaa3","title":"برنامج تشغيل USB","link":"flash-drive-scan-topic.html","desc":"مسح ضوئي من محرك الأقراص","descFull":"مسح ضوئي من محرك الأقراص الفلاش عناصر القائمة لمسح محرك الأقراص الفلاش وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تهيئة غير متاح JPEG (.jpg) PDF ‏(‎.pdf) * TIFF (.tif) XPS ‏(‎.xps) TXT (.txt) RTF ‏(rtf.) * DOCX ‏(doc.) XLSX ‏(‎.xlsx) CSV (.csv) تحديد تنسيق الملف للصورة الممسوحة ضوئيًا. لا تظهر التنسيقات  TXT (.txt)  و RTF (.rtf)  و DOCX (.docx)  و XLSX (.xlsx)  و CSV (.csv)  إلا إذا قمت بشراء وتثبيت حل التعرف الضوئي على الأحرف (OCR). الإعدادات العامة للتعرف الضوئي على الأحرف اللغات المعروفة [قائمة اللغات] لتهيئة إعدادات للتعرف الضوئي على الأحرف (OCR). تظهر هذه القائمة فقط في حال شرائك حلّ التعرف الضوئي على الأحرف (OCR) وتثبيته. تدوير تلقائي إيقاف * تشغيل تسوية الألوان إيقاف * تشغيل تحسين التباين التلقائي إيقاف * تشغيل إعدادات PDF إصدار PDF 1.3 1.4 1.5 * 1.6 1.7 تهيئة إعدادات PDF للصورة الممسوحة ضوئيًا. يتم دعم  الإصدار الأرشيفي (PDF/A)  و الأرشيفي —فقط إذا تم تعيين  إصدار PDF  إلى 1.4 أو 1.7. يظهر خيار  مضغوط لدرجة عالية —عند تركيب قرص ثابت فقط. آمن —يتم دعمه فقط عندما يتم تعيين  إصدار PDF  على 1.4 أو أعلى. أرشيفي (PDF/A) إيقاف * تشغيل إصدار أرشيفي A‑1a * A‑1b A‑2u مضغوط لدرجة عالية إيقاف * تشغيل \"التأمين\" إيقاف * تشغيل قابل للبحث إيقاف * تشغيل نوع المحتوى غير متاح نص نص/صورة فوتوغرافية * صورة فوتوغرافية رسومات تحسين نتيجة الإخراج بالاستناد إلى نوع محتوى المستند الأصلي. مصدر المحتوى غير متاح ليزر أسود وأبيض ليزر ألوان * ضخ الحبر‬ صورة فوتوغرافية/فيلم مجلة جريدة صحيفة غير ذلك تحسين نتيجة المخرجات استنادًا إلى نوع محتوى المستند الأصلي. اللون غير متاح أبيض وأسود رمادي الألوان * تلقائي تعيين الطابعة لالتقاط محتوى الملف بالألوان أو بلون واحد. درجة الوضوح غير متاح 75 نقطة لكل بوصة 150 نقطة لكل بوصة * 200 نقطة لكل بوصة 300 نقطة لكل بوصة 400 نقطة لكل بوصة 600 نقطة لكل بوصة تعيين درجة وضوح الصورة الممسوحة ضوئيًا. القتامة غير متاح 1–9  (5*) ضبط قتامة الصورة الممسوحة ضوئيًا. الاتجاه غير متاح الاتجاه الطولي * عرضي لتحديد اتجاه المستند الأصلي. حجم المستند الأصلي غير متاح أحجام مختلطة * تعيين حجم الورق للمستند الأصلي. جوانب غير متاح إيقاف * الحافة القصيرة الحافة الطويلة تحديد اتجاه المستند الأصلي عند إجراء المسح الضوئي على كلا جانبَي المستند. اسم الملف غير متاح يتم تحديد الإعداد من قبل المستخدم. تحديد اسم الملف للصورة الممسوحة ضوئيًا. التصوير المتقدم توازن الألوان سماوي  (0*) أرجواني  (0*) أصفر  (0*) ضبط كثافة الألوان الأزرق السماوي والأرجواني والأصفر. سحب اللون سحب اللون  ( لا يوجد *) الحد الافتراضي للون الأحمر  (128*) الحد الافتراضي للون الأخضر  (128*) الحد الافتراضي للون الأزرق  (128*) تحديد اللون الذي سيتم سحبه أثناء المسح الضوئي، وضبط إعداد السحب لذلك اللون. اكتشاف اللون التلقائي حساسية الألوان  (5*) حساسية المنطقة  (5*) عمق بت المسح الضوئي  (1 بت*) الحد الأدنى لدقة المسح الضوئي  (300 نقطة لكل بوصة*) تهيئة إعداد اكتشاف الألوان تلقائيًا. جودة JPEG الأفضل للمحتوى * 5–95 تعيين جودة JPEG للصورة الممسوحة ضوئيًا. التباين الأفضل للمحتوى * 0–5 تحديد التباين للصورة الممسوحة ضوئيًا. إزالة الخلفية اكتشاف الخلفية  ( مستنِد إلى المحتوى *) المستوى  (0*) إزالة لون الخلفية أو التشويش من صورة من المستند الأصلي. صورة معكوسة إيقاف * تشغيل إنشاء صورة معكوسة من المستند الأصلي. عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. التصوير المتقدم صورة سلبية إيقاف * تشغيل إنشاء صورة سلبية من المستند الأصلي. تفاصيل الظل من ‑4 إلى 4  (0*) ضبط تفاصيل الظلال في الصورة الممسوحة ضوئيًا. مسح ضوئي من حافة إلى حافة إيقاف * تشغيل إجراء مسح ضوئي للمستند الأصلي من الحافة إلى الحافة. الوضوح 1–5  (3*) ضبط وضوح الصورة الممسوحة ضوئيًا. درجة الحرارة من ‑4 إلى 4  (0*) إنشاء مخرج أكثر زرقة أو احمرارًا للمستند الأصلي. الصفحات الفارغة إزالة الصفحة الفارغة  ( عدم الإزالة *) حساسية اكتشاف الصفحة الفارغة  (5*) تعيين استشعار عمليات المسح الضوئي بالنسبة إلى الصفحات الفارغة في المستند الأصلي. عناصر تحكم المسؤول الإعداد الافتراضي للنص 5–95  (75*) تعيين جودة النص بصورة ممسوحة ضوئيًا. الإعداد الافتراضي للوضع نص/صورة الفوتوغرافية 5–95  (75*) تعيين جودة النص والصورة الفوتوغرافية لصورة ممسوحة ضوئيًا. الإعداد الافتراضي للصورة الفوتوغرافية 5–95  (50*) تعيين جودة الصورة الفوتوغرافية لصورة ممسوحة ضوئيًا. استخدام ملفات TIFF متعددة الصفحات إيقاف تشغيل * تمكين المسح الضوئي لعدة صور TIFF في ملف TIFF واحد. ضغط TIFF JPEG LZW * تعيين نوع الضغط لملفات TIFF. المسح الضوئي لمهمة مخصصة إيقاف * تشغيل تعيين الطابعة لمسح مجموعة المستندات الأصلية الأولى ضوئيًا باستخدام الإعدادات المحددة، ومن ثم إجراء مسح ضوئي للمجموعة التالية بنفس الإعدادات أو إعدادات مختلفة. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. معاينة المسح الضوئي إيقاف * تشغيل عرض معاينة المسح الضوئي للمستند الأصلي. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. ضبط انحراف وحدة تغذية المستندات التلقائية إيقاف تشغيل * قم بتعيين الطابعة لضبط الصور المنحرفة من المستندات التي تم مسحها ضوئيًا من وحدة تغذية المستندات التلقائية. القائمة مسح ضوئي من محرك الأقراص الفلاش"},{"UUID":"e9e53506-370b-436a-aefe-7e56c9fc820a","title":"برنامج تشغيل USB","link":"flash-drive-scan-topic.html","desc":"طباعة من محرك الأقراص الفلاش","descFull":"طباعة من محرك الأقراص الفلاش عناصر قائمة طباعة من محرك الأقراص الفلاش وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. عدد النُسخ 1–9999  (1*) قم بتعيين عدد النُسخ في مهمة الطباعة. مصدر الورق الدرج  [x] (1*) وحدة التغذية المتعددة الأغراض ورق يدوي التغذية اليدوية للأظرف لتعيين مصدر الورق لمهمة الطباعة. اللون إيقاف تشغيل * طباعة ملف على محرك الأقراص الفلاش بالألوان. ترتيب إيقاف [1,1,1,2,2,2] تشغيل [1,2,1,2,1,2] * لإبقاء صفحات مهمة طباعة مكدّسة بترتيب تسلسلي لا سيما عند طباعة نُسخ متعددة من المهمة. الأوجه على وجه واحد * على الوجهين تحديد ما إذا كنت تريد الطباعة على وجه واحد من الورق أم على الوجهين. تدبيس إيقاف * ‎دبوس واحد، الزاوية العلوية اليسرى ‎دبوسان، على اليسار دبوس واحد، الزاوية العلوية اليمنى دبوسان، لأعلى دبوس واحد، الزاوية السفلية اليسرى دبوسان، لأسفل دبوس واحد، الزاوية السفلية اليمنى دبوسان، على اليمين تحديد موضع الدبوس لكل مهام الطباعة. لا يظهر عنصر القائمة هذا إلا عند تركيب وحدة إنهاء التدبيس. تثقيب الفتحات إيقاف * فتحتان 3 فتحات 4 فتحات تعيين وضع التثقيب لكل مهام الطباعة. يظهر عنصر القائمة هذا فقط عند تركيب وحدة إنهاء التدبيس أو تثقيب الفتحات أو وحدة إنهاء الكتيبات. صفحات الإزاحة لا شيء * بين النُسخ بين المهام إزاحة المخرجات في كل مهمة طباعة أو كل نسخة من مهمة الطباعة. بين النُسخ ‎—يعمل هذا الإعداد على إزاحة كل نسخة من مهمة الطباعة في حال تعيين  ترتيب  على  تشغيل [1،2،1،2،1،2]‎ . إذا تم تعيين الإعداد  ترتيب  على  إيقاف [1,1,1,2,2,2] ، فعندئذٍ تتم إزاحة كل مجموعة من الصفحات المطبوعة، على سبيل المثال كل الصفحات المشار إليها بالرقم 1 وكل الصفحات المشار إليها بالرقم 2. بين المهام —يؤدي هذا الإعداد إلى تعيين وضع الإزاحة نفسه لكامل مهمة الطباعة بغض النظر عن عدد النُسخ المطبوعة. نمط القلب حافة طويلة * حافة قصيرة تحديد وجه الورقة الذي تريد أن يتم ربطه عند تنفيذ الطباعة على الجانبين. عدد الصفحات لكل وجه إيقاف * صفحتان لكل وجه 3 صفحات لكل وجه 4 صفحات لكل وجه 6 صفحات لكل وجه 9 صفحات لكل وجه 12 صفحة لكل وجه 16 صفحة لكل وجه طباعة صور الصفحات المتعددة على وجه واحد من الورق. ترتيب الصفحات لكل وجه أفقي * عكس الأفقي عكس الرأسي رأسية تحديد موضع الصور في المستند المتعدد الصفحات عند استخدام قائمة  الصفحات لكل وجه . اتجاه الصفحات لكل وجه تلقائي * عرضي طولي تحديد اتجاه الصور في المستند المتعدد الصفحات عند استخدام قائمة  الصفحات لكل وجه . حد الصفحات لكل وجه لا شيء * متواصل طباعة حد حول كل صورة صفحة عند استخدام قائمة  الصفحات لكل وجه . الأوراق الفاصلة إيقاف * بين النُسخ بين المهام بين الصفحات لإدخال أوراق فاصلة فارغة عند الطباعة. مصدر الأوراق الفاصلة الدرج  [x] (1*) وحدة التغذية المتعددة الأغراض تحديد مصدر الورق للورقة الفاصلة. الصفحات الفارغة عدم الطباعة * طباعة طباعة صفحات فارغة في مهمة طباعة. القائمة طباعة من محرك الأقراص الفلاش"},{"UUID":"c0516aaf-afce-49a3-a986-2834f7776276","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"نظرة عامة حول شبكة الاتصال","descFull":"نظرة عامة حول شبكة الاتصال عناصر قائمة نظرة عامة حول شبكة الاتصال وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. مهايئ نشط تلقائي * شبكة اتصال قياسية لاسلكي تحديد نوع اتصال شبكة الاتصال. يتوفر خيار  لاسلكي  فقط في الطابعات المتصلة بشبكة اتصال لاسلكية. \"حالة شبكة الاتصال\" الإعداد عبارة عن معلومات للقراءة فقط. عرض حالة الاتصال الخاصة بشبكة اتصال الطابعة. عرض حالة شبكة الاتصال على الطابعة إيقاف تشغيل * عرض حالة شبكة الاتصال على الشاشة. السرعة، المزدوج الإعداد عبارة عن معلومات للقراءة فقط. عرض سرعة بطاقة شبكة الاتصال النشطة الحالية. IPv4 الإعداد عبارة عن معلومات للقراءة فقط. عرض عنوان IPv4. كل عناوين IPv6 الإعداد عبارة عن معلومات للقراءة فقط. عرض كل عناوين IPv6. إعادة تشغيل ملقم الطباعة البدء إعادة تعيين جميع اتصالات الشبكة النشطة بالطابعة. يزيل هذا الإعداد جميع إعدادات تهيئة الشبكة. زمن توقف مهمة الشبكة إيقاف تشغيل * (90 ثوانٍ) لتعيين الوقت قبل أن تلغي الطابعة مهمة طباعة على شبكة الاتصال. صفحة شعار إيقاف تشغيل * طباعة صفحة شعار. المسح إلى نطاق منفذ PC يتم تحديد الإعداد من قبل المستخدم. لتحديد نطاق منفذ صالح للطابعات خلف جدار حماية مانع للمنفذ. تمكين اتصالات شبكة الاتصال إيقاف تشغيل * تمكين الطابعة للاتصال بشبكة اتصال. \"تمكين LLDP\" إيقاف * تشغيل عرض حالة الشبكة على الشاشة الرئيسية. القائمة نظرة عامة حول شبكة الاتصال"},{"UUID":"372dc6e1-361a-43d0-8384-d88da0b62b44","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"لاسلكي تتوفر هذه القائمة فقط","descFull":"لاسلكي تتوفر هذه القائمة فقط في الطابعات المتصلة بشبكة اتصال Wi‑Fi أو بطابعات تحتوي على محوّل شبكة اتصال لاسلكية.  عناصر القائمة لاسلكي وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف الإعداد على لوحة الطابعة اختيار \"شبكة اتصال\" [قائمة الشبكات اللاسلكية المتاحة] لتحديد شبكة الاتصال اللاسلكية التي تتصل بها الطابعة. إضافة شبكة اتصال Wi-Fi اسم شبكة الاتصال وضع الشبكة  ( بنية تحتية *) وضع الأمان اللاسلكي  ( معطّل *) أدخل اسم الشبكة ونوع الشبكة يدويًا. إعداد Wi‑Fi Protected Setup غير متاح بدء طريقة النسخ بضغطة زر بدء استخدام أسلوب PIN لإنشاء شبكة اتصال Wi‑Fi وتمكين أمان شبكة الاتصال. يوصل الإعداد  بدء طريقة النسخ بضغطة زر  الطابعة بشبكة اتصال Wi‑Fi عن طريق الضغط على الأزرار الموجودة بكل من الطابعة ونقطة الوصول (الموجّه اللاسلكي) خلال وقت محدد. يوصل الإعداد  بدء طريقة رقم PIN  الطابعة بشبكة اتصال Wi-Fi عند إدخال رقم PIN موجود على الطابعة في إعدادات الاتصال اللاسلكي لنقطة الوصول. وضع شبكة الاتصال غير متاح نوع BSS (ضبط الخدمة الأساسي) البنية الأساسية * لتحديد وضع شبكة الاتصال. التوافق غير متاح 802.11b/g/n ‏(2,4 جيجاهرتز) * 802.11a/b/g/n/ac ‏(2,4 جيجاهرتز/5 جيجاهرتز) 802.11a/n/ac ‏(5 جيجاهرتز) لتحديد المعيار لشبكة اتصال Wi‑Fi. يظهر  802.11a/b/g/n/ac ‏(2,4 جيجاهرتز/5 جيجاهرتز)  و 802.11a/n/ac‏ (5 جيجاهرتز)  فقط عند تثبيت خيار Wi-Fi. وضع الأمان اللاسلكي غير متاح معطّل * WPA2/WPA-Personal WPA2-Personal WPA3/WPA-Personal WPA3-Personal 802.1x ‑ RADIUS لتعيين وضع الأمان لتوصيل الطابعة بالأجهزة التي تدعم اتصال Wi-Fi. WPA2/WPA Personal غير متاح معيار AES لتمكين أمان Wi-Fi من خلال الوصول المحمي بتقنية Wi-Fi ‏(WPA). يظهر عنصر القائمة هذا فقط عند تعيين  وضع أمان الاتصال اللاسلكي  إلى  WPA2/WPA-Personal . ضبط PSK غير متاح يتم تحديد الإعداد من قبل المستخدم. لتعيين كلمة المرور لضمان اتصال Wi-Fi آمن. WPA2-Personal غير متاح معيار AES لتمكين أمان Wi-Fi من خلال WPA2. يظهر عنصر القائمة هذا فقط عند تعيين  وضع أمان الاتصال اللاسلكي  إلى  WPA2-Personal . وضع التشفير 802.1x غير متاح WPA+ WPA2 * لتمكين أمان Wi‑Fi من خلال المعيار 802.1x. يظهر عنصر القائمة هذا فقط عند تعيين  وضع أمان الاتصال اللاسلكي  إلى  802.1x - RADIUS . يمكن تهيئة  802.1x - RADIUS  من Embedded Web Server فقط. IPv4 \"تمكين DHCP\" تشغيل * إيقاف لتمكين إعدادات IPv4 وتهيئتها في الطابعة. تعيين عنوان IP ثابت عنوان IP قناع الشبكة المدخل IPv6 تمكين بروتوكول IPv6 تشغيل * إيقاف لتمكين إعدادات IPv6 وتهيئتها في الطابعة. تمكين DHCPv6 تشغيل إيقاف * تهيئة تلقائي غير محدد الحالة للعنوان تشغيل * إيقاف عنوان ملقم DNS يتم تحديد الإعداد من قبل المستخدم. عنوان IPv6 المعين يدويًا يتم تحديد الإعداد من قبل المستخدم. موجّه IPv6 المعين يدويًا يتم تحديد الإعداد من قبل المستخدم. بادئة العنوان يتم تحديد الإعداد من قبل المستخدم. كل عناوين IPv6 يتم تحديد الإعداد من قبل المستخدم. كل عناوين موجّه IPv6 يتم تحديد الإعداد من قبل المستخدم. \"عنوان شبكة الاتصال\" غير متاح عنوان UAA LAA اعرض عناوين شبكة الاتصال. PCL SmartSwitch غير متاح إيقاف تشغيل * لتعيين الطابعة لتنتقل إلى محاكاة PCL تلقائيًا عندما تتطلب مهمة طباعة ذلك، بغض النظر عن لغة الطابعة الافتراضية. في حالة ضبط  PCL SmartSwitch  على  إيقاف ‎، فإن الطابعة لا تقوم بفحص البيانات الواردة وتستخدم لغة الطابعة الافتراضية المحددة في قائمة  الإعداد . PS SmartSwitch غير متاح إيقاف تشغيل * لتعيين الطابعة لتنتقل إلى محاكاة PS تلقائيًا عندما تتطلب مهمة طباعة ذلك، بغض النظر عن لغة الطابعة الافتراضية. في حالة ضبط  PS SmartSwitch  على  إيقاف ‎، فإن الطابعة لا تقوم بفحص البيانات الواردة وتستخدم لغة الطابعة الافتراضية المحددة في قائمة  الإعداد . التخزين المؤقت للمهمة غير متاح تشغيل إيقاف * قم بتخزين مهام الطباعة مؤقتًا في محرك التخزين قبل الطباعة. يظهر عنصر القائمة هذا فقط عند تثبيت جهاز تخزين. MAC PS الثنائي غير متاح تلقائي * تشغيل إيقاف قم بتعيين الطابعة لمعالجة مهام طباعة مضاهاة PostScript الثنائية لنظام التشغيل Macintosh. يقوم  تشغيل  بمعالجة مهام طباعة محاكاة PostScript الثنائية الأولية. يعمل الإعداد  إيقاف  كعامل تصفية لمهام الطباعة باستخدام البروتوكول القياسي. القائمة لاسلكي"},{"UUID":"fd7f1497-6798-406d-8ba2-c82cddf1d988","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"Wi‑Fi Direct عناصر قائمة Wi‑Fi","descFull":"Wi‑Fi Direct عناصر قائمة Wi‑Fi Direct وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تمكين Wi‑Fi Direct تشغيل إيقاف * تعيين الطباعة للاتصال مباشرة مع الأجهزة التي تحتوي على Wi-Fi. اسم Wi‑Fi Direct يتم تحديد الإعداد من قبل المستخدم. حدد اسم شبكة اتصال Wi‑Fi Direct. كلمة مرور Wi‑Fi Direct يتم تحديد الإعداد من قبل المستخدم. عيّن كلمة المرور لمصادقة المستخدمين على اتصال Wi-Fi والتحقق منهم. إظهار كلمة المرور على صفحة الإعداد إيقاف تشغيل * أظهر  كلمة مرور Wi‑Fi Direct  على  صفحة إعداد شبكة الاتصال . رقم القناة المفضلة 1–11 تلقائي * تعيين القناة المفضّلة لشبكة اتصال Wi-Fi. عنوان IP الخاص بمالك المجموعة يتم تحديد الإعداد من قبل المستخدم. تحديد عنوان IP الخاص بمالك المجموعة. الموافقة التلقائية على الطلبات بضغطة زر إيقاف * تشغيل الموافقة على طلبات الاتصال بشبكة الاتصال تلقائيًا. إن الموافقة على الأجهزة العميلة تلقائيًا غير آمن. القائمة Wi‑Fi Direct"},{"UUID":"de3dd850-4eb6-4ca9-a48d-69f13a30836f","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"إدارة خدمات الهاتف المحمول عناصر","descFull":"إدارة خدمات الهاتف المحمول عناصر قائمة إدارة خدمات الهاتف المحمول وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تمكين طباعة IPP تشغيل * إيقاف قم بتمكين طابعة الشبكة من طباعة المهام باستخدام بروتوكول الطباعة عبر الإنترنت (IPP). تمكين فاكس IPP تشغيل * إيقاف قم بتمكين طابعة USB من إرسال مهام الفاكس باستخدام IPP. تمكين IPP عبر USB تشغيل * إيقاف تمكين طابعة USB لطباعة المهام باستخدام IPP. تم تصميم IPP عادةً لطابعات الشبكة. تمكين المسح الضوئي تشغيل * إيقاف تمكين طابعة الشبكة من طباعة المهام باستخدام بروتوكول eSCL. تمكين اكتشاف Mopria تشغيل * إيقاف قم بتمكين الأجهزة المحمولة من اكتشاف طابعة Mopria™ المعتمدة. القائمة إدارة خدمات الهاتف المحمول"},{"UUID":"40f1fac2-5f23-4c8b-a66d-a8d384a0095d","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"Ethernet عناصر قائمة Ethernet وأوصافها","descFull":"Ethernet عناصر قائمة Ethernet وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. سرعة الشبكة غير متاح الإعداد عبارة عن معلومات للقراءة فقط. عرض سرعة مهايئ شبكة الاتصال النشط. IPv4 \"تمكين DHCP\" تشغيل * إيقاف تهيئة إعدادات IPv4. يتم تحديد الإعدادات من قبل المستخدم. تعيين عنوان IP ثابت عنوان IP قناع الشبكة المدخل IPv6 تمكين بروتوكول IPv6 تشغيل * إيقاف تهيئة إعدادات IPv6. تمكين DHCPv6 إيقاف * تشغيل تهيئة تلقائي غير محدد الحالة للعنوان تشغيل * إيقاف عنوان ملقم DNS يتم تحديد الإعداد من قبل المستخدم. عنوان IPv6 المعين يدويًا يتم تحديد الإعداد من قبل المستخدم. موجّه IPv6 المعين يدويًا يتم تحديد الإعداد من قبل المستخدم. بادئة العنوان (64*) 0–128  (64*) كل عناوين IPv6 الإعداد عبارة عن معلومات للقراءة فقط. كل عناوين موجّه IPv6 الإعداد عبارة عن معلومات للقراءة فقط. \"عنوان شبكة الاتصال\" غير متاح عنوان UAA LAA تحديد عنوان شبكة الاتصال. PCL SmartSwitch غير متاح إيقاف تشغيل * لتعيين الطابعة لتنتقل إلى محاكاة PCL تلقائيًا عندما تتطلب مهمة طباعة ذلك، بغض النظر عن لغة الطابعة الافتراضية. في حال تعطيل PCL SmartSwitch، لا تقوم الطابعة بفحص البيانات الواردة وتستخدم لغة الطابعة الافتراضية المحددة في قائمة  إعداد . PS SmartSwitch غير متاح إيقاف تشغيل * تعيين الطابعة لتنتقل إلى محاكاة PostScript تلقائيًا عندما تتطلب مهمة طباعة ذلك، بغض النظر عن لغة الطابعة الافتراضية. في حال تعطيل PCL SmartSwitch، لا تقوم الطابعة بفحص البيانات الواردة وتستخدم لغة الطابعة الافتراضية المحددة في قائمة  إعداد . التخزين المؤقت للمهمة غير متاح إيقاف * تشغيل قم بتخزين المهام مؤقتًا على محرك التخزين قبل الطباعة. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. MAC PS الثنائي غير متاح تلقائي * إيقاف تشغيل قم بتعيين الطابعة لمعالجة مهام طباعة مضاهاة PostScript الثنائية لنظام التشغيل Macintosh. يقوم إعداد  تلقائي  بمعالجة مهام الطباعة من أجهزة الكمبيوتر باستخدام إما نظام التشغيل Windows أو Macintosh. إيقاف  يقوم بتصفية مهام طباعة مضاهاة PostScript باستخدام البروتوكول القياسي. Ethernet ذات كفاءة في توفير الطاقة غير متاح تشغيل إيقاف تلقائي * لتخفيض استهلاك الطاقة عندما لا تتلقى الطابعة أي بيانات من شبكة اتصال Ethernet. القائمة Ethernet"},{"UUID":"71a483ae-8f99-4e6d-948a-db2e48e86c40","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"TCP/IP تظهر هذه القائمة فقط","descFull":"TCP/IP تظهر هذه القائمة فقط في طابعات شبكات الاتصال أو الطابعات المرفقة بخوادم الطباعة. عناصر القائمة TCP/IP وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تعيين اسم المضيف يتم تحديد الإعداد من قبل المستخدم. لتعيين اسم المضيف الحالي لعنوان TCP/IP. اسم المجال يتم تحديد الإعداد من قبل المستخدم. تعيين اسم المجال. Allow DHCP/BOOTP to update NTP server (السماح لـ DHCP/BOOTP بتحديث خادم NTP) تشغيل * إيقاف السماح للأجهزة العميلة لبروتوكول التهيئة الديناميكي للمضيف (DHCP) وبروتوكول BOOTstrap‏ (BOOTP) بتحديث إعدادات NTP الخاصة بالطابعة. اسم Zero Configuration يتم تحديد الإعداد من قبل المستخدم. تحديد اسم خدمة لشبكة zero configuration. تمكين IP تلقائي إيقاف تشغيل * تعيين عنوان IP تلقائيًا. عنوان ملقم DNS يتم تحديد الإعداد من قبل المستخدم. تعيين عنوان خادم نظام اسم المجال الحالي (DNS). عنوان ملقم DNS الاحتياطي يتم تحديد الإعداد من قبل المستخدم. تحديد عناوين خادم DNS الاحتياطي. عنوان ملقم DNS الاحتياطي 2 عنوان ملقم DNS الاحتياطي 3 طلب بحث المجال يتم تحديد الإعداد من قبل المستخدم. تحديد قائمة بأسماء المجالات لتحديد موقع الطابعة ومصادرها الموجودة في مجالات مختلفة على الشبكة. \"تمكين DDNS\" إيقاف * تشغيل لتحديث إعدادات DNS الديناميكي. DDNS TTL يتم تحديد الإعداد من قبل المستخدم. تحديد إعدادات DDNS الحالية. الإعداد الافتراضي لـ TTL‎ وقت تحديث DDNS \"تمكين mDNS\" إيقاف تشغيل * تحديث إعدادات DNS للبث المتعدد. عنوان ملقم WINS يتم تحديد الإعداد من قبل المستخدم. تحديد عنوان الخادم لخدمة Windows Internet Name Service (WINS). تمكين بروتوكول BOOTP إيقاف * تشغيل السماح لبروتوكول BOOTP بتعيين عنوان IP للطابعة. قائمة الملقم المقيدة يتم تحديد الإعداد من قبل المستخدم. تحديد عناوين IP المسموح لها بالاتصال بالطابعة عبر TCP/IP. استخدام فاصلة للفصل بين عناوين IP. يمكنك إضافة حتى 50 عنوان IP. خيارات قائمة الملقم المقيدة حظر كل المنافذ * حظر الطباعة فقط حظر الطباعة وHTTP فقط تحديد خيار الوصول إلى عناوين IP غير المدرجة في القائمة. MTU 256–1500 Ethernet‎  (1500*) تحديد معلمة وحدة أقصى حد للإرسال (MTU) لاتصالات TCP. منفذ الطباعة البسيطة 1–65535  (9100*) تحديد رقم منفذ بسيط للطابعات المتصلة على شبكة. أقصى سرعة لنقل البيانات الصادرة إيقاف * تشغيل تعيين الحد الأقصى لسرعة النقل الخاصة بالطابعة. يتراوح الخيار لهذا الإعداد ما بين 100 و1000000 كيلوبت في الثانية عند تمكينه. دعم TLS تمكين TLSv1.0  ( إيقاف *) تمكين TLSv1.1  ( Off *) تمكين TLSv1.2  ( تشغيل *) لتمكين بروتوكول أمان طبقة النقل. قائمة تشفير SSL يتم تحديد الإعداد من قبل المستخدم. تحديد خوارزميات التشفير التي يجب استخدامها لاتصالات SSL أو TLS. قائمة تشفير TLSv1.3 SSL القائمة TCP/IP"},{"UUID":"e81e3257-78a1-48e1-a81b-dfff4e280987","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"إدارة الشبكة البسيط (SNMP) تظهر","descFull":"إدارة الشبكة البسيط (SNMP) تظهر هذه القائمة فقط في طابعات شبكات الاتصال أو الطابعات المتصلة بملقمات الطباعة. عناصر قائمة بروتوكول إدارة الشبكة البسيط (SNMP) ووصفها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. إدارة الشبكة البسيط (SNMP) الإصداران 1 و2c تم التمكين إيقاف تشغيل * تهيئة بروتوكول إدارة الشبكة البسيط (SNMP) الإصداران 1 و 2c لتثبيت برامج تشغيل الطابعة وتطبيقاتها. السماح لمجموعة SNMP إيقاف تشغيل * تمكين PPM MIB إيقاف تشغيل * مجتمع إدارة الشبكة البسيط (SNMP) يتم تحديد الإعداد من قبل المستخدم. إصدار 3 من إدارة الشبكة البسيط (SNMP) تم التمكين إيقاف تشغيل * قم بتمكين إدارة الشبكة البسيط (SNMP) الإصدار 3 لتثبيت أمان الطابعة وتحديثه. اسم السياق يتم تحديد الإعداد من قبل المستخدم. أدخل اسم السياق. تعيين بيانات اعتماد القراءة / الكتابة اسم المستخدم كلمة مرور المصادقة كلمة مرور الخصوصية أدخل بيانات اعتماد القراءة والكتابة للإصدار 3 من إدارة الشبكة البسيط (SNMP). تعيين بيانات اعتماد القراءة فقط اسم المستخدم كلمة مرور المصادقة كلمة مرور الخصوصية أدخل بيانات اعتماد القراءة فقط للإصدار 3 من إدارة الشبكة البسيط (SNMP). تجزئة المصادقة \"MD5\" SHA1 * قم بتعيين تجزئة المصادقة المعمول بها. أدنى مستوى للمصادقة لا توجد مصادقة، لا توجد خصوصية توجد مصادقة، لا توجد خصوصية المصادقة، الخصوصية * قم بتعيين الحد الأدنى لمستوى المصادقة المطبق. خوارزمية الخصوصية DES AES‑128 * قم بتعيين خوارزمية الخصوصية المعمول بها. القائمة إدارة الشبكة البسيط (SNMP)"},{"UUID":"ef1f3152-d3e8-4edb-bf22-007e4474defa","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"IPSec تظهر هذه القائمة فقط","descFull":"IPSec تظهر هذه القائمة فقط في طابعات شبكات الاتصال أو الطابعات المتصلة بملقمات الطباعة. عناصر قائمة IPSec وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تمكين IPSec إيقاف * تشغيل تمكين أمان بروتوكول الإنترنت (IPSec). التهيئة الأساسية افتراضي * التوافق \"التأمين\" تعيين تهيئة IPSec الأساسية. لا يظهر عنصر القائمة هذا إلا عند تعيين  تمكين IPSec  على  تشغيل . اقتراح مجموعة DH‏ (Diffie‑Hellman) modp2048 ‏(14) * modp3072 (15) modp4096 ‏(16) modp6144‏ (17) تعيين تهيئة IPSec الأساسية. يظهر عنصر القائمة هذا فقط عند تعيين  التهيئة الأساسية  على  التوافق . طريقة التشفير المقترحة 3DES معيار AES * تعيين طريقة التشفير. يظهر عنصر القائمة هذا فقط عند تعيين  التهيئة الأساسية  على  التوافق . طريقة المصادقة المقترحة SHA1 SHA256 * SHA512 تعيين طريقة المصادقة. يظهر عنصر القائمة هذا فقط عند تعيين  التهيئة الأساسية  على  التوافق . عمر IKE SA (بالساعات) 1 2 4 8 24 * تحديد فترة انتهاء صلاحية IKE SA. يظهر عنصر القائمة هذا فقط عند تعيين  التهيئة الأساسية  على  آمن . عمر IPSec SA (بالساعات) 1 2 4 8 24 * تحديد فترة صلاحية IPSec SA. يظهر عنصر القائمة هذا فقط عند تعيين  التهيئة الأساسية  على  آمن . شهادة جهاز IPSec الافتراضي * تحديد شهادة IPSec. لا يظهر عنصر القائمة هذا إلا عند تعيين  تمكين IPSec  على  تشغيل . الاتصالات المصادَقَة باستخدام المفتاح المشترك مسبقًا المضيف  [x] تهيئة الاتصالات المصادَقَة للطابعة. لا تظهر عناصر القائمة هذه إلا عند تعيين  تمكين IPSec  على  تشغيل . الاتصالات المصادَقَة للشهادة المضيف  [x]  العنوان[/الشبكة الفرعية] القائمة IPSec"},{"UUID":"5abb4a21-e9f8-4620-b169-a3a9824a5bef","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"802.1x 802.1x تظهر هذه القائمة","descFull":"802.1x 802.1x تظهر هذه القائمة فقط في طابعات شبكات الاتصال أو الطابعات المتصلة بملقمات الطباعة. عناصر قائمة 802.1x وأوصافها عنصر القائمة عناصر القائمة الفرعية: الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. نشط غير متاح إيقاف * تشغيل للسماح للطابعة بالانضمام إلى شبكات الاتصال التي تتطلب المصادقة قبل السماح بالوصول. مصادقة ‎802.1x اسم تسجيل دخول الجهاز يتم تحديد الإعداد من قبل المستخدم. حدد اسم تسجيل الدخول الفريد. كلمة مرور تسجيل دخول الجهاز يتم تحديد الإعداد من قبل المستخدم. حدد كلمة المرور الفريدة. التحقق من صحة شهادة الملقم تشغيل * إيقاف قم بتمكين هذا الخيار للمطالبة بالتحقق من شهادة الأمان على ملقم المصادقة. تمكين تسجيل الأحداث تشغيل إيقاف * تمكين الطابعة من تسجيل سجلات الاتصال. شهادة جهاز ‎802.1x الافتراضي * حدد الشهادة الرقمية التي تريد استخدامها. إذا تم تثبيت شهادة واحدة فقط، فسيكون  الافتراضي  هو الخيار الوحيد الذي يظهر.  آلية المصادقة EAP ‑ MD5 تشغيل * إيقاف تمكين إطار عمل MD5 لبروتوكول المصادقة القابل للتوسيع (EAP). EAP - MSCHAPv2 تشغيل * إيقاف تفعيل طريقة المصادقة EAP باستخدام بروتوكول Microsoft Challenge Handshake Authentication Protocol (MSCHAP) الإصدار 2. \"LEAP\" تشغيل * إيقاف قم بتمكين بروتوكول المصادقة القابل للتوسيع خفيف الوزن (LEAP)، وهو نسخة معدلة من MSCHAP. \"PEAP\" تشغيل * إيقاف قم بتمكين بروتوكول المصادقة القابل للتوسيع المحمي (PEAP)، وهي طريقة توفر مصادقة أكثر أمانًا لشبكات 802.11 اللاسلكية. يدعم PEAP التحكم في الوصول إلى منفذ 802.1x. EAP - TLS تشغيل * إيقاف قم بتمكين بروتوكول أمان طبقة النقل (EAP-TLS)، حيث يقوم الجهاز العميل والملقم بمصادقة بعضهما البعض باستخدام الشهادات الرقمية. EAP - TTLS تشغيل * إيقاف قم بتمكين بروتوكول أمان طبقة النقل المغلف (EAP-TTLS)، وهو بروتوكول مشابه لـ EAP-TLS باستثناء أن الملقم فقط يمتلك شهادة لمصادقة نفسه أمام الجهاز العميل أولاً. أسلوب مصادقة TTLS \"CHAP\" MSCHAP MSCHAPv2 * PAP حدد طريقة EAP TTLS التي تريد استخدامها لجهازك. القائمة 802.1x"},{"UUID":"f20d7376-7b1a-4f3e-95b2-6445f5f0ec73","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"تهيئة LPD تظهر هذه القائمة","descFull":"تهيئة LPD تظهر هذه القائمة فقط في طابعات شبكات الاتصال أو الطابعات المتصلة بملقمات الطباعة. عناصر قائمة LPD Configuration (تهيئة LPD) وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. مهلة LPD 0–65535 ثانية  (90*) تعيين المهلة الزمنية للتوقف لإيقاف خادم البرنامج الخفي لطابعة الخطوط (LPD) عن انتظار مهام الطباعة المحجوزة أو غير الصالحة إلى أجل غير مسمى. صفحة شعار LPD إيقاف * تشغيل طباعة صفحة شعار لجميع مهام طباعة LPD. صفحة الشعار هي الصفحة الأولى من مهمة الطباعة المستخدمة كفاصل بين مهام الطباعة ولتعريف مُنشئ طلب مهمة الطباعة. صفحة فيلم LPD إيقاف * تشغيل طباعة صفحة ملحقة لجميع مهام طباعة LPD. الصفحة الملحقة هي الصفحة الأخيرة في مهمة الطباعة. تحويل حرف إرجاع LPD إيقاف * تشغيل تمكين تحويل الرجوع إلى أول السطر. الرجوع إلى أول السطر هو آلية تعطي أوامر للطابعة بتحرك موضع المؤشر إلى الموضع الأول على السطر نفسه. القائمة تهيئة LPD"},{"UUID":"aa89c2b8-a17e-428e-990e-6da846fe2998","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"إعدادات بروتوكول HTTP/FTP عناصر قائمة","descFull":"إعدادات بروتوكول HTTP/FTP عناصر قائمة HTTP/FTP Settings (إعدادات FTP) وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. الوكيل عنوان IP الوكيل لـ HTPP يتم تحديد الإعداد من قبل المستخدم. قم بتهيئة إعدادات ملقم HTTP. مَنفذ IP الافتراضي لـ HTTP يتم تحديد الإعداد من قبل المستخدم. قم بتهيئة عنوان منفذ IP الافتراضي لـ HTTP. منفذ المصنع الافتراضي لـ HTTP هو 80. عنوان IP الوكيل لـ FTP يتم تحديد الإعداد من قبل المستخدم. لتهيئة إعدادات FTP. مَنفذ IP الافتراضي لـ FTP يتم تحديد الإعداد من قبل المستخدم. قم بتهيئة عنوان منفذ IP الافتراضي لـ FTP. منفذ المصنع الافتراضي لـ HTTP هو 21. \"المصادقة\" لا يوجد تلقائي * أساسي Digest NTLM حدد بيانات اعتماد المصادقة. اسم المستخدم يتم تحديد الإعداد من قبل المستخدم. حدد اسم المستخدم الفريد. كلمة المرور يتم تحديد الإعداد من قبل المستخدم. حدد كلمة المرور الفريدة. مجالات محلية يتم تحديد الإعداد من قبل المستخدم. تحديد أسماء مجالات لملقم HTTP وFTP. إعدادات أخرى تمكين ملقم HTTP تشغيل * إيقاف الوصول إلى Embedded Web Server لمراقبة الطابعة وإدارتها. تمكين HTTPS تشغيل * إيقاف تمكين بروتوكول النقل الآمن للنصوص التشعبية (HTTPS) لتشفير نقل البيانات من ملقم الطباعة وإليه. فرض اتصالات HTTPS تشغيل إيقاف * إجبار الطابعة على استخدام اتصالات HTTPS. تمكين FTP/TFTP تشغيل * إيقاف إرسال ملفات باستخدام بروتوكول FTP/TFTP. HTTPS Device Certificate (شهادة جهاز HTTPS) الافتراضي * لعرض شهادة جهاز HTTP المستخدمة في الطابعة. Timeout for HTTP/FTP Requests (انتهاء وقت طلبات HTTP/FTP) 1–299 ثانية  (30*) تحديد الفترة الزمنية قبل توقف اتصال الملقم. Retries for HTTP/FTP Requests (إعادة محاولات طلبات HTTP/FTP) 1–299 ثانية  (3*) تعيين عدد محاولات إعادة الاتصال بملقم بروتوكول HTTP/FTP. القائمة إعدادات بروتوكول HTTP/FTP"},{"UUID":"f22adddf-bd25-40a5-b571-e4ad55fda604","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"ThinPrint عناصر القائمة ThinPrint وأوصافها","descFull":"ThinPrint عناصر القائمة ThinPrint وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تمكين ThinPrint إيقاف * تشغيل الطباعة باستخدام ThinPrint. رقم المنفذ 4000–4999  (4000*) تعيين رقم المنفذ لخادم ThinPrint. Bandwidth (bits/sec) (النطاق الترددي (بت/ث)) 100–1000000  (0*) تعيين سرعة إرسال البيانات في بيئة ThinPrint. Packet Size (kbytes) (حجم الحزمة (كيلوبايت)) 0–64000  (0*) تعيين حجم الحزمة لإرسال البيانات. القائمة ThinPrint"},{"UUID":"c7e3b8e1-942c-41b0-be77-e9559ec69dbe","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"USB عناصر القائمة USB وأوصافها","descFull":"USB عناصر القائمة USB وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. PCL SmartSwitch إيقاف تشغيل * تعيين الطابعة لكي يتم التحويل إلى محاكاة PCL عندما يتطلب ذلك مهمة طباعة يتم استلامها عبر منفذ USB، بغض النظر عن اللغة الافتراضية للطابعة. في حال تعطيل PCL SmartSwitch، لا تقوم الطابعة بفحص البيانات الواردة وتستخدم لغة الطابعة الافتراضية المحددة في قائمة  إعداد . PS SmartSwitch إيقاف تشغيل * تعيين الطابعة لكي يتم التحويل إلى محاكاة PostScript عندما يتطلب ذلك مهمة طباعة يتم استلامها عبر منفذ USB، بغض النظر عن اللغة الافتراضية للطابعة. في حال تعطيل PCL SmartSwitch، لا تقوم الطابعة بفحص البيانات الواردة وتستخدم لغة الطابعة الافتراضية المحددة في قائمة  إعداد . التخزين المؤقت للمهمة إيقاف * تشغيل قم بتخزين المهام مؤقتًا على محرك التخزين قبل الطباعة. يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. MAC PS الثنائي تلقائية * تشغيل إيقاف قم بتعيين الطابعة لمعالجة مهام طباعة مضاهاة PostScript الثنائية لنظام التشغيل Macintosh. يقوم إعداد  تلقائي  بمعالجة مهام الطباعة من أجهزة الكمبيوتر باستخدام إما نظام التشغيل Windows أو Macintosh. إيقاف  يقوم بتصفية مهام طباعة مضاهاة PostScript باستخدام البروتوكول القياسي. تمكين منفذ USB إيقاف تشغيل * قم بتمكين منافذ محرك أقراص USB الأمامية والخلفية. القائمة USB"},{"UUID":"1885a8b6-e19f-4cb6-984d-c717ef0289e8","title":"شبكة الاتصال/المنافذ","link":"network-overview-topic.html","desc":"تقييد الوصول إلى شبكة الاتصال","descFull":"تقييد الوصول إلى شبكة الاتصال الخارجية عناصر قائمة تقييد الوصول إلى شبكة الاتصال الخارجية وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تقييد الوصول إلى شبكة الاتصال الخارجية إيقاف * تشغيل لتقييد الوصول إلى مواقع شبكة الاتصال. عنوان شبكة الاتصال الخارجية يتم تحديد الإعداد من قبل المستخدم. لتحديد عناوين شبكة الاتصال ذات الوصول المقيّد. عنوان البريد الإلكتروني للإخطارات يتم تحديد الإعداد من قبل المستخدم. لتحديد عنوان البريد الإلكتروني لإرسال إخطار بالأحداث المسجّلة. تردد Ping 1–300  (10*) لتحديد المدة الفاصلة لاستعلام شبكة الاتصال بالثواني. الموضوع يتم تحديد الإعداد من قبل المستخدم. تحديد موضوع ورسالة الإخطار بالبريد الإلكتروني. الرسالة القائمة تقييد الوصول إلى شبكة الاتصال الخارجية"},{"UUID":"a8ba2e0e-8997-4fd9-a68d-3675b1f7173a","title":"طرق تسجيل الدخول","link":"login-methods-subgroup.html","desc":"إدارة الأذونات عناصر قائمة إدارة","descFull":"إدارة الأذونات عناصر قائمة إدارة الأذونات وأوصافها عنصر القائمة الإعدادات الوصف الوصول إلى الوظيفة الوصول إلى دفتر العناوين في التطبيقات تعديل دفتر العناوين إدارة الاختصارات إنشاء ملفات تعريف إدارة الإشارات المرجعية طباعة من محرك الأقراص الفلاش طباعة الألوان من محرك الأقراص الفلاش مسح ضوئي من محرك الأقراص الفلاش وظيفة النسخ طباعة نسخة بالألوان سحب اللون وظيفة البريد الإلكتروني وظيفة الفاكس وظيفة بروتوكول FTP تحرير الفاكسات الموقوفة الوصول إلى المهام المحجوزة استخدام ملفات التعريف إلغاء مهام في الجهاز تغيير اللغة بروتوكول الطباعة عبر الإنترنت (IPP) بدء عمليات المسح عن بُعد B/W Print (طباعة بالأبيض والأسود) طباعة بالألوان مجلد شبكة الاتصال - المسح الضوئي القرص الثابت - الطباعة القرص الثابت - الطباعة بالألوان القرص الثابت - المسح الضوئي حدد وظائف الطابعة التي يمكن للمستخدم الوصول إليها. تظهر بعض عناصر القائمة فقط عند تثبيت محرك تخزين. قوائم الإدارة قائمة الأمان قائمة \"شبكة الاتصال/المنافذ قائمة الورق قائمة \"التقارير\" قوائم تهيئة الوظائف قائمة مستلزمات الطباعة قائمة \"بطاقة الخيارات\" قائمة SE قائمة الجهاز حدد قوائم الطابعة التي يمكن للمستخدم الوصول إليها. إدارة الأجهزة الإدارة عن بُعد تحديثات البرنامج الثابت تهيئة التطبيقات تأمين لوحة المشغّل الوصول إلى Embedded Web Server استيراد / تصدير كل الإعدادات المسح خارج نطاق الخدمة التسجيل في خدمات السحابة حدد وظائف  إدارة الأجهزة  التي يمكن للمستخدم الوصول إليها. التطبيقات التطبيقات الجديدة عرض شرائح تغيير ورق الحائط شاشة التوقف نسخ البطاقة مركز المسح الضوئي مركز المسح المخصص  [x] للتحكم بالوصول إلى تطبيقات الطابعة. القائمة إدارة الأذونات"},{"UUID":"99eefb5d-0922-4845-b480-1b45296dc318","title":"طرق تسجيل الدخول","link":"login-methods-subgroup.html","desc":"الحسابات المحلية عناصر قائمة الحسابات","descFull":"الحسابات المحلية عناصر قائمة الحسابات المحلية وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف إدارة المجموعات/الأذونات إضافة مجموعة يتم تحديد الإعداد من قبل المستخدم. حدد المجموعات التي لديها حق الوصول إلى وظائف الطابعة، القوائم الإدارية، خيارات إدارة الطابعة، والتطبيقات. جميع المستخدمين استيراد عناصر التحكم في الوصول استيراد عناصر التحكم في الوصول من الحسابات المسجلة في الطابعة. إضافة مستخدم \"اسم المستخدم/كلمة المرور\" اسم المستخدم كلمة المرور رقم PIN يتم تحديد الإعداد من قبل المستخدم. أضف مستخدمًا وحدد طريقة تسجيل الدخول إلى الطابعة. القائمة الحسابات المحلية"},{"UUID":"53dbee4b-d96f-4835-a587-d4589222b5a2","title":"طرق تسجيل الدخول","link":"login-methods-subgroup.html","desc":"طرق تسجيل الدخول الافتراضية تظهر","descFull":"طرق تسجيل الدخول الافتراضية تظهر هذه القائمة فقط عند تهيئة قائمة  الحسابات المحلية . عناصر قائمة طرق تسجيل الدخول الافتراضية وأوصافها عنصر القائمة الإعدادات الوصف لوحة التحكم \"اسم المستخدم/كلمة المرور\" اسم المستخدم كلمة المرور رقم PIN تحديد طريقة تسجيل الدخول الافتراضية للوصول إلى لوحة التحكم. المتصفح \"اسم المستخدم/كلمة المرور\" اسم المستخدم كلمة المرور رقم PIN تحديد طريقة تسجيل الدخول الافتراضية للوصول إلى المتصفح. القائمة طرق تسجيل الدخول الافتراضية"},{"UUID":"4cfd3dce-8ff4-42b5-9a99-c24ee8a80141","title":"الأمان","link":"login-methods-subgroup.html","desc":"جدولة أجهزة USB عنصر قائمة","descFull":"جدولة أجهزة USB عنصر قائمة جدولة أجهزة USB ووصفه عنصر القائمة عناصر القائمة الفرعية الإعدادات الوصف عمليات الجدولة إضافة جدول جديد حفظ الجدول الإجراء يوم (أيام) الوقت جدولة الوصول إلى منفذ USB الأمامي. القائمة جدولة أجهزة USB"},{"UUID":"a39388b6-35f3-4891-acc2-dfa57aff1169","title":"الأمان","link":"login-methods-subgroup.html","desc":"سجل مراقبة الأمان عناصر قائمة","descFull":"سجل مراقبة الأمان عناصر قائمة \"سجل مراقبة الأمان\" وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. تمكين التدقيق إيقاف * تشغيل قم بتعيين الطابعة لتسجيل الأحداث في سجل التدقيق الآمن وسجل النظام عن بُعد. تمكين سجل النظام عن بُعد إيقاف * تشغيل قم بتعيين الطابعة لإرسال سجلات التدقيق إلى ملقم عن بُعد. ملقم سجل النظام عن بُعد يتم تحديد الإعداد من قبل المستخدم. لتحديد ملقم سجل النظام عن بُعد. منفذ سجل النظام عن بُعد 1–65535  (514*) حدد المنفذ الذي ترسل الطابعة عبره الأحداث المسجلة إلى ملقم عن بُعد. طريقة سجل النظام عن بُعد UDP عادي * Stunnel حدد البروتوكول الذي تستخدمه الطابعة لنقل الأحداث المسجلة إلى ملقم عن بُعد. أداة إنشاء سجل النظام عن بُعد 0 ‑ رسائل Kernel 1 ‑ رسائل مستوى المستخدم 2 ‑ نظام البريد 3 ‑ البرنامج الخفي للنظام 4 ‑ رسائل الأمان/ التخويل * 5 ‑ الرسائل التي يتم إنشاؤها داخليًا عن طريق سجلات النظام 6 ‑ النظام الفرعي لطابعة الخط 7 ‑ النظام الفرعي لأخبار شبكة الاتصال 8 ‑ النظام الفرعي لـ UUCP 9 ‑ البرنامج الخفي للساعة 10 ‑ رسائل الأمن/ التخويل 11 ‑ البرنامج الخفي لبروتوكول FTP 12 ‑ النظام الفرعي لـ NTP 13 ‑ مراقبة السجل 14 ‑ تنبيه السجل 15 ‑ البرنامج الخفي للساعة 16 ‑ استخدام محلي 0 (local0) 17‑ استخدام محلي 1 (local1) 18 ‑ استخدام محلي 2 (local2) 19 ‑ استخدام محلي 3 (local3) 20 ‑ استخدام محلي 4 (local4) 21 ‑ استخدام محلي 5 (local5) 22 ‑ استخدام محلي 6 (local6) 23 ‑ استخدام محلي 7 (local7) حدد قيمة لأداة الإنشاء (Facility) تستخدمها الطابعة عند إرسال أحداث السجل إلى ملقم syslog عن بُعد. أهمية الأحداث بالنسبة إلى السجل 0 ‑ طوارئ 1 ‑ تنبيه 2 ‑ مهم 3 ‑ خطأ 4 ‑ تحذير * 5 ‑ إشعار 6 ‑ معلوماتي 7 ‑ تصحيح حدد قيمة خطورة كل حدث. الأحداث التي لم يتم تسجيلها في سجل النظام البعيد إيقاف * تشغيل قم بتعيين الطابعة لإرسال أي أحداث قابلة للتطبيق. عنوان البريد الإلكتروني للمسؤول يتم تحديد الإعداد من قبل المستخدم. حدد عنوان البريد الإلكتروني لمسؤول الطابعة الذي يتم إخطاره بأحداث سجل معينة. تنبيه سجل البريد الإلكتروني الذي تم مسحه إيقاف * تشغيل قم بتعيين الطابعة لإرسال بريد إلكتروني إلى المسؤول في كل مرة يتم فيها حذف سجل. تنبيه لسجل البريد الإلكتروني الملتف إيقاف * تشغيل قم بتعيين الطابعة لإرسال بريد إلكتروني إلى المسؤول عند التفاف إدخالات السجل. تسجيل الإجراءات بالكامل التفاف حول أقدم الإدخالات * أرسل السجل بالبريد الإلكتروني ثم احذف كل الإدخالات حدد كيفية قيام الطابعة بحل مشكلات تخزين السجل عندما يملأ السجل الذاكرة المخصصة لها. تنبيه البريد الإلكتروني عند امتلاء السجل بنسبة % إيقاف * تشغيل قم بتعيين الطابعة لإرسال بريد إلكتروني إلى المسؤول عندما يملأ السجل الذاكرة المخصصة له. تنبيه بمستوى البريد الإلكتروني % 1–99  (90*) حدد ما إذا كانت المساحة التي يشغلها السجل تساوي أو تتجاوز قيمة مستوى التنبيه الكامل. تنبيه سجل البريد الإلكتروني الذي تم تصديره إيقاف * تشغيل إرسال إخطار بالبريد الإلكتروني إلى المسؤول عند تصدير سجل. تنبيه تغيير إعدادات البريد الإلكتروني إيقاف * تشغيل قم بتعيين الطابعة لإرسال بريد إلكتروني إلى المسؤول عندما تكون قيمة قائمة  تمكين التدقيق  تم تغييرها. نهايات أسطر السجل LF‏ (\\n) * CR ‏(\\r) CRLF ‏(\\r\\n) تعرف كيفية معالجة الطابعة لنهايات الأسطر في ملف السجل بناءً على نظام التشغيل الذي يتم من خلاله تحليل الملف أو عرضه. تصدير التوقيعات الرقمية إيقاف * تشغيل قم بتعيين الطابعة لتوقيع سجلات الأمان المصدرة تلقائيًا. مسح السجل يتم تحديد الإعداد من قبل المستخدم. حذف كل سجلات المراقبة. سجل التصدير Syslog (سجل النظام) (RFC 5424) Syslog (سجل النظام) (RFC 3164) CSV تصدير السجلات من الطابعة أو محرك الأقراص المحمول. القائمة سجل مراقبة الأمان"},{"UUID":"1abbb4b4-bfd6-42db-94e2-6ffce88ea934","title":"الأمان","link":"login-methods-subgroup.html","desc":"قيود تسجيل الدخول عناصر قائمة","descFull":"قيود تسجيل الدخول عناصر قائمة قيود تسجيل الدخول وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. فشل تسجيل الدخول 1–10  (3*) حدد عدد محاولات تسجيل الدخول الفاشلة قبل أن يتم قفل المستخدم. إطار وقت الفشل من دقيقة إلى 60 دقيقة  (5*) حدد الإطار الزمني المسموح به لمحاولات تسجيل الدخول الفاشلة قبل قفل المستخدم. وقت التأمين من دقيقة إلى 60 دقيقة  (5*) حدد مقدار الوقت الذي لا يُسمح فيه بتسجيل الدخول. انتهاء وقت تسجيل الدخول إلى الشبكة من دقيقة إلى 120 دقيقة  (10*) حدد مقدار الوقت الذي يمكن أن تظل فيه الواجهة عن بُعد، مثل صفحة الويب، في وضع الخمول قبل أن يتم تسجيل خروج المستخدم تلقائيًا. القائمة قيود تسجيل الدخول"},{"UUID":"a77c6825-986f-4b25-8a5d-f60443280d47","title":"الأمان","link":"login-methods-subgroup.html","desc":"إعداد الطباعة السرية عناصر قائمة","descFull":"إعداد الطباعة السرية عناصر قائمة إعداد الطباعة السرية وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. الحد الأقصى لرقم PIN غير الصالح 2–10 تعيين حد لعدد مرات إدخال رقم PIN غير صالح. عند بلوغ الحد الأقصى، يتم حذف مهام الطباعة الخاصة باسم المستخدم هذا. انتهاء فترة المهمة السرية إيقاف * ساعة واحدة 4 ساعات 24 ساعة 72 ساعة ‎أسبوع واحد قم بتعيين وقت انتهاء صلاحية فردية لكل نوع من المهام المحجوزة قبل حذفها تلقائيًا من ذاكرة الطابعة. أنواع المهام المحجوزة بها هي  السرية  و المكررة  و الاحتياطية  و المراجعة . في حالة تم تغيير إعداد وقت انتهاء الصلاحية بينما توجد مهام طباعة سرية في ذاكرة الطابعة أو القرص الثابت للطابعة، فإن وقت انتهاء الصلاحية لهذه المهام لن يتغير إلى قيمة الإعداد الافتراضي الجديدة. في حالة إيقاف تشغيل الطابعة، فإنه يتم حينئذٍ حذف جميع مهام الطباعة السرية المحفوظة في ذاكرة الطابعة. تكرار انتهاء فترة المهمة إيقاف * ساعة واحدة 4 ساعات 24 ساعة 72 ساعة ‎أسبوع واحد تعيين وقت انتهاء صلاحية مهام الطباعة التي تريد تكرارها. التحقق من انتهاء فترة المهمة إيقاف * ساعة واحدة 4 ساعات 24 ساعة 72 ساعة ‎أسبوع واحد تعيين وقت انتهاء صلاحية طباعة نسخة من مهمة للتحقق من جودتها قبل طباعة النسخ المتبقية. حفظ انتهاء فترة المهمة إيقاف * ساعة واحدة 4 ساعات 24 ساعة 72 ساعة ‎أسبوع واحد تعيين فترة انتهاء الصلاحية للمهام التي تريد تخزينها في الطابعة لطباعتها لاحقًا. يتطلب تعليق كل المهام إيقاف * تشغيل تعيين الطابعة لتعليق كل مهام الطباعة. الاحتفاظ بالمستندات المتكررة إيقاف * تشغيل تعيين الطابعة للاحتفاظ بكل المستندات باسم الملف نفسه. القائمة إعداد الطباعة السرية"},{"UUID":"b6849d52-6e4e-409f-99de-e7f73917a721","title":"الأمان","link":"login-methods-subgroup.html","desc":"التشفير عناصر قائمة التشفير وأوصافها","descFull":"التشفير عناصر قائمة التشفير وأوصافها عنصر القائمة الإعدادات الوصف التخزين الداخلي الإعداد عبارة عن معلومات للقراءة فقط. إظهار حالة التشفير لوحدة التخزين الداخلية. القرص الثابت الإعداد عبارة عن معلومات للقراءة فقط. لعرض حالة التشفير للقرص الثابت. يظهر عنصر القائمة هذا فقط عندما يتم تركيب قرص ثابت. محرك أقراص التخزين الذكي (ISD) الإعداد عبارة عن معلومات للقراءة فقط. لعرض حالة التشفير لمحرك أقراص التخزين الذكي (ISD). يظهر عنصر القائمة هذا فقط عند تركيب محرك أقراص تخزين ذكي (ISD). القائمة التشفير"},{"UUID":"58820e00-1861-4310-a786-877c2858dc1a","title":"الأمان","link":"login-methods-subgroup.html","desc":"مسح ملفات البيانات الموقتة عناصر","descFull":"مسح ملفات البيانات الموقتة عناصر قائمة مسح ملفات البيانات المؤقتة وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. مُخزّن في الذاكرة الذاتية إيقاف * تشغيل قم بتعيين الطابعة لمسح كل بيانات المهمة من ذاكرتها بعد انتهاء المهمة. مُخزّن على القرص الثابت 1 مسح المرور * ‎ 3مسح المرور ‎ 7مسح المرور حدد الطريقة التي تستخدمها الطابعة لمسح كافة بيانات المهمة من القرص الثابت بعد انتهاء المهمة. يظهر عنصر القائمة هذا فقط عندما يتم تركيب قرص ثابت. القائمة مسح ملفات البيانات الموقتة"},{"UUID":"1a772cb8-fb98-4973-bdb7-50f478f48f62","title":"الأمان","link":"login-methods-subgroup.html","desc":"إعدادات حلول LDAP عناصر قائمة","descFull":"إعدادات حلول LDAP عناصر قائمة إعدادات حلول LDAP وأوصافها عنصر القائمة الإعدادات الوصف اتباع إحالات LDAP إيقاف * تشغيل للبحث في ملقمات مختلفة في المجال عن حساب المستخدم الذي قام بتسجيل الدخول. التحقق من شهادة LDAP نعم لا * لتمكين التحقق من شهادات LDAP. القائمة إعدادات حلول LDAP"},{"UUID":"4cf96157-dce3-42ae-b67a-41802c88a6ee","title":"الأمان","link":"login-methods-subgroup.html","desc":"متنوع عناصر قائمة متنوع وأوصافها","descFull":"متنوع عناصر قائمة متنوع وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. ميزات محمية عرض * إخفاء لعرض كل الميزات التي يحميها إعداد التحكّم بالوصول إلى الوظائف (FAC) بغض النظر عن إذن الأمان الذي يملكه المستخدم. يعرض الخيار  إخفاء  الميزات المحمية بإعداد التحكم في الوصول إلى الوظائف (FAC) فقط والتي يمكن للمستخدم الوصول إليها. إذن الطباعة إيقاف * تشغيل اطلب من المستخدم تسجيل الدخول قبل الطباعة. تسجيل الدخول إلى إذن الطباعة الافتراضي \"اسم المستخدم/كلمة المرور\" * اسم المستخدم تعيين تسجيل الدخول الافتراضي إلى  إذن الطباعة . رابط إعادة تعيين الأمان تمكين وصول \"الضيف\" * بلا تأثير تحديد إمكانية وصول المستخدم إلى الطابعة. يعطي الخيار  تمكين وصول \"الضيف\"  إمكانية وصول أي شخص إلى كل جوانب الطابعة. قد يجعل خيار  بلا تأثير  إمكانية الوصول إلى الطابعة مستحيلاً عندما لا تتوفر معلومات الأمان المطلوبة. استخدام محرك أقراص التخزين الذكي لبيانات المستخدم إيقاف تشغيل * لتمكين محرك التخزين الذكي لتخزين بيانات المستخدم. يتم تعطيل عنصر القائمة هذا عند تركيب قرص الصلب. الحد الأدنى لطول كلمة المرور 0–32  (0*) حدد الحد الأدنى لطول كلمة المرور المستخدمة للحسابات الداخلية مثل  كلمة المرور  و اسم المستخدم/كلمة المرور  الخاصة بالحسابات. تمكين إظهار كلمة المرور/رمز PIN إيقاف تشغيل * إظهار كلمة المرور أو رقم التعريف الشخصي. السماح بتشفير خدمة الذاكرة الدائمة‬‏‫ إيقاف * تشغيل قم بتمكين تشفير خدمة الذاكرة الدائمة‬‏‫ في جهازك. يتوفر هذا الإعداد في حالة تعطيل  تشفير خدمة الذاكرة الدائمة‬‏‫ . القائمة متنوع"},{"UUID":"75aa58c3-a21c-4e3d-814c-36edc59ce2e3","title":"خدمات السحابة","link":"cloud-services-enrollment-topic.html","desc":"التسجيل في خدمات السحابة عناصر","descFull":"التسجيل في خدمات السحابة عناصر قائمة التسجيل في خدمات السحابة وأوصافها عنصر القائمة الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. عرض المزيد من المعلومات الإعداد عبارة عن معلومات للقراءة فقط. اعرض المزيد من المعلومات حول استخدام Lexmark Cloud Services. تمكين التواصل مع Lexmark Cloud Services إيقاف * تشغيل لتمكين الطابعة من التواصل مع Lexmark Cloud Services. عرض الحالة الحالية الإعداد عبارة عن معلومات للقراءة فقط. لعرض حالة الاتصال بين الطابعة وLexmark Cloud Services. القائمة التسجيل في خدمات السحابة"},{"UUID":"c8f67b67-22ea-4146-8113-faec111c7c69","title":"التقارير","link":"menu-settings-page-topic.html","desc":"Menu Settings Page (صفحة إعدادات","descFull":"Menu Settings Page (صفحة إعدادات القائمة) عنصر قائمة  صفحة إعدادات القوائم  ووصفه عنصر القائمة الوصف Menu Settings Page (صفحة إعدادات القائمة) طباعة تقرير يحتوي على قوائم الطابعة. قائمة Menu Settings Page (صفحة إعدادات القائمة)"},{"UUID":"5cdb0e20-f7ff-4e47-abc2-0614d36ee391","title":"التقارير","link":"menu-settings-page-topic.html","desc":"جهاز عناصر قائمة الجهاز وأوصافها","descFull":"جهاز عناصر قائمة الجهاز وأوصافها عنصر القائمة الوصف معلومات الجهاز طباعة تقرير يحتوي على معلومات بخصوص الطابعة. إحصائيات الجهاز اطبع تقريرًا حول حالة المستلزمات وعدد الورق ومعلومات المهمة والمزيد. قائمة ملفات التعريف طباعة قائمة بملفات التعريف المخزنة في الطابعة. تقرير الأصول لطباعة أداة تشخيص لمشاكل الطباعة. لتجنب اقتصاص المحتوى، اطبع التقرير على ورق بحجم Letter أو A4. القائمة جهاز"},{"UUID":"661de05c-55f5-4978-8528-de2b459a1c88","title":"التقارير","link":"menu-settings-page-topic.html","desc":"طباعة عناصر قائمة الطباعة وأوصافها","descFull":"طباعة عناصر قائمة الطباعة وأوصافها عنصر القائمة الإعدادات الوصف خطوط الطباعة خطوط PCL خطوط PS لطباعة نماذج ومعلومات حول الخطوط المتوفرة في كل من لغات الطابعة. العرض التوضيحي للطباعة صفحة العرض التوضيحي لطباعة أداة تشخيص لمشاكل الطباعة. لتجنب اقتصاص المحتوى، اطبع التقرير على ورق بحجم Letter أو A4. يظهر عنصر القائمة هذا فقط عندما تكون الطابعة مثبتة عليها صفحة العرض التوضيحي. دليل الطباعة يتم تحديد الإعداد من قبل المستخدم. قم بطباعة تقرير يوضح الموارد المخزنة في محرك الأقراص المحمول أو القرص الثابت الخاص بالطابعة. القائمة طباعة"},{"UUID":"4c5eb510-fbf4-462e-b6ac-f47aca6c8707","title":"التقارير","link":"menu-settings-page-topic.html","desc":"الاختصارات عناصر قائمة الاختصارات وأوصافها","descFull":"الاختصارات عناصر قائمة الاختصارات وأوصافها عنصر القائمة الوصف كل الاختصارات طباعة تقرير يسرد الاختصارات المخزنة في الطابعة. تظهر  اختصارات الفاكس  فقط عند تركيب  الفاكس . اختصارات الفاكس اختصارات النسخ اختصارات البريد الإلكتروني اختصارات بروتوكول FTP اختصارات مجلد شبكة الاتصال القائمة الاختصارات"},{"UUID":"28e23589-87da-406b-8556-eddee6de82f9","title":"التقارير","link":"menu-settings-page-topic.html","desc":"الفاكس تظهر هذه القائمة فقط","descFull":"الفاكس تظهر هذه القائمة فقط إذا تمت تهيئة الفاكس وتم تعيين  تمكين سجل المهام  إلى  تشغيل . عناصر قائمة الفاكس وأوصافها عنصر القائمة الوصف سجل مهام الفاكس طباعة تقرير بخصوص آخر 200 مهمة مكتملة من مهام الفاكس. سجل مكالمات الفاكس طباعة تقرير بخصوص آخر 100 مكالمة تمت محاولة إجراؤها واستلامها وحظرها. القائمة الفاكس"},{"UUID":"60eab025-e8e9-46f1-81f2-6284a4dce37c","title":"التقارير","link":"menu-settings-page-topic.html","desc":"شبكة الاتصال عناصر قائمة شبكة","descFull":"شبكة الاتصال عناصر قائمة شبكة الاتصال وأوصافها عنصر القائمة الوصف صفحة إعداد شبكة الاتصال طباعة صفحة تعرض إعدادات الشبكة والإعدادات اللاسلكية المُكوّنة على الطابعة. يظهر عنصر القائمة هذا فقط في طابعات شبكات الاتصال أو الطابعات المتصلة بملقمات الطباعة. الأجهزة العميلة المتصلة بواسطة Wi‑Fi Direct لطباعة صفحة تُظهر قائمة الأجهزة المتصلة بالطابعة باستخدام Wi‑Fi Direct. يظهر عنصر القائمة هذا فقط عند تعيين  تمكين Wi‑Fi Direct  إلى  تشغيل . القائمة شبكة الاتصال"},{"UUID":"1a5d50cf-8cee-4cc4-9e9a-1eb3bafd53b8","title":"قوائم الطابعة","link":"troubleshooting-menu-topic.html","desc":"استكشاف الأخطاء وإصلاحها عناصر قائمة","descFull":"استكشاف الأخطاء وإصلاحها عناصر قائمة استكشاف الأخطاء وإصلاحها وأوصافها عنصر القائمة الوصف صفحات اختبار جودة الطباعة اطبع نماذج صفحات لتحدد وتصحِّح عيوب جودة الطباعة. تنظيف الماسحة الضوئية لطباعة إرشادات حول كيفية تنظيف الماسحة الضوئية. القائمة استكشاف الأخطاء وإصلاحها صفحات اختبار جودة الطباعة تنظيف الماسحة الضوئية"},{"UUID":"4c1db29a-1afa-496a-9fd0-93b2a2b040e6","title":"قوائم الطابعة","link":"forms-merge-topic.html","desc":"دمج النماذج يظهر عنصر القائمة","descFull":"دمج النماذج يظهر عنصر القائمة هذا فقط عند تثبيت محرك تخزين. عناصر قائمة دمج النماذج وأوصافها عنصر القائمة عنصر القائمة الفرعية الإعدادات الوصف تشير علامة النجمة (*) الموجودة بجوار القيمة إلى الإعداد الافتراضي للمصنع. وضع الدمج غير متاح الطباعة * التقاط البيانات تعطيل تحديد وضع التشغيل لدمج النماذج. هدف التقاط البيانات غير متاح فلاش * قم بتعيين الوجهة المستهدفة حيث تتم إعادة توجيه البيانات الملتقطة. يظهر عنصر القائمة هذا فقط عند تعيين  وضع الدمج  إلى  التقاط البيانات . إعدادات منفذ الطباعة وعامل التصفية منفذ شبكة الاتصال تشغيل * إيقاف قم بتمكين دمج النماذج لمعالجة كافة البيانات المرسلة إلى منفذ شبكة الاتصال. عامل تصفية شبكة الاتصال معطّل * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF حدد عامل تصفية الشبكة لجميع البيانات التي يتم إرسالها إلى الطابعة. منفذ USB تشغيل * إيقاف قم بتمكين دمج النماذج لمعالجة كافة البيانات المرسلة إلى منفذ USB. مرشح USB معطّل * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF حدد عامل تصفية USB لجميع البيانات التي يتم إرسالها إلى الطابعة. مهلة المنفذ المحلي 1–100  (10*) حدد قيمة المهلة لمهام دمج النماذج المرسلة إلى المنفذ المحلي. متنوع طباعة كل النماذج البدء قم بطباعة كافة مجموعات النماذج المخزنة في محرك التخزين الذكي أو القرص الثابت. طباعة صفحة الخطأ تشغيل * إيقاف تمكين طباعة صفحة خطأ عند حدوث خطأ في مهمة دمج النماذج. القائمة دمج النماذج"},{"UUID":"d6044f96-03c5-4d08-8f7c-b9bbf873a480","title":"قوائم الطابعة","link":"printing-menu-settings-page-topic.html","desc":"طباعة  صفحة إعدادات القوائم","descFull":"طباعة  صفحة إعدادات القوائم من لوحة تحكم الطابعة، انتقل إلى  الإعدادات التقارير . حدد  صفحة إعدادات القوائم . طباعة صفحة إعدادات القوائم صفحة إعدادات القوائم طباعة قوائم الطباعة"},{"UUID":"0ea1b9d2-053e-496d-8322-e43bb068ed49","title":"خيارات إنهاء الطابعة","link":"using-staple-finisher-topic.html","desc":"استخدام وحدة إنهاء التدبيس التدبيس","descFull":"استخدام وحدة إنهاء التدبيس التدبيس باستخدام برنامج تشغيل الطباعة لمستخدمي نظام التشغيل Windows بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة، ومن ثم انقر فوق  الخصائص  أو  التفضيلات  أو  الخيارات  أو  إعداد . انقر فوق  الورق/الإنهاء ، ثم قم بتهيئة  الورق  الإعدادات. في قائمة  التدبيس ، حدد الإعداد الذي تريده. انقر فوق  موافق  ثم انقر فوق  طباعة . لمستخدمي Macintosh أثناء فتح أحد المستندات، اختر  ملف طباعة . حدد طابعة. من القائمة  خيارات الإنهاء  ، حدد  تطبيق الإنهاء خيارات الطابعة . انقر فوق  تدبيس ، ثم حدد إعدادًا. انقر فوق  ‎طباعة . التدبيس باستخدام لوحة التحكم من لوحة التحكم، حدد  طباعة ، ثم حدد مصدر مهمة الطباعة. حدد المستند. حدد  مزيد من الإعدادات ، ثم حدد  خيارات الإنهاء . حدد  تدبيس ، ثم حدد إعدادًا. اطبع المستند. ‏‫وحدة إنهاء التدبيس‬ استخدام التدبيس الأوراق المطبوعة التدبيس المستندات المنسوخة"},{"UUID":"cdb501e3-4a40-407f-8347-596485bf428b","title":"خيارات إنهاء الطابعة","link":"using-staple-hole-punch-finisher-topic.html","desc":"استخدام وحدة إنهاء التدبيس ووحدة","descFull":"استخدام وحدة إنهاء التدبيس ووحدة إنهاء تثقيب الفتحات استخدام وحدة إنهاء التدبيس ووحدة إنهاء تثقيب الفتحات تدبيس الورق أو تثقيب باستخدام برنامج تشغيل الطباعة لمستخدمي نظام التشغيل Windows بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة، ومن ثم انقر فوق  الخصائص  أو  التفضيلات  أو  الخيارات  أو  إعداد . انقر فوق  الورق/الإنهاء ، ثم قم بتهيئة  الورق  الإعدادات. اعتمادًا على الإنهاء التي تريده، حدد إعداد  التدبيس  أو  تثقيب الفتحات . يمكنك تحديد إعداد لكليهما إذا كنت تريد تدبيس المواد المطبوعة وتثقيبها. انقر فوق  موافق  ثم انقر فوق  طباعة . لمستخدمي Macintosh بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة. من القائمة  خيارات الإنهاء  ، حدد  تطبيق الإنهاء خيارات الطابعة . انقر فوق  التدبيس  أو  التثقيب ، ثم حدد إعدادًا. انقر فوق  ‎طباعة . تدبيس أو تثقيب الورق باستخدام لوحة التحكم من لوحة التحكم، حدد  طباعة ، ثم حدد مصدر مهمة الطباعة. حدد المستند. حدد  مزيد من الإعدادات ، ثم حدد  خيارات الإنهاء . اعتمادًا على الإنهاء التي تريده، حدد إعداد  التدبيس  أو  تثقيب الفتحات . يمكنك تحديد إعداد لكليهما إذا كنت تريد تدبيس المواد المطبوعة وتثقيبها. اطبع المستند. تدبيس الأوراق المطبوعة تثقيب الفتحات في الأوراق المطبوعة وحدة إنهاء التدبيس ووحدة إنهاء تثقيب الفتحات استخدام"},{"UUID":"54a7dafa-cb45-47f2-a6be-96ab28e55f9d","title":"خيارات إنهاء الطابعة","link":"using-offset-stacker-topic.html","desc":"استخدام وحدة التكديس وحدة التكديس","descFull":"استخدام وحدة التكديس وحدة التكديس باستخدام برنامج تشغيل الطباعة لمستخدمي نظام التشغيل Windows بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة، ومن ثم انقر فوق  الخصائص  أو  التفضيلات  أو  الخيارات  أو  إعداد . انقر فوق  الورق/الإنهاء ، ثم قم بتهيئة  الورق  الإعدادات. في قائمة  الإزاحة‬  حدد إعدادًا. انقر فوق  موافق  ثم انقر فوق  طباعة . لمستخدمي Macintosh بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة. من القائمة  خيارات الإنهاء  ، حدد  تطبيق الإنهاء خيارات الطابعة . انقر فوق  إزاحة ، ثم حدد إعدادًا. انقر فوق  ‎طباعة . وحدة التكديس باستخدام لوحة التحكم حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. لتجنب الحصول على صورة مقتصّة، تأكد من تطابق حجم ورقة المستند الأصلي مع حجم ورقة الإخراج. من لوحة التحكم، حدد  نسخ ، ثم حدد عدد النُسخ. حدد  مزيد من الإعدادات ، ثم حدد  صفحات الإزاحة . قم بتمكين القائمة، ثم حدد إعدادًا. اطبع المستند. وحدة التكديس مع الفصل استخدام التكديس مع الفصل"},{"UUID":"68f9c990-45ac-4088-b90e-245cb7d21628","title":"خيارات إنهاء الطابعة","link":"using-booklet-finisher-topic.html","desc":"استخدام وحدة إنهاء الكتيب قبل","descFull":"استخدام وحدة إنهاء الكتيب قبل إنشاء كتيب، حمِّل الورق بحيث تكون الحافة القصيرة باتجاه الجانب الأيمن من الدرج. إنشاء كتيب باستخدام برنامج تشغيل الطباعة لمستخدمي نظام التشغيل Windows بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة، ومن ثم انقر فوق  الخصائص  أو  التفضيلات  أو  الخيارات  أو  إعداد . حدد  كتيب . انقر فوق ‏‫علامة التبويب  ‎الورق/وحدة الإنهاء  ثم قم بتهيئة إعدادات الورق. في قائمة  الطي‬‬  حدد إعدادًا. انقر فوق  موافق  ثم انقر فوق  طباعة . لمستخدمي Macintosh بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة. من القائمة  خيارات الإنهاء  ، حدد  تطبيق الإنهاء خيارات الطابعة . حدد  كتيب ، ثم حدد إعداد  الطي . انقر فوق  \"موافق\" . إنشاء كتيب باستخدام لوحة التحكم حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. لتجنب الحصول على صورة مقتصّة، تأكد من تطابق حجم ورقة المستند الأصلي مع حجم ورقة الإخراج. من لوحة التحكم، حدد  نسخ ، ثم قم بتهيئة الإعدادات. حدد  مزيد من الإعدادات ، ثم حدد  إنشاء كتيب . قم بتمكين  وحدة إنهاء الكتيب ، ثم حدد إعدادًا. انسخ المستند. إنشاء كتيب صنع كتيب وحدة إنهاء الكتيبات استخدام"},{"UUID":"0d2fc047-8b44-4546-9b34-5db43a0b5dc5","title":"خيارات إنهاء الطابعة","link":"using-hptfu-topic.html","desc":"استخدام نقل الورق مع خيار","descFull":"استخدام نقل الورق مع خيار الطي طي الورق باستخدام برنامج تشغيل الطباعة لمستخدمي نظام التشغيل Windows بعد فتح أحد المستندات، انقر فوق  ملف طباعة . حدد طابعة، ومن ثم انقر فوق  الخصائص  أو  التفضيلات  أو  الخيارات  أو  إعداد . انقر فوق  ‎الورق/وحدة الإنهاء ‎، ثم قم بتهيئة إعدادات الورق. في قائمة  الطي‬‬  حدد إعدادًا. انقر فوق  موافق  ثم انقر فوق  طباعة . لمستخدمي Macintosh أثناء فتح أحد المستندات، اختر  ملف طباعة . حدد طابعة. من القائمة  خيارات الإنهاء  ، حدد  تطبيق الإنهاء خيارات الطابعة . انقر فوق  طي ، ثم حدد إعدادًا. انقر فوق  ‎طباعة . طي الورق باستخدام لوحة التحكم حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. لتجنب الحصول على صورة مقتصّة، تأكد من تطابق حجم ورقة المستند الأصلي مع حجم ورقة الإخراج. من لوحة التحكم، حدد  نسخ ، ثم حدد عدد النُسخ. حدد  مزيد من الإعدادات ، ثم حدد  خيارات الإنهاء . حدد  طي ، ثم حدد إعدادًا. انسخ المستند. نقل الورق مع خيار الطي استخدام طي النسخ المطبوعة طي المستندات المنسوخة"},{"UUID":"2b096e0f-db1b-4b57-a0ba-65497b871f1b","title":"صيانة الطابعة","link":"checking-supplies-status-topic.html","desc":"فحص قطع الطابعة ومستلزماتها فحص","descFull":"فحص قطع الطابعة ومستلزماتها فحص قطع الطابعة ومستلزماتها من الزاوية العلوية اليمنى للوحة التحكم، حدد  . عرض حالة قطع الطابعة ومستلزماتها. يمكنك أيضًا تحديد   للتحقق من الإشعارات التي تتطلب تدخل المستخدم. فحص، حالة المستلزمات حالة المستلزمات‬ فحص حالة قطع الطابعة فحص"},{"UUID":"d56d870c-281f-474f-8503-228f71c04444","title":"صيانة الطابعة","link":"configuring-supply-notifications-topic.html","desc":"تهيئة إخطارات مستلزمات الطباعة تهيئة","descFull":"تهيئة إخطارات مستلزمات الطباعة تهيئة إخطارات مستلزمات الطباعة افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الإعدادات الجهاز الإخطارات . انقر فوق  إخطارات مستلزمات الطباعة . حدد إخطارًا لكل عنصر مستلزمات. طبّق التغييرات. إخطارات مستلزمات الطباعة تهيئة إخطارات تهيئة مستلزمات الطباعة"},{"UUID":"6ca0d7bd-d98a-4621-9682-8fa98c177f4e","title":"صيانة الطابعة","link":"setting-up-email-alert-topic.html","desc":"إعداد تنبيهات البريد الالكتروني إعداد","descFull":"إعداد تنبيهات البريد الالكتروني إعداد تنبيهات البريد الالكتروني افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الإعدادات الجهاز الإخطارات . انقر فوق  إعداد تنبيه البريد الإلكتروني ، ثم قم بتهيئة الإعدادات. لمزيد من المعلومات حول إعدادات SMTP، اتصل بموفر البريد الإلكتروني الذي تتعامل معه. طبّق التغييرات. انقر فوق  إعداد تنبيهات وقوائم البريد الإلكتروني ، ثم قم بتهيئة الإعدادات. طبّق التغييرات. تنبيهات البريد الإلكتروني إعداد إعداد تنبيهات البريد الالكتروني"},{"UUID":"598c129c-e41b-4ccd-a5b5-93273a6b251f","title":"صيانة الطابعة","link":"generating-reports-and-logs-topic.html","desc":"إنشاء التقارير والسجلات إنشاء التقارير","descFull":"إنشاء التقارير والسجلات إنشاء التقارير والسجلات من لوحة تحكم الطابعة، انتقل إلى  الإعدادات التقارير . حدد التقرير أو السجل الذي ترغب في طباعته. صفحة إعدادات القوائم  — تعرض تفضيلات الطابعة وإعداداتها وتهيئاتها الحالية. جهاز معلومات الجهاز  — إظهار الرقم التسلسلي للطابعة والحلول المثبتة والفاكس. إحصائيات الجهاز  — إظهار حالة المستلزمات وإجمالي الأوراق المطبوعة ومعلومات مهمة الطابعة. قائمة ملفات التعريف —إظهار قائمة بملفات التعريف أو الاختصارات المخزنة في الطابعة. تقرير الأصول —إظهار التقرير الذي يحتوي على معلومات أصول الطابعة، مثل الرقم التسلسلي واسم الطراز. طباعة خطوط الطباعة  — إظهار الخطوط المتوفرة في كل لغة من لغات الطابعة. ‏‫العرض التوضيحي للطباعة‬ —إظهار ملفات العروض التوضيحية المتوفرة في البرنامج الثابت، وخيار الذاكرة المؤقتة، وخيار القرص. ‏‫دليل الطباعة —إظهار الموارد المخزنة في محرك أقراص فلاش أو القرص الثابت أو محرك أقراص التخزين الذكي (ISD). يظهر التقرير فقط عند تثبيت محرك أقراص محمول أو قرص ثابت للطابعة أو ISD. الاختصارات كافة الاختصارات  — إظهار قائمة بجميع الاختصارات المخزنة على الطابعة. اختصارات الفاكس  —إظهار قائمة باختصارات الفاكس المخزنة على الطابعة. نسخ الاختصارات  —إظهار قائمة باختصارات النسخ المخزنة على الطابعة. كافة البريد الإلكتروني  — إظهار قائمة باختصارات البريد الإلكتروني المخزنة على الطابعة. اختصارات بروتوكول FTP  — إظهار قائمة باختصارات بروتوكول نقل الملفات (FTP) المخزنة على الطابعة. اختصارات ملف شبكة الاتصال  — إظهار قائمة باختصارات مجلدات الشبكة المخزنة على الطابعة. الفاكس سجل مهام الفاكس —يدرج آخر 200 مهمة فاكس مكتملة. يظهر التقرير فقط عند  تمكين سجل الوظائف . سجل مكالمات الفاكس  — إظهار الموارد المخزنة على محرك الأقراص المحمول أو محرك التخزين. يظهر التقرير فقط عند تثبيت محرك أقراص محمول أو محرك تخزين. شبكة الاتصال صفحة إعداد الشبكة —إظهار إعدادات الشبكة واللاسلكية التي تم تهيئتها على الطابعة. يظهر هذا التقرير فقط في طابعات الشبكة والطابعات المتصلة بملقمات الطباعة. الأجهزة العميلة المتصلة بتقنية Wi-Fi Direct  — إظهار قائمة الأجهزة المتصلة بالطابعة باستخدام Wi-Fi Direct. يظهر هذا التقرير فقط عند تعيين  تمكين Wi‑Fi Direct  إلى  تشغيل . تقارير الطباعة سجلات الطباعة عرض التقارير والسجلات قراءة العداد، العرض أوراق مطبوعة، عرض"},{"UUID":"54942af2-2174-484f-a85d-e63cabcc20eb","title":"طلب الأجزاء والمستلزمات","link":"ordering-parts-and-supplies-group.html","desc":"لطلب شراء مستلزمات الطباعة في","descFull":"لطلب شراء مستلزمات الطباعة في الولايات المتحدة، تستطيع الاتصال بـ Lexmark على الرقم 6275-539-800-1 للحصول على معلومات حول وكلاء Lexmark المعتمدين لمستلزمات الطباعة في المنطقة التي تقيم بها. للدول والمناطق الأخرى، قم بزيارة موقع  www.lexmark.com  أو الاتصال بالمكان الذي اشتريت منه الطابعة. لطلب شراء مستلزمات الطباعة، اتصل بالمكان الذي اشتريت منه الطابعة. تفترض جميع التقديرات الخاصة بالعمر الافتراضي لمستلزمات الطابعة، إجراء الطباعة على ورق عادي بحجم Letter أو A4. وقد يؤدي عدم الحفاظ على أداء الطابعة الأمثل أو استبدال الأجزاء والمستلزمات إلى إتلاف طابعتك. أجزاء ومستلزمات الطباعة الأصلية"},{"UUID":"f90de51c-a352-4e43-a52d-96e58b5d8f97","title":"طلب الأجزاء والمستلزمات","link":"ordering-parts-and-supplies-group.html","desc":"استخدام مستلزمات الطباعة والأجزاء الأصلية","descFull":"استخدام مستلزمات الطباعة والأجزاء الأصلية من Lexmark تم تصميم طابعة Lexmark لتعمل بشكل أفضل مع الأجزاء والمستلزمات الأصلية من Lexmark. قد يؤثر استخدام المستلزمات أو الأجزاء التي يوفرها طرف ثالث على أداء الطابعة ومكوناتها الخاصة بالتصوير أو موثوقيتها أو عمرها. قد يؤثر أيضًا على تغطية الضمان. لا يغطي الضمان التلفَ الناتج من استخدام المستلزمات والأجزاء التي يوفرها طرف ثالث. تم تصميم كل مؤشرات العمر لتعمل مع المستلزمات والأجزاء الأصلية من Lexmark وقد ترسل نتائج غير متوقَّعَة إذا تم استخدام مستلزمات وأجزاء يوفرها طرف ثالث. قد يتسبب استخدام عنصر التصوير بعد العمر الافتراضي المحدد له في إتلاف طابعة Lexmark أو المكونات المرتبطة بها. يمكن إعادة تعيين المستلزمات والقطع غير الخاضعة لبنود اتفاقية برنامج الإرجاع وإعادة تصنيعها. ولكن ضمان جهة التصنيع لا يغطي الأضرار الناجمة عن استخدام مستلزمات أو قطع غير أصلية. قد تتسبّب إعادة تعيين عدادات المستلزمات أو القطع بدون إعادة تصنيعها بشكل صحيح بضرر لطابعتك. بعد إعادة تعيين عداد المستلزمات أو القطع، قد تعرض طابعتك خطأً يشير إلى وجود عنصر إعادة التعيين. استخدام القطع ومستلزمات الطباعة الأصلية من Lexmark القطع ومستلزمات الطباعة الأصلية من Lexmark"},{"UUID":"6396135d-8bfd-44a1-ad4b-e6527b1ed7fd","title":"طلب الأجزاء والمستلزمات","link":"ordering-parts-and-supplies-group.html","desc":"طلب خرطوشة مسحوق حبر طلب","descFull":"طلب خرطوشة مسحوق حبر طلب خرطوشة مسحوق حبر تم تحديد إنتاجية الخرطوشة المقدرة وفقًا لمعيار ISO/IEC 19798. قد تؤثر التغطية الطباعة شديدة الانخفاض لفترات زمنية طويلة تأثيرًا سلبيًا في الإنتاجية الفعلية. لطلب شراء خراطيش مسحوق الحبر، اتصل بالمكان الذي اشتريت منه الطابعة. خراطيش مسحوق الحبر الخاصة ببرنامج الإرجاع Lexmark CX833، CX961، CX962، CX963 الصنف الولايات المتحدة وكندا وأستراليا ونيوزيلندا الاتحاد الأوروبي والمنطقة الاقتصادية الأوروبية وأيسلندا وليختنشتاين والنرويج وسويسرا باقي دول آسيا والمحيط الهادئ أمريكا اللاتينية وبورتوريكو والمكسيك مصممة خصيصًا للاستخدام في بقية أوروبا والشرق الأوسط وأفريقيا وأوروبا الشرقية الوسطى ورابطة الدول المستقلة لمزيد من المعلومات حول الدول في كل منطقة، انتقل إلى  www.lexmark.com/regions . سماوي 77L10C0 77L20C0 77L30C0 77L40C0 77L50C0 أرجواني 77L10M0 77L20M0 77L30M0 77L40M0 77L50M0 أصفر 77L10Y0 77L20Y0 77L30Y0 77L40Y0 77L50Y0 أسود 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 خراطيش مسحوق الحبر عالية الإنتاجية الخاصة ببرنامج الإرجاع Lexmark CX833 الصنف الولايات المتحدة وكندا وأستراليا ونيوزيلندا الاتحاد الأوروبي والمنطقة الاقتصادية الأوروبية وأيسلندا وليختنشتاين والنرويج وسويسرا باقي دول آسيا والمحيط الهادئ أمريكا اللاتينية وبورتوريكو والمكسيك مصممة خصيصًا للاستخدام في بقية أوروبا والشرق الأوسط وأفريقيا وأوروبا الشرقية الوسطى ورابطة الدول المستقلة لمزيد من المعلومات حول الدول في كل منطقة، انتقل إلى  www.lexmark.com/regions . سماوي 79L10K0 79L20K0 79L30K0 79L40K0 79L50K0 أرجواني 79L1HM0 79L2HM0 79L3HM0 79L4HM0 79L5HM0 أصفر 79L1HY0 79L2HY0 79L3HY0 79L4HY0 79L5HY0 أسود 79L1HK0 79L2HK0 79L3HK0 79L4HK0 79L5HK0 Lexmark CX961، CX962، CX963 الصنف الولايات المتحدة وكندا وأستراليا ونيوزيلندا الاتحاد الأوروبي والمنطقة الاقتصادية الأوروبية وأيسلندا وليختنشتاين والنرويج وسويسرا باقي دول آسيا والمحيط الهادئ أمريكا اللاتينية وبورتوريكو والمكسيك مصممة خصيصًا للاستخدام في بقية أوروبا والشرق الأوسط وأفريقيا وأوروبا الشرقية الوسطى ورابطة الدول المستقلة لمزيد من المعلومات حول الدول في كل منطقة، انتقل إلى  www.lexmark.com/regions . سماوي 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 أرجواني 77L1HM0 77L2HM0 77L3HM0 77L4HM0 77L5HM0 أصفر 77L1HY0 77L2HY0 77L3HY0 77L4HY0 77L5HY0 أسود 77L1HK0 77L2HK0 77L3HK0 77L4HK0 77L5HK0 Lexmark XC8355 الصنف الولايات المتحدة وكندا وأستراليا ونيوزيلندا باقي أوروبا والشرق الأوسط وأفريقيا لمزيد من المعلومات حول الدول في كل منطقة، انتقل إلى  www.lexmark.com/regions . سماوي 24B7574 24B7582 أرجواني 24B7575 24B7583 أصفر 24B7576 24B7584 أسود 24B7577 24B7585 Lexmark XC9635، XC9645، XC9655 الصنف الولايات المتحدة وكندا وأستراليا ونيوزيلندا باقي أوروبا والشرق الأوسط وأفريقيا لمزيد من المعلومات حول الدول في كل منطقة، انتقل إلى  www.lexmark.com/regions . سماوي 24B7570 24B7578 أرجواني 24B7571 24B7579 أصفر 24B7572 24B7580 أسود 24B7573 24B7581 خراطيش مسحوق الحبر العادية عالية الإنتاجية Lexmark CX833 الصنف عالمي لمزيد من المعلومات حول الدول في كل منطقة، انتقل إلى  www.lexmark.com/regions . سماوي 77L0H20 أرجواني 77L0H30 أصفر 77L0H40 أسود 77L0H10 Lexmark CX961، CX962، CX963 الصنف عالمي لمزيد من المعلومات حول الدول في كل منطقة، انتقل إلى  www.lexmark.com/regions . سماوي 79L0H20 أرجواني 79L0H30 أصفر 79L0H40 أسود 79L0H10 طلب مستلزمات الطباعة خرطوشة مسحوق الحبر خرطوشة مسحوق الحبر طلب"},{"UUID":"3ba981a3-1a81-4d89-8521-c5e0a4e089a6","title":"طلب الأجزاء والمستلزمات","link":"ordering-parts-and-supplies-group.html","desc":"طلب وحدة تصوير بالأسود طلب","descFull":"طلب وحدة تصوير بالأسود طلب وحدة تصوير بالأسود لطلب وحدة تصوير بالأسود، اتصل بالمكان الذي اشتريت منه الطابعة. وحدة التصوير باللون الأسود وأرقام القطعة الخاصة بها الصنف رقم الجزء برنامج إرجاع وحدة التصوير بالأسود 77L0ZK0 وحدة التصوير بالأسود 77L0Z10 وحدة التصوير بالأسود طلب طلب مستلزمات الطباعة وحدة التصوير بالأسود"},{"UUID":"04882808-2730-4811-9bfa-13dbde97e788","title":"طلب الأجزاء والمستلزمات","link":"ordering-parts-and-supplies-group.html","desc":"طلب مجموعة تصوير بالألوان لطلب","descFull":"طلب مجموعة تصوير بالألوان لطلب مجموعة تصوير بالألوان، اتصل بالمكان الذي اشتريت منه الطابعة. الصنف رقم الجزء مجموعة التصوير بالألوان الخاصة ببرنامج الإرجاع 77L0ZV0 مجموعة تصوير عادية بالألوان 77L0Z50 مجموعة التصوير بالألوان طلب طلب مستلزمات الطباعة مجموعة التصوير بالألوان"},{"UUID":"b3d18c09-78bf-48aa-b6b6-cbbea4635ab8","title":"طلب الأجزاء والمستلزمات","link":"ordering-parts-and-supplies-group.html","desc":"طلب زجاجة نفايات مسحوق الحبر","descFull":"طلب زجاجة نفايات مسحوق الحبر طلب زجاجة نفايات مسحوق الحبر لطلب زجاجة نفايات مسحوق الحبر، اتصل بالمكان الذي اشتريت منه الطابعة. رقم القطعة الخاص بزجاجة نفايات مسحوق الحبر الصنف رقم الجزء زجاجة نفايات مسحوق الحبر 77L0W00 طلب مستلزمات الطباعة زجاجة نفايات مسحوق الحبر زجاجة نفايات مسحوق الحبر طلب"},{"UUID":"77f9d63a-548e-4df4-8da3-7fb58ce28002","title":"طلب الأجزاء والمستلزمات","link":"ordering-parts-and-supplies-group.html","desc":"طلب خرطوشة دبابيس لطلب خرطوشة","descFull":"طلب خرطوشة دبابيس لطلب خرطوشة دبابيس، اتصل بالمكان الذي اشتريت منه الطابعة. خرطوشة الدبابيس ورقم القطعة الخاص بها الصنف رقم الجزء 1  متاح فقط لصانع الكتيبات. 2  متوفر فقط لوحدة إنهاء الكتيبات، ووحدة إنهاء التدبيس والتدبيس ووحدة إنهاء تثقيب الفتحات. خراطيش الدبابيس (4 عبوات) 1 20L7500 خراطيش الدبابيس (3 عبوات) 2 25A0013 خرطوشة دبابيس طلب طلب مستلزمات الطباعة خرطوشة دبابيس"},{"UUID":"1906a89e-6386-4974-917f-79d0ffd7e6f3","title":"طلب الأجزاء والمستلزمات","link":"ordering-parts-and-supplies-group.html","desc":"طلب مجموعة صيانة طلب مجموعة","descFull":"طلب مجموعة صيانة طلب مجموعة صيانة لطلب مجموعة الصيانة، اتصل بالمكان الذي اشتريت منه الطابعة. قم بمطابقة مجموعة الصيانة مع جهد الطابعة. قد يتطلب استخدام أنواع معينة من الورق استبدال مجموعة أدوات الصيانة بصورة أكثر تكرارًا. تتضمن مجموعة الصيانة وحدة صهر وبكرات التقاط. يمكن طلب هذه القطع واستبدالها بشكل منفصل إذا لزم الأمر. مجموعات الصيانة وأرقام الأجزاء الموصى بها الصنف رقم الجزء لا يمكن أن يتم استبدال مجموعة الصيانة إلا من قبل فني صيانة معتمد. اتصل بمزود الخدمة الذي تتعامل معه. مجموعة أدوات صيانة المصهر 100 فولت لبرنامج الإرجاع، النوع 02 41X5654 مجموعة أدوات صيانة المصهر 110-120 فولت لبرنامج الإرجاع، النوع 00 41X5655 مجموعة أدوات صيانة المصهر 220-240 فولت لبرنامج الإرجاع، النوع 01 41X5656 مجموعة صيانة المصهر 100 فولت العادي، النوع 12 41X6053 مجموعة صيانة المصهر 110-120 فولت العادي، النوع 10 41X6051 مجموعة صيانة المصهر 220-240 فولت العادي، النوع 11 41X6052 طلب مستلزمات الطباعة مجموعة صيانة وحدة الصهر مجموعة صيانة وحدة الصهر طلب"},{"UUID":"5cc6bc10-0c4a-4db6-a23b-44227ffa43bd","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال خرطوشة مسحوق الحبر استبدال","descFull":"استبدال خرطوشة مسحوق الحبر استبدال خرطوشة مسحوق الحبر افتح الباب الأمامي.  أخرج خرطوشة مسحوق الحبر المستعملة. قم بفك عبوة خرطوشة مسحوق الحبر الجديدة. ادفع خرطوشة مسحوق الحبر إلى الداخل حتى تسمع  صوت  استقرارها في مكانها. أغلق الباب. خرطوشة مسحوق الحبر استبدال استبدال مستلزمات الطباعة خرطوشة مسحوق الحبر"},{"UUID":"3544c848-33bf-46c1-b158-f53da40469ca","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال وحدة التصوير بالأسود افتح","descFull":"استبدال وحدة التصوير بالأسود افتح الباب الأمامي. أزل خراطيش مسحوق الحبر. أزل زجاجة نفايات مسحوق الحبر. لتجنب سكب مسحوق الحبر، ضع الزجاجة في وضع مستقيم. قم بإزالة مجموعة التصوير. لا تعرّض مجموعة التصوير للضوء المباشر. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة موصل الصور. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. ضع مجموعة التصوير على سطح نظيف ومستوٍ بشكل عمودي لتجنب خدش أسطوانة الموصل الضوئي أو إتلافها.  افتح وحدة التصوير بالأسود المستخدمة. أزل وحدة التصوير بالأسود. أخرج وحدة التصوير بالأسود الجديدة من العبوة. أدخل وحدة التصوير بالأسود الجديدة. اقفل وحدة التصوير بالأسود الجديدة في مكانها. أدخل مجموعة التصوير حتى تستقر في موضعها تمامًا. أدخل زجاجة نفايات مسحوق الحبر حتى تسمع صوت  طقطقة  عند استقرارها في مكانها. اسحب ماسحات رأس الطباعة للخارج برفق، ثم نظف عدسات رأس الطباعة. لمزيد من المعلومات حول تنظيف عدسات رأس الطباعة، راجع  . أدخل خراطيش مسحوق الحبر. أغلق الباب. وحدة التصوير بالأسود استبدال استبدال مستلزمات الطباعة وحدة التصوير بالأسود"},{"UUID":"6dd7ff66-e83f-4584-aa7d-040d265e2608","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال مجموعة التصوير بالألوان افتح","descFull":"استبدال مجموعة التصوير بالألوان افتح الباب الأمامي. أزل خراطيش مسحوق الحبر. أزل زجاجة نفايات مسحوق الحبر. لتجنب سكب مسحوق الحبر، ضع الزجاجة في وضع مستقيم. أخرج مجموعة التصوير المستخدمة. ضع مجموعة التصوير على سطح نظيف ومستوٍ بشكل عمودي لتجنب خدش أسطوانة الموصل الضوئي أو إتلافها.  افتح وحدة التصوير بالأسود. أخرج وحدة التصوير بالأسود. لا تتخلص من وحدة التصوير بالأسود. وسيتم تثبيتها على مجموعة التصوير الجديدة. أخرج مجموعة التصوير الجديدة من العبوة. تشمل مجموعة التصوير على سلة التصوير ووحدات المطور ذات اللون السماوي والأرجواني والأصفر. لا تعرّض مجموعة التصوير للضوء المباشر. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة موصل الصور. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود في مجموعة التصوير الجديدة. اقفل وحدة التصوير بالأسود في مكانها. أدخل مجموعة التصوير الجديدة حتى تستقر في موضعها تمامًا. أدخل زجاجة نفايات مسحوق الحبر حتى تسمع صوت  طقطقة  عند استقرارها في مكانها. اسحب ماسحات رأس الطباعة للخارج برفق، ثم نظف عدسات رأس الطباعة. لمزيد من المعلومات حول تنظيف عدسات رأس الطباعة، راجع  . أدخل خراطيش مسحوق الحبر. أغلق الباب. مجموعة التصوير بالألوان استبدال استبدال مستلزمات الطباعة مجموعة التصوير بالألوان"},{"UUID":"92923f85-98d3-4ee0-aba0-9ca98f6ac4c0","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال زجاجة نفايات مسحوق الحبر","descFull":"استبدال زجاجة نفايات مسحوق الحبر استبدال زجاجة نفايات مسحوق الحبر افتح الباب الأمامي. أزل زجاجة نفايات مسحوق الحبر المستخدمة. لتجنب سكب مسحوق الحبر، ضع الزجاجة في وضع مستقيم. أخرج زجاجة نفايات مسحوق الحبر الجديدة من عبوتها. أدخل زجاجة نفايات مسحوق الحبر الجديدة حتى تسمع صوت  طقطقة  عند استقرارها في مكانها، ثم أغلق الباب. استبدال مستلزمات الطباعة زجاجة نفايات مسحوق الحبر زجاجة نفايات مسحوق الحبر استبدال"},{"UUID":"3a3b7208-44a6-4335-b795-f1482477d686","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال وحدة الصهر استبدال وحدة","descFull":"استبدال وحدة الصهر استبدال وحدة الصهر قم بإيقاف تشغيل الطابعة. افصل سلك التيار من مأخذ التيار الكهربائي ثم من الطابعة. افتح الباب B. قد يكون الجزء الداخلي من الطابعة ساخنًا. للحد من خطر التعرض للإصابة من أحد المكونات الساخنة، اترك السطح ليبرد قبل ملامسته. قم بإلغاء قفل وحدة المصهر المستخدمة ثم قم بإزالتها. أخرج وحدة الصهر الجديدة من العبوة. أدخل وحدة الصهر الجديدة حتى تصدر صوت  طقطقة  عند استقرارها في مكانها، ثم أقفلها. أغلق الباب B. قم بتوصيل أحد طرفي سلك التيار بالطابعة، ثم قم بتوصيل الطرف الآخر بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك التيار بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. قم بتشغيل الطابعة. جهاز الصهر استبدال استبدال القطع جهاز الصهر"},{"UUID":"1b0249e7-e95e-42bb-9990-0e8f2fc75360","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال مقحمة الدرج استبدال مقحمة","descFull":"استبدال مقحمة الدرج استبدال مقحمة الدرج اسحب مقحمة الدرج المستخدم للخارج. قم بفك مقحمة الدرج الجديدة. أدخل مقحمة الدرج الجديدة. مقحمة الدرج استبدال استبدال القطع مقحمة الدرج"},{"UUID":"22e0adc2-b910-4584-aa2e-56305c69734a","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال أدلة الحجم في الدرج","descFull":"استبدال أدلة الحجم في الدرج الاختياري سعة 550 ورقة استبدال أدلة الحجم في الدرج الاختياري سعة 550 ورقة اسحب الدرج للخارج. قم بإزالة أدلة الحجم المستخدمة. قم بفك أدلة الحجم الجديدة. أدخل أدلة الحجم الجديدة حتى تسمع صوت  طقطقة  استقرارها في مكانها. قم بإدخال الدرج. أدلة الحجم استبدال استبدال القطع أدلة الحجم"},{"UUID":"f83c38f6-a347-4754-ac6a-c5509ce4aa3d","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"إعادة وضع الغطاء في الدرج","descFull":"إعادة وضع الغطاء في الدرج الاختياري سعة 550 ورقة إعادة وضع الغطاء في الدرج الاختياري سعة 550 ورقة أزل غطاء الدرج المستخدم. قم بفك غطاء الدرج الجديد. أدخل غطاء الدرج الجديد حتى تسمع صوت طقطقة عند استقرارها في مكانها. استبدال القطع غطاء الدرج غطاء الدرج استبدال غطاء درج جرار سعة 550 ورقة"},{"UUID":"c654e58d-8f16-4507-b275-a08006d5080d","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال ملحق الصندوق العلوي لوحدة","descFull":"استبدال ملحق الصندوق العلوي لوحدة إنهاء الكتيبات قم بإزالة ملحق الصندوق العلوي المستخدم. قم بفك ملحق الصندوق العلوي الجديد. أدخل ملحق الصندوق العلوي الجديد. استبدال القطع وحدة إنهاء الكتيبات ملحق الصندوق العلوي وحدة إنهاء الكتيبات ملحق الصندوق العلوي استبدال"},{"UUID":"ef250b37-20ce-409f-a011-9ae2ac0dc278","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال صندوق تثقيب الفتحات اعتمادًا","descFull":"استبدال صندوق تثقيب الفتحات اعتمادًا على وحدة الإنهاء المثبتة، قد يختلف مظهر صندوق التثقيب الفتحات. افتح باب وحدة الإنهاء. أزل صندوق تثقيب الفتحات المستخدم. أخرج صندوق تثقيب الفتحات الجديد من علبته. أدخل صندوق تثقيب الفتحات الجديد. أغلق باب وحدة الإنهاء. استبدال القطع صندوق تثقيب الفتحات صندوق تثقيب الفتحات استبدال"},{"UUID":"91902b23-26cb-498f-be56-df0949cb2a08","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال الحاوية القياسية استبدال الحاوية","descFull":"استبدال الحاوية القياسية استبدال الحاوية القياسية انزع الحاوية القياسية المستخدمة. قم بفك تغليف الحاوية القياسية. ‏‫قم بتركيب الحاوية القياسية الجديدة. استبدال القطع حاوية قياسية حاوية قياسية استبدال"},{"UUID":"323a606e-19bd-4d66-a88f-13abbb01c13c","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال غطاء المروحة أزل غطاء","descFull":"استبدال غطاء المروحة أزل غطاء المروحة المستخدم. قم بفك الغطاء الجديد. ادفع الغطاء الجديد إلى الداخل حتى تسمع  صوت  استقرارها في مكانها. استبدال القطع غطاء مروحة غطاء مروحة استبدال"},{"UUID":"44e6b3d1-7da5-435a-a670-3e78cff944c5","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال الغطاء الأيمن قم بإزالة","descFull":"استبدال الغطاء الأيمن قم بإزالة الغطاء الأيمن المستخدم. قم بفك الغطاء الجديد. ادفع الغطاء الجديد إلى الداخل حتى تسمع  صوت  استقرارها في مكانها. استبدال القطع الغطاء الأيمن الغطاء الأيمن استبدال"},{"UUID":"41ceab44-e319-4056-8eaa-4220bdc4e53e","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال أداة تنظيف الزجاج افتح","descFull":"استبدال أداة تنظيف الزجاج افتح غطاء الماسحة الضوئية. قم بإزالة أداة تنظيف الزجاج المستخدمة. قم بفك منظف الزجاج الجديد. أدخل منظف الزجاج الجديد. أغلق غطاء الماسحة الضوئية. استبدال القطع أداة تنظيف الزجاج أداة تنظيف الزجاج استبدال"},{"UUID":"afa43583-4b69-4042-8fc0-1767b374c51d","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"استبدال غطاء موصل نقل الورق","descFull":"استبدال غطاء موصل نقل الورق استبدال غطاء موصل نقل الورق انزع الحاوية القياسية. قم بإزالة غطاء موصل نقل الورق المستخدم. قم بفك غطاء الموصل الجديد. قم بتوصيل غطاء الموصل الجديد حتى تسمع صوت  طقطقة  عند استقراره في مكانه. ‏‫قم بتركيب الحاوية القياسية. استبدال القطع غطاء موصل نقل الورق غطاء موصل نقل الورق استبدال"},{"UUID":"92c1fec0-ca03-4779-a860-f72cffaa96ee","title":"استبدال وحدة خرطوشة الدبابيس","link":"replacing-toner-cartridge-topic.html","desc":"استبدال خرطوشة الدبابيس في وحدة","descFull":"استبدال خرطوشة الدبابيس في وحدة إنهاء التدبيس أمسك المقبض F، ثم قم بتحريك وحدة إنهاء التدبيس‬ إلى اليسار. قم بإزالة حامل خرطوشة الدبابيس. أزل خرطوشة الدبابيس الفارغة. ادفع خرطوشة الدبابيس الجديدة إلى الداخل حتى تسمع  صوت  استقرارها في مكانها. أدخل حامل خرطوشة الدبابيس حتى يصدر صوت  طقطقة  عند استقراره في مكانه. قم بتحريك وحدة إنهاء التدبيس إلى اليمين. استبدال مستلزمات الطباعة خرطوشة دبابيس خرطوشة دبابيس استبدال"},{"UUID":"e3be3623-2d59-492a-b48c-bceae1852369","title":"استبدال وحدة خرطوشة الدبابيس","link":"replacing-toner-cartridge-topic.html","desc":"استبدال خرطوشة الدبابيس في وحدة","descFull":"استبدال خرطوشة الدبابيس في وحدة إنهاء التدبيس وتثقيب الفتحات افتح الباب H. اسحب المقبض الأخضر للخارج، ثم قم بإزالة حامل خرطوشة الدبابيس. أزل خرطوشة الدبابيس الفارغة. قم بفك عبوة خرطوشة الدبابيس الجديدة. ادفع خرطوشة الدبابيس الجديدة إلى الداخل حتى تسمع  صوت  استقرارها في مكانها. أدخل حامل خرطوشة الدبابيس حتى يصدر صوت  طقطقة  عند استقراره في مكانه. أغلق الباب H. استبدال مستلزمات الطباعة خرطوشة دبابيس خرطوشة دبابيس استبدال"},{"UUID":"4d51cda8-faac-4967-b3a9-b8a4e09e5b7a","title":"استبدال وحدة خرطوشة الدبابيس","link":"replacing-toner-cartridge-topic.html","desc":"استبدال خرطوشة الدبابيس في وحدة","descFull":"استبدال خرطوشة الدبابيس في وحدة إنهاء الكتيبات افتح الباب H. اسحب المقبض الأخضر للخارج، ثم قم بإزالة حامل خرطوشة الدبابيس. أزل خرطوشة الدبابيس الفارغة. قم بفك عبوة خرطوشة الدبابيس الجديدة. ادفع خرطوشة الدبابيس الجديدة إلى الداخل حتى تسمع  صوت  استقرارها في مكانها. أدخل حامل خرطوشة الدبابيس حتى يصدر صوت  طقطقة  عند استقراره في مكانه. أغلق الباب H. استبدال مستلزمات الطباعة خرطوشة دبابيس خرطوشة دبابيس استبدال"},{"UUID":"1cea702b-9b1f-4042-a54f-9ded1ba7c180","title":"استبدال وحدة خرطوشة الدبابيس","link":"replacing-toner-cartridge-topic.html","desc":"استبدال حاملات خراطيش الدبابيس في","descFull":"استبدال حاملات خراطيش الدبابيس في وحدة إنهاء الكتيبات افتح باب وحدة الإنهاء. اسحب صانع الكتيبات للخارج، ثم قم بإزالة حاملات خراطيش الدبابيس المستخدمة. قم بإخراج حوامل خراطيش الدبابيس الجديدة من علبتها. أدخل حاملات خرطوشة الدبابيس الجديدة. أدخل وحدة إنشاء الكتيبات، ثم أغلق باب وحدة الإنهاء. استبدال القطع حامل خرطوشة الدبابيس حامل خرطوشة الدبابيس استبدال"},{"UUID":"aecf0889-54ed-4db9-8ad0-a9f94a04270c","title":"استبدال الأجزاء والمستلزمات","link":"replacing-toner-cartridge-topic.html","desc":"إعادة تعيين عدادات استخدام المستلزمات","descFull":"إعادة تعيين عدادات استخدام المستلزمات إعادة تعيين عدادات استخدام المستلزمات من لوحة التحكم، انتقل إلى  الإعدادات الجهاز Maintenance قائمة التهيئة ‎استخدام المستلزمات والعدادات . حدد العداد الذي تريد إعادة تعيينه. يمكن إعادة تعيين المستلزمات والقطع غير الخاضعة لبنود اتفاقية برنامج الإرجاع وإعادة تصنيعها. ولكن ضمان جهة التصنيع لا يغطي الأضرار الناجمة عن استخدام مستلزمات أو قطع غير أصلية. إعادة ضبط عدادات الإمدادات أو القطع دون إعادة تصنيع مناسبة قد يتسبب في تلف الطابعة. بعد إعادة ضبط عداد الإمداد أو الجزء، قد تعرض الطابعة خطأً يشير إلى وجود العنصر المعاد تعيينه. يمكن إعادة تعيين المستلزمات والقطع غير الخاضعة لبنود اتفاقية برنامج الاستخدام والإرجاع وإعادة تصنيعها. ولكن ضمان جهة التصنيع لا يغطي الأضرار الناجمة عن استخدام مستلزمات أو قطع غير أصلية. إعادة ضبط عدادات الإمدادات أو القطع دون إعادة تصنيع مناسبة قد يتسبب في تلف الطابعة. بعد إعادة ضبط عداد الإمداد أو الجزء، قد تعرض الطابعة خطأً يشير إلى وجود العنصر المعاد تعيينه. عدادات استخدام المستلزمات إعادة إعداد إعادة تعيين عدادات استخدام المستلزمات"},{"UUID":"ebe58bd2-55a0-44d9-9ee1-d9f6e715d599","title":"تنظيف أجزاء الطابعة","link":"cleaning-printer-topic.html","desc":"تنظيف الطابعة تنظيف الطابعة لتجنب","descFull":"تنظيف الطابعة تنظيف الطابعة لتجنب خطر التعرض لصدمة كهربائية عند تنظيف الجزء الخارجي من الطابعة، افصل سلك التيار عن مأخذ الحائط وافصل كافة الكابلات عن الطابعة قبل المتابعة. قم بأداء هذه المهمة كل بضعة أشهر. لا يشمل ضمان الطابعة تلف الطابعة الناجم عن التعامل معها بطريقة غير صحيحة. قم بإيقاف تشغيل الطابعة، ثم قم بفصل سلك التيار عن مأخذ التيار الكهربائي. أزل الورق من الحاوية القياسية ووحدة التغذية متعددة الأغراض. باستخدام فرشاة ناعمة أو مكنسة كهربائية، قم بإزالة أي غبار أو نسالة أو قطع من الورق حول الطابعة.   باستخدام قطعة قماش مبللة وناعمة وخالية من الوبر، امسح الجزء الخارجي من الطابعة. لا تستخدم المنظفات أو المطهرات المنزلية حيث قد تتسبب مثل هذه المواد في تلف السطح الخارجي للطابعة. تأكد من جفاف جميع مناطق الطابعة بعد التنظيف. وصل سلك التيار بمأخذ التيار الكهربائي ثم قم بتشغيل الطابعة. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. تنظيف الطابعة الطابعة، التنظيف"},{"UUID":"2f715bb8-a14c-4b37-9d3f-f8bbdbdfdc24","title":"تنظيف أجزاء الطابعة","link":"cleaning-printer-topic.html","desc":"تنظيف شاشة اللمس تنظيف شاشة","descFull":"تنظيف شاشة اللمس تنظيف شاشة اللمس لتجنب خطر التعرض لصدمة كهربائية عند تنظيف الجزء الخارجي من الطابعة، افصل سلك التيار عن مأخذ التيار الكهربائي وافصل كل الكابلات عن الطابعة قبل المتابعة. قم بإيقاف تشغيل الطابعة، ثم قم بفصل سلك التيار عن مأخذ التيار الكهربائي. امسح شاشة اللمس بواسطة قطعة قماش مبللة وناعمة وخالية من الوبر. لا تستخدم المنظفات أو المطهرات المنزلية، فقد تتسبب هذه المواد في إتلاف شاشة اللمس. تأكد من جفاف شاشة اللمس بعد التنظيف. وصل سلك التيار بمأخذ التيار الكهربائي ثم قم بتشغيل الطابعة. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك التيار بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. شاشة باللمس، التنظيف تنظيف شاشة اللمس"},{"UUID":"33010c6a-f4ed-4017-8d09-87c3bb5596d6","title":"تنظيف أجزاء الطابعة","link":"cleaning-printer-topic.html","desc":"تنظيف الماسحة الضوئية افتح غطاء","descFull":"تنظيف الماسحة الضوئية افتح غطاء الماسحة الضوئية. قم بإزالة أداة تنظيف الزجاج. افتح الباب A1. باستخدام الأداة، امسح زجاج وحدة تغذية المستندات التلقائية (ADF). أغلق الباب A1. امسح المناطق التالية بواسطة قطعة قماش مبللة وناعمة وخالية من الوبر: لوحة زجاج وحدة تغذية المستندات التلقائية (ADF) لوحة زجاج الماسحة الضوئية زجاج الماسحة الضوئية باستخدام الأداة، امسح زجاج وحدة تغذية المستندات التلقائية (ADF). أعد الأداة إلى مكانها. أغلق غطاء الماسحة الضوئية. الماسحة الضوئية تنظيف جودة الطباعة تنظيف الماسحة الضوئية تنظيف الماسحة الضوئية"},{"UUID":"ea2b0f3a-9685-42c7-a158-fd682b7ece22","title":"تنظيف أجزاء الطابعة","link":"cleaning-printer-topic.html","desc":"تنظيف عدسات رأس الطباعة افتح","descFull":"تنظيف عدسات رأس الطباعة افتح الباب الأمامي. أزل خراطيش مسحوق الحبر. اسحب الماسحة للخارج بلطف حتى تتوقف. لا يتم فصل الماسحة عن الطابعة. ادفع الماسحة مرة أخرى داخل رأس الطباعة حتى تتوقف. تكرار  الخطوة 3  و  الخطوة 4  ثلاث مرات لكل رأس طباعة. أدخل خراطيش مسحوق الحبر. أغلق الباب الأمامي. عدسات رأس الطباعة تنظيف تنظيف عدسات رأس الطباعة"},{"UUID":"c04eaba3-793b-472b-9045-e9848f83c805","title":"تنظيف أجزاء الطابعة","link":"cleaning-printer-topic.html","desc":"تفريغ صندوق تثقيب الفتحات اعتمادًا","descFull":"تفريغ صندوق تثقيب الفتحات اعتمادًا على وحدة الإنهاء المثبتة، قد يختلف مظهر صندوق التثقيب الفتحات. افتح باب وحدة الإنهاء. أزل صندوق تثقيب الفتحات ثم فرّغه. أدخل صندوق تثقيب الفتحات. أغلق باب وحدة الإنهاء. صندوق تثقيب الفتحات تفريغ تفريغ صندوق تثقيب الفتحات"},{"UUID":"87351e9c-fdd5-4fba-beab-defc501e6b54","title":"توفير الطاقة والورق","link":"configuring-power-save-mode-settings-topic.html","desc":"تهيئة إعدادات وضع توفير الطاقة","descFull":"تهيئة إعدادات وضع توفير الطاقة تهيئة إعدادات وضع توفير الطاقة وضع \"السكون\" من لوحة التحكم، انتقل إلى  الإعدادات الجهاز إدارة الطاقة المهلات ‏‫وضع السكون‬ . اضبط الفترة الزمنية التي تبقى خلالها الطابعة في وضع الخمول قبل أن تدخل في  وضع السكون . وضع الإسبات من لوحة التحكم، انتقل إلى  الإعدادات الجهاز إدارة الطاقة المُهلات ‏‫وضع السكون‬ . اضبط الفترة الزمنية التي تبقى في خلالها الطابعة في وضع الخمول قبل الدخول في وضع الإسبات. لكي تعمل  مُهلة وضع الإسبات ، قم بتعيين  مهلة وضع الإسبات في حالة الاتصال  إلى  الإسبات . يكون ملقم الويب المضمن (Embedded Web Server) معطلاً حين تكون الطابعة في وضع الإسبات. وضع \"السكون\" تهيئة وضع الإسبات تهيئة أوضاع توفير الطاقة تهيئة"},{"UUID":"412ac3d8-969e-485c-999c-afcfd9a9408d","title":"توفير الطاقة والورق","link":"configuring-power-save-mode-settings-topic.html","desc":"ضبط سطوع الشاشة ضبط سطوع","descFull":"ضبط سطوع الشاشة ضبط سطوع الشاشة من لوحة التحكم، انتقل إلى  الإعدادات الجهاز إعداد التفضيلات‬ . في القائمة  سطوع الشاشة ، اضبط الإعداد. سطوع شاشة العرض ضبط ضبط السطوع"},{"UUID":"50faf7b4-5d07-40a6-a329-a985ed97213e","title":"توفير الطاقة والورق","link":"configuring-power-save-mode-settings-topic.html","desc":"توفير مستلزمات الطباعة الطباعة على","descFull":"توفير مستلزمات الطباعة الطباعة على وجهَي الورق. إن الطباعة على الجانبين هو الإعداد الافتراضي في الطابعة. طباعة عدة صفحات على وجه واحد من الورق. استخدم ميزة المعاينة للاطلاع على شكل المستند قبل طباعته. اطبع نسخة واحدة من المستند للتحقق من المحتوى ومن التنسيق بهدف التأكد من صحتها. توفير المستلزمات المستلزمات، توفير"},{"UUID":"fffc6f38-8018-460f-8dff-bab820d3a843","title":"صيانة الطابعة","link":"moving-printer-topic.html","desc":"تحريك الطابعة إلى موقع آخر","descFull":"تحريك الطابعة إلى موقع آخر تحريك الطابعة إلى موقع آخر إذا كان وزن الطابعة يفوق 20 كجم (44 رطلاً)، فقد يلزم وجود شخصَين أو أكثر لرفعها بأمان. لتجنب خطر الحريق أو التعرض لصدمة كهربائية، لا تستخدم إلا سلك الطاقة المرفق بهذا المنتج أو سلكًا بديلاً معتمدًا من قبل الشركة المصنعة. عند نقل الطابعة، اتبع هذه الإرشادات لتجنب حدوث إصابة شخصية أو ضرر في الطابعة: تأكد من أن كل الأبواب والأدراج مغلقة. قم بإيقاف تشغيل الطابعة، ثم قم بفصل سلك التيار عن مأخذ التيار الكهربائي. افصل جميع الأسلاك والكابلات عن الطابعة. إذا كانت الطابعة مزوّدة بأدراج اختيارية منفصلة ثابتة على الأرض أو وحدات إخراج اختيارية متصلة بها، فقم بفصلها قبل نقل الطابعة. في حال اشتمال الطابعة على قاعدة مثبتة على عجلات، فادفعها بحرص إلى الموقع الجديد. كن حذرًا أثناء المرور فوق العتبات وشقوق الأرضية. إذا لم تكن بالطابعة قاعدة عجلات بل تمت تهيئتها مع أدراج اختيارية أو وحدات إخراج اختيارية، فقم بإزالة وحدات الإخراج الاختيارية وارفع الطابعة عن الأدراج. لا تحاول رفع الطابعة وأي وحدات اختيارية في وقت واحد. استخدم المقابض الموجودة على الطابعة لرفعها دائمًا. يجب أن تكون أية عربة مستخدمة في تحريك الطابعة ذات سطح يدعم مساحة قاعدة الطابعة بالكامل. يجب أن يكون لأي عربة مستخدمة في تحريك الجهاز سطحٌ يدعم مقاييس الملحقات الاختيارية. حافظ على الطابعة في وضع عمودي. تجنّب عمليات التحريك الشديدة. تأكد من أن أصابعك ليست تحت الطابعة عند وضعها في مكانها. وتأكد من وجود مساحة خلوص كافية حول الطابعة. لا يغطي ضمان الطابعة التلف الناتج عن نقل الطابعة بشكل غير ملائم. تحريك الطابعة"},{"UUID":"adffe297-022b-4c62-9ee9-a91c2d7a23a5","title":"استكشاف مشكلة وإصلاحها","link":"print-quality-problems-topic.html","desc":"مشكلات جودة الطباعة ابحث عن","descFull":"مشكلات جودة الطباعة ابحث عن الصورة التي تشير إلى مشكلة تشبه مشكلة جودة الطباعة التي تواجهها، ومن ثم انقر فوق الارتباط تحتها لقراءة خطوات حل المشكلة."},{"UUID":"8eaa3623-47d1-49ba-82b1-5a55ed5bc2cf","title":"استكشاف مشكلة وإصلاحها","link":"printer-error-codes-topic.html","desc":"رموز أخطاء الطابعة رموز الخطأ","descFull":"رموز أخطاء الطابعة رموز الخطأ وكيفية حلّها رموز الخطأ رسالة الخطأ الحل 2.01 الإمداد مطلوب. حدد زر  إلغاء المهمة  ثم اطلب المستلزم اللازم. لمزيد من المعلومات، راجع  . 3.01 حاوية الإخراج القياسية ممتلئة. قم بإزالة أي ورق من حاوية الإخراج، ثم حدد زر  المتابعة . 3.02, 3.03, 3.04 إزالة الورق من الحاوية. قم بإزالة أي ورق من حاوية الإخراج، ثم حدد زر  المتابعة . 7.13, 7.23, 7.33,7.43 قم بإدخال مقحمة الدرج [x]. أدخِل الدرج المشار إليه. 8.01 أغلق الباب الأمامي. أبقِ الباب الأمامي مغلقًا إلا في حال إجراء الصيانة. 8.02, 8.03, 8.04, 8.05, 8.08, 8.10, 8.11 أغلق الباب [x]. أبقِ الباب المشار إليه مغلقًا إلا في حال إجراء الصيانة. 8.06 ‏‫قم بإعادة تركيب درج الورق سعة 1500 ورقة. تأكد من توصيل الدرج بالطابعة بشكل صحيح. 8.07 ‏‫قم بإعادة تركيب وحدة إنهاء التدبيس. تأكد من توصيل وحدة الإنهاء بالطابعة بشكل صحيح. 8.08 أغلق غطاء وحدة نقل الورق F. أبقِ الغطاء مغلقًا ما لم تقم بإجراء الصيانة. 8.09 أغلق غطاء وحدة نقل الورق G. 9 لزم للطابعة إعادة تشغيلها. قد تكون مهمة الطباعة الأخيرة غير مكتملة. حدد  المتابعة  لمسح الرسالة ومتابعة الطباعة. 11.11, 11.21, 11.31, 11.41, 11.51, 11.81, 11.91 قم بتحميل <المصدر/> مع <النوع/> <المقاس/>. حمّل الدرج المشار إليه بالورق. لمزيد من المعلومات، راجع  . 11.12, 11.22, 11.32, 11.42, 11.82, 11.92 قم بتحميل <المصدر/> مع <النوع/> <المقاس/> <الاتجاه/>. 12.11, 12.21, 12.31, 12.41, 12.51, 12.91 قم بتغيير <المصدر/> إلى <النوع/> <الحجم/>.  اسحب الدرج المشار إليه وقم بإزالة الورق، ثم قم بتحميل نوع وحجم الورق الصحيحين. لمزيد من المعلومات، راجع  . 12.12, 12.22, 12.32, 12.4212.92 قم بتغيير <المصدر/> إلى <النوع/> <الحجم/> <الاتجاه/>.  31.00 صندوق تثقيب الفتحات مفقود أو ممتلئ. افتح الباب H. قم بإزالة صندوق تثقيب الفتحات. إذا كان صندوق تثقيب الفتحات ممتلئًا، فقم بإفراغه. أدخل صندوق تثقيب الفتحات. أغلق الباب H. 31.35‏، 31.35A‏، 31.35B أعد تركيب زجاجة نفايات مسحوق الحبر المفقودة أو غير المستجيبة. افتح الباب الأمامي. أزل زجاجة نفايات مسحوق الحبر. لتجنب سكب مسحوق الحبر، ضع الزجاجة في وضع مستقيم. أدخل زجاجة نفايات مسحوق الحبر. أغلق الباب الأمامي. 31.40z،‏ 31.41z،‏ 31.42z،‏ 31.43z أعد تثبيت خرطوشة مسحوق الحبر [اللون] المفقودة أو غير المستجيبة. افتح الباب الأمامي. أخرج الخرطوشة. ركب الخرطوشة. أغلق الباب الأمامي. ‎31.60z أعد تركيب وحدة التصوير المفقودة أو غير المستجيبة. افتح الباب الأمامي. أزل خراطيش مسحوق الحبر. أزل زجاجة نفايات مسحوق الحبر. لتجنب سكب مسحوق الحبر، ضع الزجاجة في وضع مستقيم. قم بإزالة مجموعة التصوير. لا تعرّض مجموعة التصوير للضوء المباشر. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة موصل الصور. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. قم بإلغاء قفل وحدة التصوير بالأسود ثم قم بإزالتها. أدخل وحدة التصوير بالأسود، ثم اجعلها تستقر في مكانها. أدخل مجموعة التصوير حتى تستقر في موضعها تمامًا. أدخل زجاجة نفايات مسحوق الحبر. أدخل خراطيش مسحوق الحبر. أغلق الباب الأمامي. 31.64z أعد تركيب مجموعة التصوير المفقودة أو غير الموصولة أو غير المستجيبة. افتح الباب الأمامي. أزل خراطيش مسحوق الحبر. أزل زجاجة نفايات مسحوق الحبر. لتجنب سكب مسحوق الحبر، ضع الزجاجة في وضع مستقيم. قم بإزالة مجموعة التصوير. لا تعرّض مجموعة التصوير للضوء المباشر. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة موصل الصور. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل مجموعة التصوير حتى تستقر في موضعها تمامًا. أدخل زجاجة نفايات مسحوق الحبر. أدخل خراطيش مسحوق الحبر. أغلق الباب الأمامي. 31.80z أعد تركيب وحدة الصهر المفقودة أو غير المستجيبة. افتح الباب B. قد يكون الجزء الداخلي من الطابعة ساخنًا. للحد من خطر التعرض للإصابة من أحد المكونات الساخنة، اترك السطح ليبرد قبل ملامسته. قم بإلغاء قفل وحدة المصهر ثم قم بإزالتها. أدخِل وحدة المصهر، ثم قم بإحكام تثبيتها في مكانها. أغلق الباب B. 32.40z،‏ 32.41z،‏ 32.42z،‏ 32.43z استبدل خرطوشة مسحوق الحبر [اللون] غير المدعومة. لمزيد من المعلومات، راجع  . ‎32.60z استبدل وحدة التصوير باللون الأسود غير المدعومة. لمزيد من المعلومات، راجع  . 32.65z استبدل مجموعة التصوير بالألوان غير المدعومة. لمزيد من المعلومات، راجع  . 33.40z, 33.41z, 33.42z, 33.43z خرطوشة [الألوان] عادية معاد تعبئتها لمزيد من المعلومات، راجع  . 33.60z وحدة تصوير سوداء غير أصلية، راجع دليل المستخدم. لمزيد من المعلومات، راجع  . 33.64z مجموعة التصوير الملون غير الأصلية، راجع دليل المستخدم. 34.00 الورق قصير للغاية اضبط إعداد حجم الورق حتى يتطابق مع الورق الذي تم تحميله في الدرج. من لوحة التحكم، انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . 34.10, 34.20, 34.30, 34.40, 34.50 تَحقَّق من [المصدر]، ثم اضبط الأدلة والاتجاه. اسحب الدرج المشار إليه إلى الخارج، ثم تأكد من تحميل الورق بشكل صحيح. لمزيد من المعلومات، راجع  . 34.90 تحقق من وحدة التغذية متعددة الأغراض، واضبط الأدلة والاتجاه. تأكد من تحميل الورق بشكل صحيح. لمزيد من المعلومات، راجع  . 37.1 الذاكرة غير كافية لترتيب المهمة. جرّب أي مما يلي: حدد  متابعة  لطباعة جزء من المهمة المخزنة وبدء ترتيب بقية مهمة الطباعة. إلغاء مهمة الطباعة الحالية. 37.3 الذاكرة غير كافية، تم حذف بعض المهام المحجوزة. حدد  المتابعة  لمسح الرسالة ومتابعة الطباعة. 38.1 الذاكرة ممتلئة. حاول القيام بواحد أو أكثر من الإجراءات التالية: حدد  المتابعة  لمسح الرسالة ومتابعة الطباعة. إلغاء مهمة الطباعة الحالية. قم بتركيب ذاكرة طابعة إضافية. قلل عدد الصفحات في مهمة الطباعة. 39.1 صفحة معقدة، ربما لم تتم طباعة بعض البيانات. حاول القيام بواحد أو أكثر من الإجراءات التالية: حدد  المتابعة  لمسح الرسالة ومتابعة الطباعة. إلغاء مهمة الطباعة الحالية. قم بتركيب ذاكرة طابعة إضافية. قلل تعقيد مهمة الطباعة وحجمها قبل إرسالها للطباعة مرة أخرى. قلل عدد الصفحات في مهمة الطباعة. قلل عدد أي خطوط تم تنزيلها وحجمها. احذف أي خطوط أو وحدات الماكرو غير الضرورية من مهمة الطباعة. قلل عدد الرسومات في مهمة الطباعة. 42.yyC، 42.yyK، 42.yyM، 42.yyY استبدل خرطوشة مسحوق الحبر [اللون]، منطقة الطابعة غير متطابقة. لمزيد من المعلومات، راجع  . 43.40Y, 43.41Y, 43.42Y, 43.43Y أعد تركيب خرطوشة مسحوق الحبر [اللون]. افتح الباب الأمامي. أخرج الخرطوشة. ركب الخرطوشة. أغلق الباب الأمامي. 43.40Z, 43.41Z, 43.42Z, 43.43Z استبدل خرطوشة مسحوق الحبر [اللون]. لمزيد من المعلومات، راجع  . 50 خطأ في خط PPDS. قم بتثبيت خط PPDS المشار إليه في مهمة الطباعة، ثم حدد  المتابعة  للسماح للطابعة بالبحث عن الخط البديل. 51 تم اكتشاف ذاكرة فلاش معيبة حاول القيام بواحد أو أكثر من الإجراءات التالية: استبدل ذاكرة الفلاش. حدد  المتابعة  لمسح الرسالة ومتابعة الطباعة. إلغاء مهمة الطباعة الحالية. 52 مساحة فارغة غير كافية في ذاكرة فلاش للموارد. حاول القيام بواحد أو أكثر من الإجراءات التالية: حدد  المتابعة  لمسح الرسالة ومتابعة الطباعة. احذف الخطوط والمخططات الكلية والبيانات الأخرى المخزنة في ذاكرة الفلاش. تثبيت محرك أقراص تخزين. يتم حذف الخطوط والمخططات الكلية التي يتم تنزيلها والتي لم تكن مخزنة مسبقًا في ذاكرة الفلاش. 58.4 تهيئة خيار الإخراج غير صحيح. قم بإيقاف تشغيل الطابعة، ثم قم بتثبيت الحاوية أو وحدة الإنهاء الصحيحة. 61 قم بإزالة القرص المعيب. استبدل محرك أقراص التخزين المعيب. 62 القرص ممتلئ. حاول القيام بواحد أو أكثر من الإجراءات التالية: حدد  المتابعة  لمسح الرسالة ومتابعة الطباعة. احذف الخطوط والمخططات الكلية والبيانات الأخرى المخزنة على محرك التخزين. تثبيت محرك أقراص تخزين. 63 قم بتهيئة القرص. يؤدي التنسيق الآن إلى مسح كل المعلومات من محرك أقراص التخزين. لتنسيق القرص، قم بما يلي: من لوحة التحكم، انتقل إلى  الإعدادات‏‎ الجهاز الصيانة خارج الخدمة . حدد  تصحيح كل المعلومات على القرص الثابت ، ثم حدد  المسح . 71.01 لم يتم إعداد \"اسم محطة الفاكس\". اتّصل بالمسؤول عن النظام. لمزيد من المعلومات، راجع  . 71.02 لم يتم إعداد \"رقم محطة الفاكس\". اتّصل بالمسؤول عن النظام. 71.03 لم يتم توصيل خط هاتف تناظري، الفاكس معطّل. افحص الاتصال والخط للتأكد من وجود إشارة. لمزيد من المعلومات، راجع  . 71.04 خط الهاتف التناظري متصل بالمنفذ الخاطئ. افصل خط الهاتف، ثم قم بتوصيله بمنفذ LINE. 71.06 تعذر الاتصال بملقم فاكس HTTPS. تم قطع الاتصال بملقم فاكس HTTPS. تحقق من اتصال الطابعة بالإنترنت. 71.07 الطابعة غير مسجلة في ملقم الفاكس HTTPS. تأكد من إضافة الطابعة إلى قائمة الأجهزة في بوابة ملقم الفاكس HTTPS. اتّصل بالمسؤول عن النظام. 71.11 قسم الفاكس. قسم الفاكس لا يعمل. اتّصل بالمسؤول عن النظام. 71.12 الذاكرة ممتلئة، لا يمكن طباعة الفاكسات. حدد  طباعة الكل  لطباعة كل عدد الفاكسات الذي تم حفظه. 71.13 الذاكرة ممتلئة. تعذر إرسال الفاكسات. جرّب أي مما يلي: تابع وحاول إرسال الفاكس مرة أخرى. امسح المستند الأصلي ضوئيًا صفحة واحدة في كل مرة، واطلب رقم الفاكس ثم قم بإرسال المستند بالفاكس. 71.4 وقت الطابعة غير صحيح. قم بتهيئة الوقت على الطابعة. من لوحة التحكم، انتقل إلى  الإعدادات الجهاز التفضيلات التاريخ والوقت تهيئة . 72.01 لم يتم إعداد ملقم SMTP للبريد الإلكتروني. اتّصل بالمسؤول عن النظام.  جرّب أي مما يلي: قم بإعداد وظيفة البريد الإلكتروني. لمزيد من المعلومات، راجع  . تعطيل رسالة الخطأ. لمزيد من المعلومات، راجع  . 72.02 لم يتم إعداد خادم ارتباط الويب. اتّصل بالمسؤول عن النظام. اتصل بمسؤول النظام. 72.04 لم يتم إعداد ملقم الفاكس To Format (للتنسيق). اتّصل بالمسؤول عن النظام. جرّب أي مما يلي:  قم بتهيئة  To Format (للتنسيق) . من لوحة التحكم انتقل  Settings Fax إعداد ملقم الفاكس إعدادات الفاكس العامة . اتصل بمسؤول النظام. 75.01 تم اكتشاف العنصر الآمن. نفذ أيًا مما يلي: استخدم العنصر الآمن المثبت. الطابعة تحذف جميع الشهادات الموجودة وقد تقوم أيضًا بمسح وإعادة تهيئة محرك التخزين. قم بإيقاف تشغيل الطابعة، ثم قم بإزالة العنصر الآمن. 75.02 لم يتم التعرف على العنصر الآمن. 75.03 خطأ في الاتصال مع العنصر الآمن.  نفذ أيًا مما يلي: توقف عن استخدام العنصر الآمن. الطابعة تحذف جميع الشهادات الموجودة وقد تقوم أيضًا بمسح وإعادة تهيئة محرك التخزين. قم بإيقاف تشغيل الطابعة، وقم بإزالتها، ثم قم بتثبيت العنصر الآمن. 75.11 فشل تحديث العنصر الآمن. نفذ أيًا مما يلي: حاول التحديث مرة أخرى. قم بإلغاء التحديث. قد تقوم الطابعة بمسح جميع الشهادات ومحتويات محرك التخزين الموجودة. 75.12 تحديث العنصر الآمن غير مكتمل. نفذ أيًا مما يلي: أعد تشغيل الطابعة. انتظر لمدة 10 ثواني لإكمال التحديث. قم بإلغاء التحديث. قد تقوم الطابعة بمسح جميع الشهادات ومحتويات محرك التخزين الموجودة. 80.01, 80.09 مستوى مجموعة الصيانة منخفض تقريبًا. حدد  المتابعة  لمسح الرسالة. 80.11, 80.19 مستوى مجموعة الصيانة منخفض. 80.21, 80.29 مستوى مجموعة الصيانة منخفض جدًا. 80.31 استبدل مجموعة الصيانة لمتابعة الطباعة. لمزيد من المعلومات، راجع  . 80.31 استبدل مجموعة الصيانة، تم تخطي العمر الموصى به. 81.11 مجموعة بكرات الدرج الجرار سعة 1500 ورقة حدد  المتابعة  لمسح الرسالة. 81.31 استبدل مجموعة أسطوانات الدرج سعة 1500 ورقة، وتجاوز العمر الموصى به . لمزيد من المعلومات، اتصل  دعم العملاء . 82.00, 82.02, 82.09 زجاجة نفايات مسحوق الحبر ممتلئة تقريبًا. لمزيد من المعلومات، راجع  . 82.3, 82.32, 82.33, 82.39 استبدل زجاجة نفايات مسحوق الحبر. 83.1y وحدة النقل حدد  المتابعة  لمسح الرسالة. 83.3y استبدل وحدة النقل، تجاوز العمر الموصى به. لمزيد من المعلومات، اتصل  دعم العملاء . 83.4y استبدل وحدة النقل. 83.20 خرطوشة الدبابيس منخفضة. حدد  المتابعة  لمسح الرسالة. 83.20 وحدة التدبيس S2 الداخلية منخفضة. 83.20 ‎وحدة التدبيس S2 الخارجية المنخفضة. 83.30 خرطوشة الدبابيس فارغة أو مفقودة. جرّب أي مما يلي: قم بإزالة خرطوشة الدبابيس، ثم أعد إدخالها. استبدل خرطوشة الدبابيس. لمزيد من المعلومات، راجع   أو  . 83.30 خرطوشة الدبابيس S1 فارغة أو مفقودة. جرّب أي مما يلي: قم بإزالة خرطوشة الدبابيس، ثم أعد إدخالها. استبدل خرطوشة الدبابيس. لمزيد من المعلومات، راجع  . 83.30 خرطوشة الدبابيس S2 الداخلية فارغة أو مفقودة. جرّب أي مما يلي: قم بإزالة خرطوشة الدبابيس، ثم أعد إدخالها. استبدل خرطوشة الدبابيس. لمزيد من المعلومات، راجع  . 83.30 خرطوشة الدبابيس S2 الخارجية فارغة أو مفقودة. 84.01K, 84.03K, 84.09K وحدة التصوير باللون الأسود منخفضة تقريبًا. حدد  المتابعة  لمسح الرسالة. 84.11K, 84.13K, 84.19K وحدة التصوير باللون الأسود منخفضة. 84.21C, 84.03C, 84.09C وحدة التصوير بالأسود منخفضة جدًا. 84.01C, 84.03C, 84.09C مجموعة التصوير بالألوان منخفضة تقريبًا. 84.11C, 84.13C, 84.19C مجموعة التصوير بالألوان منخفضة. 84.21C, 84.23C, 84.29C مجموعة التصوير بالألوان منخفضة. 84.31, 84.33 استبدل وحدة التصوير باللون الأسود، تم تخطي العمر الموصى به. لمزيد من المعلومات، راجع  . 84.31, 84.33 استبدل مجموعة التصوير بالألوان، تم تخطي العمر الموصى به. لمزيد من المعلومات، راجع  . 84.41, 84.43, 84.48 استبدل وحدة التصوير باللون الأسود لمتابعة الطباعة. لمزيد من المعلومات، راجع  . 84.41, 84.43, 84.48 استبدل مجموعة التصوير بالألوان لاستئناف الطباعة. لمزيد من المعلومات، راجع  . 86.23 يلزم صيانة الماسحة الضوئية قريبًا. حدد  المتابعة  لمسح الرسالة. 86.33 استبدل مجموعة وحدة التغذية التلقائية للمستندات (ADF)، تم تخطي العمر الافتراضي الموصى به. لمزيد من المعلومات، اتصل  دعم العملاء . 88.00[x], 88.07[x], 88.08[x], 88.09[x] خرطوشة مسحوق الحبر [اللون] منخفضة تقريبًا. حدد  المتابعة  لمسح الرسالة. 88.10[x], 88.17[x], 88.18[x], 88.19[x] خرطوشة مسحوق الحبر [اللون] منخفضة. 88.20[x], 88.27[x], 88.28[x], 88.29[x] خرطوشة مسحوق الحبر منخفضة تقريبًا. 88.30[x], 88.37[x], 88.38[x] استبدل خرطوشة مسحوق الحبر [اللون]، <NUM/> الصفحات المتبقّية المتوقَّع. لمزيد من المعلومات، راجع  . 88.30[x], 88.37[x], 88.38[x] استبدل خرطوشة مسحوق الحبر [اللون]. 88.40[x], 88.47[x], 88.48[x] استبدل خرطوشة مسحوق الحبر [اللون]، وعدد الصفحات المتبقّية هو صفر. 88.40[x], 88.47[x], 88.48[x] استبدل خرطوشة مسحوق الحبر [اللون]. 200.03, 200.05, 200.12, 200.13, 200.14, 200.15, 200.22, 200.23, 200.24, 200.25, 200.26, 200.32, 200.33, 200.34, 200.35, 200.36, 200.42, 200.43, 200.44, 200.45, 200.46, 200.52, 200.53, 200.54, 200.55, 200.56, 200.91, 201.91, 202.02, 202.03, 202.04, 202.05, 202.12, 202.13, 202.14, 202.15, 202.22, 202.23, 202.24, 202.25, 202.32, 202.33, 202.34, 202.35, 202.42, 202.43, 202.44, 202.45, 202.52, 202.53, 202.54, 202.55, 202.91, 202.93, 202.95, 231.03, 231.05, 231.13, 231.15, 231.23, 231.25, 231.33, 231.35, 231.43, 231.45, 231.53, 231.55, 231.91, 232.03, 232.05, 232.13, 232.15, 232.23, 232.25, 232.33, 232.35, 232.43, 232.45, 232.53, 232.55, 232.93, 232.94, 232.95, 240.05, 240.25, 240.35, 240.45, 240.55, 240.91, 240.95, 241.12, 241.14, 241.15, 241.91 انحشار الورق في [LOCATION/]. لمزيد من المعلومات، راجع  . 240.06 انحشار الورق في [LOCATION/]. لمزيد من المعلومات، راجع  . 241.16, 241.82, 241.83, 241.84, 661.13, 661.84 خطأ في تحميل الورق في [LOCATION/]. افتح الدرج 1. قم بإزالة رزمة الورق ثم أعد ضبطها. إذا لزم الأمر، فاضبط موجهات الورق. تحميل الدرج 1. أغلق الدرج 1. 242.23, 242.25, 242.35, 242.45, 242.55, 242.91 انحشار الورق في [LOCATION/]. لمزيد من المعلومات، راجع  . 242.33, 242.43, 243.33, 243.35, 243.36, 243.43, 243.35, 243.45, 243.45, 243.55, 243.91, 244.43, 244.45, 244.91 انحشار الورق في [LOCATION/]. لمزيد من المعلومات، راجع أيًا مما يلي: 243.43, 243.53, 244.43, 244.45, 244.46, 244.91, 245.53, 245.56, 245.55, 245.91, 602.59, 664.43, 665.53 انحشار الورق في [LOCATION/]. لمزيد من المعلومات، راجع  . 28X.13K, 28X.93K, 28X.15K, 28X.95K, 281.16K, 281.96K, 680.20K, 680.40K أعد وضع كافة المستندات الأصلية في حال استعادة مهمة. جرّب أي مما يلي: أعد تشغيل المهمة. إلغاء المهمة. 28X.13Q, 28X.93Q, 28X.15Q, 28X.95Q, 281.16Q, 281.96Q, 680.20Q أعد وضع المستندات الأصلية المحشورة في حالة متابعة المهمة. حاول القيام بإحدى الطرق التالية: المسح الضوئي من زجاج الماسحة الضوئية. المسح الضوئي من وحدة تغذية المستندات التلقائية إنهاء المهمة دون إجراء مزيد من المسح الضوئي. إلغاء المهمة. 280.06 إعادة تحميل النسخ الأصلية في وحدة التغذية التلقائية للمستندات (ADF) وإعادة تشغيل المهمة. 280.06, 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 281.11, 281.15, 281.16, 281.91, 281.95, 281.96, 282.11, 282.13, 282.15, 282.91, 282.93, 282.95, 283.11, 283.13, 283.91, 283.15, 283.93, 284.11, 284.13, 284.15, 284.91, 284.93, 284.95, 295.01 انحشار في الماسحة الضوئية. لمزيد من المعلومات، راجع  . 291.06 أغلق الغطاء المسطح وحمّل المستندات الأصلية في حالة إعادة تشغيل المهمة. قم بتنفيذ أحد الإرشادات التالية: المسح الضوئي من زجاج الماسحة الضوئية. المسح الضوئي من وحدة تغذية المستندات التلقائية إنهاء المهمة دون إجراء مزيد من المسح الضوئي. إلغاء المهمة. 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 444.66, 450.21, 450.23, 450.25, 450.98, 450.99, 451.21, 451.23, 451.25, 452.66, 453.21, 453.23, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 460.66, 461.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 472.66, 477.66, 480.66, 483.66, 486.29, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 انحشار الورق في [LOCATION/]. لمزيد من المعلومات، راجع  . 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 442.66, 444.66, 445.66, 450.21, 450.23, 450.25, 451.21, 451.23, 451.25, 451.98, 451.99, 452.66, 453.21, 453.23, 453.25, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 459.66, 460.66, 461.66, 462.66, 463.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 470.66, 472.66, 473.66, 476.66, 477.66, 480.66, 483.66, 486.29, 490.66, 491.21, 491.25, 491.66, 493.21, 494.21, 492.66, 494.66, 495.66, 496.66, 497.66, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 انحشار الورق في [LOCATION/]. لمزيد من المعلومات، راجع  . 420.11, 420.13, 420.15, 420.99, 421.56, 422.56, 423.56, 424.56, 425.13, 425.15, 425.11, 426.11, 426.15, 428.56A, 428.56B, 431.56, 435.56, 438.11, 439.19, 461.56, 698.19 انحشار الورق في [LOCATION/]. لمزيد من المعلومات، راجع  . 438.11, 500.11, 500.13, 500.15, 500.99, 502.11, 502.13, 502.15, 504.11, 504.13, 504.15, 505.13, 506.11, 506.13, 506.15, 507.11, 507.13, 507.15,  508.56, 509.56, 510.56, 511.56, 512.56, 513.56, 514.19, 698.19, 698.29 انحشار الورق في [LOCATION/]. لمزيد من المعلومات، راجع  . 602.29, 662.23 خطأ في تحميل الورق في درج 2 لمزيد من المعلومات، راجع  . 602.39, 663.33 خطأ في تحميل الورق في درج 3 لمزيد من المعلومات، راجع أيًا مما يلي: 602.49, 664.43 خطأ في تحميل الورق في درج 4 لمزيد من المعلومات، راجع  . رموز أخطاء الطابعة رموز الخطأ رسائل الطابعة رسائل الخطأ"},{"UUID":"52387011-8986-430b-95e8-bd3f449edb4a","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"الصفحات الفارغة أو البيضاء قبل","descFull":"الصفحات الفارغة أو البيضاء قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من إزالة جميع مواد التغليف من مجموعة التصوير ووحدة التصوير وخراطيش مسحوق الحبر. تحقق مما إذا كانت الطابعة تستخدم خرطوشة مسحوق حبر أصلية ومدعومة من Lexmark. تحقق مما إذا كانت الطابعة تستخدم خرطوشة مسحوق حبر أصلية ومدعومة. إذا كانت الخرطوشة غير مدعومة، فركِّب خرطوشة مدعومة. تأكد من تركيب مجموعة التصوير ووحدة التصوير السوداء بشكل صحيح. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة صفحات بيضاء مشكلة في جودة الطباعة صفحات فارغة صفحات فارغة صفحات بيضاء"},{"UUID":"3e0d77b9-c500-4bc9-9a03-c3420484699b","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"طباعة داكنة قبل حل المشكلة،","descFull":"طباعة داكنة قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: من لوحة التحكم انتقل إلى  الإعدادات Print الجودة التصوير المتقدم ثم حدد  ضبط اللون . وفقًا لنظام التشغيل، أخفض درجة قتامة مسحوق الحبر من \"تفضيلات الطباعة\" أو من مربع الحوار \"طباعة\". يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل الى  الإعدادات طباعة الجودة قتامة مسحوق الحبر . وفقًا لنظام التشغيل، حدِّد نوع الورق من تفضيلات الطباعة أو من مربع حوار طباعة. تأكد من أن الإعداد يُطابق الورق الذي تم تحميله في الدرج.  يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . تأكد من أن الورق لا يحتوي على ملمس أو لمسة نهائية خشنة. قم بتحميل الورق من عبوة جديدة. يمتص الورق الرطوبة بسبب الرطوبة المرتفعة قم بتخزين الورق في غلافه الأصلي حتى تصبح جاهزًا لاستخدامه. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة طباعة داكنة طباعة داكنة"},{"UUID":"574df2d8-8cae-41b0-9804-987fc1015881","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"الصور باهتة قبل حل المشكلة،","descFull":"الصور باهتة قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: حمّل الدرج بورق من النوع والوزن المحددين. وفقًا لنظام التشغيل، حدِّد نوع الورق من تفضيلات الطباعة أو من مربع حوار طباعة. تأكد من أن الإعداد يُطابق الورق الذي تم تحميله في الدرج.  يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . من لوحة التحكم انتقل إلى  الإعدادات Print الجودة التصوير المتقدم ثم حدد  ضبط اللون . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة ظهور صورة طيف ظهور صورة طيف"},{"UUID":"0d82aa67-436c-4866-9023-40613370ee0b","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"واجهة خلفية رمادية أو ملونة","descFull":"واجهة خلفية رمادية أو ملونة قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: وفقًا لنظام التشغيل، ارفع درجة قتامة مسحوق الحبر من \"تفضيلات الطباعة\" أو من مربع الحوار \"طباعة\". يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل الى  الإعدادات طباعة الجودة قتامة مسحوق الحبر . من لوحة التحكم انتقل إلى  الإعدادات Print الجودة التصوير المتقدم ثم حدد  ضبط اللون . تأكد من تركيب مجموعة التصوير ووحدة التصوير السوداء بشكل صحيح. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة واجهة خلفية رمادية أو ملونة خلفية رمادية اللون على المطبوعات خلفية ملوّنة على المطبوعات"},{"UUID":"c0239967-5401-4f04-9581-b49d471cdb4a","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"هوامش غير صحيحة حاول القيام","descFull":"هوامش غير صحيحة حاول القيام بواحد أو أكثر من الإجراءات التالية: اضبط موجّهات الورق في الدرج على الموضع الصحيح للورق الذي تم تحميله. وفقًا لنظام التشغيل، حدد حجم الورق من \"تفضيلات الطباعة\" أو من مربع حوار \"طباعة\". تأكد من أن الإعداد يُطابق الورق الذي تم تحميله.  يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة هوامش غير صحيحة هوامش غير صحيحة"},{"UUID":"4b82cb3d-82b3-40c4-9409-5a42e2144b23","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"طباعة فاتحة قبل حل المشكلة،","descFull":"طباعة فاتحة قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من إزالة جميع مواد التغليف من مجموعة التصوير ووحدة التصوير وخراطيش مسحوق الحبر. من لوحة التحكم انتقل إلى  الإعدادات Print الجودة التصوير المتقدم ثم حدد  ضبط اللون . وفقًا لنظام التشغيل، ارفع درجة قتامة مسحوق الحبر من \"تفضيلات الطباعة\" أو من مربع الحوار \"طباعة\".  يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل الى  الإعدادات طباعة الجودة قتامة مسحوق الحبر . من لوحة التحكم، انتقل إلى  الإعدادات‏‎ الطباعة الجودة ومن ثم إيقاف  حافظ الألوان . وفقًا لنظام التشغيل، حدِّد نوع الورق من تفضيلات الطباعة أو من مربع حوار طباعة. تأكد من أن الإعداد يُطابق الورق الذي تم تحميله.  يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . تأكد من أن الورق لا يحتوي على ملمس أو لمسة نهائية خشنة. قم بتحميل الورق من عبوة جديدة. يمتص الورق الرطوبة بسبب الرطوبة المرتفعة قم بتخزين الورق في غلافه الأصلي حتى تصبح جاهزًا لاستخدامه. تأكد من تركيب مجموعة التصوير ووحدة التصوير السوداء بشكل صحيح. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة طباعة فاتحة طباعة فاتحة"},{"UUID":"0c50b0b3-fa31-47be-b288-5df25988bf73","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"ألوان مفقودة قبل حل المشكلة،","descFull":"ألوان مفقودة قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من إزالة جميع مواد التغليف من مجموعة التصوير ووحدة التصوير وخراطيش مسحوق الحبر. أزل وحدة المطور الخاصة باللون المفقود. قم بإزالة مجموعة التصوير. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. قم بإزالة وحدة المطور الخاصة باللون المفقود ثم أعد إدخالها. أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة ألوان مفقودة ألوان مفقودة"},{"UUID":"63a5f3d0-8514-41c4-aeff-d3b1d618fa15","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"طباعة ملطخة ونقاط طباعة ملطخة","descFull":"طباعة ملطخة ونقاط طباعة ملطخة ونقاط قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: تحقّق هل يوجد أي تلوث بسبب تسرب مسحوق الحبر في الطابعة. تأكد من تطابق إعدادات حجم الورق ونوع الورق مع الورق الذي تم تحميله. من لوحة التحكم، انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . تأكد من أن الورق لا يحتوي على ملمس أو لمسة نهائية خشنة. وفقًا لنظام التشغيل، حدِّد حجم الورق ونوعه من \"تفضيلات الطباعة\" أو من مربع حوار \"طباعة\". تأكد من أن الإعدادات تُطابق الورق الذي تم تحميله في الدرج. قم بتحميل الورق من عبوة جديدة. يمتص الورق الرطوبة بسبب الرطوبة المرتفعة قم بتخزين الورق في غلافه الأصلي حتى تصبح جاهزًا لاستخدامه. تأكد من تركيب مجموعة التصوير ووحدة التصوير السوداء بشكل صحيح. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة طباعة ملطّخة ومنقّطة طباعة ملطّخة ومنقّطة نقاط على الصفحة المطبوعة"},{"UUID":"2e83edbb-7aad-44c6-b52d-97620b1c401d","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"الصفحة المطبوعة مائلة أو منحرفة","descFull":"الصفحة المطبوعة مائلة أو منحرفة قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: قم بتحميل الورق من عبوة جديدة. افتح الدرج، ثم أزل الورق. قم بتحميل الورق من عبوة جديدة. يمتص الورق الرطوبة بسبب الرطوبة المرتفعة قم بتخزين الورق في غلافه الأصلي حتى تصبح جاهزًا لاستخدامه. اضبط موجّهات الورق في الدرج على الموضع الصحيح للورق الذي تم تحميله. تأكد من أنك تطبع على ورق مدعوم. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة الطباعة منحرفة مشكلة في جودة الطباعة طباعة متعرجة طباعة متعرجة الطباعة منحرفة"},{"UUID":"fedc9f97-eb3f-431a-8900-b4d1c69b25cc","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"الصور ذات الألوان الخالصة أو","descFull":"الصور ذات الألوان الخالصة أو الصفحات السوداء قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة صور ذات ألوان خالصة أو صور سوداء ألوان ثابتة الصور بالأسود"},{"UUID":"22829a78-ec5d-4a94-89a0-c7700ce52217","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"اقتصاص النصوص أو الصور قبل","descFull":"اقتصاص النصوص أو الصور قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من إزالة جميع مواد التغليف من مجموعة التصوير ووحدة التصوير وخراطيش مسحوق الحبر. اضبط موجّهات الورق في الدرج على الموضع الصحيح للورق الذي تم تحميله. وفقًا لنظام التشغيل، حدد حجم الورق من \"تفضيلات الطباعة\" أو من مربع حوار \"طباعة\". تأكد من أن الإعداد يُطابق الورق الذي تم تحميله في الدرج.  يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . تأكد من تركيب مجموعة التصوير ووحدة التصوير السوداء بشكل صحيح. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة اقتصاص النصوص أو الصور اقتصاص النص في الطباعة اقتصاص الصور المطبوعة"},{"UUID":"dc90b8cf-3e37-4fdd-8dbd-2764c783ef3d","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"إزالة مسحوق الحبر بسهولة قبل","descFull":"إزالة مسحوق الحبر بسهولة قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها  صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. جرّب أحد الخطوات التالية: تأكد من توصيل سلك التيار الخاص بالطابعة بمأخذ تيار كهربائي مُصنَّف بشكل مناسب ومؤرض بشكل صحيح. وفقًا لنظام التشغيل، حدِّد نوع الورق من تفضيلات الطباعة أو من مربع حوار طباعة. تأكد من أن الإعداد يُطابق الورق الذي تم تحميله. قم بتهيئة نوع الورق من لوحة التحكم. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة إزالة مسحوق الحبر بسهولة عند الاحتكاك إزالة مسحوق الحبر بسهولة عند الاحتكاك"},{"UUID":"469dc8fb-e4cd-4b1e-bb4b-9d71aa661565","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"كثافة الطباعة متفاوتة قبل حل","descFull":"كثافة الطباعة متفاوتة قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: افتح الباب B، ثم تأكد من تثبيت أسطوانة النقل الثانية في مكانها. تأكد من تركيب مجموعة التصوير ووحدة التصوير السوداء بشكل صحيح. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة كثافة طباعة متفاوتة كثافة طباعة متفاوتة"},{"UUID":"e6eb821e-d6b6-43a6-afe9-99dd83bf0f83","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"خطوط أفقية قاتمة قبل حل","descFull":"خطوط أفقية قاتمة قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. إذا استمرت الخطوط الأفقية الداكنة في الظهور على المطبوعات، فراجع  . حاول القيام بواحد أو أكثر من الإجراءات التالية: وفقًا لنظام التشغيل، حدِّد نوع الورق من تفضيلات الطباعة أو من مربع حوار طباعة. تأكد من أن الإعداد يُطابق الورق الذي تم تحميله. يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . تأكد من أن الورق لا يحتوي على ملمس أو لمسة نهائية خشنة. قم بتحميل الورق من عبوة جديدة. يمتص الورق الرطوبة بسبب الرطوبة المرتفعة قم بتخزين الورق في غلافه الأصلي حتى تصبح جاهزًا لاستخدامه. تأكد من تركيب مجموعة التصوير ووحدة التصوير السوداء بشكل صحيح. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة خطوط داكنة أفقية خطوط داكنة أفقية"},{"UUID":"92b559d0-613a-4096-a3e8-48e5d33fcd1a","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"خطوط داكنة عمودية قبل حل","descFull":"خطوط داكنة عمودية قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: وفقًا لنظام التشغيل، حدِّد نوع الورق من تفضيلات الطباعة أو من مربع حوار طباعة. تأكد من أن الإعداد يُطابق الورق الذي تم تحميله في الدرج. يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . تأكد من أن الورق لا يحتوي على ملمس أو لمسة نهائية خشنة. قم بتحميل الورق من عبوة جديدة. يمتص الورق الرطوبة بسبب الرطوبة المرتفعة قم بتخزين الورق في غلافه الأصلي حتى تصبح جاهزًا لاستخدامه. تأكد من تركيب مجموعة التصوير ووحدة التصوير السوداء بشكل صحيح. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة تظهر خطوط عمودية داكنة على المطبوعات خطوط داكنة عمودية على المطبوعات"},{"UUID":"2f1f2e2e-edd9-4f34-a0a5-67e2a72bab3b","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"الخطوط البيضاء الأفقية قبل حل","descFull":"الخطوط البيضاء الأفقية قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. إذا استمرت الخطوط الأفقية البيضاء في الظهور على المطبوعات، فراجع  . حاول القيام بواحد أو أكثر من الإجراءات التالية: وفقًا لنظام التشغيل، حدِّد نوع الورق من تفضيلات الطباعة أو من مربع حوار طباعة. تأكد من أن الإعداد يُطابق الورق الذي تم تحميله في الدرج. يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . قم بتحميل مصدر الورق المحدد بنوع الورق الموصى به. تأكد من تركيب مجموعة التصوير ووحدة التصوير السوداء بشكل صحيح. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض جزء الموصل الضوئي للضوء المباشر. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أجزاء الموصل الضوئي. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة خطوط بيضاء أفقية خطوط بيضاء أفقية"},{"UUID":"4868e9b9-61ef-40be-a83e-ecfa3ece2c13","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"خطوط رأسية بيضاء قبل حل","descFull":"خطوط رأسية بيضاء قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حاول القيام بواحد أو أكثر من الإجراءات التالية: وفقًا لنظام التشغيل، حدِّد نوع الورق من تفضيلات الطباعة أو من مربع حوار طباعة. تأكد من أن الإعداد يُطابق الورق الذي تم تحميله في الدرج. يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . تأكد من استخدام نوع الورق الموصى به. تأكد من تحميل مصدر الورق المحدد بنوع الورق الموصى به. تأكد من تركيب مجموعة التصوير ووحدة التصوير السوداء بشكل صحيح. أزل مجموعة التصوير، ثم أزل وحدة التصوير بالأسود. لا تعرّض مجموعة التصوير ووحدة التصوير بالأسود للضوء المباشر لفترة تزيد عن 10 دقائق. قد يتسبب التعرض للضوء لمدة طويلة في حدوث مشكلات في جودة الطباعة. لا تلمس أسطوانة الموصل الضوئي الموجودة أسفل مجموعة التصوير ووحدة التصوير باللون الأسود. فقد يؤثر فعل ذلك على جودة مهام الطباعة في المستقبل. أدخل وحدة التصوير بالأسود، ثم أدخل مجموعة التصوير. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة خطوط بيضاء عمودية خطوط بيضاء عمودية"},{"UUID":"a2bd824d-1d0b-4002-b37e-d6970d83d965","title":"جودة الطباعة رديئة","link":"solving-printing-problems.html","desc":"عيوب متكررة قبل حل المشكلة،","descFull":"عيوب متكررة قبل حل المشكلة، اطبع صفحات اختبار جودة الطباعة. من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها صفحات اختبار جودة الطباعة . استخدم الدرج 1 لطباعة نماذج الصفحات وتأكد من تحميل الورق في الاتجاه الطولي. حدد عدد الألوان التي فيها عيوب. قم بقياس المسافة بين العيوب المتكررة على صفحة الألوان المتأثرة. باستخدام مسطرة عيوب الصيانة، قم بقياس المسافة بين العيوب المتكررة التي تظهر على الصفحة الملونة المتأثرة. استبدل مستلزم الطباعة أو القطعة التي يطابق القياس الموجود على صفحة الألوان المتأثرة. مجموعة التصوير بالألوان أو وحدة التصوير باللون الأسود 94.5 ملم (3.72 بوصة) 19.9 ملم (1.18 بوصة) 23.2 ملم (0.19 بوصة) وحدة المطور 43.6 ملم (1.72 بوصة) 45.0 ملم (1.77 بوصة) جهاز الصهر 95 ملم (3.74 بوصة) 110 ملم (4.33 بوصة) إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة عيوب الطباعة المتكررة عيوب الطباعة المتكررة"},{"UUID":"5f5ed84b-3b7a-479e-a417-fd9364230750","title":"مشكلات الطباعة","link":"solving-printing-problems.html","desc":"لا تتم طباعة مهام الطباعة","descFull":"لا تتم طباعة مهام الطباعة حاول القيام بواحد أو أكثر من الإجراءات التالية: من المستند الذي تحاول طباعته، افتح مربع حوار تفضيلات الطباعة أو الطباعة، ثم تحقق من تحديد الطابعة الصحيحة. تحقق مما إذا كانت الطابعة قيد التشغيل، ثم قم بحل أي رسائل خطأ تظهر على الشاشة. تحقق مما إذا كانت المنافذ تعمل ومما إذا كانت الكابلات موصولة بإحكام بجهاز الكمبيوتر والطابعة. لمزيد من المعلومات، راجع وثائق الإعداد الواردة مع الطابعة. أوقف تشغيل الطابعة وانتظر مدة 10 ثوانٍ ثم أعِد تشغيلها. أزِل برنامج تشغيل الطباعة، ثم أعد تثبيته. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في الطباعة لا تتم طباعة مهام الطباعة لا تتم طباعة مهام الطباعة لا تتم طباعة مهام الطباعة"},{"UUID":"65393134-32d8-4bdd-b4c5-e421fe37f844","title":"مشكلات الطباعة","link":"solving-printing-problems.html","desc":"تتعذر طباعة المستندات السرية والمحجوزة","descFull":"تتعذر طباعة المستندات السرية والمحجوزة حاول القيام بواحد أو أكثر من الإجراءات التالية: من لوحة التحكم، تحقق من أن المستندات مدرجة في قائمة  المهام المحجوزة . إذا لم تكن المستندات مدرجة، فقم بطباعتها باستخدام خيارَي الطباعة والحجز. قم بحل أخطاء التنسيق المحتملة أو البيانات غير الصالحة في مهمة الطباعة. احذف مهمة الطباعة ثم أرسلها مرة أخرى. لملفات PDF، قم بإنشاء ملف جديد ومن ثم اطبع المستند. إذا كنت تطبع من الإنترنت، فقد تقرأ الطابعة عناوين المهام المتعددة على أنها متكررة. بالنسبة لمستخدمي Windows، تأكد من تحديد  الاحتفاظ بالمستندات المكررة  في تفضيلات الطباعة أو مربع حوار الطباعة. بالنسبة لمستخدمي Macintosh، قم بتسمية كل مهمة بشكل مختلف. احذف بعض المهام المحجوزة لتحرير بعض المساحة في ذاكرة الطابعة. قم بتركيب ذاكرة طابعة إضافية. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة تعذرت طباعة المستندات السرية والمستندات المحجوزة الأخرى تعذر طباعة المستندات السرية تعذر طباعة المستندات المحجوزة"},{"UUID":"97f780c8-a084-4487-880d-16c99045fe4f","title":"مشكلات الطباعة","link":"solving-printing-problems.html","desc":"تتم طباعة المهمة من درج","descFull":"تتم طباعة المهمة من درج خاطئ أو على ورق غير صحيح حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من أنك تقوم بالطباعة على الورق الصحيح. وفقًا لنظام التشغيل، حدِّد حجم الورق ونوعه من \"تفضيلات الطباعة\" أو من مربع حوار \"طباعة\". تأكد من أن الإعدادات مطابقة للورق الذي تم تحميله. يمكنك أيضًا تغيير الإعدادات في لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . تحقق مما إذا كانت الأدراج مرتبطة. لمزيد من المعلومات، راجع  . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في الطباعة طباعة المهمة من الدرج غير الصحيح مشكلة في الطباعة طباعة المهمة على الورقة غير الصحيحة طباعة المهمة من الدرج غير الصحيح طباعة المهمة على الورقة غير الصحيحة"},{"UUID":"6ad6868f-edea-4c5d-8512-529ce1f8a36c","title":"مشكلات الطباعة","link":"solving-printing-problems.html","desc":"طباعة بطيئة حاول القيام بواحد","descFull":"طباعة بطيئة حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من توصيل كبل الطابعة بشكل آمن بالطابعة والكمبيوتر وملقم الطباعة والخيار وجهاز الشبكة الآخر. تأكد من أن الطابعة ليست في  الوضع الهادئ . من لوحة التحكم انتقل إلى  الإعدادات الجهاز  صيانة قائمة التهيئة عمليات الجهاز الوضع الهادئ . حدد دقة المستند الذي تريد طباعته. وفقًا لنظام التشغيل الخاص بك، قم بالوصول إلى تفضيلات الطباعة أو مربع حوار الطباعة. عين دقة  جودة اللون على 4800 . يمكنك أيضًا تغيير الإعداد على لوحة التحكم. انتقل إلى  الإعدادات الطباعة الجودة دقة الطباعة . وفقًا لنظام التشغيل، حدِّد نوع الورق من تفضيلات الطباعة أو من مربع حوار طباعة. يمكنك أيضًا تغيير الإعداد على لوحة التحكم. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . تتم طباعة الورق الأثقل بشكل أبطأ. قد تتم طباعة الورق الأضيق من letter وA4 وlegal بشكل أبطأ. تأكد من تطابق إعدادات المادة والوزن في الطابعة مع الورق الذي يتم تحميله. من لوحة التحكم, انتقل إلى  الإعدادات الورق تهيئة الوسائط أنواع الوسائط .  قد تتم طباعة الورق ذي المواد الخشنة والورق ذي الأوزان الثقيلة ببطء أكثر. قم بإزالة المهام المحجوزة. تأكد من عدم سخونة الطابعة بشكل مفرط. اترك الطابعة حتى تبرد بعد مهمة طباعة طويلة. حافِظ على درجة الحرارة المحيطة الموصى بها للطابعة. لمزيد من المعلومات، راجع  . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في الطباعة طباعة بطيئة طباعة بطيئة"},{"UUID":"e25be91a-54b4-4a49-937c-a4157286867a","title":"استكشاف مشكلة وإصلاحها","link":"trb-printer-not-responding-topic.html","desc":"الطابعة لا تستجيب حاول القيام","descFull":"الطابعة لا تستجيب حاول القيام بواحد أو أكثر من الإجراءات التالية: تحقق مما إذا كان سلك التيار متصلاً بمأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. يجب التأكد من عدم فصل مأخذ التيار الكهربائي عن طريق مفتاح أو قاطع. تأكد من أن الطابعة قيد التشغيل. يجب التأكد من أن الطابعة ليست في وضع السكون أو السبات. يجب التأكد من توصيل الكابلات التي تربط الطابعة بالكمبيوتر بالمنافذ الصحيحة. أوقف تشغيل الطابعة وقم بتثبيت خيارات الأجهزة، ثم أعد تشغيل الطابعة. ارجع إلى المراجع المصاحبة للخيار لمزيد من المعلومات. قم بتثبيت برنامج تشغيل الطباعة. أوقف تشغيل الطابعة وانتظر مدة 10 ثوانٍ ثم أعِد تشغيلها. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في الطباعة الطابعة لا تستجيب الطابعة لا تستجيب"},{"UUID":"a3dbf49d-abb8-4ca8-be0a-3737b83ca812","title":"استكشاف مشكلة وإصلاحها","link":"trb-unable-to-read-flash-drive-topic.html","desc":"تتعذر قراءة محرك أقراص فلاش","descFull":"تتعذر قراءة محرك أقراص فلاش حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من أن الطابعة ليست مشغولة بمعالجة مهام متعددة. تأكد من إدخال محرك الأقراص المحمول في منفذ USB الأمامي. لا يعمل محرك أقراص فلاش عند إدخاله في منفذ USB الخلفي. تحقق من أن محرك الأقراص الفلاش مدعومًا. لمزيد من المعلومات، راجع  . أزِل محرك أقراص فلاش ثم قم بتركيبه. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . يتعذر قراءة محرك أقراص فلاش مشكلة في الطباعة يتعذر قراءة محرك أقراص فلاش"},{"UUID":"0046e97b-cffa-44d9-b961-ee00a29608ab","title":"استكشاف مشكلة وإصلاحها","link":"enabling-usb-port-topic.html","desc":"تمكين منفذ USB من لوحة","descFull":"تمكين منفذ USB من لوحة التحكم انتقل إلى  إعدادات الشبكة/المنافذ USB . حدد  تمكين منفذ USB . منفذ USB تمكين تمكين منفذ USB إعداد منفذ USB"},{"UUID":"2f119935-e5af-4ee3-be39-b0a450cd9a0f","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"تجنب انحشار الورق حمِّل الورق","descFull":"تجنب انحشار الورق حمِّل الورق تحميلاً صحيحًا تأكد من وضع الورق بشكل مسطح في الدرج. تحميل الورق الصحيح وغير الصحيح تحميل الورق الصحيح تحميل الورق غير الصحيح لا تقم بتحميل الدرج أو إزالته أثناء إجراء الطابعة للطباعة. عدم تحميل كمية ورق أكثر من اللازم. تأكد من أن ارتفاع رزمة الورق لم يتعدَ مؤشر الحد الأقصى لتعبئة الورق. لا تحرّك الورق داخل الدرج. حمِّل الورق على النحو المبين في الرسم التوضيحي. تأكد من وضع موجهات الورق بالطريقة الصحيحة ومن أنها لا تضغط بقوة على الورق أو المغلفات. ادفع الدرج بإحكام داخل الطابعة بعد تحميل الورق. استخدم الورق المُوصى به استخدم الورق أو الوسائط الخاصة الموصى بها فقط. لا تقوم بتحميل الورق المثني أو المبلل أو المطوي أو المفتول. قم بثني حواف الورق وتهويتها وتسويتها قبل التحميل. لا تستخدم ورق تم قصه أو شذبه باليد. لا تخلط الورق ذا الأحجام أو الأوزان أو الأنواع المختلفة في نفس الدرج. تأكد من تعيين حجم الورق ونوعه بالشكل الصحيح على الكمبيوتر أو لوحة التحكم الخاصة بالطابعة. خزِّن الورق وفقًا لتوصيات الجهة المُصنِّعة. انحشار الورق تجنب انحشار، الورق تجنب تفادي انحشار الورق"},{"UUID":"e3c93621-612d-47b5-974b-1287b66e5864","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"تحديد أماكن انحشار الورق عند","descFull":"تحديد أماكن انحشار الورق عند تعيين  المساعدة على التخلص من الانحشار  إلى  تشغيل ، تُخرج الطابعة صفحات فارغة أو صفحات مطبوعة جزئيًا بعد إزالة الصفحة المحشورة. تحقق من المخرجات المطبوعة الخاصة بالصفحات الفارغة. عند تعيين  إصلاح انحشار الورق  إلى  تشغيل  أو  تلقائي ، تعيد الطابعة طباعة الصفحات المحشورة. مواقع الانحشار مواقع الانحشار 1 الباب B 2 وحدة التغذية متعددة الأغراض 3 الدرج القياسي 4 حاوية قياسية 5 وحدة تغذية المستندات التلقائية 6 ‏‫وحدة إنهاء التدبيس‬ 7 درج اختياري سعة 550 ورقة 8 درج سعة 2 x‏ 550 ورقة 9 الدرج سعة 1500ورقة 10 وحدة إنهاء التدبيس وتثقيب الفتحات 11 نقل الورق مع خيار الطي 12 درج الإدخال المزدوج سعة 2000 ورقة 13 وحدة إنهاء الكتيبات انحشار الورق تحديد موقع مواقع الانحشار حول"},{"UUID":"9a20e72a-fde6-42ae-9adc-e4acec1efa2e","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار ورق في الدرج القياسي","descFull":"انحشار ورق في الدرج القياسي انحشار ورق في الدرج القياسي اسحب الدرج القياسي إلى الخارج. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. قم بإدخال الدرج. التخلص من انحشار الورق في الدرج القياسي إزالة انحشار الورق في الدرج القياسي انحشار الورق في الدرج القياسي"},{"UUID":"53de5493-ba95-4b6a-9d3b-b52ab1392dec","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق في الدرج الاختياري","descFull":"انحشار الورق في الدرج الاختياري سعة 550 ورقة افتح الباب D. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب. اسحب الدرج الاختياري بسعة 550 ورقة. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. قم بإدخال الدرج. التخلص من انحشار الورق في الدرج الجرار سعة 550 ورقة إزالة انحشار الورق في الدرج الجرار سعة 550 ورقة انحشار الورق في درج سعة 550 ورقة"},{"UUID":"a024c49d-8730-4e0b-af35-c98ff7303d5c","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق في وحدة تغذية","descFull":"انحشار الورق في وحدة تغذية المستندات التلقائية انحشار الورق في الباب A افتح الباب A. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب A. انحشار الورق في الباب A1 افتح غطاء الماسحة الضوئية. اضغط على الماسِكات الخضراء لفتح الباب A1. أدر المقبض الأخضر بالقرب من الباب A1 إلى اليمين، ثم أزل الورق المنحشر. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب A1، ثم أغلق غطاء الماسحة الضوئية. انحشار الورق في صندوق تغذية المستندات التلقائية أزل أي ورق من صندوق تغذية المستندات التلقائية. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. التخلص من انحشار الورق في وحدة تغذية المستندات التلقائية انحشار الورق في وحدة تغذية المستندات التلقائية إزالة انحشار الورق في وحدة تغذية المستندات التلقائية"},{"UUID":"9b1ac685-0116-435b-8340-0e69693465ee","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق داخل وحدة التغذية","descFull":"انحشار الورق داخل وحدة التغذية متعددة الأغراض أزل أي ورق من وحدة التغذية متعددة الأغراض. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. التخلص من انحشار الورق في وحدة التغذية متعددة الأغراض إزالة انحشار الورق في وحدة التغذية متعددة الأغراض انحشار الورق في وحدة التغذية متعددة الأغراض"},{"UUID":"c009067d-0914-492b-9ab7-259bbb5b9714","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار ورق في الدرج سعة","descFull":"انحشار ورق في الدرج سعة 2 x 550 افتح الباب E. قم بإزالة الورق المنحشر داخل الباب E. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب E. اسحب الدرج 3 إلى الخارج. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. أدخل الدرج 3. تكرار  الخطوة 4  إلى  الخطوة 6  للدرج 4. التخلص من انحشار الورق درج سعة 2 x‏ 550 ورقة إزالة انحشار الورق درج سعة 2 x‏ 550 ورقة انحشار الورق درج سعة 2 x‏ 550 ورقة"},{"UUID":"5f0991d5-4f3c-45ed-a815-dcd0cd7c48b8","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق في درج الإدخال","descFull":"انحشار الورق في درج الإدخال المزدوج سعة 2000 ورقة افتح الباب E. قم بإزالة الورق المنحشر داخل الباب E. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب E. التخلص من انحشار الورق درج الإدخال المزدوج سعة 2000 ورقة إزالة انحشار الورق درج الإدخال المزدوج سعة 2000 ورقة انحشار الورق في الدرج الجرار سعة 2000 ورقة"},{"UUID":"de5f1c04-a0af-4e74-b236-1462ab775a7d","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق في الدرج الجرار","descFull":"انحشار الورق في الدرج الجرار سعة 1500 ورقة افتح الباب K. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب K. أمسك بالمقبض J، ثم قم بتحريك الدرج إلى اليمين. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. أعد الدرج إلى مكانه. التخلص من انحشار الورق في الدرج الجرار سعة 1500 ورقة إزالة انحشار الورق في الدرج الجرار سعة 1500 ورقة انحشار الورق في الدرج الجرار سعة 1500 ورقة"},{"UUID":"334018ae-74f1-423a-87db-6f94165686e8","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق في الباب B","descFull":"انحشار الورق في الباب B افتح الباب B. قد يكون الجزء الداخلي من الطابعة ساخنًا. للحد من خطر التعرض للإصابة من أحد المكونات الساخنة، اترك السطح ليبرد قبل ملامسته. للوقاية من التلف الناتج عن التفريغ الإلكتروستاتيكي، المس أي إطار معدني مكشوف في الطابعة قبل الوصول إلى المناطق الداخلية للطابعة أو لمسها. أزل الورق المنحشر من أي من المواقع التالية: تأكد من إزالة جميع أجزاء الورق المحشورة. أعلى وحدة الصهر في وحدة الصهر أسفل وحدة المصهر تحت بكرة خروج الحاوية القياسية داخل وحدة الطباعة المزدوجة أغلق الباب B. انحشار الورق في الباب B انحشار الورق داخل وحدة الصهر انحشار الورق داخل وحدة الطباعة المزدوجة التخلص من انحشار الورق داخل المصهر التخلص من انحشار الورق داخل وحدة الطباعة المزدوجة إزالة انحشار الورق داخل المصهر إزالة انحشار الورق داخل وحدة الطباعة المزدوجة"},{"UUID":"d8da30f8-f624-4687-875e-25eb1607a7fc","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق في الحاوية القياسية","descFull":"انحشار الورق في الحاوية القياسية قم بإزالة أي ورق من الحاوية القياسية. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. التخلص من انحشار الورق الحاوية القياسية إزالة انحشار الورق في الحاوية القياسية انحشار الورق في الحاوية القياسية"},{"UUID":"5332db3b-2a72-49cf-8a16-f49b0804f2af","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق في وحدة إنهاء","descFull":"انحشار الورق في وحدة إنهاء التدبيس قم بإزالة الورق المنحشر في حاوية وحدة إنهاء التدبيس‬. تأكد من إزالة جميع أجزاء الورق المحشورة. أمسك المقبض F، ثم قم بتحريك وحدة إنهاء التدبيس‬ إلى اليسار. افتح الباب R1، ثم قم بتدوير المقبض R2 في اتجاه عقارب الساعة. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب R1. قم بإزالة الورق المنحشر الموجود في أسطوانة خروج الحاوية القياسية. تأكد من إزالة جميع أجزاء الورق المحشورة. أعد ‏‫وحدة إنهاء التدبيس‬ إلى مكانها. التخلص من انحشار الورق وحدة إنهاء التدبيس إزالة انحشار الورق وحدة إنهاء التدبيس انحشار الورق وحدة إنهاء التدبيس"},{"UUID":"74e76c50-43ee-4331-8ef7-e78e96bd438b","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق أثناء نقل الورق","descFull":"انحشار الورق أثناء نقل الورق مع خيار الطي قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. افتح الباب F. مقبض الرفع N4. مقبض الرفع N5. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق المقبض N5، ثم أغلق المقبض N4. ادفع المقبض لأسفل N1. أدر المقبض N2 عكس اتجاه عقارب الساعة. قم بإزالة الورق المحشور. لمنع تلف الطابعة، قم بإزالة أي ملحقات يدوية قبل إزالة الورق المنحشر. تأكد من إزالة جميع أجزاء الورق المحشورة. أعد المقبض N1 إلى مكانه. أغلق الباب F. التخلص من انحشار الورق أثناء نقل الورق مع خيار الطي إزالة انحشار الورق أثناء نقل الورق مع خيار الطي انحشار الورق أثناء نقل الورق مع خيار الطي"},{"UUID":"a3c68f4e-5258-443e-8979-78c4d4c98ac5","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق في وحدة إنهاء","descFull":"انحشار الورق في وحدة إنهاء التدبيس وتثقيب الفتحات إذا تم تهيئة الطابعة الخاصة بك مع وسيلة نقل الورق، فقم بما يلي: قم بإزالة الورق المحشور في الحاوية 1. تأكد من إزالة جميع أجزاء الورق المحشورة. لا تقم بإزالة الصفحات المطبوعة الموجودة في برنامج التحويل البرمجي الأساسي لتجنب فقدان الصفحات. قم بإزالة الورق المنحشر في الحاوية القياسية لوحدة الإنهاء. تأكد من إزالة جميع أجزاء الورق المحشورة. قم بإزالة الورق المحشور في الحاوية 2. تأكد من إزالة جميع أجزاء الورق المحشورة. افتح غطاء نقل الورق G، ثم قم بإزالة الورق المنحشر. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق غطاء وحدة نقل الورق G. افتح الباب I، وافتح الباب R1، ثم قم بإزالة الورق المنحشر. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب R1، ثم أغلق الباب I. افتح غطاء نقل الورق F. افتح الباب H. مقبض الرفع R4. أدر المقبض R3 عكس اتجاه عقارب الساعة، ثم قم بإزالة الورق المنحشر في الحاوية 1. تأكد من إزالة جميع أجزاء الورق المحشورة. أدر المقبض R2 عكس اتجاه عقارب الساعة، ثم قم بإزالة الورق المنحشر في غطاء نقل الورق F. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق غطاء وحدة نقل الورق F. أعد المقبض R4 إلى موضعه الأصلي. أغلق الباب H. إذا تم تهيئة الطابعة الخاصة بك مع خيار نقل الورق مع الطي، فقم بما يلي: قم بإزالة الورق المحشور في الحاوية 1. تأكد من إزالة جميع أجزاء الورق المحشورة. لا تقم بإزالة الصفحات المطبوعة الموجودة في برنامج التحويل البرمجي الأساسي لتجنب فقدان الصفحات. قم بإزالة الورق المنحشر في الحاوية القياسية لوحدة الإنهاء. تأكد من إزالة جميع أجزاء الورق المحشورة. قم بإزالة الورق المحشور في الحاوية 2. تأكد من إزالة جميع أجزاء الورق المحشورة. افتح الباب F. افتح الباب N4. افتح الباب N5. افتح الباب H. مقبض الرفع R4. أدر المقبض R3 عكس اتجاه عقارب الساعة، ثم قم بإزالة الورق المنحشر في الحاوية 1. تأكد من إزالة جميع أجزاء الورق المحشورة. أدر المقبض R2 عكس اتجاه عقارب الساعة، ثم قم بإزالة الورق المنحشر بين البابين N4 وN5. تأكد من إزالة جميع أجزاء الورق المحشورة. افتح الباب B. قد يكون الجزء الداخلي من الطابعة ساخنًا. للحد من خطر التعرض للإصابة من أحد المكونات الساخنة، اترك السطح ليبرد قبل ملامسته. للوقاية من التلف الناتج عن التفريغ الإلكتروستاتيكي، المس أي إطار معدني مكشوف في الطابعة قبل الوصول إلى المناطق الداخلية للطابعة أو لمسها. قم بإزالة الورق المنحشر الموجود أسفل أسطوانة خروج الحاوية القياسية. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب B. ادفع المقبض لأسفل N1. أدر المقبض N2 عكس اتجاه عقارب الساعة. قم بإزالة الورق المحشور. لمنع تلف الطابعة، قم بإزالة أي ملحقات يدوية قبل إزالة الورق المنحشر. تأكد من إزالة جميع أجزاء الورق المحشورة. أعد المقبض N1 إلى مكانه. أغلق المقبض N5، ثم أغلق المقبض N4. أغلق الباب F. أعد المقبض R4 إلى موضعه الأصلي. أغلق الباب H. التخلص من انحشار الورق في وحدة إنهاء التدبيس وتثقيب الفتحات إزالة انحشار الورق في وحدة إنهاء التدبيس وتثقيب الفتحات انحشار الورق في وحدة إنهاء التدبيس وتثقيب الفتحات"},{"UUID":"8ac32282-82f1-4a1f-96c9-2892cbf00ee7","title":"التخلص من انحشار الورق","link":"clearing-jams.html","desc":"انحشار الورق في وحدة إنهاء","descFull":"انحشار الورق في وحدة إنهاء الكتيبات إذا تم تهيئة الطابعة الخاصة بك مع وسيلة نقل الورق، فقم بما يلي: قم بإزالة الورق المنحشر في الحاوية القياسية لوحدة الإنهاء. تأكد من إزالة جميع أجزاء الورق المحشورة. قم بإزالة الورق المحشور في الحاوية 1. تأكد من إزالة جميع أجزاء الورق المحشورة. قم بإزالة الورق المحشور في الحاوية 1. تأكد من إزالة جميع أجزاء الورق المحشورة. لا تقم بإزالة الصفحات المطبوعة الموجودة في برنامج التحويل البرمجي الأساسي لتجنب فقدان الصفحات. قم بإزالة الورق المحشور في الحاوية 3. تأكد من إزالة جميع أجزاء الورق المحشورة. افتح غطاء نقل الورق G، ثم قم بإزالة الورق المنحشر. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق غطاء وحدة نقل الورق G. افتح غطاء نقل الورق F. افتح الباب H. حرك المقبض R3 إلى اليمين، ثم قم بإزالة الورق المنحشر. تأكد من إزالة جميع أجزاء الورق المحشورة. حرك المقبض R1 إلى اليسار، وأدر المقبض R2 عكس اتجاه عقارب الساعة، ثم قم بإزالة الورق المنحشر. تأكد من إزالة جميع أجزاء الورق المحشورة. أدر المقبض R5 عكس اتجاه عقارب الساعة، ثم قم بإزالة الورق المنحشر من الحاوية القياسية لوحدة الإنهاء. تأكد من إزالة جميع أجزاء الورق المحشورة. ارفع المقبض R4، وأدر المقبض R2 في اتجاه عقارب الساعة، ثم قم بإزالة الورق المنحشر. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق غطاء وحدة نقل الورق F. أعد المقابض R1 وR3 وR4 إلى وضعها الأصلي. أغلق الباب H. إذا تم تهيئة الطابعة الخاصة بك مع خيار نقل الورق مع الطي، فقم بما يلي: قم بإزالة الورق المنحشر في الحاوية القياسية لوحدة الإنهاء. تأكد من إزالة جميع أجزاء الورق المحشورة. قم بإزالة الورق المحشور في الحاوية 1. تأكد من إزالة جميع أجزاء الورق المحشورة. قم بإزالة الورق المحشور في الحاوية 1. تأكد من إزالة جميع أجزاء الورق المحشورة. لا تقم بإزالة الصفحات المطبوعة الموجودة في برنامج التحويل البرمجي الأساسي لتجنب فقدان الصفحات. قم بإزالة الورق المحشور في الحاوية 3. تأكد من إزالة جميع أجزاء الورق المحشورة. افتح الباب F. افتح الباب H. افتح الباب N4. افتح الباب N5. مقبض الرفع R4. أدر المقبض R2 في اتجاه عقارب الساعة، ثم قم بإزالة الورق المنحشر في المقبض R4. تأكد من إزالة جميع أجزاء الورق المحشورة. حرك المقبض R1 إلى اليسار، وأدر المقبض R2 عكس اتجاه عقارب الساعة، ثم قم بإزالة الورق المنحشر بين البابين N4 وN5. تأكد من إزالة جميع أجزاء الورق المحشورة. افتح الباب B. قد يكون الجزء الداخلي من الطابعة ساخنًا. للحد من خطر التعرض للإصابة من أحد المكونات الساخنة، اترك السطح ليبرد قبل ملامسته. للوقاية من التلف الناتج عن التفريغ الإلكتروستاتيكي، المس أي إطار معدني مكشوف في الطابعة قبل الوصول إلى المناطق الداخلية للطابعة أو لمسها. قم بإزالة الورق المنحشر الموجود أسفل أسطوانة خروج الحاوية القياسية. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب B. ادفع المقبض لأسفل N1. أدر المقبض N2 عكس اتجاه عقارب الساعة. قم بإزالة الورق المحشور. لمنع تلف الطابعة، قم بإزالة أي ملحقات يدوية قبل إزالة الورق المنحشر. تأكد من إزالة جميع أجزاء الورق المحشورة. أعد المقبض N1 إلى مكانه. أغلق الباب N5، ثم أغلق الباب N4. أغلق الباب F. أعد المقبضين R1 وR4 إلى مواضعهما الأصلية. أغلق الباب H. انحشار الورق في صانع الكتيبات قم بإزالة الورق المنحشر في الحاوية 2. تأكد من إزالة جميع أجزاء الورق المحشورة. افتح الباب H. أدر المقابض R6 وR11 وR10 في اتجاه عقارب الساعة. اسحب وحدة إنشاء الكتيبات إلى الخارج. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. أدر المقبض R9 عكس اتجاه عقارب الساعة حتى يتوقف. افتح الباب R8. قم بإزالة الورق المحشور. تأكد من إزالة جميع أجزاء الورق المحشورة. أغلق الباب R8. أعد صانع الكتيبات إلى وحدة إنهاء الكتيبات. أغلق الباب H. التخلص من انحشار الورق وحدة إنهاء الكتيب إزالة انحشار الورق وحدة إنهاء الكتيب انحشار الورق في وحدة إنهاء الكتيب"},{"UUID":"f960fafe-87b9-42c6-86fe-d3fa1f44a552","title":"مشاكل اتصال شبكة الاتصال","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"يتعذر فتح Embedded Web Server","descFull":"يتعذر فتح Embedded Web Server يتعذر فتح Embedded Web Server حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من تشغيل الطابعة. تأكد من صحة عنوان IP الخاص بالطابعة. عرض عنوان IP على لوحة التحكم. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. تأكد من تثبيت مستعرض مدعوم. الإصدار 11 من Internet Explorer أو الإصدارات اللاحقة Microsoft Edge إصدار سفاري 6 أو الأحدث Google Chrome  الإصدار 32 أو الأحدث Mozilla Firefox الإصدار 24 أو الأحدث تأكد مما إذا كان اتصال شبكة الاتصال يعمل. إذا كان الاتصال لا يعمل، فاتصل بالمسؤول. تأكد من أن توصيلات الكابلات بالطابعة وملقم الطباعة موصلة بإحكام. للحصول على مزيد من المعلومات، راجع المستندات المرفقة بملقم الطباعة. تحقّق مما إذا كانت خوادم وكيل ويب معطّلة. إذا تم تعطيل الملقمات، فاتصل بالمسؤول. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . يتعذر فتح Embedded Web Server استكشاف الأخطاء وإصلاحها يتعذر فتح Embedded Web Server"},{"UUID":"e257ade4-8ffa-4f23-bc6f-a6bdfa68eb97","title":"مشاكل اتصال شبكة الاتصال","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"يتعذر توصيل الطابعة بشبكة اتصال","descFull":"يتعذر توصيل الطابعة بشبكة اتصال Wi-Fi يتعذر توصيل الطابعة بشبكة اتصال Wi-Fi حاول القيام بواحد أو أكثر من الإجراءات التالية: من لوحة التحكم، انتقل إلى  الإعدادات الشبكة/منافذ نظرة عامة على الشبكة مهايئ نشط ومن ثم حدد  تلقائي . تأكد من اتصال الكمبيوتر بشبكة Wi-Fi الصحيحة. لمزيد من المعلومات، راجع  . قد تشارك بعض أجهزة التوجيه اسم Wi-Fi الافتراضي. تأكد من إدخال كلمة المرور الصحيحة لشبكة الاتصال. انتبه إلى المسافات والأرقام والأحرف الكبيرة في كلمة المرور. تأكد من تحديد وضع الأمان اللاسلكي الصحيح. من لوحة التحكم، انتقل إلى  الإعدادات الشبكة/المنافذ لاسلكي وضع الأمان اللاسلكي . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . يتعذر توصيل الطابعة بشبكة Wi-Fi استكشاف الأخطاء وإصلاحها يتعذر توصيل الطابعة بشبكة Wi-Fi"},{"UUID":"552f16b8-c3ba-4aba-b94a-e6c091bda9aa","title":"مشاكل في خيارات الأجهزة","link":"trb-cannot-detect-internal-option-topic.html","desc":"تعذّر الكشف عن الوحدة الاختيارية","descFull":"تعذّر الكشف عن الوحدة الاختيارية الداخلية تعذّر الكشف عن الوحدة الاختيارية الداخلية حاول القيام بواحد أو أكثر من الإجراءات التالية: أوقف تشغيل الطابعة وانتظر مدة 10 ثوانٍ ثم أعِد تشغيلها. قم بطباعة  صفحة إعدادات القوائم ، ومن ثم تحقق ما إذا كان الخيار الداخلي يظهر في قائمة الميزات المركبة. من لوحة التحكم انتقل إلى  الإعدادات التقارير صفحة إعدادات القوائم . تحقق ما إذا تم تركيب الوحدة الاختيارية الداخلية بشكل صحيح في لوحة وحدة التحكم. قم بإيقاف تشغيل الطابعة، ثم قم بفصل سلك التيار عن مأخذ التيار الكهربائي. تأكد من توصيل الوحدة الاختيارية الداخلية بمنفذ التوصيل المناسب في لوحة وحدة التحكم. وصل سلك التيار بمأخذ التيار الكهربائي ثم قم بتشغيل الطابعة. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك التيار بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. تأكد إذا ما كان الخيار الداخلي متوفرًا في برنامج تشغيل الطباعة. إذا لزم الأمر، أضف الخيار الداخلي يدويًا في برنامج تشغيل الطباعة لجعله متاحًا لمهام الطباعة. لمزيد من المعلومات، راجع  . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في خيارات الأجهزة يتعذّر اكتشاف خيار داخلي لم يتم اكتشاف الخيار الداخلي يتعذّر اكتشاف خيار داخلي"},{"UUID":"2e28ea38-f36c-4eeb-b10d-bb67283414b1","title":"مشاكل في خيارات الأجهزة","link":"trb-cannot-detect-internal-option-topic.html","desc":"منفذ الحلول الداخلية لا يعمل","descFull":"منفذ الحلول الداخلية لا يعمل بشكل صحيح منفذ الحلول الداخلية لا يعمل بشكل صحيح حاول القيام بواحد أو أكثر من الإجراءات التالية: قم بطباعة  صفحة إعدادات القائمة  وتحقق إذا ما كان منفذ الحلول الداخلية (ISP) يظهر في قائمة الميزات المثبتة. من لوحة التحكم انتقل إلى  الإعدادات التقارير صفحة إعدادات القوائم . إزالة ثم قم بإعادة تثبيت ISP. لمزيد من المعلومات، راجع  . تحقق من توصيل الكابل ومنفذ الحلول الداخلي. استخدم الكابل الصحيح، ثم تأكد من إحكام توصيله بمنفذ الحلول الداخلية. تحقق مما إذا كان كابل واجهة حل ISP متصلاً بشكل آمن بالفتحة الخاصة به على لوحة وحدة التحكم. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . استكشاف الأخطاء وإصلاحها منفذ الحلول الداخلية مشكلة في خيارات الطابعة منفذ الحلول الداخلية منفذ الحلول الداخلية لا يعمل بشكل صحيح"},{"UUID":"1646ca9f-2ac6-4148-bda1-7de1cab27e7d","title":"مشاكل في خيارات الأجهزة","link":"trb-cannot-detect-internal-option-topic.html","desc":"بطاقة الواجهة المتوازية أو التسلسلية","descFull":"بطاقة الواجهة المتوازية أو التسلسلية لا تعمل بشكل صحيح بطاقة الواجهة المتوازية أو التسلسلية لا تعمل بشكل صحيح حاول القيام بواحد أو أكثر من الإجراءات التالية: قم بطباعة  صفحة إعدادات القائمة  وتحقق إذا ما كانت بطاقة الواجهة المتوازية أو التسلسلية تظهر في قائمة الميزات المثبتة. من لوحة التحكم انتقل إلى  الإعدادات التقارير صفحة إعدادات القوائم . قم بإزالة بطاقة الواجهة المتوازية أو التسلسلية ثم أعد تثبيتها. لمزيد من المعلومات، راجع  . تحقق من الاتصال بين الكابل وبطاقة الواجهة المتوازية أو التسلسلية. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في خيارات الطابعة بطاقة الواجهة المتوازية مشكلة في خيارات الطابعة بطاقة الواجهة التسلسلية استكشاف الأخطاء وإصلاحها بطاقة الواجهة المتوازية استكشاف الأخطاء وإصلاحها بطاقة الواجهة التسلسلية"},{"UUID":"25654b8e-54bd-46bf-a3ff-38be47ac5011","title":"مشاكل في خيارات الأجهزة","link":"trb-cannot-detect-internal-option-topic.html","desc":"تم اكتشاف ذاكرة محمولة معيبة","descFull":"تم اكتشاف ذاكرة محمولة معيبة تم اكتشاف ذاكرة محمولة معيبة حاول القيام بواحد أو أكثر من الإجراءات التالية: استبدل ذاكرة الفلاش المعيبة. حدد  المتابعة  لتجاهل الرسالة ومتابعة الطباعة. إلغاء مهمة الطباعة الحالية. رسائل الطابعة تم اكتشاف ذاكرة فلاش معيبة ذاكرة الفلاش معيبة استكشاف الأخطاء وإصلاحها ذاكرة الفلاش معيبة"},{"UUID":"a8df2c86-67bb-420d-b8b6-5b575f58038d","title":"مشاكل في خيارات الأجهزة","link":"trb-cannot-detect-internal-option-topic.html","desc":"مساحة فارغة غير كافية للموارد","descFull":"مساحة فارغة غير كافية للموارد في ذاكرة الفلاش مساحة فارغة غير كافية للموارد في ذاكرة الفلاش حاول القيام بواحد أو أكثر من الإجراءات التالية: حدد  المتابعة  لمسح الرسالة ومتابعة الطباعة. احذف الخطوط والمخططات الكلية والبيانات الأخرى المخزنة في ذاكرة الفلاش. تثبيت محرك أقراص تخزين. يتم حذف الخطوط والمخططات الكلية التي يتم تنزيلها والتي لم تكن مخزنة مسبقًا في ذاكرة الفلاش. رسائل الطابعة مساحة فارغة غير كافية للموارد في ذاكرة الفلاش مساحة فارغة غير كافية للموارد في ذاكرة الفلاش"},{"UUID":"d6796f6d-cd20-4d27-96ca-f02aea76d54d","title":"مشاكل المستلزمات","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"استبدال الخرطوشة، عدم تطابق منطقة","descFull":"استبدال الخرطوشة، عدم تطابق منطقة الطابعة لإصلاح هذه المشكلة، تفضّل بشراء خرطوشة من المنطقة الصحيحة التي تلائم منطقة الطابعة أو اشترِ خرطوشة عالمية. يشير الرقم الأول في الرسالة الذي يلي 42 إلى منطقة الطابعة. يشير الرقم الثاني في الرسالة الذي يلي 42 إلى منطقة الخرطوشة. قم بتركيب خرطوشة مسحوق الحبر الصحيحة. مناطق خراطيش مسحوق الحبر والطابعات المنطقة الرمز الرقمي منطقة عالمية أو غير معرّفة 0 أمريكا الشمالية (الولايات المتحدة، كندا) 1 المنطقة الاقتصادية الأوروبية، أوروبا الغربية، دول الشمال، سويسرا 2 آسيا والمحيط الهادئ 3 أمريكا اللاتينية 4 باقي أوروبا والشرق الأوسط وأفريقيا 5 أستراليا ونيوزيلندا 6 منطقة غير صالحة 9 لإيجاد إعدادات منطقة الطابعة وخرطوشة مسحوق الحبر، تفضّل بطباعة  صفحات اختبار جودة الطباعة . من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها صفحات اختبار جودة الطباعة . رسائل الطابعة استبدال الخرطوشة، عدم تطابق منطقة الطابعة استبدال الخرطوشة، عدم تطابق منطقة الطابعة خرطوشة، منطقة الطابعة غير متطابقة"},{"UUID":"0be3a756-79a9-459f-a4ff-b427e6cbc914","title":"مشاكل المستلزمات","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"خرطوشة [الألوان] عادية معاد تعبئتها","descFull":"خرطوشة [الألوان] عادية معاد تعبئتها لقد اكتشفت الطابعة خرطوشة Lexmark عادية معاد تعبئتها بحبر غير أصلي بواسطة جهة أخرى غير Lexmark. اكتشفت الطابعة خرطوشة تمت إعادة تعبئتها بحبر غير أصلي بواسطة جهة أخرى غير الشركة المصنعة للطابعة. حدد  موافق‬  للمتابعة. تمت تصميم جميع مؤشرات عمر مكونات الطابعة للعمل مع مستلزمات وقطع غيار Lexmark الأصلية، وقد تظهر نتائج غير متوقعة عند استخدام مستلزمات أو قطع غيار من جهات أخرى غير Lexmark في طابعة Lexmark الخاصة بك. تمت تصميم جميع مؤشرات عمر مكونات الطابعة للعمل مع مستلزمات وقطع غيار الشركة المصنعة للطابعة، وقد تظهر نتائج غير متوقعة عند استخدام مستلزمات أو قطع غيار من جهات أخرى غير الشركة المصنعة في طابعتك. للحصول على مزيد من المعلومات، راجع بيان الضمان المحدود المضمّن مع هذه الطابعة. رسائل الطابعة خرطوشة عادية معاد تعبئتها حبر غير أصلي مستلزمات‬ الطرف الثالث"},{"UUID":"b712cb41-cde1-4c72-9437-311847131743","title":"مشاكل المستلزمات","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"مستلزمات ليست من إنتاج Lexmark‏","descFull":"مستلزمات ليست من إنتاج Lexmark‏ مستلزمات ليست من إنتاج Dell مستلزمات ليست من جهة تصنيع الطابعة اكتشفت الطابعة مستلزمات طباعة ليست من إنتاج Lexmark أو جزء مثبت في الطابعة. اكتشفت الطابعة مستلزمات طباعة أو جزءاً مثبتاً في الطابعة ليس من إنتاج Dell. اكتشفت الطابعة مستلزمات أو جزءًا مركّبًا في الطابعة غير متعرف عليه. تم تصميم طابعة Lexmark الخاصة بك لتعمل بشكلٍ أفضل مع مستلزمات Lexmark الأصلية للطباعة وأجزائها. قد يؤثر استخدام المستلزمات أو الأجزاء التي يوفرها طرف ثالث على أداء الطابعة ومكوناتها الخاصة بالتصوير أو موثوقيتها أو عمرها. تم تصميم طابعة Dell لتعمل بشكلٍ أفضل مع الأجزاء ومستلزمات الطباعة الأصلية من Dell. قد يؤثر استخدام المستلزمات أو الأجزاء التي يوفرها طرف ثالث على أداء الطابعة ومكوناتها الخاصة بالتصوير أو موثوقيتها أو عمرها. تم تصميم الطابعة لتعمل بشكلٍ أفضل مع الأجزاء ومستلزمات الطباعة الأصلية من إنتاج الجهة المُصنِّعة لهذه الطابعة. قد يؤثر استخدام المستلزمات أو الأجزاء التي يوفرها طرف ثالث على أداء الطابعة ومكوناتها الخاصة بالتصوير أو موثوقيتها أو عمرها. تم تصميم كافة مؤشرات العمر الافتراضي لتعمل مع مستلزمات Lexmark الأصلية للطباعة وقطعها وقد ترسل نتائج غير متوقَّعَة إذا تم استخدام مستلزمات أو قطع من أطراف ثالثة. قد يتسبب استخدام عنصر التصوير بعد العمر الافتراضي المعد له في إتلاف طابعة Lexmark الخاصة بك أو المكونات المرتبطة بها. تم تصميم كافة مؤشرات العمر لتعمل مع الأجزاء ومستلزمات الطباعة الأصلية من Dell، وقد تعطي نتائج غير متوقَّعَة في حال استخدام أجزاء ومستلزمات طباعة من إنتاج طرف آخر. قد يتسبب استخدام عنصر التصوير بعد انتهاء العمر الافتراضي في إتلاف طابعة Dell أو المكونات ذات الصلة. تم تصميم جميع مؤشرات العمر لتعمل مع المستلزمات والأجزاء المُصنعة لدى جهة تصنيع الطابعة وقد تقدم نتائج غير متوقَّعَة إذا تم استخدام مستلزمات أو أجزاء تابعة لجهات خارجية. قد يتسبب استخدام عنصر التصوير بعد العمر الافتراضي المعد له في إتلاف الطابعة أو المكونات ذات الصلة.  قد يؤثر استخدام المستلزمات أو الأجزاء التي يوفرها طرف ثالث على تغطية الضمان. لا يغطي الضمان التلف الناتج عن استخدام المستلزمات أو الأجزاء التي يوفرها طرف ثالث. لقبول أي من هذه المخاطر أو قبولها كلها وللمتابعة باستخدام مستلزمات الطباعة أو الأجزاء غير الأصلية في الطابعة، المس مع الاستمرار رسالة الخطأ التي تظهر على شاشة العرض لمدة 15 ثانية باستخدام إصبعَين. عند ظهور مربع حوار تأكيد، المس  متابعة . إذا لم ترغب في قبول هذه المخاطر، فأزل المستلزمات أو الأجزاء التي يوفرها الطرف الثالث من طابعتك، وركّب مستلزمات أو أجزاء أصلية من إنتاج Lexmark. لمزيد من المعلومات، راجع  . إذا لم ترغب في قبول هذه المخاطر، يتعيّن عليك إزالة المستلزمات أو القطع التي يوفرها الطرف الثالث من طابعتك وتركيب مستلزمات أو قطع أصلية من إنتاج Dell. إذا لم ترغب في قبول هذه المخاطر، يتعيّن عليك إزالة المستلزمات أو القطع التي يوفرها الطرف الثالث من طابعتك وتركيب مستلزمات أو قطع أصلية من جهة تصنيع الطابعة. إذا لم تطبع الطابعة بعد مسح رسالة الخطأ، فقم بإعادة تعيين عداد استخدام المستلزمات. من لوحة التحكم، انتقل إلى  الإعدادات الجهاز Maintenance قائمة التهيئة ‎استخدام المستلزمات والعدادات . حدد القطع أو المستلزمات التي تريد إعادة تعيينها، ثم حدد  ابدأ . اقرأ رسالة التحذير، ثم حدد  متابعة . المس شاشة العرض لمدة 15 ثانية باستخدام إصبعين لمسح الرسالة. إذا لم تتمكن من إعادة تعيين عدادات استخدام المستلزمات، فقم بإرجاع عنصر المستلزمات إلى مكان شرائه. رسائل الطابعة مستلزمات ليست من إنتاج Lexmark مستلزمات ليست من إنتاج Lexmark رسائل الطابعة مستلزمات ليست من إنتاج Dell مستلزمات ليست من إنتاج Dell رسائل الطابعة مستلزمات ليست من جهة تصنيع طابعات مستلزمات ليست من جهة تصنيع طابعات إعادة إعداد عدادات استخدام المستلزمات عدادات استخدام المستلزمات إعادة إعداد إعادة إعداد عدادات استخدام المستلزمات"},{"UUID":"c671bcf5-d4f7-4b5b-bfba-b1a74a455899","title":"مشاكل تغذية الورق","link":"trb-paper-curl-topic.html","desc":"تجعد الورق حاول القيام بواحد","descFull":"تجعد الورق حاول القيام بواحد أو أكثر من الإجراءات التالية: اضبط الموجّهات في الدرج على الموضع الصحيح للورق الذي تم تحميله. وفقًا لنظام التشغيل، حدِّد نوع الورق من تفضيلات الطباعة أو من مربع حوار طباعة. تأكد من أن الإعداد يُطابق الورق الذي تم تحميله. يمكنك كذلك تغيير الإعداد من لوحة التحكم الخاصة بالطابعة. انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . قم بإزالة الورق، واقلبه، ثم أعد تحميل الورق. قم بتحميل الورق من عبوة جديدة. يمتص الورق الرطوبة بسبب الرطوبة المرتفعة قم بتخزين الورق في غلافه الأصلي حتى تصبح جاهزًا لاستخدامه. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة في جودة الطباعة تجعد الورق تجعد الورق"},{"UUID":"129fc537-3a08-4de8-bd75-bfdb10451bfd","title":"مشاكل تغذية الورق","link":"trb-paper-curl-topic.html","desc":"لصق الأظرف أثناء الطباعة حاول","descFull":"لصق الأظرف أثناء الطباعة حاول القيام بواحد أو أكثر من الإجراءات التالية: استخدم مغلفًا تم تخزينه في بيئة جافة. فالطباعة على الأظرف التي تحتوي على درجة رطوبة عالية قد يؤدي إلى لصق ألسنة الأظرف. تأكد من تعيين نوع الورق إلى  مغلّف . من لوحة التحكم، انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة تغذية الورق قفل الأظرف أثناء الطباعة قفل الأظرف أثناء الطباعة"},{"UUID":"5d48cde9-2aec-4c46-ab5b-b1a051f53701","title":"مشاكل تغذية الورق","link":"trb-paper-curl-topic.html","desc":"الطباعة المرتبة لا تعمل حاول","descFull":"الطباعة المرتبة لا تعمل حاول القيام بواحد أو أكثر من الإجراءات التالية: من لوحة التحكم، انتقل إلى  الإعدادات طباعة تخطيط ترتيب ، ثم حدد  تشغيل [1,2,1,2,1,2] . من المستند الذي تحاول طباعته، افتح مربع حوار تفضيلات الطباعة أو الطباعة، ثم حدد  ترتيب . قلل عدد الصفحات المراد طباعتها. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة تغذية الورق الطباعة المرتَّبة لا تعمل الطباعة المرتَّبة لا تعمل"},{"UUID":"fbbd9262-a20c-4776-8a4a-865b35d57757","title":"مشاكل تغذية الورق","link":"trb-paper-curl-topic.html","desc":"ربط الأدراج لا يعمل حاول","descFull":"ربط الأدراج لا يعمل حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من أن الأدراج المرتبطة تحتوي على نفس حجم الورق واتجاهه ونوع الورق. تأكد من وضع موجهات الورق بالشكل الصحيح. عيِّن حجم الورق ونوعه ليطابقا الورق الذي تم تحميله في الأدراج التي تم ربطها. من لوحة التحكم، انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . تأكد من تعيين  ربط الأدراج  إلى  تلقائي . لمزيد من المعلومات، راجع  . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة تغذية الورق إن ميزة ربط الأدراج لا تعمل إن ميزة ربط الأدراج لا تعمل"},{"UUID":"d6770418-3839-4a68-984e-129482b1298b","title":"مشاكل تغذية الورق","link":"trb-paper-curl-topic.html","desc":"انحشار الورق بشكل متكرر حاول","descFull":"انحشار الورق بشكل متكرر حاول القيام بواحد أو أكثر من الإجراءات التالية: تحقق من تحميل الورق بالشكل الصحيح. تأكد من وضع موجهات الورق بالشكل الصحيح. تأكد من أن ارتفاع رزمة الورق لم يتعدَ مؤشر الحد الأقصى لتعبئة الورق. تأكد من الطباعة على حجم الورق ونوع الورق الموصى بهما. اضبط حجم الورق ونوعه الصحيحَين. من لوحة التحكم، انتقل إلى  الإعدادات الورق تهيئة الدرج حجم/نوع الورق . قم بتحميل الورق من عبوة جديدة. يمتص الورق الرطوبة بسبب الرطوبة المرتفعة قم بتخزين الورق في غلافه الأصلي حتى تصبح جاهزًا لاستخدامه. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة تغذية الورق انحشار الورق بشكل متكرر انحشار الورق بشكل متكرر"},{"UUID":"3b0dbce6-46bc-41cb-b9a3-f73183adc65b","title":"مشاكل تغذية الورق","link":"trb-paper-curl-topic.html","desc":"لا تتم إعادة طباعة الصفحات","descFull":"لا تتم إعادة طباعة الصفحات المحشورة من لوحة التحكم، انتقل إلى  الإعدادات الجهاز الإخطارات استعادة محتوى انحشار الورق . في قائمة  إصلاح انحشار الورق  حدد  تشغيل  أو  تلقائي . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة الطباعة تعذر إعادة طباعة الصفحات المحشورة تعذر إعادة طباعة الصفحات المحشورة"},{"UUID":"af7c3b3e-6b64-4d17-8168-7e30fc354c87","title":"مشكلات الإرسال عبر البريد الإلكتروني","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"تعطيل رسالة الخطأ \"لم يتم","descFull":"تعطيل رسالة الخطأ \"لم يتم إعداد ملقم SMTP\" من لوحة التحكم، انتقل إلى  الإعدادات البريد الإلكتروني إعداد البريد الإلكتروني . اضبط  خطأ \"لم يتم إعداد ملقم SMTP\" على  تشغيل . لمنع حدوث الخطأ مرة أخرى، قم بإجراء واحد أو أكثر مما يلي: قم بتحديث البرنامج الثابت بالطابعة. لمزيد من المعلومات، راجع قسم \"تحديث البرنامج الثابت\". قم بتهيئة إعدادات SMTP للبريد الإلكتروني. لمزيد من المعلومات، راجع  . خطأ \"لم يتم إعداد ملقم SMTP\" تعطيل استكشاف الأخطاء وإصلاحها خطأ \"لم يتم إعداد ملقم SMTP\" تعطيل خطأ \"لم يتم إعداد ملقم SMTP\""},{"UUID":"8da01141-e89c-432f-b582-0a07a86fdbf7","title":"مشكلات الإرسال عبر البريد الإلكتروني","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"يتعذَّر إرسال رسائل البريد الإلكتروني","descFull":"يتعذَّر إرسال رسائل البريد الإلكتروني عليك بتجربة حل أو أكثر مما يلي: تأكد من تهيئة إعدادات SMTP للبريد الإلكتروني بطريقة صحيحة. لمزيد من المعلومات، راجع  . تأكد من اتصال الطابعة بشبكة اتصال ومن أن شبكة الاتصال متصلة بالإنترنت. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة البريد الإلكتروني يتعذَّر إرسال رسائل البريد الإلكتروني يتعذَّر إرسال رسائل البريد الإلكتروني"},{"UUID":"9b51824e-f5a6-4fe4-939b-fea59d49d889","title":"مشكلات الإرسال عبر الفاكس","link":"trb-caller-id-not-shown-topic.html","desc":"لم يظهر معرّف المتصل لم","descFull":"لم يظهر معرّف المتصل لم يظهر معرّف المتصل تنطبق هذه الإرشادات فقط على الطابعات المثبت عليها بطاقة فاكس. من لوحة التحكم، انتقل إلى  الإعدادات الفاكس إعداد الفاكس إعدادات استقبال الفاكس عناصر التحكم الخاصة بالمسؤول . اضبط  تمكين معرف المتصل  على  تشغيل . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة الفاكس لم يظهر معرف المتصل لم يظهر معرف المتصل"},{"UUID":"817c7196-abde-412c-8bb3-3fd80cf58e3d","title":"مشكلات الإرسال عبر الفاكس","link":"trb-caller-id-not-shown-topic.html","desc":"يتعذر إرسال الفاكسات أو استلامها","descFull":"يتعذر إرسال الفاكسات أو استلامها باستخدام الفاكس التناظري يتعذر إرسال الفاكسات أو استلامها باستخدام الفاكس التناظري حاول القيام بواحد أو أكثر من الإجراءات التالية : يمكنك حل أي رسائل خطأ تظهر على شاشة العرض. تأكد من أن توصيلات الكابلات الخاصة بالهاتف أو سماعة الرأس أو جهاز الرد الآلي آمنة. تحقق من نغمة الطلب. اتصل برقم الفاكس للتحقق من عمله بشكل صحيح. إذا كنت تستخدم ميزة الاتصال والسماعة مغلقة، قم برفع مستوى الصوت للتحقق من سماعك نغمة الطلب. تحقق من مقبس الهاتف على الحائط. قم بتوصيل الهاتف التناظري بمقبس الحائط مباشرة. واستمع لنغمة الاتصال. إذا لم تتمكن من سماع نغمة طلب، فاستخدم كابل هاتف مختلفًا. إذا ما زلت لا تسمع نغمة طلب، فقم بتوصيل الهاتف التناظري بمقبس حائط مختلف. إذا سمعت نغمة اتصال، فقم بتوصيل الطابعة بمقبس الحائط هذا. تحقق مما إذا كانت الطابعة متصلة بخدمة هاتف تناظري أو بالموصل الرقمي الصحيح. إذا كنت تستخدم خدمة الهاتف \"الخدمات المدمجة لشبكة الاتصال الرقمية\" (ISDN)، فقم بالتوصيل بمنفذ هاتف تناظري لمهايئ ISDN طرفي. للحصول على مزيد من المعلومات، اتصل بمزود ISDN. إذا كنت تستخدم DSL، فقم بالتوصيل بفلتر أو موجّه DSL يعتمد الاستخدام التناظري. للمزيد من المعلومات، اتصل بمزود DSL. إذا كنت تستخدم خدمة الهاتف الخاصة (PBX)، فتأكد من أنك متصل بوصلة تناظرية على PBX. في حالة عدم وجود أي من السابق، فيمكنك تثبيت خط هاتف تناظري لجهاز الفاكس. افصل المعدات الأخرى وقم بتعطيل خدمات الهاتف الأخرى مؤقتًا. افصل المعدات الأخرى (مثل أجهزة الرد الآلي أو الكمبيوتر أو المودم أو مشترك خط الهاتف) بين الطابعة وخط الهاتف. قم بتعطيل ميزة انتظار المكالمة والبريد الصوتي. للحصول على المزيد من المعلومات، اتصل بشركة الهاتف. قم بمسح المستند الأصلي ضوئياً صفحة واحدة في كل مرة. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة الفاكس يتعذر إرسال الفاكسات أو استلامها باستخدام الفاكس التناظري يتعذر إرسال الفاكسات أو استلامها باستخدام الفاكس التناظري"},{"UUID":"e731f6f8-15f8-4348-b479-bcb17b64d6b1","title":"مشكلات الإرسال عبر الفاكس","link":"trb-caller-id-not-shown-topic.html","desc":"يمكن استلام الفاكسات لكن يتعذر","descFull":"يمكن استلام الفاكسات لكن يتعذر إرسالها باستخدام الفاكس التناظري يمكن استلام الفاكسات لكن يتعذر إرسالها باستخدام الفاكس التناظري حاول القيام بواحد أو أكثر من الإجراءات التالية: حمِّل مستند أصلي في درج وحدة تغذية المستندات التلقائية (ADF) أو على زجاج الماسحة الضوئية. إعداد رقم الاختصار بشكل صحيح. تحقق من تعيين رقم الاختصار إلى رقم الهاتف الذي تريد طلبه. اطلب رقم الهاتف يدوياً. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة الفاكس يتعذر إرسال الفاكسات باستخدام الفاكس التناظري يتعذر إرسال الفاكسات باستخدام الفاكس التناظري"},{"UUID":"4ee66e89-a032-4e56-9a11-fd67d70fd2bf","title":"مشكلات الإرسال عبر الفاكس","link":"trb-caller-id-not-shown-topic.html","desc":"يمكن إرسال الفاكسات لكن يتعذر","descFull":"يمكن إرسال الفاكسات لكن يتعذر استلامها باستخدام الفاكس التناظري يمكن إرسال الفاكسات لكن يتعذر استلامها باستخدام الفاكس التناظري حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من أنّ مصدر الورق غير فارغ. افحص إعدادات عدد رنات التأخير. من لوحة التحكم، انتقل إلى  الإعدادات الفاكس إعداد الفاكس إعدادات استلام الفاكس عدد الرنات قبل الرد . إذا كانت الطابعة تطبع صفحات فارغة، فراجع  . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة الفاكس يمكن إرسال الفاكسات لكن يتعذر استلامها باستخدام الفاكس التناظري يتعذر استلام الفاكسات باستخدام الفاكس التناظري"},{"UUID":"dd314a66-5b8b-4971-a8c0-e58aef1c93d6","title":"مشكلات الإرسال عبر الفاكس","link":"trb-caller-id-not-shown-topic.html","desc":"يتعذر إعداد etherFAX يتعذر إعداد","descFull":"يتعذر إعداد etherFAX يتعذر إعداد etherFAX حاول القيام بواحد أو أكثر من الإجراءات التالية : تحقق من اتصال الطابعة. من لوحة التحكم، انتقل إلى  الإعدادات التقارير الشبكة صفحة إعداد الشبكة . تحقق من حالة الشبكة على الصفحة المطبوعة. تأكد من اتصال الطابعة بشبكة اتصال ومن أن شبكة الاتصال متصلة بالإنترنت. تأكد من إعداد etherFAX بالشكل الصحيح. لمزيد من المعلومات، راجع  . إذا استمرت المشكلة، فانتقل إلى  https://www.etherfax.net/lexmark . مشكلة الفاكس يتعذر إعداد etherFAX يتعذر إعداد etherFAX"},{"UUID":"c12770de-6cf1-46fa-8333-7973aa4774de","title":"مشكلات الإرسال عبر الفاكس","link":"trb-caller-id-not-shown-topic.html","desc":"يتعذر إرسال الفاكسات أو استلامها","descFull":"يتعذر إرسال الفاكسات أو استلامها باستخدام etherFAX يتعذر إرسال الفاكسات أو استلامها باستخدام etherFAX حاول القيام بواحد أو أكثر من الإجراءات التالية : تأكد من اتصال الطابعة بشبكة اتصال ومن أن شبكة الاتصال متصلة بالإنترنت. تأكد من إعداد etherFAX بالشكل الصحيح. لمزيد من المعلومات، راجع  . قم بتقسيم المستندات الكبيرة إلى ملفات بأحجام أصغر. إذا استمرت المشكلة، فانتقل إلى  https://www.etherfax.net/lexmark . مشكلة الفاكس يتعذر إرسال الفاكسات أو استلامها باستخدام etherFAX يتعذر إرسال الفاكسات أو استلامها باستخدام etherFAX"},{"UUID":"eb53ef1f-b550-4bf4-a612-b6fc286160c7","title":"مشكلات الإرسال عبر الفاكس","link":"trb-caller-id-not-shown-topic.html","desc":"جودة طباعة فاكس رديئة جودة","descFull":"جودة طباعة فاكس رديئة جودة طباعة فاكس رديئة حاول القيام بواحد أو أكثر من الإجراءات التالية: قم بحل أي عيوب في جودة الطباعة. قم بطباعة  صفحات اختبار الجودة . من لوحة التحكم، انتقل إلى  الإعدادات استكشاف الأخطاء وإصلاحها صفحات اختبار جودة الطباعة . قم بتصحيح أي عيوب في جودة الطباعة. لمزيد من المعلومات، راجع  . إذا كنت تستخدم جهاز فاكس تناظريًا، فأخفض سرعة نقل الفاكس الوارد. من لوحة التحكم، انتقل إلى  الإعدادات الفاكس إعداد الفاكس  إعدادات استقبال الفاكس عناصر التحكم الخاصة بالمسؤول . في قائمة  أقصى سرعة  حدد سرعة أقل للإرسال. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة الفاكس جودة طباعة منخفضة جودة طباعة فاكس رديئة"},{"UUID":"ed8ac6dd-6a24-497f-9451-4292f4a8f5fe","title":"مشكلات الإرسال عبر الفاكس","link":"trb-caller-id-not-shown-topic.html","desc":"معلومات ناقصة في صفحة غلاف","descFull":"معلومات ناقصة في صفحة غلاف الفاكس معلومات ناقصة في صفحة غلاف الفاكس أوقف تشغيل الطابعة وانتظر مدة 10 ثوانٍ ثم أعِد تشغيلها. أرسل الفاكس أو قم باسترداده. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة الفاكس معلومات مفقودة على صفحة غلاف الفاكس معلومات مفقودة على صفحة غلاف الفاكس"},{"UUID":"54f3b586-6f4c-4d6f-bd18-cb809c0d5b35","title":"مشكلات الإرسال عبر الفاكس","link":"trb-caller-id-not-shown-topic.html","desc":"يتعذر إرسال صفحة غلاف الفاكس","descFull":"يتعذر إرسال صفحة غلاف الفاكس من الكمبيوتر يتعذر إرسال صفحة غلاف الفاكس من الكمبيوتر حاول القيام بواحد أو أكثر من الإجراءات التالية : تأكد من تحديث برنامج تشغيل الطباعة. للحصول على المزيد من المعلومات، انتقل إلى  www.lexmark.com/downloads . تأكد من تحديث برنامج تشغيل الطباعة. لمزيد من المعلومات، اتصل بالمكان الذي اشتريت منه الطابعة. تأكد من تحديث برنامج تشغيل الطباعة، ثم قم بإرسال الفاكس. لمزيد من المعلومات، اتصل  بالوكيل الخاص بك . امسح إعداد  عرض الإعدادات دائمًا قبل إرسال الفاكس . افتح مربع الحوار  طباعة  من المستند الذي تحاول إرساله عبر الفاكس. حدد الطابعة، ثم انقر فوق  خصائص  أو  تفضيلات  أو  خيارات  أو  إعداد . انقر فوق  الفاكس ، ثم امسح إعداد  عرض الإعدادات دائماً قبل الإرسال عبر الفاكس . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة الفاكس يتعذَّر إرسال صفحة غلاف الفاكس من الكمبيوتر يتعذَّر إرسال صفحة غلاف الفاكس من الكمبيوتر"},{"UUID":"579b5cd9-7dd5-49d9-8255-54b4239c39c9","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"يتعذر جارٍ المسح الضوئي إلى","descFull":"يتعذر جارٍ المسح الضوئي إلى كمبيوتر حاول القيام بواحد أو أكثر من الإجراءات التالية: قم بإجراء مهمة نسخ. إذا فشلت المهمة، فأوقف تشغيل الطابعة، وانتظر لمدة 10 ثوانٍ تقريبًا، ثم قم بتشغيل الطابعة. تحقق من اتصال الطابعة. طباعة  صفحة إعداد شبكة الاتصال . من لوحة التحكم, انتقل إلى  الإعدادات التقارير شبكة الاتصال ، ومن ثم حدد  صفحة إعداد شبكة الاتصال . تأكد من القسم الأول من الصفحة وتأكد من أن الحالة متصلة. تأكد من أن الطابعة والكمبيوتر متصلَين بشبكة الاتصال نفسها. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة المسح الضوئي يتعذر جارٍ المسح الضوئي إلى كمبيوتر يتعذر جارٍ المسح الضوئي إلى كمبيوتر"},{"UUID":"11281f94-44b9-49c3-b3f6-e214f288f0ea","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"يتعذر جارٍ المسح الضوئي إلى","descFull":"يتعذر جارٍ المسح الضوئي إلى مجلد شبكة حاول القيام بواحد أو أكثر من الإجراءات التالية: قم بإنشاء اختصار لمجلد الشبكة، ثم قم بمسح مستند ضوئيًا باستخدام الاختصار. لمزيد من المعلومات، راجع  . تأكد من صحة مسار مجلد الشبكة وتنسيقه. على سبيل المثال،  // server_hostname /foldername/path حيث  server_hostname  هو مجال مؤهل بالكامل (FQDN) أو عنوان IP. تأكد من أن لديك إذن وصول للكتابة إلى مجلد الشبكة. يمكنك تحديث اختصار مجلد شبكة الاتصال. افتح متصفح ويب، ثم اكتب عنوان IP الخاص بالطابعة في حقل العنوان. اعرض عنوان IP للطابعة على الشاشة الرئيسية للطابعة. ويتم عرض عنوان IP في أربع مجموعات من الأرقام المفصولة بنقاط على النحو 123.123.123.123. إذا كنت تستخدم خادم وكيل، فقم بتعطيله مؤقتًا لتحميل صفحة الويب بشكل صحيح. انقر فوق  الاختصارات ، ومن ثم حدد اختصارًا. إذا كان لديك أنواع اختصارات متعددة، فحدد  مجلد الشبكة . في الحقل مسار المشاركة، اكتب مسار مجلد شبكة الاتصال. على سبيل المثال،  \\\\server_hostname\\foldername\\path . استخدم دائمًا الخطوط المائلة للأمام عند كتابة مسار المشاركة. من القائمة  المصادقة  حدد طريقة المصادقة. إذا تم تعيين  المصادقة  إلى \" استخدام اسم المستخدم وكلمة المرور المعيّنَين ، فاكتب بيانات الاعتماد في الحقلين. انقر فوق  حفظ . تأكد من أن الطابعة ومجلد شبكة الاتصال متصلَين بشبكة الاتصال نفسها. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . يتعذر جارٍ المسح الضوئي إلى مجلد شبكة الاتصال مشكلة المسح الضوئي يتعذر جارٍ المسح الضوئي إلى مجلد شبكة الاتصال"},{"UUID":"dea239ec-769c-4446-917e-38965bec13e4","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"نسخ جزئية لمستند أو صورة","descFull":"نسخ جزئية لمستند أو صورة فوتوغرافية حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من تحميل المستند أو الصورة الفوتوغرافية على زجاج الماسحة الضوئية في الركن الأيسر العلوي بحيث يكون الوجه لأسفل. طابق إعداد حجم الورق مع الورق الذي تم تحميله في الدرج. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة النسخ النُسخ الجزئية للمستندات مشكلة النسخ النُسخ الجزئية للصور الفوتوغرافية نسخ جزئية لمستندات أو صور فوتوغرافية مشكلة المسح الضوئي النُسخ الجزئية للمستندات مشكلة المسح الضوئي النُسخ الجزئية للصور الفوتوغرافية"},{"UUID":"7926bc98-6717-4edf-a472-fbe498fc3a85","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"جودة نسخ رديئة حاول القيام","descFull":"جودة نسخ رديئة حاول القيام بواحد أو أكثر من الإجراءات التالية: نظف زجاج الماسحة الضوئية وزجاجة وحدة تغذية المستندات التلقائية بواسطة قطعة قماش مبللة وناعمة وخالية من الوبر. إذا كانت طابعتك تحتوي على زجاج ثانٍ لوحدة تغذية المستندات التلقائية (ADF) داخل وحدة تغذية المستندات التلقائية (ADF)، فنظف ذلك الزجاج أيضًا. لمزيد من المعلومات، راجع  . تأكد من تحميل المستند أو الصورة الفوتوغرافية على زجاج الماسحة الضوئية في الركن الأيسر العلوي بحيث يكون الوجه لأسفل. تحقق من جودة المستند أو الصورة الفوتوغرافية الأصلية واضبط إعدادات جودة المسح الضوئي وفقًا لذلك. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة النسخ جودة النسخ رديئة جودة النسخ رديئة مشكلة المسح الضوئي جودة النسخ رديئة جودة المسح رديئة"},{"UUID":"c0781ac0-8890-4be3-b416-fa10b17d846b","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"ظهور خطوط رأسية داكنة عند","descFull":"ظهور خطوط رأسية داكنة عند المسح الضوئي من وحدة تغذية المستندات التلقائية (ADF). ارفع غطاء الماسحة الضوئية، ثم قم بإزالة أداة تنظيف الزجاج. امسح زجاج وحدة التغذية التلقائية للمستندات (ADF) بجوار زجاج الماسحة الضوئية. افتح الباب A1، ثم قم بتنظيف زجاج وحدة تغذية المستندات التلقائية (ADF). أعد الأداة إلى مكانها. أغلق غطاء الماسحة الضوئية. لمزيد من المعلومات حول تنظيف الماسح الضوئي، راجع  . إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة المسح الضوئي خطوط رأسية داكنة على الإخراج عند المسح الضوئي من وحدة تغذية المستندات التلقائية (ADF) خطوط رأسية داكنة على الإخراج عند المسح الضوئي من وحدة تغذية المستندات التلقائية (ADF) مشكلة في جودة المسح الضوئي"},{"UUID":"cbbeb683-3350-469a-8fd4-91b822540669","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"صورة غير مستقيمة أو نص","descFull":"صورة غير مستقيمة أو نص غير مستقيم عند المسح الضوئي من وحدة تغذية المستندات التلقائية صورة غير مستقيمة أو نص غير مستقيم عند المسح الضوئي من وحدة تغذية المستندات التلقائية قم بتحميل 50 ورقة عادية ونظيفة في وحدة تغذية المستندات التلقائية. يساعد الورق العادي في تنظيف أسطوانات التغذية لوحدة تغذية المستندات التلقائية أو في إزالة الغبار أو المواد الأخرى التي تغطّيها عنها. من لوحة التحكم، اسحب لليمين إلى مركز التحكم، ثم حدد  . قم بتحميل مستند أصلي في وحدة تغذية المستندات التلقائية. امسح المستند ضوئيًا. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة المسح الضوئي صورة غير مستقيمة مشكلة المسح الضوئي نص غير مستقيم استكشاف الأخطاء وإصلاحها صورة غير مستقيمة من المسح الضوئي لـ ADF استكشاف الأخطاء وإصلاحها نص غير مستقيم من المسح الضوئي لـ ADF صورة غير مستقيمة من المسح الضوئي لـ ADF نص غير مستقيم من المسح الضوئي لـ ADF"},{"UUID":"b60a9c1f-9bb7-47ee-a292-5536ceeac498","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"لم تتم عملية المسح الضوئي","descFull":"لم تتم عملية المسح الضوئي بنجاح لم تتم عملية المسح الضوئي بنجاح حاول القيام بواحد أو أكثر من الإجراءات التالية: تأكد من توصيل كابل Ethernet أو كابل USB بالكمبيوتر والطابعة بإحكام. تحقق من الملف الذي تريد مسحه ضوئيًا، وتأكد مما يلي: أن اسم الملف غير مستخدم مسبقًا في المجلد الوجهة. أن المستند أو الصورة الفوتوغرافية التي تريد مسحها ضوئيًا غير مفتوحة في تطبيق آخر. تأكد من تحديد مربع الاختيار  إلحاق طابع التاريخ  أو  استبدال الملف الموجود  في إعدادات التهيئة للوجهة. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة المسح الضوئي لم تتم مهمة المسح الضوئي بنجاح لم تتم مهمة المسح الضوئي بنجاح استكشاف الأخطاء وإصلاحها لم تتم مهمة المسح الضوئي بنجاح"},{"UUID":"d0c048f1-63e8-465e-9d7d-c9ac787cd059","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"الماسحة الضوئية لا تغلق الماسحة","descFull":"الماسحة الضوئية لا تغلق الماسحة الضوئية لا تغلق أزل العوائق التي تبقي غطاء الماسحة الضوئية مفتوحًا. أغلق الماسحة الضوئية. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة المسح الضوئي الماسحة الضوئية لا تغلق الماسحة الضوئية لا تغلق"},{"UUID":"73914b92-608f-46b9-af41-22ec9c1a9823","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"يستغرق المسح الضوئي وقتًا طويلاً","descFull":"يستغرق المسح الضوئي وقتًا طويلاً أو يقوم بتعطيل الكمبيوتر يستغرق المسح الضوئي وقتًا طويلاً أو يقوم بتعطيل الكمبيوتر أغلق كل التطبيقات التي تتداخل مع المسح الضوئي. قم بمسح المستند ضوئيًا مرة أخرى. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة المسح الضوئي المسح الضوئي يستغرق وقتً طويلاً مشكلة المسح الضوئي يعطّل المسح الضوئي الكمبيوتر يستغرق المسح الضوئي وقتًا طويلاً أو يقوم بتعطيل الكمبيوتر"},{"UUID":"17d4aa85-739a-47ae-8d48-1e6ac16ae109","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"الماسحة الضوئية لا تستجيب الماسحة","descFull":"الماسحة الضوئية لا تستجيب الماسحة الضوئية لا تستجيب حاول القيام بواحد أو أكثر من الإجراءات التالية: تحقق من توصيل سلك التيار بشكل صحيح بالطابعة ومأخذ التيار الكهربائي. لتجنب خطر الحريق أو التعرض لصدمة الكهربائية، قم بتوصيل سلك الطاقة بمأخذ للتيار الكهربائي مصنّف بشكل ملائم وموصَل أرضيًا بطريقة صحيحة وقريب من المنتج ويسهل الوصول إليه. تحقق مما إذا كانت الطابعة قيد التشغيل، ثم قم بحل أي رسائل خطأ تظهر على الشاشة. أوقف تشغيل الطابعة وانتظر مدة 10 ثوانٍ ثم أعِد تشغيلها. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة النسخ الماسحة الضوئية لا تستجيب مشكلة المسح الضوئي الماسحة الضوئية لا تستجيب الماسحة الضوئية لا تستجيب"},{"UUID":"33c0e8ce-9260-4fcf-896b-ba9f3ce33689","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"ضبط تسجيل الماسحة الضوئية ضبط","descFull":"ضبط تسجيل الماسحة الضوئية ضبط تسجيل الماسحة الضوئية من لوحة التحكم، انتقل إلى  الإعدادات Device الصيانة قائمة التهيئة تهيئة الماسحة الضوئية تسجيل دليل الماسح الضوئي . من قائمة  طباعة الاختبار السريع  حدد  البدء . ضع صفحة الاختبار على زجاج الماسحة الضوئية، ثم حدد  التسجيل المسطّح . من قائمة  نسخ الاختبار السريع  حدد  البدء . قارن صفحة الاختبار بالمستند الأصلي. إذا اختلفت هوامش صفحة الاختبار عن المستند الأصلي، فاضبط إعدادات  الهامش الأيسر الأفقي  و الهامش العلوي . كرر   و  إلى حين تطابق هوامش الصفحة  نسخ الاختبار السريع  مع المستند الأصلي إلى حد بعيد. ضبط تسجيل الماسحة الضوئية"},{"UUID":"f7b79da0-148b-44dc-b7e3-93748f6eb7c5","title":"مشكلات المسح الضوئي","link":"trb-cannot-scan-to-computer-topic.html","desc":"ضبط تسجيل وحدة تغذية المستندات","descFull":"ضبط تسجيل وحدة تغذية المستندات التلقائية (ADF) من لوحة التحكم، انتقل إلى  الإعدادات Device الصيانة قائمة التهيئة تهيئة الماسحة الضوئية تسجيل دليل الماسح الضوئي . من قائمة  طباعة الاختبار السريع  حدد  البدء . ضع صفحة الاختبار على درج وحدة تغذية المستندات التلقائية (ADF). المس  تسجيل وحدة تغذية المستندات التلقائية (ADF) في الأمام  أو  تسجيل وحدة تغذية المستندات التلقائية (ADF) في الخلف . لمحاذاة  تسجيل وحدة تغذية المستندات التلقائية (ADF) في الأمام ، ضع صفحة الاختبار مع توجيه وجهها لأعلى وإدخال الحافة القصيرة أولاً في وحدة تغذية المستندات التلقائية (ADF). لمحاذاة  تسجيل وحدة تغذية المستندات التلقائية (ADF) في الخلف ، ضع صفحة الاختبار مع توجيه وجهها لأسفل وإدخال الحافة القصيرة أولاً في وحدة تغذية المستندات التلقائية (ADF). من قائمة  نسخ الاختبار السريع  حدد  البدء . قارن صفحة الاختبار بالمستند الأصلي. إذا اختلفت هوامش صفحة الاختبار عن المستند الأصلي، فاضبط إعدادات  الضبط الأفقي  و الهامش العلوي . كرر   و  إلى حين تطابق هوامش الصفحة  نسخ الاختبار السريع  مع المستند الأصلي إلى حد بعيد. تسجيل وحدة تغذية المستندات التلقائية (ADF) ضبط ضبط تسجيل وحدة تغذية المستندات التلقائية (ADF)"},{"UUID":"ffde0bc2-4350-4e53-b4cb-92cc7b0b7be4","title":"مشكلات جودة الألوان","link":"modifying-colors-in-printed-output-topic.html","desc":"تعديل الألوان في المخرجات المطبوعة","descFull":"تعديل الألوان في المخرجات المطبوعة من لوحة التحكم انتقل إلى  الإعدادات الطباعة الجودة التصوير المتقدم تصحيح اللون . في قائمة  تصحيح الألوان  حدد  يدوي . في قائمة  محتوى تصحيح الألوان  حدد إعداد تحويل اللون المناسب. أنواع كائنات قائمة الألوان اليدوية وجداول تحويل الألوان الخاصة بها نوع الكائن جداول تحويل الألوان صورة RGB نص RGB رسومات RGB مشرقة — تنتج ألوانًا ساطعة وأكثر تشبعًا ومن الممكن تطبيقها على كافة تنسيقات الألوان الجديدة. عرض sRGB  — لإنتاج مطبوعات ذات ألوان تشبه الألوان المعروضة على شاشة عرض كمبيوتر. تم تحسين استخدام مسحوق الحبر الأسود لطباعة الصور الفوتوغرافية. عرض-أسود خالص  — لإنتاج مطبوعات ذات ألوان تشبه الألوان المعروضة على شاشة عرض كمبيوتر. يستخدم هذا الإعداد مسحوق الحبر الأسود فقط لإنتاج جميع درجات اللون الرمادي المحايد. sRGB Vivid —يوفر درجة متزايدة من تشبع الألوان لتصحيح ألوان  sRGB Display . يتم تحسين استخدام مسحوق الحبر الأسود لطباعة الرسومات التجارية. إيقاف صورة CMYK نص CMYK رسومات CMYK CMYK الولايات المتحدة —لتطبيق تصحيح الألوان لتقريب مخرجات ألوان مواصفات النشر لإزاحة ويب (SWOP). CMYK أوروبا —لتطبيق تصحيح الألوان لتقريب مخرجات ألوان EuroScale. CMYK مشرقة —يعمل على زيادة تشبع اللون لإعداد تصحيح الألوان  US CMYK . إيقاف تعديل إخراج الألوان تصحيح الألوان يدويًا تصحيح الألوان"},{"UUID":"111b1815-dac4-4337-a198-850f07ac0e02","title":"مشكلات جودة الألوان","link":"modifying-colors-in-printed-output-topic.html","desc":"الأسئلة المتكررة حول الطباعة بالألوان","descFull":"الأسئلة المتكررة حول الطباعة بالألوان ما المقصود بلون RGB؟ يُعد لون RGB وسيلة لوصف الألوان من خلال الإشارة إلى المقدار المستخدم من اللون الأحمر أو الأخضر أو الأزرق لإنتاج لون محدد. يمكن دمج ألوان الأحمر والأخضر والأزرق بكميات مختلفة لإنتاج مجموعة كبيرة من الألوان الموجودة في الطبيعة. تستخدم شاشات الكمبيوتر والماسحات الضوئية والكاميرات الرقمية هذه الوسيلة لعرض الألوان. ما المقصود بلون CMYK؟ يُعد لون CMYK وسيلة لوصف الألوان من خلال الإشارة إلى المقدار المستخدم من ألوان السماوي والأرجواني والأصفر والأسود لإنتاج لون محدد. يمكن طباعة أحبار أو أحبار CMYK بكميات مختلفة لإنتاج مجموعة كبيرة من الألوان التي يمكن ملاحظتها في الطبيعة. تتبع آلات الطباعة وطابعات ضخ الحبر وطابعات الليزر الألوان هذا الأسلوب لإنتاج الألوان.  كيف يمكن طباعة اللون المحدد في المستند؟ تُستخدم البرامج لتحديد الألوان في المستند وتعديلها باستخدام مجموعات ألوان RGB أو CMYK. للمزيد من المعلومات، انظر موضوعات التعليمات الخاصة بالبرنامج. كيف تحدد الطابعة اللون المطلوب طباعته؟ عند طباعة أحد المستندات، يتم إرسال المعلومات الخاصة بنوع ولون كل كائن إلى الطابعة. ثم يتم تمرير المعلومات من خلال جداول تحويل الألوان. تتم ترجمة اللون إلى الكميات المناسبة من أحبار CMYK المستخدمة لإنتاج اللون الذي تريده. تحدد معلومات الكائن طريقة تطبيق جداول تحويل الألوان. على سبيل المثال، يمكن تطبيق نوع واحد من جداول تحويل الألوان على النص أثناء تطبيق جدول تحويل ألوان مختلف على الصور الفوتوغرافية. ما المقصود بتصحيح الألوان يدويًا؟ في حالة تمكين تصحيح الألوان يدويًا، تستخدم الطابعة جداول تحويل الألوان المحددة من قِبل المستخدم لمعالجة الكائنات. إعدادات تصحيح الألوان يدويًا خاصة لنوع الكائن الذي تتم طباعته (نص أو رسومات أو صور)، كما أنها خاصة لكيفية تحديد لون الكائن في البرنامج (مجموعات ألوان RGB أو CMYK). لتطبيق جدول تحويل ألوان مختلف يدويًا، راجع  . إذا لم يحدد البرنامجُ الألوانَ من مجموعات ألوان RGB أو CMYK، فلن يكون تصحيح الألوان يدويًا مفيدًا. كما أنه لن يكون فعالاً إذا كان البرنامج أو نظام تشغيل الكمبيوتر يتحكّم في ضبط الألوان. في معظم الحالات، يؤدي ضبط تصحيح الألوان على \"تلقائي\" إلى إنشاء ألوان مفضّلة للمستندات. كيف يمكن مطابقة لون محدد (شعار إحدى الشركات مثلاً)؟ من قائمة  الجودة  بالطابعة يتوفر تسعة أنواع من مجموعات  نماذج الألوان . تتوفر أيضًا هذه المجموعات من صفحة  نماذج الألوان  في Embedded Web Server. يؤدي تحديد أي مجموعة نماذج إلى إنشاء مطبوعات متعددة الصفحات تحتوي على المئات من المربعات الملونة. يحتوي كل مربع على مجموعة ألوان CMYK أو RGB بحسب الجدول المحدد. يتم الحصول على الألوان الموجودة في كل مربع ألوان بتمرير مجموعة ألوان CMYK أو RGB المسماة على المربع. من خلال فحص مجموعات  نماذج الألوان  يمكنك تحديد المربع الذي يحتوي على اللون الأقرب إلى اللون الذي تتم مطابقته. يمكن استخدام مجموعة الألوان الموجودة على ملصق العلبة لتعديل لون الكائن في أحد البرامج. للمزيد من المعلومات، انظر موضوعات التعليمات الخاصة بالبرنامج. قد يكون تصحيح الألوان يدويًا ضروريًا لاستخدام جدول تحويل الألوان المحدد للكائن المعين. يتوقف تحديد مجموعة  نماذج الألوان  التي يجب استخدامها لمشكلة معينة تتعلق بمطابقة الألوان على: إعداد  تصحيح الألوان  الذي يتم استخدامه ( تلقائيًا  أو  إيقاف ، أو  يدويًا ). نوع الكائن الذي تتم طباعته (نص أو رسومات أو صور). كيفية تحديد لون الكائن في البرنامج (مجموعات ألوان RGB أو CMYK). إذا لم يحدد البرنامجُ الألوانَ من مجموعات ألوان RGB أو CMYK، فلن تكون صفحات  نماذج الألوان  مفيدة. تضبط بعض البرامج مجموعات ألوان RGB أو CMYK المحددة في البرنامج عبر إدارة الألوان. في هذه الحالات، قد لا يكون اللون المطبوع مطابقًا تمامًا لصفحات  نماذج الألوان . مشكلة جودة الألوان الأسئلة المتكررة حول الطباعة بالألوان طباعة الألوان تصحيح الألوان نماذج الألوان"},{"UUID":"30364793-3074-442f-84d7-2f69c85fcffe","title":"مشكلات جودة الألوان","link":"modifying-colors-in-printed-output-topic.html","desc":"مخرجات الطباعة تبدو خفيفة اللون","descFull":"مخرجات الطباعة تبدو خفيفة اللون مخرجات الطباعة تبدو خفيفة اللون حاول القيام بواحد أو أكثر من الإجراءات التالية: من لوحة التحكم انتقل إلى  الإعدادات Print الجودة التصوير المتقدم ثم حدد  ضبط اللون . من لوحة التحكم، انتقل إلى  الإعدادات الطباعة الجودة التصوير المتقدم ، حدد  ضبط توازن الألوان  وضبط الإعدادات. إذا استمرت المشكلة، اتصل  دعم العملاء . إذا استمرت المشكلة، اتصل  بالوكيل الخاص بك . مشكلة جودة الألوان مخرجات الطباعة تبدو خفيفة اللون مخرجات الطباعة تبدو خفيفة اللون استكشاف الأخطاء وإصلاحها مخرجات الطباعة تبدو خفيفة اللون"},{"UUID":"58d51022-5a10-498f-a9dd-5e6326fd4d12","title":"استكشاف مشكلة وإصلاحها","link":"trb-contacting-customer-support-topic.html","desc":"الاتصال بخدمة دعم العملاء الاتصال","descFull":"الاتصال بخدمة دعم العملاء الاتصال بخدمة دعم العملاء قبل الاتصال بدعم العملاء، احرص على أن تكون المعلومات التالية متوفرة لديك: مشكلة الطابعة رسالة الخطأ نوع طراز الطابعة ورقمها التسلسلي انتقل إلى  https://support.lexmark.com  لتلقي الدعم عبر البريد الإلكتروني أو الدردشة، أو تصفح مكتبة الأدلة ووثائق الدعم وبرامج التشغيل والتنزيلات الأخرى. الدعم الفني عبر الهاتف متوفر أيضًا. في الولايات المتحدة أو كندا، اتصل على 6275-539-800-1. بالنسبة إلى الدول أو المناطق الأخرى، انتقل إلى  دليل الاتصال للدعم الدولي . اتصل بالمكان الذي قمت بشراء الطابعة منه. الاتصال بـ \"مركز دعم العملاء\" دعم العملاء"},{"UUID":"7cdd27b3-72b0-4876-b919-dda5687afb8d","title":"استكشاف مشكلة وإصلاحها","link":"troubleshooting-chapter.html","desc":"الاتصال بالوكيل قبل الاتصال بالوكيل،","descFull":"الاتصال بالوكيل قبل الاتصال بالوكيل، احرص على أن تكون المعلومات الآتية متوفرة لديك: مشكلة الطابعة رسالة الخطأ نوع طراز الطابعة ورقمها التسلسلي الاتصال بالوكيل وكيل الطابعة"},{"UUID":"29f32160-3f1e-4712-88a2-a5e4b4d31eb8","title":"استكشاف مشكلة وإصلاحها","link":"troubleshooting-chapter.html","desc":"الاتصال بالدعم الفني عند الاتصال","descFull":"الاتصال بالدعم الفني عند الاتصال بالدعم الفني، صف المشكلة والرسالة التي تظهر على شاشة الطابعة وخطوات استكشاف الأخطاء وإصلاحها التي اتخذتها بالفعل. انظر الملصق الموجود داخل الغطاء الأمامي العلوي أو الموجود على ظهر الطابعة، ومن ثم دوِّن التالي: طراز الطابعة رقم رمز الخدمة أو رمز الخدمة السريعة لمزيد من المعلومات، انتقل إلى موقع الويب  www.dell.com/support . استكشاف الأخطاء وإصلاحها الاتصال بالدعم الفني الاتصال بالدعم الفني"},{"UUID":"f749e4a1-8fcf-4bb5-8349-4fc73934e2be","title":"إعادة التدوير والتخلص من المستلزمات","link":"recycling-lexmark-products-topic.html","desc":"إعادة تدوير منتجات Lexmark إعادة","descFull":"إعادة تدوير منتجات Lexmark إعادة تدوير منتجات Lexmark انتقل إلى  www.lexmark.com/recycle . حدد البلد أو المنطقة. حدد برنامج إعادة التدوير. منتجات إعادة التدوير"},{"UUID":"42296c4f-0fd1-45d0-a5cf-9d0d2eb58673","title":"إعادة التدوير والتخلص من المستلزمات","link":"recycling-lexmark-packaging-topic.html","desc":"إعادة تدوير مواد تغليف Lexmark","descFull":"إعادة تدوير مواد تغليف Lexmark إعادة تدوير مواد تغليف Lexmark تسعى Lexmark دائمًا إلى تخفيف مواد التغليف. ومواد تغليف أقل تعني أنه يتم نقل طابعات Lexmark بأكثر طريقة فعالة وملائمة للبيئة وأنه سيكون هناك مواد تغليف أقل للتخلص منها. كنتيجة لهذه الإجراءات، تنخفض الانبعاثات المسببة للاحتباس الحراري ويتم توفير الطاقة والموارد الطبيعية. بالإضافة إلى ذلك، توفّر Lexmark إمكانية إعادة تدوير مكونات مواد التغليف في بعض الدول أو المناطق. للحصول على المزيد من المعلومات، انتقل إلى  www.lexmark.com/recycle . المواد الكرتونية من Lexmark قابلة لإعادة التدوير بنسبة 100% حيث يوجد منشآت إعادة تدوير متخصصة. قد لا يكون هناك منشآت في المنطقة التي تتواجد فيها. الفلّين المستخدَم في مواد تغليف Lexmark قابل لإعادة التدوير حيث يوجد منشآت إعادة تدوير للفلّين. قد لا يكون هناك منشآت في المنطقة التي تتواجد فيها.  عند إرجاع خرطوشة إلى Lexmark، يمكنك إعادة استخدام العلبة التي جاءت بها الخرطوشة. وتقوم Lexmark بإعادة تدوير العلبة. إعادة تدوير المنتج مواد التغليف"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n     ×\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n      ("+_vm._s(_vm.resultsCount)+") Results Found\n     ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n      No Results Found\n     ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n      "+_vm._s(result.title)+"\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n     "+_vm._s(result.desc)+"\n    ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"CX833، CX961، CX962، CX963، XC8355، XC9635، XC9645، XC9655 الطابعات متعددة الوظائف"}},[_vm._v("\n     CX833، CX961، CX962، CX963، XC8355، XC9635، XC9645، XC9655 الطابعات متعددة الوظائف\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_ar","title":"معلومات السلامة"}},[_vm._v("\n     معلومات السلامة\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":".html#d0e23","title":"مصطلحات متفق عليها"}},[_vm._v("\n      مصطلحات متفق عليها\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e43","title":"بيانات عن المنتج"}},[_vm._v("\n      بيانات عن المنتج\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_ar","title":"التعرّف على الطابعة"}},[_vm._v("\n     التعرّف على الطابعة\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e221"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_ar","title":"العثور على معلومات عن الطابعة"}},[_vm._v("\n      العثور على معلومات عن الطابعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_ar","title":"العثور على الرقم التسلسلي للطابعة"}},[_vm._v("\n      العثور على الرقم التسلسلي للطابعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_ar","title":"مواصفات الطابعة"}},[_vm._v("\n      مواصفات الطابعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_ar","title":"استخدام لوحة التحكم"}},[_vm._v("\n      استخدام لوحة التحكم\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"using-home-screen-topic.html#using-home-screen_ar","title":"رموز الشاشة الرئيسية"}},[_vm._v("\n      رموز الشاشة الرئيسية\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"colors-of-indicator-light-topic.html#colors-of-indicator-light_ar","title":"ألوان ضوء المؤشر"}},[_vm._v("\n      ألوان ضوء المؤشر\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_ar","title":"استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية"}},[_vm._v("\n      استخدام وحدة تغذية المستندات التلقائية وزجاج الماسحة الضوئية\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_ar","title":"تحديد موقع فتحة الأمان"}},[_vm._v("\n      تحديد موقع فتحة الأمان\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"paper-guidelines-topic.html#d0e769","title":"تحديد نوع الورق"}},[_vm._v("\n      تحديد نوع الورق\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"supported-applications-topic.html#d0e10635","title":"ميزات الإضافية للطابعة والدعم"}},[_vm._v("\n      ميزات الإضافية للطابعة والدعم\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ar","title":"الإعداد والتثبيت والتهيئة"}},[_vm._v("\n     الإعداد والتثبيت والتهيئة\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10762"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_ar","title":"تحديد موقع للطابعة"}},[_vm._v("\n      تحديد موقع للطابعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printer-ports-topic.html#printer-ports_ar","title":"منافذ الطابعة"}},[_vm._v("\n      منافذ الطابعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"setting-up-scan-center-topic.html#d0e10961","title":"تهيئة التطبيقات والحلول"}},[_vm._v("\n      تهيئة التطبيقات والحلول\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e11138","title":"إعداد ميزات إمكانية الوصول واستخدامها"}},[_vm._v("\n      إعداد ميزات إمكانية الوصول واستخدامها\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e11443","title":"إعداد الطابعة للإرسال عبر الفاكس"}},[_vm._v("\n      إعداد الطابعة للإرسال عبر الفاكس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"loading-trays-group.html#loading-trays-group_ar","title":"تحميل الورق والوسائط الخاصة"}},[_vm._v("\n      تحميل الورق والوسائط الخاصة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e12239","title":"تثبيت البرامج وبرامج التشغيل والبرنامج الثابت وتحديثها"}},[_vm._v("\n      تثبيت البرامج وبرامج التشغيل والبرنامج الثابت وتحديثها\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"installing-optional-550-sheet-tray-topic.html#d0e12565","title":"تركيب الوحدات الاختيارية للجهاز"}},[_vm._v("\n      تركيب الوحدات الاختيارية للجهاز\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"connecting-printer-to-wireless-network-topic.html#d0e14096","title":"التوصيل عبر شبكة اتصال"}},[_vm._v("\n      التوصيل عبر شبكة اتصال\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_ar","title":"تأمين الطابعة"}},[_vm._v("\n     تأمين الطابعة\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14448"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_ar","title":"محو ذاكرة الطابعة"}},[_vm._v("\n      محو ذاكرة الطابعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_ar","title":"مسح محرك أقراص تخزين الطابعة"}},[_vm._v("\n      مسح محرك أقراص تخزين الطابعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ar","title":"استعادة إعدادات المصنع الافتراضية"}},[_vm._v("\n      استعادة إعدادات المصنع الافتراضية\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_ar","title":"بيان الذاكرة"}},[_vm._v("\n      بيان الذاكرة\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_ar","title":"طباعة"}},[_vm._v("\n     طباعة\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14640"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printing-from-computer-topic.html#printing-from-computer_ar","title":"الطباعة من كمبيوتر"}},[_vm._v("\n      الطباعة من كمبيوتر\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14691","title":"الطباعة من جهاز محمول"}},[_vm._v("\n      الطباعة من جهاز محمول\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_ar","title":"الطباعة من محرك أقراص فلاش"}},[_vm._v("\n      الطباعة من محرك أقراص فلاش\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ar","title":"تهيئة المهام السرية"}},[_vm._v("\n      تهيئة المهام السرية\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ar","title":"طباعة المهام السرية والمهام المحجوزة الأخرى"}},[_vm._v("\n      طباعة المهام السرية والمهام المحجوزة الأخرى\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printing-font-sample-list-topic.html#printing-font-sample-list_ar","title":"طباعة قائمة نماذج الخطوط"}},[_vm._v("\n      طباعة قائمة نماذج الخطوط\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printing-directory-list-topic.html#printing-directory-list_ar","title":"طباعة قائمة الأدلة"}},[_vm._v("\n      طباعة قائمة الأدلة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_ar","title":"وضع أوراق فاصلة في مهام الطباعة"}},[_vm._v("\n      وضع أوراق فاصلة في مهام الطباعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_ar","title":"إلغاء مهمة طباعة"}},[_vm._v("\n      إلغاء مهمة طباعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ar","title":"ضبط قتامة مسحوق الحبر"}},[_vm._v("\n      ضبط قتامة مسحوق الحبر\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_ar","title":"النسخ"}},[_vm._v("\n     النسخ\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15186"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_ar","title":"إنشاء النُسخ"}},[_vm._v("\n      إنشاء النُسخ\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_ar","title":"نسخ الصور الفوتوغرافية"}},[_vm._v("\n      نسخ الصور الفوتوغرافية\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"copying-on-letterhead-topic.html#copying-on-letterhead_ar","title":"النسخ على الورق ذي الرأسية"}},[_vm._v("\n      النسخ على الورق ذي الرأسية\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_ar","title":"النسخ على وجهَي الورقة"}},[_vm._v("\n      النسخ على وجهَي الورقة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_ar","title":"تصغير أو تكبير النُسخ"}},[_vm._v("\n      تصغير أو تكبير النُسخ\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_ar","title":"ترتيب النُسخ"}},[_vm._v("\n      ترتيب النُسخ\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_ar","title":"وضع أوراق فاصلة بين النُسخ"}},[_vm._v("\n      وضع أوراق فاصلة بين النُسخ\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_ar","title":"طباعة عدة صفحات على ورقة واحدة"}},[_vm._v("\n      طباعة عدة صفحات على ورقة واحدة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_ar","title":"نسخ البطاقات"}},[_vm._v("\n      نسخ البطاقات\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_ar","title":"إنشاء اختصار نسخة"}},[_vm._v("\n      إنشاء اختصار نسخة\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_ar","title":"البريد الإلكتروني"}},[_vm._v("\n     البريد الإلكتروني\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15459"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"configuring-smtp-settings-topic.html#configuring-smtp-settings_ar","title":"تهيئة إعدادات SMTP"}},[_vm._v("\n      تهيئة إعدادات SMTP\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_ar","title":"إرسال بريد إلكتروني"}},[_vm._v("\n      إرسال بريد إلكتروني\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_ar","title":"إنشاء اختصار بريد إلكتروني"}},[_vm._v("\n      إنشاء اختصار بريد إلكتروني\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_ar","title":"الفاكس"}},[_vm._v("\n     الفاكس\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e16908"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_ar","title":"إرسال فاكس"}},[_vm._v("\n      إرسال فاكس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_ar","title":"جدولة فاكس"}},[_vm._v("\n      جدولة فاكس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_ar","title":"إنشاء اختصار وجهة الفاكس"}},[_vm._v("\n      إنشاء اختصار وجهة الفاكس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_ar","title":"تغيير دقة الفاكس"}},[_vm._v("\n      تغيير دقة الفاكس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_ar","title":"ضبط قتامة الفاكس"}},[_vm._v("\n      ضبط قتامة الفاكس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_ar","title":"طباعة سجل الفاكس"}},[_vm._v("\n      طباعة سجل الفاكس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_ar","title":"منع استلام الفاكسات غير المرغوب فيها"}},[_vm._v("\n      منع استلام الفاكسات غير المرغوب فيها\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_ar","title":"إيقاف رسائل الفاكس"}},[_vm._v("\n      إيقاف رسائل الفاكس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_ar","title":"إعادة توجيه الفاكس"}},[_vm._v("\n      إعادة توجيه الفاكس\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_ar","title":"مسح ضوئي"}},[_vm._v("\n     مسح ضوئي\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17204"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_ar","title":"جارٍ المسح الضوئي إلى الكمبيوتر"}},[_vm._v("\n      جارٍ المسح الضوئي إلى الكمبيوتر\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_ar","title":"جارٍ المسح الضوئي إلى ملقم FTP"}},[_vm._v("\n      جارٍ المسح الضوئي إلى ملقم FTP\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_ar","title":"إنشاء اختصار FTP"}},[_vm._v("\n      إنشاء اختصار FTP\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"scanning-to-network-folder-topic.html#scanning-to-network-folder_ar","title":"جارٍ المسح الضوئي إلى مجلد شبكة"}},[_vm._v("\n      جارٍ المسح الضوئي إلى مجلد شبكة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"configuring-network-folder-destination-topic.html#configuring-network-folder-destination_ar","title":"تهيئة وجهة مجلد الشبكة"}},[_vm._v("\n      تهيئة وجهة مجلد الشبكة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_ar","title":"إضافة اختصار لمجلد شبكة الاتصال"}},[_vm._v("\n      إضافة اختصار لمجلد شبكة الاتصال\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_ar","title":"جارٍ المسح الضوئي إلى محرك الأقراص الفلاش"}},[_vm._v("\n      جارٍ المسح الضوئي إلى محرك الأقراص الفلاش\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printer-menus-chapter.html#printer-menus-chapter_ar","title":"قوائم الطابعة"}},[_vm._v("\n     قوائم الطابعة\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17493"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"menu-map-topic.html#menu-map_ar","title":"خريطة القوائم"}},[_vm._v("\n      خريطة القوائم\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"preferences-topic.html#d0e17807","title":"جهاز"}},[_vm._v("\n      جهاز\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"layout-topic.html#d0e20041","title":"طباعة"}},[_vm._v("\n      طباعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e21323","title":"الورق"}},[_vm._v("\n      الورق\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e21655","title":"النسخ"}},[_vm._v("\n      النسخ\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e22214","title":"الفاكس"}},[_vm._v("\n      الفاكس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e24081","title":"البريد الإلكتروني"}},[_vm._v("\n      البريد الإلكتروني\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e25178","title":"FTP"}},[_vm._v("\n      FTP\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e25884","title":"برنامج تشغيل USB"}},[_vm._v("\n      برنامج تشغيل USB\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e26730","title":"شبكة الاتصال/المنافذ"}},[_vm._v("\n      شبكة الاتصال/المنافذ\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e28881","title":"الأمان"}},[_vm._v("\n      الأمان\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e29978","title":"خدمات السحابة"}},[_vm._v("\n      خدمات السحابة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e30035","title":"التقارير"}},[_vm._v("\n      التقارير\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_ar","title":"استكشاف الأخطاء وإصلاحها"}},[_c('strong',[_vm._v("\n       استكشاف الأخطاء وإصلاحها\n      ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"forms-merge-topic.html#forms-merge_ar","title":"دمج النماذج"}},[_c('strong',[_vm._v("\n       دمج النماذج\n      ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_ar","title":"طباعة صفحة إعدادات القوائم"}},[_vm._v("\n      طباعة\n      "),_c('strong',[_vm._v("\n       صفحة إعدادات القوائم\n      ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_ar","title":"خيارات إنهاء الطابعة"}},[_vm._v("\n     خيارات إنهاء الطابعة\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30518"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"using-staple-finisher-topic.html#using-staple-finisher_ar","title":"استخدام وحدة إنهاء التدبيس"}},[_vm._v("\n      استخدام وحدة إنهاء التدبيس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_ar","title":"استخدام وحدة إنهاء التدبيس ووحدة إنهاء تثقيب الفتحات"}},[_vm._v("\n      استخدام وحدة إنهاء التدبيس ووحدة إنهاء تثقيب الفتحات\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"using-offset-stacker-topic.html#using-offset-stacker_ar","title":"استخدام وحدة التكديس"}},[_vm._v("\n      استخدام وحدة التكديس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"using-booklet-finisher-topic.html#using-booklet-finisher_ar","title":"استخدام وحدة إنهاء الكتيب"}},[_vm._v("\n      استخدام وحدة إنهاء الكتيب\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"using-hptfu-topic.html#using-hptfu_ar","title":"استخدام نقل الورق مع خيار الطي"}},[_vm._v("\n      استخدام نقل الورق مع خيار الطي\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_ar","title":"صيانة الطابعة"}},[_vm._v("\n     صيانة الطابعة\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30928"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"checking-supplies-status-topic.html#checking-supplies-status_ar","title":"فحص قطع الطابعة ومستلزماتها"}},[_vm._v("\n      فحص قطع الطابعة ومستلزماتها\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_ar","title":"تهيئة إخطارات مستلزمات الطباعة"}},[_vm._v("\n      تهيئة إخطارات مستلزمات الطباعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"setting-up-email-alert-topic.html#setting-up-email-alert_ar","title":"إعداد تنبيهات البريد الالكتروني"}},[_vm._v("\n      إعداد تنبيهات البريد الالكتروني\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"generating-reports-and-logs-topic.html#generating-reports-and-logs_ar","title":"إنشاء التقارير والسجلات"}},[_vm._v("\n      إنشاء التقارير والسجلات\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_ar","title":"طلب الأجزاء والمستلزمات"}},[_vm._v("\n      طلب الأجزاء والمستلزمات\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e31783","title":"استبدال الأجزاء والمستلزمات"}},[_vm._v("\n      استبدال الأجزاء والمستلزمات\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e32407","title":"تنظيف أجزاء الطابعة"}},[_vm._v("\n      تنظيف أجزاء الطابعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e32571","title":"توفير الطاقة والورق"}},[_vm._v("\n      توفير الطاقة والورق\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_ar","title":"تحريك الطابعة إلى موقع آخر"}},[_vm._v("\n      تحريك الطابعة إلى موقع آخر\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_ar","title":"استكشاف مشكلة وإصلاحها"}},[_vm._v("\n     استكشاف مشكلة وإصلاحها\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32709"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"print-quality-problems-topic.html#print-quality-problems_ar","title":"مشكلات جودة الطباعة"}},[_vm._v("\n      مشكلات جودة الطباعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_ar","title":"رموز أخطاء الطابعة"}},[_vm._v("\n      رموز أخطاء الطابعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_ar","title":"مشكلات الطباعة"}},[_vm._v("\n      مشكلات الطباعة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_ar","title":"الطابعة لا تستجيب"}},[_vm._v("\n      الطابعة لا تستجيب\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ar","title":"تتعذر قراءة محرك أقراص فلاش"}},[_vm._v("\n      تتعذر قراءة محرك أقراص فلاش\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_ar","title":"تمكين منفذ USB"}},[_vm._v("\n      تمكين منفذ USB\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_ar","title":"التخلص من انحشار الورق"}},[_vm._v("\n      التخلص من انحشار الورق\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e36133","title":"مشاكل اتصال شبكة الاتصال"}},[_vm._v("\n      مشاكل اتصال شبكة الاتصال\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e36226","title":"مشاكل في خيارات الأجهزة"}},[_vm._v("\n      مشاكل في خيارات الأجهزة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e36399","title":"مشاكل المستلزمات"}},[_vm._v("\n      مشاكل المستلزمات\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"trb-paper-curl-topic.html#d0e36547","title":"مشاكل تغذية الورق"}},[_vm._v("\n      مشاكل تغذية الورق\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e36741","title":"مشكلات الإرسال عبر البريد الإلكتروني"}},[_vm._v("\n      مشكلات الإرسال عبر البريد الإلكتروني\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e36796","title":"مشكلات الإرسال عبر الفاكس"}},[_vm._v("\n      مشكلات الإرسال عبر الفاكس\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e37118","title":"مشكلات المسح الضوئي"}},[_vm._v("\n      مشكلات المسح الضوئي\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"modifying-colors-in-printed-output-topic.html#d0e37536","title":"مشكلات جودة الألوان"}},[_vm._v("\n      مشكلات جودة الألوان\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ar","title":"الاتصال بخدمة دعم العملاء"}},[_vm._v("\n      الاتصال بخدمة دعم العملاء\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_ar","title":"إعادة التدوير والتخلص من المستلزمات"}},[_vm._v("\n     إعادة التدوير والتخلص من المستلزمات\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37762"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_ar","title":"إعادة تدوير منتجات Lexmark"}},[_vm._v("\n      إعادة تدوير منتجات Lexmark\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ar","title":"إعادة تدوير مواد تغليف Lexmark"}},[_vm._v("\n      إعادة تدوير مواد تغليف Lexmark\n     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_ar","title":"إشعارات"}},[_vm._v("\n     إشعارات\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37798"}},[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37801","title":"معلومات عن المنتج"}},[_vm._v("\n      معلومات عن المنتج\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37818","title":"إشعار الإصدار"}},[_vm._v("\n      إشعار الإصدار\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_ar","title":"العلامات التجارية"}},[_vm._v("\n      العلامات التجارية\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_ar","title":"إشعارات الترخيص"}},[_vm._v("\n      إشعارات الترخيص\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_ar","title":"مستويات انبعاث التشويش"}},[_vm._v("\n      مستويات انبعاث التشويش\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37916","title":"Environmental labeling for packaging"}},[_vm._v("\n      Environmental labeling for packaging\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_ar","title":"التخلص من المنتج"}},[_vm._v("\n      التخلص من المنتج\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_ar","title":"إرجاع خراطيش Lexmark بغرض إعادة استخدامها أو إعادة تدويرها"}},[_vm._v("\n      إرجاع خراطيش Lexmark بغرض إعادة استخدامها أو إعادة تدويرها\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_ar","title":"إشعار الحساسية للكهرباء الاستاتيكية"}},[_vm._v("\n      إشعار الحساسية للكهرباء الاستاتيكية\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_ar","title":"برنامج ENERGY STAR"}},[_vm._v("\n      برنامج ENERGY STAR\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_ar","title":"معلومات درجة الحرارة"}},[_vm._v("\n      معلومات درجة الحرارة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_ar","title":"إشعار الليزر"}},[_vm._v("\n      إشعار الليزر\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_ar","title":"استهلاك الطاقة"}},[_vm._v("\n      استهلاك الطاقة\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38177","title":"الإشعارات التنظيمية الخاصة بالمنتجات اللاسلكية"}},[_vm._v("\n      الإشعارات التنظيمية الخاصة بالمنتجات اللاسلكية\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_ar","title":"إشعار المكون النمطي"}},[_vm._v("\n      إشعار المكون النمطي\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_ar","title":"التعرض لإشعاع تردد الراديو"}},[_vm._v("\n      التعرض لإشعاع تردد الراديو\n     ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-right":"14pt","margin-left":"0pt"}},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_ar","title":"إشعار تداخل لاسلكي"}},[_vm._v("\n      إشعار تداخل لاسلكي\n     ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js